/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/resources/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 228);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(8)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod);
    global.DDEventManager = mod.exports;
  }
})(this, function (module) {
  'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var DDEventManager = function () {

    /**
     * constructor
     */
    function DDEventManager(context) {
      var _this = this;

      _classCallCheck(this, DDEventManager);

      this.context = context;
      this._stacks = [];
      this._history = {};

      var on = function on(typeDefine, listener) {
        _this.addListener(typeDefine, listener);
      };

      var one = function one(typeDefine, listener) {
        _this.addListener(typeDefine, listener, true);
      };

      var has = function has(type, listener) {
        if (_this.has(type)) {
          if (listener) {
            listener();
          }
          return true;
        }
        return false;
      };

      var hasAndOn = function hasAndOn(typeDefine, listener) {
        var type = typeDefineSplitter(typeDefine).type;
        var isHas = has(type, listener);
        on(typeDefine, listener);
        return isHas;
      };

      var hasAndOne = function hasAndOne(typeDefine, listener) {
        var type = typeDefineSplitter(typeDefine).type;
        if (!has(type, listener)) {
          one(typeDefine, listener);
          return false;
        }
        return true;
      };

      var off = function off(typeDefine, listener) {
        _this.off(typeDefine, listener);
      };

      var emit = function emit(typeDefine, params) {
        _this.emit(typeDefine, params);
      };

      this.context.on = on;
      this.context.one = one;
      this.context.has = has;
      this.context.hasAndOn = hasAndOn;
      this.context.hasAndOne = hasAndOne;
      this.context.off = off;
      this.context.emit = emit;
    }

    /**
     * 全クリア
     */


    DDEventManager.prototype.destroy = function destroy() {
      this._stacks.forEach(function (stack) {
        stack.remove();
      });

      this._history = {};
    };

    DDEventManager.prototype.find = function find(typeDefine, listener) {
      return this._stacks.filter(function (stack) {
        return stack.match(typeDefine, listener);
      });
    };

    DDEventManager.prototype.has = function has(type) {
      return this._history[type] !== undefined;
    };

    DDEventManager.prototype.off = function off(typeDefine, listener) {
      var stacks = this.find(typeDefine, listener);
      stacks.forEach(function (stack) {
        stack.remove();
      });
    };

    DDEventManager.prototype.emit = function emit(typeDefine, params) {
      var type = typeDefineSplitter(typeDefine).type;
      var stacks = this.find(typeDefine);

      stacks.forEach(function (stack) {
        stack.trigger(params);
      });

      this._history[type] = true;
    };

    DDEventManager.prototype.addListener = function addListener(typeDefine, listener, once) {
      var stack = new DDEventManagerStack(this, typeDefine, listener, once);
      this._stacks.push(stack);
    };

    return DDEventManager;
  }();

  var DDEventManagerStack = function () {

    /**
     * constructor
     */
    function DDEventManagerStack(context, typeDefine, listener) {
      var once = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      _classCallCheck(this, DDEventManagerStack);

      typeDefine = typeDefineSplitter(typeDefine);

      this.context = context;
      this.type = typeDefine.type;
      this.tag = typeDefine.tag;
      this.listener = listener;
      this.once = once;
    }

    /**
     * コンテキストから除去
     */


    DDEventManagerStack.prototype.remove = function remove() {
      this.context._stacks.splice(this.context._stacks.indexOf(this), 1);
    };

    DDEventManagerStack.prototype.match = function match(typeDefine, listener) {
      if (listener && listener !== this.listener) return false;

      typeDefine = typeDefineSplitter(typeDefine);

      var type = typeDefine.type,
          tag = typeDefine.tag;

      if (type && type !== '' && this.type !== type) {
        return false;
      }

      if (tag && this.tag !== tag) {
        return false;
      }

      return true;
    };

    DDEventManagerStack.prototype.trigger = function trigger(params) {
      this.listener(params);
      if (this.once) {
        this.remove();
      }
    };

    return DDEventManagerStack;
  }();

  function typeDefineSplitter(typeDefine) {
    var tmp = typeDefine.split('.');
    return { type: tmp[0], tag: tmp[1] };
  }

  module.exports = DDEventManager;
});


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.5.13
 * (c) 2014-2017 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// these helpers produces better vm code in JS engines due to their
// explicitness and function inlining
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value e.g. [object Object]
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : typeof val === 'object'
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert a input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if a attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether the object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind, faster than native
 */
function bind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }
  // record original fn length
  boundFn._length = fn.length;
  return boundFn
}

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/)
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/**
 * Return same value
 */
var identity = function (_) { return _; };

/**
 * Generate a static keys string from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured'
];

/*  */

var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: 'production' !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: 'production' !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = /[^\w.$]/;
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */


// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = (function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm || {};
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */


var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// the current target watcher being evaluated.
// this is globally unique because there could be only one
// watcher being evaluated at any time.
Dep.target = null;
var targetStack = [];

function pushTarget (_target) {
  if (Dep.target) { targetStack.push(Dep.target); }
  Dep.target = _target;
}

function popTarget () {
  Dep.target = targetStack.pop();
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode, deep) {
  var componentOptions = vnode.componentOptions;
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    vnode.children,
    vnode.text,
    vnode.elm,
    vnode.context,
    componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.isCloned = true;
  if (deep) {
    if (vnode.children) {
      cloned.children = cloneVNodes(vnode.children, true);
    }
    if (componentOptions && componentOptions.children) {
      componentOptions.children = cloneVNodes(componentOptions.children, true);
    }
  }
  return cloned
}

function cloneVNodes (vnodes, deep) {
  var len = vnodes.length;
  var res = new Array(len);
  for (var i = 0; i < len; i++) {
    res[i] = cloneVNode(vnodes[i], deep);
  }
  return res
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);[
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
].forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * By default, when a reactive property is set, the new value is
 * also converted to become reactive. However when passing down props,
 * we don't want to force conversion because the value may be a nested value
 * under a frozen data structure. Converting it would defeat the optimization.
 */
var observerState = {
  shouldConvert: true
};

/**
 * Observer class that are attached to each observed
 * object. Once attached, the observer converts target
 * object's property keys into getter/setters that
 * collect dependencies and dispatches updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    var augment = hasProto
      ? protoAugment
      : copyAugment;
    augment(value, arrayMethods, arrayKeys);
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through each property and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive(obj, keys[i], obj[keys[i]]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment an target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src, keys) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment an target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    observerState.shouldConvert &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    'production' !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    'production' !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;
  var keys = Object.keys(from);
  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (isPlainObject(toVal) && isPlainObject(fromVal)) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      'production' !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  return childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    'production' !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && 'production' !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!/^[a-zA-Z][\w-]*$/.test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'can only contain alphanumeric characters and the hyphen, ' +
      'and must start with a letter.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def = dirs[key];
      if (typeof def === 'function') {
        dirs[key] = { bind: def, update: def };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);
  var extendsFrom = child.extends;
  if (extendsFrom) {
    parent = mergeOptions(parent, extendsFrom, vm);
  }
  if (child.mixins) {
    for (var i = 0, l = child.mixins.length; i < l; i++) {
      parent = mergeOptions(parent, child.mixins[i], vm);
    }
  }
  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */

function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // handle boolean props
  if (isType(Boolean, prop.type)) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (!isType(String, prop.type) && (value === '' || value === hyphenate(key))) {
      value = true;
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldConvert = observerState.shouldConvert;
    observerState.shouldConvert = true;
    observe(value);
    observerState.shouldConvert = prevShouldConvert;
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }
  if (!valid) {
    warn(
      "Invalid prop: type check failed for prop \"" + name + "\"." +
      " Expected " + (expectedTypes.map(capitalize).join(', ')) +
      ", got " + (toRawType(value)) + ".",
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isType (type, fn) {
  if (!Array.isArray(fn)) {
    return getType(fn) === getType(type)
  }
  for (var i = 0, len = fn.length; i < len; i++) {
    if (getType(fn[i]) === getType(type)) {
      return true
    }
  }
  /* istanbul ignore next */
  return false
}

/*  */

function handleError (err, vm, info) {
  if (vm) {
    var cur = vm;
    while ((cur = cur.$parent)) {
      var hooks = cur.$options.errorCaptured;
      if (hooks) {
        for (var i = 0; i < hooks.length; i++) {
          try {
            var capture = hooks[i].call(cur, err, vm, info) === false;
            if (capture) { return }
          } catch (e) {
            globalHandleError(e, cur, 'errorCaptured hook');
          }
        }
      }
    }
  }
  globalHandleError(err, vm, info);
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      logError(e, null, 'config.errorHandler');
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */
/* globals MessageChannel */

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using both micro and macro tasks.
// In < 2.4 we used micro tasks everywhere, but there are some scenarios where
// micro tasks have too high a priority and fires in between supposedly
// sequential events (e.g. #4521, #6690) or even between bubbling of the same
// event (#6566). However, using macro tasks everywhere also has subtle problems
// when state is changed right before repaint (e.g. #6813, out-in transitions).
// Here we use micro task by default, but expose a way to force macro task when
// needed (e.g. in event handlers attached by v-on).
var microTimerFunc;
var macroTimerFunc;
var useMacroTask = false;

// Determine (macro) Task defer implementation.
// Technically setImmediate should be the ideal choice, but it's only available
// in IE. The only polyfill that consistently queues the callback after all DOM
// events triggered in the same loop is by using MessageChannel.
/* istanbul ignore if */
if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  macroTimerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else if (typeof MessageChannel !== 'undefined' && (
  isNative(MessageChannel) ||
  // PhantomJS
  MessageChannel.toString() === '[object MessageChannelConstructor]'
)) {
  var channel = new MessageChannel();
  var port = channel.port2;
  channel.port1.onmessage = flushCallbacks;
  macroTimerFunc = function () {
    port.postMessage(1);
  };
} else {
  /* istanbul ignore next */
  macroTimerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

// Determine MicroTask defer implementation.
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  microTimerFunc = function () {
    p.then(flushCallbacks);
    // in problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
} else {
  // fallback to macro
  microTimerFunc = macroTimerFunc;
}

/**
 * Wrap a function so that if any code inside triggers state change,
 * the changes are queued using a Task instead of a MicroTask.
 */
function withMacroTask (fn) {
  return fn._withTask || (fn._withTask = function () {
    useMacroTask = true;
    var res = fn.apply(null, arguments);
    useMacroTask = false;
    return res
  })
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    if (useMacroTask) {
      macroTimerFunc();
    } else {
      microTimerFunc();
    }
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      perf.clearMeasures(name);
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' &&
    Proxy.toString().match(/native code/);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) || key.charAt(0) === '_';
      if (!has && !isAllowed) {
        warnNonPresent(target, key);
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        warnNonPresent(target, key);
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val)) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        cloned[i].apply(null, arguments$1);
      }
    } else {
      // return handler return value for single handlers
      return fns.apply(null, arguments)
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  vm
) {
  var name, def, cur, old, event;
  for (name in on) {
    def = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    /* istanbul ignore if */
    if (isUndef(cur)) {
      'production' !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur);
      }
      add(event.name, cur, event.once, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor,
  context
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (isDef(factory.contexts)) {
    // already pending
    factory.contexts.push(context);
  } else {
    var contexts = factory.contexts = [context];
    var sync = true;

    var forceRender = function () {
      for (var i = 0, l = contexts.length; i < l; i++) {
        contexts[i].$forceUpdate();
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender();
      }
    });

    var reject = once(function (reason) {
      'production' !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender();
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (typeof res.then === 'function') {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isDef(res.component) && typeof res.component.then === 'function') {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            setTimeout(function () {
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender();
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          setTimeout(function () {
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn, once) {
  if (once) {
    target.$once(event, fn);
  } else {
    target.$on(event, fn);
  }
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var this$1 = this;

    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var this$1 = this;

    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        this$1.$off(event[i], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    if (fn) {
      // specific handler
      var cb;
      var i$1 = cbs.length;
      while (i$1--) {
        cb = cbs[i$1];
        if (cb === fn || cb.fn === fn) {
          cbs.splice(i$1, 1);
          break
        }
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      for (var i = 0, l = cbs.length; i < l; i++) {
        try {
          cbs[i].apply(vm, args);
        } catch (e) {
          handleError(e, vm, ("event handler for \"" + event + "\""));
        }
      }
    }
    return vm
  };
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  var slots = {};
  if (!children) {
    return slots
  }
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

function resolveScopedSlots (
  fns, // see flow/vnode
  res
) {
  res = res || {};
  for (var i = 0; i < fns.length; i++) {
    if (Array.isArray(fns[i])) {
      resolveScopedSlots(fns[i], res);
    } else {
      res[fns[i].key] = fns[i].fn;
    }
  }
  return res
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    if (vm._isMounted) {
      callHook(vm, 'beforeUpdate');
    }
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var prevActiveInstance = activeInstance;
    activeInstance = vm;
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(
        vm.$el, vnode, hydrating, false /* removeOnly */,
        vm.$options._parentElm,
        vm.$options._refElm
      );
      // no need for the ref nodes after initial patch
      // this prevents keeping a detached DOM tree in memory (#5851)
      vm.$options._parentElm = vm.$options._refElm = null;
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    activeInstance = prevActiveInstance;
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, null, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren
  var hasChildren = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    parentVnode.data.scopedSlots || // has new scoped slots
    vm.$scopedSlots !== emptyObject // has old scoped slots
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = (parentVnode.data && parentVnode.data.attrs) || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    observerState.shouldConvert = false;
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      props[key] = validateProp(key, vm.$options.props, propsData, vm);
    }
    observerState.shouldConvert = true;
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  if (listeners) {
    var oldListeners = vm.$options._parentListeners;
    vm.$options._parentListeners = listeners;
    updateComponentListeners(vm, listeners, oldListeners);
  }
  // resolve slots + force update if has children
  if (hasChildren) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  var handlers = vm.$options[hook];
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      try {
        handlers[i].call(vm);
      } catch (e) {
        handleError(e, vm, (hook + " hook"));
      }
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
}

/*  */


var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */

var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = function () {};
      'production' !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    var dep = this$1.deps[i];
    if (!this$1.newDepIds.has(dep.id)) {
      dep.removeSub(this$1);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
    var this$1 = this;

  var i = this.deps.length;
  while (i--) {
    this$1.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
    var this$1 = this;

  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this$1.deps[i].removeSub(this$1);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  observerState.shouldConvert = isRoot;
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive(props, key, value, function () {
        if (vm.$parent && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  observerState.shouldConvert = true;
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    'production' !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      'production' !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : userDef;
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : userDef.get
      : noop;
    sharedPropertyDefinition.set = userDef.set
      ? userDef.set
      : noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (methods[key] == null) {
        warn(
          "Method \"" + key + "\" has an undefined value in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = methods[key] == null ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  keyOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(keyOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function (newData) {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      cb.call(vm, watcher.value);
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    observerState.shouldConvert = false;
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive(vm, key, result[key]);
      }
    });
    observerState.shouldConvert = true;
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject).filter(function (key) {
        /* istanbul ignore next */
        return Object.getOwnPropertyDescriptor(inject, key).enumerable
      })
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && provideKey in source._provided) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    keys = Object.keys(val);
    ret = new Array(keys.length);
    for (i = 0, l = keys.length; i < l; i++) {
      key = keys[i];
      ret[i] = render(val[key], key, i);
    }
  }
  if (isDef(ret)) {
    (ret)._isVList = true;
  }
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    var slotNodes = this.$slots[name];
    // warn duplicate slot usage
    if (slotNodes) {
      if (false) {
        warn(
          "Duplicate presence of slot \"" + name + "\" found in the same render tree " +
          "- this will likely cause render errors.",
          this
        );
      }
      slotNodes._rendered = true;
    }
    nodes = slotNodes || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInAlias,
  eventKeyName
) {
  var keyCodes = config.keyCodes[key] || builtInAlias;
  if (keyCodes) {
    if (Array.isArray(keyCodes)) {
      return keyCodes.indexOf(eventKeyCode) === -1
    } else {
      return keyCodes !== eventKeyCode
    }
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      'production' !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        if (!(key in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree by doing a shallow clone.
  if (tree && !isInFor) {
    return Array.isArray(tree)
      ? cloneVNodes(tree)
      : cloneVNode(tree)
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      'production' !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var options = Ctor.options;
  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () { return resolveSlots(children, parent); };

  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm = Object.create(parent);
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = data.scopedSlots || emptyObject;
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    vnode.fnContext = contextVm;
    vnode.fnOptions = options;
    if (data.slot) {
      (vnode.data || (vnode.data = {})).slot = data.slot;
    }
  }

  return vnode
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */




// Register the component hook to weex native render engine.
// The hook will be triggered by native, not javascript.


// Updates the state of the component to weex native render engine.

/*  */

// https://github.com/Hanks10100/weex-native-directive/tree/master/component

// listening on native callback

/*  */

/*  */

// hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (
    vnode,
    hydrating,
    parentElm,
    refElm
  ) {
    if (!vnode.componentInstance || vnode.componentInstance._isDestroyed) {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance,
        parentElm,
        refElm
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    } else if (vnode.data.keepAlive) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor, context);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // merge component management hooks onto the placeholder node
  mergeHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  // Weex specific: invoke recycle-list optimized @render function for
  // extracting cell-slot template.
  // https://github.com/Hanks10100/weex-native-directive/tree/master/component
  /* istanbul ignore if */
  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent, // activeInstance in lifecycle state
  parentElm,
  refElm
) {
  var options = {
    _isComponent: true,
    parent: parent,
    _parentVnode: vnode,
    _parentElm: parentElm || null,
    _refElm: refElm || null
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function mergeHooks (data) {
  if (!data.hook) {
    data.hook = {};
  }
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var fromParent = data.hook[key];
    var ours = componentVNodeHooks[key];
    data.hook[key] = fromParent ? mergeHook$1(ours, fromParent) : ours;
  }
}

function mergeHook$1 (one, two) {
  return function (a, b, c, d) {
    one(a, b, c, d);
    two(a, b, c, d);
  }
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input';(data.props || (data.props = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  if (isDef(on[event])) {
    on[event] = [data.model.callback].concat(on[event]);
  } else {
    on[event] = data.model.callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    'production' !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if (isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (isDef(vnode)) {
    if (ns) { applyNS(vnode, ns); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (isUndef(child.ns) || isTrue(force))) {
        applyNS(child, ns, force);
      }
    }
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (vm._isMounted) {
      // if the parent didn't update, the slot nodes will be the ones from
      // last render. They need to be cloned to ensure "freshness" for this render.
      for (var key in vm.$slots) {
        var slot = vm.$slots[key];
        // _rendered is a flag added by renderSlot, but may not be present
        // if the slot is passed from manually written render functions
        if (slot._rendered || (slot[0] && slot[0].elm)) {
          vm.$slots[key] = cloneVNodes(slot, true /* deep */);
        }
      }
    }

    vm.$scopedSlots = (_parentVnode && _parentVnode.data.scopedSlots) || emptyObject;

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        if (vm.$options.renderError) {
          try {
            vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
          } catch (e) {
            handleError(e, vm, "renderError");
            vnode = vm._vnode;
          }
        } else {
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

var uid$1 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$1++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;
  opts._parentElm = options._parentElm;
  opts._refElm = options._refElm;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var extended = Ctor.extendOptions;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = dedupe(latest[key], extended[key], sealed[key]);
    }
  }
  return modified
}

function dedupe (latest, extended, sealed) {
  // compare latest and sealed to ensure lifecycle hooks won't be duplicated
  // between merges
  if (Array.isArray(latest)) {
    var res = [];
    sealed = Array.isArray(sealed) ? sealed : [sealed];
    extended = Array.isArray(extended) ? extended : [extended];
    for (var i = 0; i < latest.length; i++) {
      // push original options and not sealed options to exclude duplicated options
      if (extended.indexOf(latest[i]) >= 0 || sealed.indexOf(latest[i]) < 0) {
        res.push(latest[i]);
      }
    }
    return res
  } else {
    return latest
  }
}

function Vue$3 (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue$3);
stateMixin(Vue$3);
eventsMixin(Vue$3);
lifecycleMixin(Vue$3);
renderMixin(Vue$3);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */

function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    var this$1 = this;

    for (var key in this$1.cache) {
      pruneCacheEntry(this$1.cache, key, this$1.keys);
    }
  },

  watch: {
    include: function include (val) {
      pruneCache(this, function (name) { return matches(val, name); });
    },
    exclude: function exclude (val) {
      pruneCache(this, function (name) { return !matches(val, name); });
    }
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue$3);

Object.defineProperty(Vue$3.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue$3.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

Vue$3.version = '2.5.13';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      'production' !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setAttribute (node, key, val) {
  node.setAttribute(key, val);
}


var nodeOps = Object.freeze({
	createElement: createElement$1,
	createElementNS: createElementNS,
	createTextNode: createTextNode,
	createComment: createComment,
	insertBefore: insertBefore,
	removeChild: removeChild,
	appendChild: appendChild,
	parentNode: parentNode,
	nextSibling: nextSibling,
	tagName: tagName,
	setTextContent: setTextContent,
	setAttribute: setAttribute
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!key) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove () {
      if (--remove.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove.listeners = listeners;
    return remove
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;
  function createElm (vnode, insertedVnodeQueue, parentElm, refElm, nested) {
    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }
      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */, parentElm, refElm);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (ref$$1.parentNode === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setAttribute(vnode.elm, i, '');
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setAttribute(vnode.elm, i, '');
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setAttribute(vnode.elm, i, '');
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (oldVnode, vnode, insertedVnodeQueue, removeOnly) {
    if (oldVnode === vnode) {
      return
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly, parentElm, refElm) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue, parentElm, refElm);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm$1 = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm$1,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm$1)) {
          removeVnodes(parentElm$1, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, isFalsyAttrValue(value) || value === 'false' ? 'false' : 'true');
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // #7138: IE10 & 11 fires input event when setting placeholder on
      // <textarea>... block the first input event and remove the blocker
      // immediately.
      /* istanbul ignore if */
      if (
        isIE && !isIE9 &&
        el.tagName === 'TEXTAREA' &&
        key === 'placeholder' && !el.__ieph
      ) {
        var blocker = function (e) {
          e.stopImmediatePropagation();
          el.removeEventListener('input', blocker);
        };
        el.addEventListener('input', blocker);
        // $flow-disable-line
        el.__ieph = true; /* IE placeholder patched */
      }
      el.setAttribute(key, value);
    }
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + "," + args)
  }
}

/*  */

function baseWarn (msg) {
  console.error(("[Vue compiler]: " + msg));
}

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value) {
  (el.props || (el.props = [])).push({ name: name, value: value });
  el.plain = false;
}

function addAttr (el, name, value) {
  (el.attrs || (el.attrs = [])).push({ name: name, value: value });
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value) {
  el.attrsMap[name] = value;
  el.attrsList.push({ name: name, value: value });
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  modifiers
) {
  (el.directives || (el.directives = [])).push({ name: name, rawName: rawName, value: value, arg: arg, modifiers: modifiers });
  el.plain = false;
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.'
    );
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = '!' + name; // mark the event as captured
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = '~' + name; // mark the event as once
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = '&' + name; // mark the event as passive
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (name === 'click') {
    if (modifiers.right) {
      name = 'contextmenu';
      delete modifiers.right;
    } else if (modifiers.middle) {
      name = 'mouseup';
    }
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = { value: value };
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
        "? " + baseValueExpression + ".trim()" +
        ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: ("\"" + value + "\""),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len;
var str;
var chr;
var index$1;
var expressionPos;
var expressionEndPos;



function parseModel (val) {
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead."
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.'
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + value + "=$$a.concat([$$v]))}" +
      "else{$$i>-1&&(" + value + "=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    if (value$1) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally'
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler (handler, event, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

function add$1 (
  event,
  handler,
  once$$1,
  capture,
  passive
) {
  handler = withMacroTask(handler);
  if (once$$1) { handler = createOnceHandler(handler, event, capture); }
  target$1.addEventListener(
    event,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  event,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    event,
    handler._withTask || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (isUndef(props[key])) {
      elm[key] = '';
    }
  }
  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else {
      elm[key] = cur;
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.lazy) {
      // inputs with lazy should only be updated when not in focus
      return false
    }
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(name, val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(/\s+/).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def) {
  if (!def) {
    return
  }
  /* istanbul ignore else */
  if (typeof def === 'object') {
    var res = {};
    if (def.css !== false) {
      extend(res, autoCssTransition(def.name || 'v'));
    }
    extend(res, def);
    return res
  } else if (typeof def === 'string') {
    return autoCssTransition(def)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  var transitionDelays = styles[transitionProp + 'Delay'].split(', ');
  var transitionDurations = styles[transitionProp + 'Duration'].split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = styles[animationProp + 'Delay'].split(', ');
  var animationDurations = styles[animationProp + 'Duration'].split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

function toMs (s) {
  return Number(s.slice(0, -1)) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    transitionNode = transitionNode.parent;
    context = transitionNode.context;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      addTransitionClass(el, toClass);
      removeTransitionClass(el, startClass);
      if (!cb.cancelled && !userWantsControl) {
        if (isValidDuration(explicitEnterDuration)) {
          setTimeout(cb, explicitEnterDuration);
        } else {
          whenTransitionEnds(el, type, cb);
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        addTransitionClass(el, leaveToClass);
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled && !userWantsControl) {
          if (isValidDuration(explicitLeaveDuration)) {
            setTimeout(cb, explicitLeaveDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        if (!isAndroid) {
          el.addEventListener('compositionstart', onCompositionStart);
          el.addEventListener('compositionend', onCompositionEnd);
        }
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    'production' !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (value === oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

// Provides transition support for a single element/component.
// supports transition mode (out-in / in-out)

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(function (c) { return c.tag || isAsyncPlaceholder(c); });
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(function (d) { return d.name === 'show'; })) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

// Provides transition support for list items.
// supports move transitions using the FLIP technique.

// Because the vdom's children update algorithm is "unstable" - i.e.
// it doesn't guarantee the relative positioning of removed elements,
// we force transition-group to update its children into two passes:
// in the first pass, we remove all nodes that need to be removed,
// triggering their leaving transition; in the second pass, we insert/move
// into the final desired state. This way in the second pass removed
// nodes will remain where they should be.

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  beforeUpdate: function beforeUpdate () {
    // force removing pass
    this.__patch__(
      this._vnode,
      this.kept,
      false, // hydrating
      true // removeOnly (!important avoids unnecessary moves)
    );
    this._vnode = this.kept;
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue$3.config.mustUseProp = mustUseProp;
Vue$3.config.isReservedTag = isReservedTag;
Vue$3.config.isReservedAttr = isReservedAttr;
Vue$3.config.getTagNamespace = getTagNamespace;
Vue$3.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue$3.options.directives, platformDirectives);
extend(Vue$3.options.components, platformComponents);

// install platform patch function
Vue$3.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
Vue$3.nextTick(function () {
  if (config.devtools) {
    if (devtools) {
      devtools.emit('init', Vue$3);
    } else if (false) {
      console[console.info ? 'info' : 'log'](
        'Download the Vue Devtools extension for a better development experience:\n' +
        'https://github.com/vuejs/vue-devtools'
      );
    }
  }
  if (false
  ) {
    console[console.info ? 'info' : 'log'](
      "You are running Vue in development mode.\n" +
      "Make sure to turn on production mode when deploying for production.\n" +
      "See more tips at https://vuejs.org/guide/deployment.html"
    );
  }
}, 0);

/*  */

var defaultTagRE = /\{\{((?:.|\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.'
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.'
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

/*!
 * HTML Parser By John Resig (ejohn.org)
 * Modified by Juriy "kangax" Zaytsev
 * Original code by Erik Arvidsson, Mozilla Public License
 * http://erik.eae.net/simplehtmlparser/simplehtmlparser.js
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
// could use https://www.w3.org/TR/1999/REC-xml-names-19990114/#NT-QName
// but for Vue templates we can enforce a simple charset
var ncname = '[a-zA-Z_][\\w\\-\\.]*';
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
var comment = /^<!--/;
var conditionalComment = /^<!\[/;

var IS_REGEX_CAPTURING_BROKEN = false;
'x'.replace(/x(.)?/g, function (m, g) {
  IS_REGEX_CAPTURING_BROKEN = g === '';
});

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t'
};
var encodedAttr = /&(?:lt|gt|quot|amp);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd));
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(lastTag, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
        advance(textEnd);
      }

      if (textEnd < 0) {
        text = html;
        html = '';
      }

      if (options.chars && text) {
        options.chars(text);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!--([\s\S]*?)-->/g, '$1')
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""));
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(attribute))) {
        advance(attr[0].length);
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      // hackish work around FF bug https://bugzilla.mozilla.org/show_bug.cgi?id=369778
      if (IS_REGEX_CAPTURING_BROKEN && args[0].indexOf('""') === -1) {
        if (args[3] === '') { delete args[3]; }
        if (args[4] === '') { delete args[4]; }
        if (args[5] === '') { delete args[5]; }
      }
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
    }

    // Find the closest opened tag of the same type
    if (tagName) {
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag.")
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /(.*?)\s+(?:in|of)\s+(.*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;

var argRE = /:(.*)$/;
var bindRE = /^:|^v-bind:/;
var modifierRE = /\.[^.]+/g;

var decodeHTMLCached = cached(he.decode);

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;



function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg) {
    if (!warned) {
      warned = true;
      warn$2(msg);
    }
  }

  function closeElement (element) {
    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    start: function start (tag, attrs, unary) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        'production' !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.'
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
        // element-scope stuff
        processElement(element, options);
      }

      function checkRootConstraints (el) {
        if (false) {
          if (el.tag === 'slot' || el.tag === 'template') {
            warnOnce(
              "Cannot use <" + (el.tag) + "> as component root element because it may " +
              'contain multiple nodes.'
            );
          }
          if (el.attrsMap.hasOwnProperty('v-for')) {
            warnOnce(
              'Cannot use v-for on stateful component root element because ' +
              'it renders multiple elements.'
            );
          }
        }
      }

      // tree management
      if (!root) {
        root = element;
        checkRootConstraints(root);
      } else if (!stack.length) {
        // allow root elements with v-if, v-else-if and v-else
        if (root.if && (element.elseif || element.else)) {
          checkRootConstraints(element);
          addIfCondition(root, {
            exp: element.elseif,
            block: element
          });
        } else if (false) {
          warnOnce(
            "Component template should contain exactly one root element. " +
            "If you are using v-if on multiple elements, " +
            "use v-else-if to chain them instead."
          );
        }
      }
      if (currentParent && !element.forbidden) {
        if (element.elseif || element.else) {
          processIfConditions(element, currentParent);
        } else if (element.slotScope) { // scoped slot
          currentParent.plain = false;
          var name = element.slotTarget || '"default"';(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        } else {
          currentParent.children.push(element);
          element.parent = currentParent;
        }
      }
      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end () {
      // remove trailing whitespace
      var element = stack[stack.length - 1];
      var lastNode = element.children[element.children.length - 1];
      if (lastNode && lastNode.type === 3 && lastNode.text === ' ' && !inPre) {
        element.children.pop();
      }
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      closeElement(element);
    },

    chars: function chars (text) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.'
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored.")
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      text = inPre || text.trim()
        ? isTextTag(currentParent) ? text : decodeHTMLCached(text)
        // only preserve whitespace if its not right after a starting tag
        : preserveWhitespace && children.length ? ' ' : '';
      if (text) {
        var res;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          children.push({
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          });
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          children.push({
            type: 3,
            text: text
          });
        }
      }
    },
    comment: function comment (text) {
      currentParent.children.push({
        type: 3,
        text: text,
        isComment: true
      });
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var l = el.attrsList.length;
  if (l) {
    var attrs = el.attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      attrs[i] = {
        name: el.attrsList[i].name,
        value: JSON.stringify(el.attrsList[i].value)
      };
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (element, options) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = !element.key && !element.attrsList.length;

  processRef(element);
  processSlot(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      warn$2("<template> cannot be keyed. Place the key on real elements instead.");
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp)
      );
    }
  }
}

function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '');
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if."
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored."
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

function processSlot (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead."
      );
    }
  } else {
    var slotScope;
    if (el.tag === 'template') {
      slotScope = getAndRemoveAttr(el, 'scope');
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "the \"scope\" attribute for scoped slots have been deprecated and " +
          "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
          "can also be used on plain elements in addition to <template> to " +
          "denote scoped slots.",
          true
        );
      }
      el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
    } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
      /* istanbul ignore if */
      if (false) {
        warn$2(
          "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
          "(v-for takes higher priority). Use a wrapper <template> for the " +
          "scoped slot to make it clearer.",
          true
        );
      }
      el.slotScope = slotScope;
    }
    var slotTarget = getBindingAttr(el, 'slot');
    if (slotTarget) {
      el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
      // preserve slot as an attribute for native shadow DOM compat
      // only for non-scoped slots.
      if (el.tag !== 'template' && !el.slotScope) {
        addAttr(el, 'slot', slotTarget);
      }
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, isProp;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name);
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isProp = false;
        if (modifiers) {
          if (modifiers.prop) {
            isProp = true;
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            addHandler(
              el,
              ("update:" + (camelize(name))),
              genAssignmentCode(value, "$event")
            );
          }
        }
        if (isProp || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value);
        } else {
          addAttr(el, name, value);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        addHandler(el, name, value, modifiers, false, warn$2);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
        }
        addDirective(el, name, rawName, value, arg, modifiers);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.'
          );
        }
      }
      addAttr(el, name, JSON.stringify(value));
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true');
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead."
      );
    }
    _el = _el.parent;
  }
}

/*  */

/**
 * Expand input[v-model] with dyanmic type bindings into v-if-else chains
 * Turn this:
 *   <input v-model="data[type]" :type="type">
 * into this:
 *   <input v-if="type === 'checkbox'" type="checkbox" v-model="data[type]">
 *   <input v-else-if="type === 'radio'" type="radio" v-model="data[type]">
 *   <input v-else :type="type" v-model="data[type]">
 */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (map['v-model'] && (map['v-bind:type'] || map[':type'])) {
      var typeBinding = getBindingAttr(el, 'type');
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$2 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$2
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"));
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"));
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^\s*([\w$_]+|\([^)]*?\))\s*=>|^function\s*\(/;
var simplePathRE = /^\s*[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['.*?']|\[".*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*\s*$/;

// keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative,
  warn
) {
  var res = isNative ? 'nativeOn:{' : 'on:{';
  for (var name in events) {
    res += "\"" + name + "\":" + (genHandler(name, events[name])) + ",";
  }
  return res.slice(0, -1) + '}'
}

function genHandler (
  name,
  handler
) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(name, handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    /* istanbul ignore if */
    return ("function($event){" + (handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? handler.value + '($event)'
      : isFunctionExpression
        ? ("(" + (handler.value) + ")($event)")
        : handler.value;
    /* istanbul ignore if */
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return ("if(!('button' in $event)&&" + (keys.map(genFilterCode).join('&&')) + ")return null;")
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var code = keyCodes[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(code)) + "," +
    "$event.key)"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */

var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data = el.plain ? undefined : genData$2(el, state);

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      'production' !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. "
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:{" + (genProps(el.attrs)) + "},";
  }
  // DOM props
  if (el.props) {
    data += "domProps:{" + (genProps(el.props)) + "},";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false, state.warn)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true, state.warn)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:\"" + (dir.arg) + "\"") : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn('Inline-template components must have exactly one child element.');
  }
  if (ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  slots,
  state
) {
  return ("scopedSlots:_u([" + (Object.keys(slots).map(function (key) {
      return genScopedSlot(key, slots[key], state)
    }).join(',')) + "])")
}

function genScopedSlot (
  key,
  el,
  state
) {
  if (el.for && !el.forProcessed) {
    return genForScopedSlot(key, el, state)
  }
  var fn = "function(" + (String(el.slotScope)) + "){" +
    "return " + (el.tag === 'template'
      ? el.if
        ? ((el.if) + "?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  return ("{key:" + key + ",fn:" + fn + "}")
}

function genForScopedSlot (
  key,
  el,
  state
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';
  el.forProcessed = true; // avoid recursion
  return "_l((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + (genScopedSlot(key, el, state)) +
    '})'
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      return (altGenElement || genElement)(el$1, state)
    }
    var normalizationType = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType ? ("," + normalizationType) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs && ("{" + (el.attrs.map(function (a) { return ((camelize(a.name)) + ":" + (a.value)); }).join(',')) + "}");
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var res = '';
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    /* istanbul ignore if */
    {
      res += "\"" + (prop.name) + "\":" + (transformSpecialNewlines(prop.value)) + ",";
    }
  }
  return res.slice(0, -1)
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */

// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast) {
  var errors = [];
  if (ast) {
    checkNode(ast, errors);
  }
  return errors
}

function checkNode (node, errors) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), errors);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), errors);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), errors);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], errors);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, errors);
  }
}

function checkEvent (exp, text, errors) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    errors.push(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim())
    );
  }
  checkExpression(exp, text, errors);
}

function checkFor (node, text, errors) {
  checkExpression(node.for || '', text, errors);
  checkIdentifier(node.alias, 'v-for alias', text, errors);
  checkIdentifier(node.iterator1, 'v-for iterator', text, errors);
  checkIdentifier(node.iterator2, 'v-for iterator', text, errors);
}

function checkIdentifier (
  ident,
  type,
  text,
  errors
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      errors.push(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())));
    }
  }
}

function checkExpression (exp, text, errors) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      errors.push(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim())
      );
    } else {
      errors.push(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n"
      );
    }
  }
}

/*  */

function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        warn$$1(
          "Error compiling template:\n\n" + template + "\n\n" +
          compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
          vm
        );
      }
      if (compiled.tips && compiled.tips.length) {
        compiled.tips.forEach(function (msg) { return tip(msg, vm); });
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];
      finalOptions.warn = function (msg, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      var compiled = baseCompile(template, finalOptions);
      if (false) {
        errors.push.apply(errors, detectErrors(compiled.ast));
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue$3.prototype.$mount;
Vue$3.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    'production' !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue$3.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["default"] = (Vue$3);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(22), __webpack_require__(62).setImmediate))

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(156);
var isBuffer = __webpack_require__(231);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__(79);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var locationOrigin = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

// const $http = axios.create({

//   // for cors
//   withCredentials: true,
// });

// // cache buster
// $http.interceptors.request.use(config => {
//   const USE_CACHE_BUSTER = config.cache === undefined || !config.cache;

//   if (USE_CACHE_BUSTER) {
//     if (typeof config.params === 'undefined') config.params = {};
//     if (config.params && typeof config.params === 'object') {
//       if (typeof URLSearchParams === 'function' && config.params instanceof URLSearchParams) {
//         config.params.append('_', Date.now());
//       } else {
//         config.params._ = Date.now();
//       }
//     }
//     return config;
//   }
// });

var dataTypeMap = {
  xml: 'xml',
  json: 'json',
  html: 'html',
  js: 'script',
  txt: 'text',
  csv: 'text'
};

var MIMES = {
  'html': { type: 'text/html', charset: true },
  'jpg': { type: 'image/jpeg', charset: false },
  'jpeg': { type: 'image/jpeg', charset: false },
  'png': { type: 'image/png', charset: false },
  'gif': { type: 'image/gif', charset: false },
  'svg': { type: 'image/svg+xml', charset: false },
  'csv': { type: 'text/csv', charset: true },
  'js': { type: 'application/javascript', charset: true },
  'css': { type: 'text/css', charset: true },
  'xml': { type: 'text/xml', charset: true },
  'json': { type: 'application/json', charset: true },
  'default': { type: 'text/plain', charset: true }
};

var $http = {
  defaults: {
    type: 'get',
    cache: false
  },
  getConfigByOpts: function getConfigByOpts() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var url = arguments[1];

    opts = Object.assign({}, opts, this.defaults);
    opts.type = opts.type ? opts.type.toLowerCase() : opts.type;
    opts.dataType = opts.dataType ? opts.dataType.toLowerCase() : opts.dataType;
    url = url || opts.url || '';

    var crossDomain = /^(http|https|\/\/)/.test(url) && !new RegExp('^' + locationOrigin).test(url);
    var extMatch = url.match(/(.*)(?:\.([^.]+$))/);
    var ext = extMatch && extMatch[2] && extMatch[2].split('?')[0].toLowerCase();
    opts.dataType = opts.dataType || dataTypeMap[ext];

    var config = {
      url: url,
      crossDomain: crossDomain,
      type: opts.type,
      timeout: opts.timeout,
      dataType: opts.dataType,
      contentType: opts.contentType,
      cache: opts.cache
    };

    if (opts.data) config.data = opts.data;

    var mime = MIMES[ext];
    if (!opts.contentType && mime && mime.charset) {
      config.beforeSend = function (xhr) {
        xhr.overrideMimeType(mime.type + ';charset=utf-8');
      };
    }

    return config;
  },
  request: function request(type, url, opts) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var config = Object.assign(_this.getConfigByOpts(opts, url), {
        type: type,
        success: function success(data, status, xhr) {
          resolve({
            data: data,
            status: status,
            xhr: xhr
          });
        },
        error: function error(xhr, status, errorThrown) {
          console.warn('[dn.$http] \u30EA\u30AF\u30A8\u30B9\u30C8\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002 ' + url);
          reject(new Error(errorThrown));
        }
      });

      $.ajax(config);
    });
  },
  get: function get(url, opts) {
    return this.request('get', url, opts);
  },
  post: function post(url) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return this.request('post', url, opts);
  }
};

exports.default = $http;

/***/ }),
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AbstractSegment = function () {
  _createClass(AbstractSegment, [{
    key: 'createKey',
    value: function createKey() {
      var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.context.year;

      var yearSuffix = this.requireYear ? year + '_' : '';
      return this.context.key + '_' + yearSuffix + this.name;
    }

    /**
     * constructor
     */

  }, {
    key: 'key',


    /**
     * getters
     */
    // get yearSuffix() { return this.requireYear ? this.context.year + '_' : '' }
    get: function get() {
      return this.createKey();
    }
  }, {
    key: 'isWatching',
    get: function get() {
      return this.watchState === 'running';
    }
  }, {
    key: 'isWatchPausing',
    get: function get() {
      return this.watchState === 'pausing';
    }
  }, {
    key: 'hasWatchListeners',
    get: function get() {
      return this._ev._stacks.find(function (stack) {
        return stack.type === 'change';
      }) !== undefined;
    }
  }]);

  function AbstractSegment(context) {
    var _this = this;

    _classCallCheck(this, AbstractSegment);

    this.requireYear = false;
    this.name = '';
    this.config = null;
    this._watchTimerId = null;
    this._watchBeforeValue = null;
    this._hideBeforeWatching = null;

    this._ev = new _ddEventManager2.default(this);
    this.context = context;
    this.watchState = 'pending';

    this.context.on('show', function () {
      if (_this._hideBeforeWatching === true) {
        _this._startWatch();
      }
      _this._hideBeforeWatching = null;
      _this.watchState = 'pausing';
    });

    this.context.on('hide', function () {
      _this._hideBeforeWatching = _this.isWatching;
      _this._stopWatch();
    });
  }

  /**
   * set config
   */


  _createClass(AbstractSegment, [{
    key: 'setConfig',
    value: function setConfig(config) {
      this.config = config;
    }

    /**
     * erase
     */

  }, {
    key: 'erase',
    value: function erase() {
      this.context.cookies.erase(this.key);
      if (typeof this.onEraseAfter === 'function') this.onEraseAfter();
      this._checkChangeValue();
    }

    /**
     * set watch handler
     */

  }, {
    key: 'listen',
    value: function listen(cb) {
      var _this2 = this;

      var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var eventMap = 'change' + (tag ? '.' + tag : '');
      this.on(eventMap, function () {
        cb(_this2);
      });
      this._startWatch();
    }

    /**
     * remove watch handler
     */

  }, {
    key: 'stopListen',
    value: function stopListen(cb) {
      var tag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      var eventMap = 'change' + (tag ? '.' + tag : '');
      this.off(eventMap, cb);
      if (this.hasWatchListeners) this._stopWatch();
    }
  }, {
    key: 'copyToAnotherYear',
    value: function copyToAnotherYear(year) {
      if (!this.requireYear || year === this.context.year) return;
      var value = this._get();
      var key = this.createKey(year);
      if (!!value) {
        this.context.cookies.set(key, value);
      } else {
        this.context.cookies.erase(key);
      }
    }
  }, {
    key: 'copyFromAnotherYear',
    value: function copyFromAnotherYear(year, _ref) {
      var _ref$cancelWhenHasVal = _ref.cancelWhenHasValue,
          cancelWhenHasValue = _ref$cancelWhenHasVal === undefined ? false : _ref$cancelWhenHasVal,
          _ref$onlyCookie = _ref.onlyCookie,
          onlyCookie = _ref$onlyCookie === undefined ? false : _ref$onlyCookie;

      if (!this.requireYear || year === this.context.year || cancelWhenHasValue && this._get(null) !== null) return;
      var key = this.createKey(year);
      var value = this.context.cookies.get(key);
      if (onlyCookie) {
        if (!!value) {
          this.context.cookies.set(this.key, value);
        } else {
          this.context.cookies.erase(this.key);
        }
      } else {
        this._set(value);
      }
    }

    /**
     * set cookie string
     */

  }, {
    key: '_set',
    value: function _set(value) {
      this.context.cookies.set(this.key, value);
      this._checkChangeValue();
    }

    /**
     * get cookie string
     */

  }, {
    key: '_get',
    value: function _get(defaultValue) {
      var value = this.context.cookies.get(this.key);
      return value === null || value === undefined ? defaultValue : value;
    }

    /**
     * check change value
     */

  }, {
    key: '_checkChangeValue',
    value: function _checkChangeValue() {
      var nowValue = this._get();
      if (this._watchBeforeValue !== nowValue) {
        this.emit('change', this);
        this._watchBeforeValue = nowValue;
      }
    }

    /**
     * watch ticker
     */

  }, {
    key: '_watchTick',
    value: function _watchTick() {
      var _this3 = this;

      this._watchTimerId = setTimeout(function () {
        _this3._checkChangeValue();
        _this3._watchTick();
      }, this.context.watchInterval);
    }

    /**
     * start watch
     */

  }, {
    key: '_startWatch',
    value: function _startWatch() {
      if (this.isWatching) return;
      if (this.isWatchPausing) {
        this._hideBeforeWatching = true;
        return;
      }
      this._clearWatchTimer();
      this._watchTick();
      this.watchState = 'running';
    }

    /**
     * stop watch
     */

  }, {
    key: '_stopWatch',
    value: function _stopWatch() {
      if (!this.isWatching) return;
      this._clearWatchTimer();
      // this._watchBeforeValue = null;
      this.watchState = 'pending';
    }

    /**
     * clear watch timer
     */

  }, {
    key: '_clearWatchTimer',
    value: function _clearWatchTimer() {
      if (this._watchTimerId !== null) {
        clearTimeout(this._watchTimerId);
      }
      this._watchTimerId = null;
    }
  }]);

  return AbstractSegment;
}();

exports.default = AbstractSegment;

/***/ }),
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(63);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22)))

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(22), __webpack_require__(56)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * UAParser.js v0.7.17
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 & MIT
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.17',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var margedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    margedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    margedRegexes[i] = regexes[i];
                }
            }
            return margedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            //var result = {},
            var i = 0, j, k, p, q, matches, match;//, args = arguments;

            /*// construct object barebones
            for (p = 0; p < args[1].length; p++) {
                q = args[1][p];
                result[typeof q === OBJ_TYPE ? q[0] : q] = undefined;
            }*/

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
            // console.log(this);
            //return this;
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]+)*/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]+)*/i,                                            // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser
            ], [NAME, VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge)\/((\d+)?[\w\.]+)/i                                          // Microsoft Edge
            ], [NAME, VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i
                                                                                // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(konqueror)\/([\w\.]+)/i,                                          // Konqueror
            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/([\w\.-]+)/i,
                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]+)*/i,                                        // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]

            /* /////////////////////
            // Media players BEGIN
            ////////////////////////

            , [

            /(apple(?:coremedia|))\/((\d+)[\w\._]+)/i,                          // Generic Apple CoreMedia
            /(coremedia) v((\d+)[\w\._]+)/i
            ], [NAME, VERSION], [

            /(aqualung|lyssna|bsplayer)\/((\d+)?[\w\.-]+)/i                     // Aqualung/Lyssna/BSPlayer
            ], [NAME, VERSION], [

            /(ares|ossproxy)\s((\d+)[\w\.-]+)/i                                 // Ares/OSSProxy
            ], [NAME, VERSION], [

            /(audacious|audimusicstream|amarok|bass|core|dalvik|gnomemplayer|music on console|nsplayer|psp-internetradioplayer|videos)\/((\d+)[\w\.-]+)/i,
                                                                                // Audacious/AudiMusicStream/Amarok/BASS/OpenCORE/Dalvik/GnomeMplayer/MoC
                                                                                // NSPlayer/PSP-InternetRadioPlayer/Videos
            /(clementine|music player daemon)\s((\d+)[\w\.-]+)/i,               // Clementine/MPD
            /(lg player|nexplayer)\s((\d+)[\d\.]+)/i,
            /player\/(nexplayer|lg player)\s((\d+)[\w\.-]+)/i                   // NexPlayer/LG Player
            ], [NAME, VERSION], [
            /(nexplayer)\s((\d+)[\w\.-]+)/i                                     // Nexplayer
            ], [NAME, VERSION], [

            /(flrp)\/((\d+)[\w\.-]+)/i                                          // Flip Player
            ], [[NAME, 'Flip Player'], VERSION], [

            /(fstream|nativehost|queryseekspider|ia-archiver|facebookexternalhit)/i
                                                                                // FStream/NativeHost/QuerySeekSpider/IA Archiver/facebookexternalhit
            ], [NAME], [

            /(gstreamer) souphttpsrc (?:\([^\)]+\)){0,1} libsoup\/((\d+)[\w\.-]+)/i
                                                                                // Gstreamer
            ], [NAME, VERSION], [

            /(htc streaming player)\s[\w_]+\s\/\s((\d+)[\d\.]+)/i,              // HTC Streaming Player
            /(java|python-urllib|python-requests|wget|libcurl)\/((\d+)[\w\.-_]+)/i,
                                                                                // Java/urllib/requests/wget/cURL
            /(lavf)((\d+)[\d\.]+)/i                                             // Lavf (FFMPEG)
            ], [NAME, VERSION], [

            /(htc_one_s)\/((\d+)[\d\.]+)/i                                      // HTC One S
            ], [[NAME, /_/g, ' '], VERSION], [

            /(mplayer)(?:\s|\/)(?:(?:sherpya-){0,1}svn)(?:-|\s)(r\d+(?:-\d+[\w\.-]+){0,1})/i
                                                                                // MPlayer SVN
            ], [NAME, VERSION], [

            /(mplayer)(?:\s|\/|[unkow-]+)((\d+)[\w\.-]+)/i                      // MPlayer
            ], [NAME, VERSION], [

            /(mplayer)/i,                                                       // MPlayer (no other info)
            /(yourmuze)/i,                                                      // YourMuze
            /(media player classic|nero showtime)/i                             // Media Player Classic/Nero ShowTime
            ], [NAME], [

            /(nero (?:home|scout))\/((\d+)[\w\.-]+)/i                           // Nero Home/Nero Scout
            ], [NAME, VERSION], [

            /(nokia\d+)\/((\d+)[\w\.-]+)/i                                      // Nokia
            ], [NAME, VERSION], [

            /\s(songbird)\/((\d+)[\w\.-]+)/i                                    // Songbird/Philips-Songbird
            ], [NAME, VERSION], [

            /(winamp)3 version ((\d+)[\w\.-]+)/i,                               // Winamp
            /(winamp)\s((\d+)[\w\.-]+)/i,
            /(winamp)mpeg\/((\d+)[\w\.-]+)/i
            ], [NAME, VERSION], [

            /(ocms-bot|tapinradio|tunein radio|unknown|winamp|inlight radio)/i  // OCMS-bot/tap in radio/tunein/unknown/winamp (no other info)
                                                                                // inlight radio
            ], [NAME], [

            /(quicktime|rma|radioapp|radioclientapplication|soundtap|totem|stagefright|streamium)\/((\d+)[\w\.-]+)/i
                                                                                // QuickTime/RealMedia/RadioApp/RadioClientApplication/
                                                                                // SoundTap/Totem/Stagefright/Streamium
            ], [NAME, VERSION], [

            /(smp)((\d+)[\d\.]+)/i                                              // SMP
            ], [NAME, VERSION], [

            /(vlc) media player - version ((\d+)[\w\.]+)/i,                     // VLC Videolan
            /(vlc)\/((\d+)[\w\.-]+)/i,
            /(xbmc|gvfs|xine|xmms|irapp)\/((\d+)[\w\.-]+)/i,                    // XBMC/gvfs/Xine/XMMS/irapp
            /(foobar2000)\/((\d+)[\d\.]+)/i,                                    // Foobar2000
            /(itunes)\/((\d+)[\d\.]+)/i                                         // iTunes
            ], [NAME, VERSION], [

            /(wmplayer)\/((\d+)[\w\.-]+)/i,                                     // Windows Media Player
            /(windows-media-player)\/((\d+)[\w\.-]+)/i
            ], [[NAME, /-/g, ' '], VERSION], [

            /windows\/((\d+)[\w\.-]+) upnp\/[\d\.]+ dlnadoc\/[\d\.]+ (home media server)/i
                                                                                // Windows Media Server
            ], [VERSION, [NAME, 'Windows']], [

            /(com\.riseupradioalarm)\/((\d+)[\d\.]*)/i                          // RiseUP Radio Alarm
            ], [NAME, VERSION], [

            /(rad.io)\s((\d+)[\d\.]+)/i,                                        // Rad.io
            /(radio.(?:de|at|fr))\s((\d+)[\d\.]+)/i
            ], [[NAME, 'rad.io'], VERSION]

            //////////////////////
            // Media players END
            ////////////////////*/

        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\);-]+(rim|apple)/i                         // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i                               // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i                  // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i                         // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,                               // HTC
            /(zte)-(\w+)*/i,                                                    // ZTE
            /(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i
                                                                                // Alcatel/GeeksPhone/Lenovo/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w+)*/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w+)*/i                                                       // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]+)*/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android\s3\.[\s\w;-]{10}(a\d{3})/i                                 // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w+)*/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)\s/i                                          // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel xl|pixel)\s/i                                   // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+(\w+)\s+build\/hm\1/i,                                    // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d\w)?)\s+build/i,    // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+)?)\s+build/i      // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)?(?:[\s_]*[\w\s]+)?)\s+build/i          // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu Tablet
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, TABLET]], [

            /android.+a000(1)\s+build/i                                         // OnePlus
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Venue[\d\s]*)\s+build/i                          // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(zte)?.+(k\d{2})\s+build/i                        // ZTE K Series Tablet
            ], [[VENDOR, 'ZTE'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2}x?.*)\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(.+)\s+build/i          // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?.+)\s+build/i                                // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?.+)\s+build/i                         // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_?)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-?)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(.*\b)\s+build/i             // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q.+)\s+build/i                           // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /(android.+)[;\/].+build/i                                          // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]


        /*//////////////////////////
            // TODO: move to string map
            ////////////////////////////

            /(C6603)/i                                                          // Sony Xperia Z C6603
            ], [[MODEL, 'Xperia Z C6603'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [
            /(C6903)/i                                                          // Sony Xperia Z 1
            ], [[MODEL, 'Xperia Z 1'], [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /(SM-G900[F|H])/i                                                   // Samsung Galaxy S5
            ], [[MODEL, 'Galaxy S5'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G7102)/i                                                       // Samsung Galaxy Grand 2
            ], [[MODEL, 'Galaxy Grand 2'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G530H)/i                                                       // Samsung Galaxy Grand Prime
            ], [[MODEL, 'Galaxy Grand Prime'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-G313HZ)/i                                                      // Samsung Galaxy V
            ], [[MODEL, 'Galaxy V'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T805)/i                                                        // Samsung Galaxy Tab S 10.5
            ], [[MODEL, 'Galaxy Tab S 10.5'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [
            /(SM-G800F)/i                                                       // Samsung Galaxy S5 Mini
            ], [[MODEL, 'Galaxy S5 Mini'], [VENDOR, 'Samsung'], [TYPE, MOBILE]], [
            /(SM-T311)/i                                                        // Samsung Galaxy Tab 3 8.0
            ], [[MODEL, 'Galaxy Tab 3 8.0'], [VENDOR, 'Samsung'], [TYPE, TABLET]], [

            /(T3C)/i                                                            // Advan Vandroid T3C
            ], [MODEL, [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN T1J\+)/i                                                    // Advan Vandroid T1J+
            ], [[MODEL, 'Vandroid T1J+'], [VENDOR, 'Advan'], [TYPE, TABLET]], [
            /(ADVAN S4A)/i                                                      // Advan Vandroid S4A
            ], [[MODEL, 'Vandroid S4A'], [VENDOR, 'Advan'], [TYPE, MOBILE]], [

            /(V972M)/i                                                          // ZTE V972M
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [

            /(i-mobile)\s(IQ\s[\d\.]+)/i                                        // i-mobile IQ
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(IQ6.3)/i                                                          // i-mobile IQ IQ 6.3
            ], [[MODEL, 'IQ 6.3'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [
            /(i-mobile)\s(i-style\s[\d\.]+)/i                                   // i-mobile i-STYLE
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /(i-STYLE2.1)/i                                                     // i-mobile i-STYLE 2.1
            ], [[MODEL, 'i-STYLE 2.1'], [VENDOR, 'i-mobile'], [TYPE, MOBILE]], [

            /(mobiistar touch LAI 512)/i                                        // mobiistar touch LAI 512
            ], [[MODEL, 'Touch LAI 512'], [VENDOR, 'mobiistar'], [TYPE, MOBILE]], [

            /////////////
            // END TODO
            ///////////*/

        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,     // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]+).*(gecko)/i                                           // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s]+\w)*/i,                  // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]+)*/i,                                    // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]+)*/i,
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki
            /linux;.+(sailfish);/i                                              // Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i                 // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w+)*/i,                                           // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]+)*/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]+)*/i,                                       // Hurd/Linux
            /(gnu)\s?([\w\.]+)*/i                                               // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.]+\d)*/i                                           // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i                   // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                  // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]+(?:.*os\s([\w]+)\slike\smac|;\sopera)/i                 // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]+\w)*/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]+)*/i,                            // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i,                               // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS
            /(unix)\s?([\w\.]+)*/i                                              // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    /*
    var Browser = function (name, version) {
        this[NAME] = name;
        this[VERSION] = version;
    };
    var CPU = function (arch) {
        this[ARCHITECTURE] = arch;
    };
    var Device = function (vendor, model, type) {
        this[VENDOR] = vendor;
        this[MODEL] = model;
        this[TYPE] = type;
    };
    var Engine = Browser;
    var OS = Browser;
    */
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
        //var browser = new Browser();
        //var cpu = new CPU();
        //var device = new Device();
        //var engine = new Engine();
        //var os = new OS();

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            //browser = new Browser();
            //cpu = new CPU();
            //device = new Device();
            //engine = new Engine();
            //os = new OS();
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };
    //UAParser.Utils = util;

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        // TODO: test!!!!!!!!
        /*
        if (require && require.main === module && process) {
            // cli
            var jsonize = function (arr) {
                var res = [];
                for (var i in arr) {
                    res.push(new UAParser(arr[i]).getResult());
                }
                process.stdout.write(JSON.stringify(res, null, 2) + '\n');
            };
            if (process.stdin.isTTY) {
                // via args
                jsonize(process.argv.slice(2));
            } else {
                // via pipe
                var str = '';
                process.stdin.on('readable', function() {
                    var read = process.stdin.read();
                    if (read !== null) {
                        str += read;
                    }
                });
                process.stdin.on('end', function () {
                    jsonize(str.replace(/\n$/, '').split('\n'));
                });
            }
        }
        */
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if ("function" === FUNC_TYPE && __webpack_require__(65)) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
                return UAParser;
            }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 65 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DialogBase = __webpack_require__(433);

var _DialogBase2 = _interopRequireDefault(_DialogBase);

var _ErrorDialogBase = __webpack_require__(438);

var _ErrorDialogBase2 = _interopRequireDefault(_ErrorDialogBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    DialogBase: _DialogBase2.default,
    ErrorDialogBase: _ErrorDialogBase2.default
  },

  data: function data() {
    return {};
  },


  computed: {
    $dialog: function $dialog() {
      return this.$refs.base.$refs.dialog;
    }
  },

  methods: {
    show: function show() {
      return this.$dialog.show();
    },
    hide: function hide() {
      return this.$dialog.hide();
    },
    toggle: function toggle() {
      return this.$dialog.toggle();
    }
  }
};

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(230);

/***/ }),
/* 80 */
/***/ (function(module, exports) {

exports.defaults = {};

exports.set = function(name, value, options) {
  // Retrieve options and defaults
  var opts = options || {};
  var defaults = exports.defaults;

  // Apply default value for unspecified options
  var expires  = opts.expires  || defaults.expires;
  var domain   = opts.domain   || defaults.domain;
  var path     = opts.path     !== undefined ? opts.path     : (defaults.path !== undefined ? defaults.path : '/');
  var secure   = opts.secure   !== undefined ? opts.secure   : defaults.secure;
  var httponly = opts.httponly !== undefined ? opts.httponly : defaults.httponly;
  var samesite = opts.samesite !== undefined ? opts.samesite : defaults.samesite;

  // Determine cookie expiration date
  // If succesful the result will be a valid Date, otherwise it will be an invalid Date or false(ish)
  var expDate = expires ? new Date(
      // in case expires is an integer, it should specify the number of days till the cookie expires
      typeof expires === 'number' ? new Date().getTime() + (expires * 864e5) :
      // else expires should be either a Date object or in a format recognized by Date.parse()
      expires
  ) : 0;

  // Set cookie
  document.cookie = name.replace(/[^+#$&^`|]/g, encodeURIComponent)                // Encode cookie name
  .replace('(', '%28')
  .replace(')', '%29') +
  '=' + value.replace(/[^+#$&/:<-\[\]-}]/g, encodeURIComponent) +                  // Encode cookie value (RFC6265)
  (expDate && expDate.getTime() >= 0 ? ';expires=' + expDate.toUTCString() : '') + // Add expiration date
  (domain   ? ';domain=' + domain     : '') +                                      // Add domain
  (path     ? ';path='   + path       : '') +                                      // Add path
  (secure   ? ';secure'               : '') +                                      // Add secure option
  (httponly ? ';httponly'             : '') +                                      // Add httponly option
  (samesite ? ';samesite=' + samesite : '');                                       // Add samesite option
};

exports.get = function(name) {
  var cookies = document.cookie.split(';');
  
  // Iterate all cookies
  while(cookies.length) {
    var cookie = cookies.pop();

    // Determine separator index ("name=value")
    var separatorIndex = cookie.indexOf('=');

    // IE<11 emits the equal sign when the cookie value is empty
    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));

    // Return cookie value if the name matches
    if (cookie_name === name) {
      return decodeURIComponent(cookie.slice(separatorIndex + 1));
    }
  }

  // Return `null` as the cookie was not found
  return null;
};

exports.erase = function(name, options) {
  exports.set(name, '', {
    expires:  -1,
    domain:   options && options.domain,
    path:     options && options.path,
    secure:   0,
    httponly: 0}
  );
};

exports.all = function() {
  var all = {};
  var cookies = document.cookie.split(';');

  // Iterate all cookies
  while(cookies.length) {
    var cookie = cookies.pop();

    // Determine separator index ("name=value")
    var separatorIndex = cookie.indexOf('=');

    // IE<11 emits the equal sign when the cookie value is empty
    separatorIndex = separatorIndex < 0 ? cookie.length : separatorIndex;

    // add the cookie name and value to the `all` object
    var cookie_name = decodeURIComponent(cookie.slice(0, separatorIndex).replace(/^\s+/, ''));
    all[cookie_name] = decodeURIComponent(cookie.slice(separatorIndex + 1));
  }

  return all;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Device = __webpack_require__(98);

var _Device2 = _interopRequireDefault(_Device);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Device2.default;

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(23);
var normalizeHeaderName = __webpack_require__(233);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(157);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(157);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractSegment2 = __webpack_require__(57);

var _AbstractSegment3 = _interopRequireDefault(_AbstractSegment2);

var _ua = __webpack_require__(171);

var _ua2 = _interopRequireDefault(_ua);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEVICE_DEFINE = {
  pc: 1, // desktop or tablet
  sp: 2 // phone
};

var UA_DEVICE_TYPE = _ua2.default.device.type === 'mobile' ? 'sp' : 'pc';
var DEFAULT_UID = randobet(32);
var DEFAULT_TYPE = DEVICE_DEFINE[UA_DEVICE_TYPE];

var defaults = {
  uid: DEFAULT_UID,
  type: DEFAULT_TYPE
};

var UserType = function (_AbstractSegment) {
  _inherits(UserType, _AbstractSegment);

  /**
   * constructor
   */
  function UserType(context) {
    _classCallCheck(this, UserType);

    var _this = _possibleConstructorReturn(this, (UserType.__proto__ || Object.getPrototypeOf(UserType)).call(this, context));

    _this.name = 'device';

    _this.initData();
    return _this;
  }

  _createClass(UserType, [{
    key: 'initData',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.context.ready();

              case 2:
                this.set();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initData() {
        return _ref.apply(this, arguments);
      }

      return initData;
    }()

    /**
     * get
     */

  }, {
    key: 'get',
    value: function get() {
      var defaultValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaults;

      var _data = this._get();
      var data = void 0;

      try {
        data = JSON.parse(_data);
        data = Object.assign(defaults, data);
      } catch (e) {
        data = defaults;
      }

      // デバイス種別は更新する
      data.type = DEFAULT_TYPE;
      return data;
    }

    /**
     * set
     */

  }, {
    key: 'set',
    value: function set() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var current = this.get();
      var storeData = Object.assign({}, current, data);
      this._set(JSON.stringify(storeData));
    }
  }]);

  return UserType;
}(_AbstractSegment3.default);

// ランダムな文字列を取得


exports.default = UserType;
function randobet(n) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var a = 'abcdefghijklmnopqrstuvwxyz' + 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + '0123456789' + b;

  a = a.split('');

  var s = '';

  for (var i = 0; i < n; i++) {
    s += a[Math.floor(Math.random() * a.length)];
  }

  return s;
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
* FUNCTION: isArray( value )
*	Validates if a value is an array.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is an array
*/
function isArray( value ) {
	return Object.prototype.toString.call( value ) === '[object Array]';
} // end FUNCTION isArray()

// EXPORTS //

module.exports = Array.isArray || isArray;


/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    'production' !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          'production' !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  'production' !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["default"] = (VueRouter);


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);
var settle = __webpack_require__(234);
var buildURL = __webpack_require__(236);
var parseHeaders = __webpack_require__(237);
var isURLSameOrigin = __webpack_require__(238);
var createError = __webpack_require__(158);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(239);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ('production' !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(240);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(235);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buttons = __webpack_require__(249);

var _buttons2 = _interopRequireDefault(_buttons);

var _textFields = __webpack_require__(264);

var _textFields2 = _interopRequireDefault(_textFields);

var _datepicker = __webpack_require__(267);

var _datepicker2 = _interopRequireDefault(_datepicker);

var _icons = __webpack_require__(273);

var _icons2 = _interopRequireDefault(_icons);

var _tabs = __webpack_require__(277);

var _tabs2 = _interopRequireDefault(_tabs);

var _accordions = __webpack_require__(288);

var _accordions2 = _interopRequireDefault(_accordions);

var _dialogs = __webpack_require__(292);

var _dialogs2 = _interopRequireDefault(_dialogs);

var _paginations = __webpack_require__(308);

var _paginations2 = _interopRequireDefault(_paginations);

var _progresses = __webpack_require__(312);

var _progresses2 = _interopRequireDefault(_progresses);

var _loadings = __webpack_require__(323);

var _loadings2 = _interopRequireDefault(_loadings);

var _downloader = __webpack_require__(339);

var _downloader2 = _interopRequireDefault(_downloader);

var _banners = __webpack_require__(345);

var _banners2 = _interopRequireDefault(_banners);

var _select = __webpack_require__(349);

var _select2 = _interopRequireDefault(_select);

var _transitions = __webpack_require__(353);

var _transitions2 = _interopRequireDefault(_transitions);

var _navigations = __webpack_require__(355);

var _navigations2 = _interopRequireDefault(_navigations);

var _notices = __webpack_require__(376);

var _notices2 = _interopRequireDefault(_notices);

var _statics = __webpack_require__(380);

var _statics2 = _interopRequireDefault(_statics);

var _advanced = __webpack_require__(382);

var _advanced2 = _interopRequireDefault(_advanced);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = Object.assign({}, _buttons2.default, _textFields2.default, _datepicker2.default, _icons2.default, _tabs2.default, _accordions2.default, _dialogs2.default, _paginations2.default, _downloader2.default, _progresses2.default, _loadings2.default, _banners2.default, _select2.default, _transitions2.default, _navigations2.default, _notices2.default, _statics2.default, _advanced2.default);

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserAttributeModel = function () {

  /**
   * constructor
   */
  function UserAttributeModel() {
    _classCallCheck(this, UserAttributeModel);

    // 将来的に動的に取得する事になるかもしれないけど今は固定値
    this.data = [{ id: '1', dispOrder: 2, label: '教員等指導者', category: 'teacher' }, { id: '2', dispOrder: 1, label: '受験生', category: 'student' }, { id: '3', dispOrder: 3, label: '高校１・２年生', category: 'student' }, { id: '4', dispOrder: 4, label: '保護者', category: 'student' }, { id: '5', dispOrder: 5, label: 'その他', category: 'student' }];
  }

  /**
   * find all
   */


  _createClass(UserAttributeModel, [{
    key: 'findAll',
    value: function findAll() {
      return this.data.sort(function (a, b) {
        return a.dispOrder > b.dispOrder ? 1 : -1;
      });
    }

    /**
     * get attribute by id
     */

  }, {
    key: 'getAttributeById',
    value: function getAttributeById(id) {
      return this.data.find(function (attr) {
        return attr.id === id;
      });
    }

    /**
     * get category by id
     */

  }, {
    key: 'getCategoryById',
    value: function getCategoryById(id) {
      var attr = this.getAttributeById(id);
      if (attr) return attr.category;
    }

    /**
     * get label by id
     */

  }, {
    key: 'getLabelById',
    value: function getLabelById(id) {
      var attr = this.getAttributeById(id);
      if (attr) return attr.label;
    }
  }]);

  return UserAttributeModel;
}();

exports.default = UserAttributeModel;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createSimpleFunctional = createSimpleFunctional;
exports.createSimpleTransition = createSimpleTransition;
exports.createJavaScriptTransition = createJavaScriptTransition;
exports.directiveConfig = directiveConfig;
exports.addOnceEventListener = addOnceEventListener;
exports.getObjectValueByPath = getObjectValueByPath;
exports.createRange = createRange;
exports.getZIndex = getZIndex;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
  var name = arguments[2];

  name = name || c.replace(/__/g, '-');

  return {
    name: 'dn-' + name,
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    name: name,

    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};
      if (!Object.isExtensible(context.data.on)) {
        context.data.on = _extends({}, context.data.on);
      }

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = context.props.origin;
        el.style.webkitTransformOrigin = context.props.origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    name: name,

    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

function getZIndex(el) {
  if (!el || el.nodeType !== Node.ELEMENT_NODE) return 0;
  var zi = document.defaultView.getComputedStyle(el).getPropertyValue('z-index');
  if (isNaN(zi)) return getZIndex(el.parentNode);

  return zi;
}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: 'dn-link-group',

  props: {
    type: {
      type: String,
      default: 'list'
    },
    title: {
      type: Boolean,
      default: true
    },
    category: {
      type: String,
      required: true
    },
    group: {
      type: String,
      required: true
    },
    onlyLatestLabel: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    isList: function isList() {
      return this.type === 'list';
    },
    isBlock: function isBlock() {
      return this.type === 'block';
    },
    computedGroup: function computedGroup() {
      return this.$store.getters['navigation/categoryGroup'](this.category, this.group);
    },
    computedLinks: function computedLinks() {
      var group = this.computedGroup;
      if (!group) return [];

      if (this.isList) return group.links;

      var links = group.links.slice();
      links.sort(function (a, b) {
        if (a.created && b.created) {
          if (a.created.timestamp > b.created.timestamp) return -1;
          if (a.created.timestamp < b.created.timestamp) return 1;
          return -1;
        }
        if (a.created) return -1;
        if (b.created) return 1;
        return 0;
      });
      return links;
    },
    updateLabelSeparator: function updateLabelSeparator() {
      return this.isBlock ? '' : ' ';
    }
  },

  render: function render(h) {
    var _this = this;

    var group = this.computedGroup;
    if (!group) return;

    var links = this.computedLinks;
    var label = group.label;

    var $children = [];
    var isBlock = this.isBlock;

    if (label == null && this.group == "investigation") {
      label = '判定を確認して出願する大学を検討する';
      isBlock = false;
    }

    if (this.title) {
      $children.push(h('h3', {
        staticClass: 'dn-link-group__title',
        class: {
          'dn-heading-3': this.isList
        },
        domProps: {
          innerHTML: label + (isBlock ? ' 関連ページ' : '')
        }
      }));
    }

    var $links = links.filter(function (link) {
      return !link.data.groupIndex && link.data.groupIndex !== '';
    }).map(function (link, index) {
      var $update = link.publishState && (!_this.onlyLatestLabel || link.created.latest) ? h('span', {
        staticClass: 'dn-link-group__update-label',
        class: {
          'dn-link-group__update-latest': link.created.latest
        }
      }, link[link.publishState].shortLabel + _this.updateLabelSeparator + (link.publishState === 'created' ? '公開' : '更新')) : null;

      var $icon = h('span', {
        staticClass: 'dn-link-group__icon'
      }, [h('dn-icon', { props: { icon: 'arrow-right' } })]);

      var $label = h('span', {
        staticClass: 'dn-link-group__label',
        domProps: {
          innerHTML: link.label
        }
      });

      var domProps = {
        href: link.href
      };

      if (link.target) {
        domProps.target = link.target;
      }

      var labelWrapChildren = [$icon, $label];
      var linkChildren = void 0;
      if (_this.isList) {
        linkChildren = labelWrapChildren;
      } else {
        linkChildren = [h('span', {
          staticClass: 'dn-link-group__label-wrap'
        }, labelWrapChildren)];
        // $update && linkChildren.push($update);
      }

      var $link = h('a', {
        staticClass: 'dn-link-group__link',
        class: {
          'dn-link-group__link--matched': link.matched
        },
        domProps: domProps
      }, linkChildren);

      var children = [$link];
      // this.isList && $update && children.push($update);

      return h('li', {
        staticClass: 'dn-link-group__item',
        key: index
      }, children);
    });

    $children.push(h('ul', {
      staticClass: 'dn-link-group__links'
    }, $links));

    if (this.$slots.default) {
      $children.push(h('div', {
        staticClass: 'dn-link-group__footer'
      }, this.$slots.default));
    }

    return h('div', {
      staticClass: 'dn-link-group',
      class: _defineProperty({}, 'dn-link-group--' + this.type, true)
    }, $children);
  }
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationTag = __webpack_require__(167);

var _NavigationTag2 = _interopRequireDefault(_NavigationTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'dn-navigation-tags',

  props: {
    link: Object,
    tag: {
      type: String,
      default: 'ul'
    },
    lg: Boolean,
    title: String
  },

  computed: {
    tags: function tags() {
      var link = this.link;

      if (!link) {
        link = this.$store.getters['navigation/matchedLink'];
      }
      return link && link.tags ? link.tags : null;
    },
    childTag: function childTag() {
      return this.tag === 'ul' ? 'li' : 'span';
    }
  },

  render: function render(h) {
    var _this = this;

    var tags = this.tags;

    if (!tags) return;

    var $children = tags.map(function (tag) {
      return h(_NavigationTag2.default, {
        props: {
          tag: _this.childTag,
          lg: _this.lg
        }
      }, tag);
    });

    var $tags = h(this.tag, {
      staticClass: 'dn-navigation-tags'
    }, $children);

    if (!this.title) return $tags;

    return h('dl', {
      staticClass: 'dn-navigation-tags-wrapper'
    }, [h('dt', {
      staticClass: 'dn-navigation-tags-wrapper__ttl'
    }, this.title), h('dd', {
      staticClass: 'dn-navigation-tags-wrapper__body'
    }, $children)]);
  }
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: 'dn-navigation-tag',

  props: {
    tag: {
      type: String,
      default: 'span'
    },
    color: {
      type: String,
      default: 'default'
    },
    lg: Boolean
  },

  computed: {
    label: function label() {
      var slots = this.$slots.default;
      var text = slots && slots[0] && slots[0].text || '';
      var length = text.length;
      var created = text.split('').join('<i class="dn-navigation-tag__spacer"></i>');
      return {
        text: text,
        created: created,
        length: length
      };
    }
  },

  render: function render(h) {
    var _class;

    var label = this.label;

    return h(this.tag, {
      staticClass: 'dn-navigation-tag',
      class: (_class = {}, _defineProperty(_class, 'dn-navigation-tag--' + this.color, true), _defineProperty(_class, 'dn-navigation-tag--length-' + label.length, true), _defineProperty(_class, 'dn-navigation-tag--lg', this.lg), _class),
      domProps: {
        innerHTML: label.created
      }
    });
  }
};

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arraySplitter = __webpack_require__(383);

var _arraySplitter2 = _interopRequireDefault(_arraySplitter);

var _snake2camel = __webpack_require__(384);

var _snake2camel2 = _interopRequireDefault(_snake2camel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var helpers = {
  arraySplitter: _arraySplitter2.default,
  snake2camel: _snake2camel2.default,
  firstUpper: function firstUpper(str) {
    if (typeof str === 'number') str = String(str);
    str = typeof str === 'string' ? str : '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  cloneJson: function cloneJson(data) {
    return JSON.parse(JSON.stringify(data));
  }
};

exports.default = helpers;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(170);

var _vuex2 = _interopRequireDefault(_vuex);

var _ua = __webpack_require__(394);

var _ua2 = _interopRequireDefault(_ua);

var _path = __webpack_require__(395);

var _path2 = _interopRequireDefault(_path);

var _config = __webpack_require__(396);

var _config2 = _interopRequireDefault(_config);

var _navigation = __webpack_require__(400);

var _navigation2 = _interopRequireDefault(_navigation);

var _links = __webpack_require__(401);

var _links2 = _interopRequireDefault(_links);

var _status = __webpack_require__(402);

var _status2 = _interopRequireDefault(_status);

var _notices = __webpack_require__(403);

var _notices2 = _interopRequireDefault(_notices);

var _mq = __webpack_require__(404);

var _mq2 = _interopRequireDefault(_mq);

var _ls = __webpack_require__(409);

var _ls2 = _interopRequireDefault(_ls);

var _factory = __webpack_require__(174);

var _factory2 = _interopRequireDefault(_factory);

var _browser = __webpack_require__(415);

var _browser2 = _interopRequireDefault(_browser);

var _segments = __webpack_require__(416);

var _segments2 = _interopRequireDefault(_segments);

var _selfcheck = __webpack_require__(422);

var _selfcheck2 = _interopRequireDefault(_selfcheck);

var _selfcheckFactory = __webpack_require__(177);

var _selfcheckFactory2 = _interopRequireDefault(_selfcheckFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

_vue2.default.use(_vuex2.default);

var registerdModuleNames = [];

var store = new _vuex2.default.Store({
  strict: false,

  state: {
    registerdNamedLs: []
  },

  modules: {
    ua: _ua2.default,
    path: _path2.default,
    config: _config2.default,
    navigation: _navigation2.default,
    links: _links2.default,
    status: _status2.default,
    notices: _notices2.default,
    mq: _mq2.default,
    ls: _ls2.default,
    browser: _browser2.default,
    segments: _segments2.default,
    selfcheck: _selfcheck2.default
  },

  getters: {
    registerdNamedLs: function registerdNamedLs(state) {
      return state.registerdNamedLs;
    }
  },

  actions: {
    useLsByPrefix: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2, prefix) {
        var commit = _ref2.commit,
            dispatch = _ref2.dispatch,
            rootGetters = _ref2.rootGetters;
        var moduleName;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(prefix === rootGetters['config/year'])) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                moduleName = 'ls-' + prefix;

                if (!registerdModuleNames.includes(moduleName)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                registerdModuleNames.push(moduleName);
                store.registerModule(moduleName, (0, _factory2.default)(prefix));
                _context.next = 9;
                return dispatch(moduleName + '/init');

              case 9:
                commit('pushRegisterdNamedLs', prefix);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function useLsByPrefix(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }(),

    loadSelfcheck: function loadSelfcheck(_ref3) {
      var getters = _ref3.getters,
          dispatch = _ref3.dispatch;
      var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getters['config/year'];

      var moduleName = 'selfcheck-' + year;
      if (registerdModuleNames.includes(moduleName)) return;
      registerdModuleNames.push(moduleName);
      store.registerModule(moduleName, (0, _selfcheckFactory2.default)(year));
      return dispatch(moduleName + '/load');
    }
  },

  mutations: {
    pushRegisterdNamedLs: function pushRegisterdNamedLs(state, prefix) {
      if (!state.registerdNamedLs.includes(prefix)) state.registerdNamedLs.push(prefix);
    }
  }
});

store.dispatch('config/load');
store.dispatch('links/load');
store.dispatch('navigation/load');
store.dispatch('status/load');
store.dispatch('notices/load');
store.dispatch('mq/start');
store.dispatch('ls/init');
store.dispatch('browser/init');

exports.default = store;

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Store", function() { return Store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapState", function() { return mapState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapMutations", function() { return mapMutations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapGetters", function() { return mapGetters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapActions", function() { return mapActions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createNamespacedHelpers", function() { return createNamespacedHelpers; });
/**
 * vuex v2.5.0
 * (c) 2017 Evan You
 * @license MIT
 */
var applyMixin = function (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
};

var devtoolHook =
  typeof window !== 'undefined' &&
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */


/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  this._children = Object.create(null);
  this._rawModule = rawModule;
  var rawState = rawModule.state;
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors$1 = { namespaced: { configurable: true } };

prototypeAccessors$1.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors$1 );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if (false) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  if (!parent.getChild(key).runtime) { return }

  parent.removeChild(key);
};

function update (path, targetModule, newModule) {
  if (false) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if (false) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if (false) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "Store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  var state = options.state; if ( state === void 0 ) state = {};
  if (typeof state === 'function') {
    state = state() || {};
  }

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  if (Vue.config.devtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors = { state: { configurable: true } };

prototypeAccessors.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors.state.set = function (v) {
  if (false) {
    assert(false, "Use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });
  this._subscribers.forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if (false) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  this._actionSubscribers.forEach(function (sub) { return sub(action, this$1.state); });

  return entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload)
};

Store.prototype.subscribe = function subscribe (fn) {
  return genericSubscribe(fn, this._subscribers)
};

Store.prototype.subscribeAction = function subscribeAction (fn) {
  return genericSubscribe(fn, this._actionSubscribers)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if (false) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if (false) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors );

function genericSubscribe (fn, subs) {
  if (subs.indexOf(fn) < 0) {
    subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    computed[key] = function () { return fn(store); };
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  var gettersProxy = {};

  var splitPos = namespace.length;
  Object.keys(store.getters).forEach(function (type) {
    // skip if the target getter is not match this namespace
    if (type.slice(0, splitPos) !== namespace) { return }

    // extract local getter type
    var localType = type.slice(splitPos);

    // Add a port to the getters proxy.
    // Define as getter property because
    // we do not want to evaluate the getters in this time.
    Object.defineProperty(gettersProxy, localType, {
      get: function () { return store.getters[type]; },
      enumerable: true
    });
  });

  return gettersProxy
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload, cb) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload, cb);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if (false) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if (false) {
      assert(store._committing, "Do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.length
    ? path.reduce(function (state, key) { return state[key]; }, state)
    : state
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if (false) {
    assert(typeof type === 'string', ("Expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if (false) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

function normalizeMap (map) {
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

var index_esm = {
  Store: Store,
  install: install,
  version: '2.5.0',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers
};


/* harmony default export */ __webpack_exports__["default"] = (index_esm);


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _uaParserJs = __webpack_require__(64);

var _uaParserJs2 = _interopRequireDefault(_uaParserJs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _uaParserJs2.default)();

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.htmlGetter = htmlGetter;
exports.linkParser = linkParser;
exports.getRoundedHref = getRoundedHref;
exports.parseDateString = parseDateString;
function htmlGetter($el) {
  return ($el.html() || '').replace(/ dn-([a-zA-Z]+)=/g, ' $1=');
}

var incrementForLinkId = 0;

function linkParser($link, groupId) {
  var data = $link.data();
  return {
    _uid: ++incrementForLinkId,
    url_id: $link.attr('url_id'),
    href: $link.attr('href'),
    target: $link.attr('target'),
    auth: $link.attr('auth') !== undefined,
    className: $link.attr('class'),
    label: htmlGetter($link),
    data: data,
    tags: data.tag ? data.tag.split(',') : [],
    groupId: groupId
  };
}

function getRoundedHref(href) {
  return href.split('#')[0].split('?')[0].replace(/\/index\.html$/, '');
}

function parseDateString(str) {
  var dt = new Date(str.replace(/-/g, '/'));
  var year = dt.getFullYear();
  var month = dt.getMonth();
  var day = dt.getDate();
  var hours = dt.getHours();
  var minutes = dt.getMinutes();

  var shortLabel = month + 1 + '/' + day;

  return {
    year: year,
    month: month,
    day: day,
    hours: hours,
    minutes: minutes,
    shortLabel: shortLabel,
    fullLabel: year + '/' + shortLabel,
    timestamp: dt.getTime()
  };
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ddMatchMedia = __webpack_require__(405);

var _ddMatchMedia2 = _interopRequireDefault(_ddMatchMedia);

var _mediaQuerySettings = __webpack_require__(406);

var _mediaQuerySettings2 = _interopRequireDefault(_mediaQuerySettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchMedia = new _ddMatchMedia2.default(_mediaQuerySettings2.default);

exports.default = matchMedia;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _windowManager = __webpack_require__(175);

var _windowManager2 = _interopRequireDefault(_windowManager);

var _util = __webpack_require__(411);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.$ls = $.jStorage;

function factory(_prefix) {
  var LS_PREFIX = _prefix + '_';
  var EVENT_TAG = 'dn-ls-' + _prefix;

  var watching = false;
  var restoreCancelTimerId = null;

  return {
    namespaced: true,

    state: {},

    getters: {
      prefix: function prefix(state) {
        return _prefix;
      },
      at: function at(state, getters) {
        return function (keyMap, defaultValue) {
          return (0, _util.deepGetState)(state, keyMap, defaultValue);
        };
      },
      keys: function keys(state) {
        return Object.keys(state);
      },
      all: function all(state) {
        var data = {};
        for (var key in state) {
          data[key] = state[key];
        }
        return data;
      },
      selfcheckSubject: function selfcheckSubject(state) {
        return function (id) {
          return state['selfcheck-subject-' + id];
        };
      }
    },

    actions: {
      init: function init(_ref) {
        var commit = _ref.commit,
            dispatch = _ref.dispatch;

        commit('restore', { force: true });
        restoreCancelTimerId = setTimeout(function () {
          restoreCancelTimerId = null;
        }, 500);
        dispatch('startWatch');
      },

      startWatch: function startWatch(_ref2) {
        var commit = _ref2.commit;

        if (watching) return;
        watching = true;
        _windowManager2.default.on('show.' + EVENT_TAG, function () {
          commit('restore');
        });
      },

      stopWatch: function stopWatch(_ref3) {
        var commit = _ref3.commit;

        if (!watching) return;
        watching = false;
        _windowManager2.default.off('.' + EVENT_TAG);
      },

      set: function set(_ref4, _ref5) {
        var commit = _ref4.commit;
        var keyMap = _ref5.keyMap,
            value = _ref5.value;

        commit('set', { keyMap: keyMap, value: value });
      },

      setSelfcheckSubject: function setSelfcheckSubject(_ref6, _ref7) {
        var commit = _ref6.commit,
            dispatch = _ref6.dispatch;
        var id = _ref7.id,
            data = _ref7.data;

        return dispatch('set', { keyMap: 'selfcheck-subject-' + id, value: data });
      },

      delete: function _delete(_ref8, keyMap) {
        var commit = _ref8.commit,
            dispatch = _ref8.dispatch,
            getters = _ref8.getters;

        if (getters['at'](keyMap, undefined) === undefined) return;
        return dispatch('set', { keyMap: keyMap, value: undefined });
      },

      deleteKeys: function deleteKeys(_ref9, keyMaps) {
        var commit = _ref9.commit,
            dispatch = _ref9.dispatch,
            getters = _ref9.getters;

        var targetKeys = keyMaps.filter(function (keyMap) {
          return getters['at'](keyMap, undefined) !== undefined;
        });
        commit('deleteKeys', targetKeys);
      },

      deleteAll: function deleteAll(_ref10) {
        var commit = _ref10.commit,
            dispatch = _ref10.dispatch,
            getters = _ref10.getters;

        var keys = getters['keys'];
        commit('deleteKeys', keys);
      },
      deleteSelfcheckSubject: function deleteSelfcheckSubject(_ref11, id) {
        var dispatch = _ref11.dispatch;

        return dispatch('delete', 'selfcheck-subject-' + id);
      }
    },

    mutations: {
      deleteKeys: function deleteKeys(state) {
        var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            _vue2.default.delete(state, key);
            $ls.deleteKey(LS_PREFIX + key);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      },

      restore: function restore(state) {
        var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (opt.force || restoreCancelTimerId === null) {
          (0, _util.restore)(state, LS_PREFIX);
        }
      },

      set: function set(state, _ref12) {
        var keyMap = _ref12.keyMap,
            value = _ref12.value;


        // 参照を断ち切るためオブジェクトだったらクローンしておく
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') value = JSON.parse(JSON.stringify(value));
        return (0, _util.deepSetState)(state, keyMap, value, LS_PREFIX);
      }
    }
  };
}
exports.default = factory;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _WindowManager = __webpack_require__(410);

var _WindowManager2 = _interopRequireDefault(_WindowManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _WindowManager2.default();

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = selfCheckDefaults;
function selfCheckDefaults() {
  return {
    type: 'selfcheck',
    selfcheckScore: null,
    directScore: null,
    selected: false,
    selfCheckIsFinished: false,
    inputs: {}
  };
}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = factory;

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _http = __webpack_require__(41);

var _http2 = _interopRequireDefault(_http);

var _selfCheckDefaults = __webpack_require__(176);

var _selfCheckDefaults2 = _interopRequireDefault(_selfCheckDefaults);

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

var _subjectSelectionValidater = __webpack_require__(423);

var _subjectSelectionValidater2 = _interopRequireDefault(_subjectSelectionValidater);

var _parseXml = __webpack_require__(424);

var _parseXml2 = _interopRequireDefault(_parseXml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var ev = {};
new _ddEventManager2.default(ev);

var GROUPABLE_CATEGORIES = [{ targets: ['1', '2'] }];

var FIRST_CHOICE_SUBJECT_SELECTABLE_CATEGORIES = {
  '1_2': {},
  '6': {}
};

// 総合特定算出時、複数科目で合計点をまとめるグループ定義
// グループ内で全ての科目を選択している時のみ丸める
var SCORE_ROUND_GROUPS = {
  // '301': ['301', '311'], // 英語・筆記、リスニング
};

function factory(year) {
  var _this = this;

  return {
    namespaced: true,

    state: {
      year: year,
      loadState: 'pending',
      categories: [],
      subjects: [],
      childSubjects: {}
    },

    getters: {

      // **************************************************
      // settings
      // **************************************************
      year: function year(state) {
        return state.year;
      },
      lsModuleName: function lsModuleName(state, getters, rootState, rootGetters) {
        return getters['year'] === rootGetters['config/year'] ? 'ls' : 'ls-' + getters['year'];
      },
      segmentSync: function segmentSync(state, getters, rootState, rootGetters) {
        return getters['year'] === rootGetters['config/year'];
      },
      isLoading: function isLoading(state) {
        return state.loadState === 'loading';
      },
      isLoaded: function isLoaded(state) {
        return state.loadState === 'loaded';
      },
      isLoadFailid: function isLoadFailid(state) {
        return state.loadState === 'failid';
      },
      dataDirName: function dataDirName(state, getters, rootState, rootGetters) {
        return rootGetters['config/year'] === getters['year'] ? 'center' : 'dn' + getters['year'];
      },
      dataDirPath: function dataDirPath(state, getters, rootState, rootGetters) {
        return rootGetters['path/$join']('resources', 'data/selfcheck/' + getters['dataDirName']);
      },
      subjectsFilePath: function subjectsFilePath(state, getters) {
        return getters['dataDirPath'] + '/subjects.xml';
      },
      selectedSubjects: function selectedSubjects(state, getters, rootState, rootGetters) {
        return getters['subjects'].filter(function (subject) {
          var history = rootGetters[getters['lsModuleName'] + '/selfcheckSubject'](subject.id);
          return !!history && history.selected;
        });
      },

      // **************************************************
      // categories
      // **************************************************
      categories: function categories(state, getters) {
        return state.categories.map(function (category) {
          return Object.assign({}, category, {
            subjects: getters['subjectsByCategoryId'](category.id)
          });
        });
      },

      groupedCategoryById: function groupedCategoryById(state, getters) {
        return function (id) {
          return getters['groupedCategories'].find(function (category) {
            return category.id === id;
          });
        };
      },

      groupedCategories: function groupedCategories(state, getters) {
        var categories = getters['categories'].slice();

        GROUPABLE_CATEGORIES.forEach(function (define) {
          var splicedCategories = [];
          var firstIndex = null;

          define.targets.forEach(function (targetId) {
            var target = categories.find(function (category) {
              return category.id === targetId;
            }),
                index = categories.indexOf(target);

            if (!target) return;

            if (firstIndex === null) firstIndex = index;

            categories.splice(index, 1);
            splicedCategories.push(target);
          });

          var mergedCategory = {
            id: [],
            name: [],
            subjects: []
          };

          splicedCategories.forEach(function (category) {
            mergedCategory.id.push(category.id);
            mergedCategory.name.push(category.name);
            mergedCategory.subjects = mergedCategory.subjects.concat(category.subjects);
          });

          mergedCategory.id = mergedCategory.id.join('_');
          mergedCategory.name = mergedCategory.name.join('・');

          categories.splice(firstIndex, 0, mergedCategory);
        });

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var category = _step.value;

            category.firstChoiceSelectable = FIRST_CHOICE_SUBJECT_SELECTABLE_CATEGORIES[category.id] !== undefined;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return categories;
      },

      subjectsByCategoryId: function subjectsByCategoryId(state, getters) {
        return function (categoryId) {
          return getters['subjects'].filter(function (subject) {
            return subject.categoryId === categoryId;
          });
        };
      },

      // **************************************************
      // subjects
      // **************************************************
      subjects: function subjects(state, getters) {
        return state.subjects.map(function (subject) {
          return Object.assign({}, subject, {
            children: getters['childSubjectsBySubjectId'](subject.id) || []
          });
        });
      },

      selectedSubjectIds: function selectedSubjectIds(state, getters) {
        return getters['selectedSubjects'].map(function (subject) {
          return subject.id;
        });
      },

      childSubjectsBySubjectId: function childSubjectsBySubjectId(state, getters) {
        return function (subjectId) {
          return getters['childSubjects'][subjectId];
        };
      },

      childSubjects: function childSubjects(state, getters) {
        var childSubjects = {};
        for (var subjectId in state.childSubjects) {
          childSubjects[subjectId] = state.childSubjects[subjectId].map(function (child) {
            return Object.assign({}, child);
          });
        }
        return childSubjects;
      },

      subjectsByState: function subjectsByState(state, getters) {
        return function (state) {
          return getters['subjects'].filter(function (subject) {
            var history = getters['subjectHistory'](subject.id);
            return history.state === state;
          });
        };
      },

      fixedSubjects: function fixedSubjects(state, getters) {
        return getters['subjectsByState']('fixed');
      },
      indeterminateSubjects: function indeterminateSubjects(state, getters) {
        return getters['subjectsByState']('indeterminate');
      },

      subjectOrChildById: function subjectOrChildById(state, getters) {
        return function (id) {
          var subjects = getters['subjects'];
          var subject = subjects.find(function (subject) {
            return subject.id === id;
          });
          if (subject) return subject;

          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = subjects[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var s = _step2.value;
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = (s.children || [])[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var c = _step3.value;

                  if (c.id === id) return c;
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        };
      },

      // API送信用のパラメータを取得
      // 合計点数は英語リスニングや、サブ科目にかかわらずそのまま送信
      // 入力情報はサブ科目や直接入力の場合含めない
      subjectInputsApiParams: function subjectInputsApiParams(state, getters) {
        return function (id) {
          var params = {};
          var subject = getters['subjectOrChildById'](id);
          var isParent = !subject.subjectId;
          var history = getters['subjectHistory'](id);
          params['sum_' + id] = history.score;

          if (isParent) {
            if (history.isSelfCheck) {
              var inputs = history.inputs || {};
              for (var key in inputs) {
                var value = inputs[key];
                if (value == 'null') {
                  value = '';
                } else if (value == '-') {
                  value = 'M';
                } else if (value == '±') {
                  value = 'P';
                }
                params[id + '_' + key] = value;
              }
            }
            if (subject.children) {
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = subject.children[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var child = _step4.value;

                  var _history = getters['subjectHistory'](child.id);
                  params['sum_' + child.id] = _history.score;
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          }
          return params;
        };
      },

      subjectSegmentParams: function subjectSegmentParams(state, getters) {
        return function (id) {
          var history = getters['subjectHistory'](id);
          return {
            id: id,
            type: history.type,
            state: history.fixed ? 'fixed' : history.selected ? 'selected' : 'pending',
            direct: history.directScore,
            selfcheck: history.selfcheckScore
          };
        };
      },

      // **************************************************
      // histories
      // **************************************************
      subjectHistory: function subjectHistory(state, getters, rootState, rootGetters) {
        return function (id) {
          var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          var subject = getters['subjectOrChildById'](id);
          var isChild = !!subject.subjectId;
          var advanceParams = opts.advanceParams === undefined ? true : opts.advanceParams;
          var mergeParent = opts.mergeParent === undefined ? true : opts.mergeParent;
          var needMerge = isChild && mergeParent;

          var parentHistory = needMerge ? rootGetters[getters['lsModuleName'] + '/selfcheckSubject'](subject.subjectId) || (0, _selfCheckDefaults2.default)() : null;
          var history = rootGetters[getters['lsModuleName'] + '/selfcheckSubject'](id) || (0, _selfCheckDefaults2.default)();

          if (needMerge) {
            history = Object.assign({}, history, {
              type: parentHistory.type,
              selected: parentHistory.selected,
              selfCheckIsFinished: parentHistory.selfCheckIsFinished
            });
          }

          if (advanceParams) {
            var isSelfCheck = history.type === 'selfcheck';
            var isDirect = history.type === 'direct';
            var score = history[history.type + 'Score'];
            var hasScore = typeof score === 'number';
            var fixed = isSelfCheck ? history.selfCheckIsFinished : hasScore;
            var _state = history.selected ? fixed ? 'fixed' : 'indeterminate' : 'pending';

            history = Object.assign({}, history, {
              isSelfCheck: isSelfCheck,
              isDirect: isDirect,
              score: score,
              hasScore: hasScore,
              fixed: fixed,
              state: _state
            });
          }
          return history;
        };
      },

      groupedCategoryFirstChoice: function groupedCategoryFirstChoice(state, getters, rootState, rootGetters) {
        return function (categoryId) {
          return rootGetters[getters['lsModuleName'] + '/at']('selfcheck-first-choice-' + categoryId) || null;
        };
      },

      totalHistory: function totalHistory(state, getters) {
        var result = { score: null, max: null, per: null, hasScore: false };
        var subjects = getters['subjects'];
        var historyHash = {};
        var subjectsHash = {};

        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = subjects[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var _subject2 = _step5.value;

            var _history2 = getters['subjectHistory'](_subject2.id);
            if (_history2.fixed && _history2.selected) {
              historyHash[_subject2.id] = _history2;
              subjectsHash[_subject2.id] = _subject2;
              result.max += _subject2.max;
              result.score += _history2.score;
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        for (var parentId in SCORE_ROUND_GROUPS) {
          var group = SCORE_ROUND_GROUPS[parentId];

          var allSelected = true;
          var groupTotal = 0;
          var groupMax = 0;

          var _iteratorNormalCompletion6 = true;
          var _didIteratorError6 = false;
          var _iteratorError6 = undefined;

          try {
            for (var _iterator6 = group[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
              var id = _step6.value;

              var subject = subjectsHash[id];
              var history = historyHash[id];

              if (!history) {
                allSelected = false;
                break;
              }

              if (!history.fixed) {
                allSelected = false;
                break;
              }

              groupTotal += history.score;
              groupMax += subject.max;
            }
          } catch (err) {
            _didIteratorError6 = true;
            _iteratorError6 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion6 && _iterator6.return) {
                _iterator6.return();
              }
            } finally {
              if (_didIteratorError6) {
                throw _iteratorError6;
              }
            }
          }

          if (allSelected) {
            var parentSubject = subjectsHash[parentId];
            var parentHistory = historyHash[parentId];
            var roundedTotal = Math.round(groupTotal * parentSubject.max / groupMax);
            result.score += roundedTotal - groupTotal;
            result.max += parentSubject.max - groupMax;
          }
        }

        result.hasScore = result.max > 0;
        result.per = result.hasScore ? result.score / result.max : null;
        return result;
      },

      subjectSelectionErrors: function subjectSelectionErrors() {
        return function (selectedIds) {
          return (0, _subjectSelectionValidater2.default)(selectedIds);
        };
      }
    },

    actions: {
      clearAllHistories: function clearAllHistories(_ref) {
        var getters = _ref.getters,
            dispatch = _ref.dispatch;

        return Promise.all([dispatch('clearFirstChoices'), dispatch('clearSubjectHistories'), dispatch('clearOptions')]);
      },
      clearFirstChoices: function clearFirstChoices(_ref2) {
        var getters = _ref2.getters,
            dispatch = _ref2.dispatch;

        var categories = getters['groupedCategories'];
        var keys = categories.map(function (category) {
          return 'selfcheck-first-choice-' + category.id;
        });
        return dispatch(getters['lsModuleName'] + '/deleteKeys', keys, { root: true });
      },
      clearSubjectHistories: function clearSubjectHistories(_ref3) {
        var getters = _ref3.getters,
            dispatch = _ref3.dispatch;

        var subjects = getters['subjects'];
        if (!subjects.length) return;
        var promiseList = [];
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = subjects[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var subject = _step7.value;

            promiseList.push(dispatch(getters['lsModuleName'] + '/deleteSelfcheckSubject', subject.id, { root: true }));
            if (subject.children) {
              var _iteratorNormalCompletion8 = true;
              var _didIteratorError8 = false;
              var _iteratorError8 = undefined;

              try {
                for (var _iterator8 = subject.children[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                  var child = _step8.value;

                  promiseList.push(dispatch(getters['lsModuleName'] + '/deleteSelfcheckSubject', child.id, { root: true }));
                }
              } catch (err) {
                _didIteratorError8 = true;
                _iteratorError8 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion8 && _iterator8.return) {
                    _iterator8.return();
                  }
                } finally {
                  if (_didIteratorError8) {
                    throw _iteratorError8;
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }

        if (getters['segmentSync']) dn.segments.scores.erase();
        return Promise.all(promiseList);
      },
      clearOptions: function clearOptions(_ref4) {
        var getters = _ref4.getters,
            dispatch = _ref4.dispatch;

        return dispatch(getters['lsModuleName'] + '/delete', 'self_check_attributes', { root: true });
      },
      setSubjectHistory: function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref6, _ref7) {
          var getters = _ref6.getters,
              dispatch = _ref6.dispatch;
          var id = _ref7.id,
              data = _ref7.data,
              syncSelfcheckScore = _ref7.syncSelfcheckScore;
          var currentHistory, newData, segmentSyncParams;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  currentHistory = getters['subjectHistory'](id, { advanceParams: false });
                  newData = Object.assign({}, currentHistory, data);


                  if (syncSelfcheckScore) {
                    if (syncSelfcheckScore === 'force' || typeof newData.directScore !== 'number') {
                      newData.directScore = newData.selfcheckScore;
                    }
                  }

                  _context.next = 5;
                  return dispatch(getters['lsModuleName'] + '/setSelfcheckSubject', { id: id, data: newData }, { root: true });

                case 5:
                  segmentSyncParams = _defineProperty({}, id, getters['subjectSegmentParams'](id));

                  if (getters['segmentSync']) dn.segments.scores.putSubjects(segmentSyncParams);

                case 7:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }));

        return function setSubjectHistory(_x2, _x3) {
          return _ref5.apply(this, arguments);
        };
      }(),

      setGroupedCategoryFirstChoice: function setGroupedCategoryFirstChoice(_ref8, _ref9) {
        var getters = _ref8.getters,
            dispatch = _ref8.dispatch;
        var categoryId = _ref9.categoryId,
            subjectId = _ref9.subjectId;

        return dispatch(getters['lsModuleName'] + '/set', { keyMap: 'selfcheck-first-choice-' + categoryId, value: subjectId }, { root: true });
      },

      syncAllSegment: function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(_ref11) {
          var getters = _ref11.getters,
              dispatch = _ref11.dispatch,
              commit = _ref11.commit;

          var subjects, syncData, _iteratorNormalCompletion9, _didIteratorError9, _iteratorError9, _iterator9, _step9, subject, updateData, promiseList, id;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (getters['segmentSync']) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt('return');

                case 2:
                  _context2.next = 4;
                  return dispatch('segments/ready', null, { root: true });

                case 4:
                  subjects = getters['subjects'];
                  syncData = {};
                  _iteratorNormalCompletion9 = true;
                  _didIteratorError9 = false;
                  _iteratorError9 = undefined;
                  _context2.prev = 9;

                  for (_iterator9 = subjects[Symbol.iterator](); !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
                    subject = _step9.value;

                    syncData[subject.id] = getters['subjectSegmentParams'](subject.id);
                  }

                  _context2.next = 17;
                  break;

                case 13:
                  _context2.prev = 13;
                  _context2.t0 = _context2['catch'](9);
                  _didIteratorError9 = true;
                  _iteratorError9 = _context2.t0;

                case 17:
                  _context2.prev = 17;
                  _context2.prev = 18;

                  if (!_iteratorNormalCompletion9 && _iterator9.return) {
                    _iterator9.return();
                  }

                case 20:
                  _context2.prev = 20;

                  if (!_didIteratorError9) {
                    _context2.next = 23;
                    break;
                  }

                  throw _iteratorError9;

                case 23:
                  return _context2.finish(20);

                case 24:
                  return _context2.finish(17);

                case 25:
                  updateData = dn.segments.scores.syncAndGetUpdateData(syncData);
                  promiseList = [];


                  for (id in updateData) {
                    promiseList.push(dispatch('syncSubjectSegment', { id: id, data: updateData[id] }));
                  }

                  if (!promiseList.length) {
                    _context2.next = 30;
                    break;
                  }

                  return _context2.abrupt('return', Promise.all(promiseList));

                case 30:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this, [[9, 13, 17, 25], [18,, 20, 24]]);
        }));

        return function syncAllSegment(_x4) {
          return _ref10.apply(this, arguments);
        };
      }(),

      syncSubjectSegment: function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref13, _ref14) {
          var getters = _ref13.getters,
              dispatch = _ref13.dispatch,
              commit = _ref13.commit;
          var id = _ref14.id,
              data = _ref14.data;
          var subject, history, storeData;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  subject = getters['subjectOrChildById'](id);

                  if (id) {
                    _context3.next = 4;
                    break;
                  }

                  console.warn('\u30BB\u30B0\u30E1\u30F3\u30C8\u306E\u79D1\u76EE\u5F97\u70B9\u3092\u30ED\u30FC\u30AB\u30EB\u30B9\u30C8\u30EC\u30FC\u30B8\u306B\u540C\u671F\u3057\u3088\u3046\u3068\u3057\u307E\u3057\u305F\u304C\u3001\u79D1\u76EEID\u300C' + id + '\u300D\u306F\u5B9A\u7FA9\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002');
                  return _context3.abrupt('return');

                case 4:
                  history = getters['subjectHistory'](id);
                  storeData = {};


                  if (data.type !== undefined) storeData.type = data.type;
                  if (data.state !== undefined) {
                    if (data.state === 'fixed') {
                      storeData.selected = true;
                      if (history.isSelfCheck) {
                        storeData.selfCheckIsFinished = true;
                      }
                    } else if (data.state === 'selected') {
                      storeData.selected = true;
                    } else if (data.state === 'pending') {
                      storeData.selected = false;
                      if (history.isSelfCheck) {
                        storeData.selfCheckIsFinished = false;
                      }
                    }
                  }

                  if (data.direct !== undefined) storeData.directScore = data.direct;
                  if (data.selfcheckScore !== undefined) storeData.selfcheckScore = data.selfcheck;
                  return _context3.abrupt('return', dispatch('setSubjectHistory', { id: id, data: storeData }));

                case 11:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this);
        }));

        return function syncSubjectSegment(_x5, _x6) {
          return _ref12.apply(this, arguments);
        };
      }(),

      load: function load(_ref15) {
        var getters = _ref15.getters,
            dispatch = _ref15.dispatch,
            commit = _ref15.commit;

        if (getters['isLoaded']) return Promise.resolve();
        return new Promise(function () {
          var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve, reject) {
            var res, categories, childrenIds, _iteratorNormalCompletion10, _didIteratorError10, _iteratorError10, _iterator10, _step10, category, _iteratorNormalCompletion11, _didIteratorError11, _iteratorError11, _iterator11, _step11, subject;

            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    if (!getters['isLoading']) {
                      _context5.next = 3;
                      break;
                    }

                    ev.one('load', resolve);
                    return _context5.abrupt('return');

                  case 3:
                    _context5.next = 5;
                    return dispatch('useLsByPrefix', getters['year'], { root: true });

                  case 5:
                    _context5.prev = 5;

                    commit('setLoadState', 'loading');
                    _context5.next = 9;
                    return _http2.default.get(getters['subjectsFilePath']);

                  case 9:
                    res = _context5.sent;
                    categories = (0, _parseXml2.default)(res.data);
                    childrenIds = [];
                    _iteratorNormalCompletion10 = true;
                    _didIteratorError10 = false;
                    _iteratorError10 = undefined;
                    _context5.prev = 15;
                    _iterator10 = categories[Symbol.iterator]();

                  case 17:
                    if (_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done) {
                      _context5.next = 41;
                      break;
                    }

                    category = _step10.value;
                    _iteratorNormalCompletion11 = true;
                    _didIteratorError11 = false;
                    _iteratorError11 = undefined;
                    _context5.prev = 22;

                    for (_iterator11 = category.subjects[Symbol.iterator](); !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
                      subject = _step11.value;

                      if (subject.childrenId) childrenIds.push({ subjectId: subject.id, childrenId: subject.childrenId });
                    }
                    _context5.next = 30;
                    break;

                  case 26:
                    _context5.prev = 26;
                    _context5.t0 = _context5['catch'](22);
                    _didIteratorError11 = true;
                    _iteratorError11 = _context5.t0;

                  case 30:
                    _context5.prev = 30;
                    _context5.prev = 31;

                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
                      _iterator11.return();
                    }

                  case 33:
                    _context5.prev = 33;

                    if (!_didIteratorError11) {
                      _context5.next = 36;
                      break;
                    }

                    throw _iteratorError11;

                  case 36:
                    return _context5.finish(33);

                  case 37:
                    return _context5.finish(30);

                  case 38:
                    _iteratorNormalCompletion10 = true;
                    _context5.next = 17;
                    break;

                  case 41:
                    _context5.next = 47;
                    break;

                  case 43:
                    _context5.prev = 43;
                    _context5.t1 = _context5['catch'](15);
                    _didIteratorError10 = true;
                    _iteratorError10 = _context5.t1;

                  case 47:
                    _context5.prev = 47;
                    _context5.prev = 48;

                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
                      _iterator10.return();
                    }

                  case 50:
                    _context5.prev = 50;

                    if (!_didIteratorError10) {
                      _context5.next = 53;
                      break;
                    }

                    throw _iteratorError10;

                  case 53:
                    return _context5.finish(50);

                  case 54:
                    return _context5.finish(47);

                  case 55:
                    if (!childrenIds.length) {
                      _context5.next = 58;
                      break;
                    }

                    _context5.next = 58;
                    return Promise.all(childrenIds.map(function () {
                      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref18) {
                        var subjectId = _ref18.subjectId,
                            childrenId = _ref18.childrenId;
                        var res;
                        return regeneratorRuntime.wrap(function _callee4$(_context4) {
                          while (1) {
                            switch (_context4.prev = _context4.next) {
                              case 0:
                                _context4.next = 2;
                                return _http2.default.get(getters['dataDirPath'] + '/' + childrenId + '.xml');

                              case 2:
                                res = _context4.sent;

                                commit('appendChildSubjects', { subjectId: subjectId, xml: res.data });
                                return _context4.abrupt('return', null);

                              case 5:
                              case 'end':
                                return _context4.stop();
                            }
                          }
                        }, _callee4, _this);
                      }));

                      return function (_x9) {
                        return _ref17.apply(this, arguments);
                      };
                    }()));

                  case 58:
                    commit('setCategories', categories);
                    commit('setLoadState', 'loaded');
                    _context5.next = 62;
                    return dispatch('syncAllSegment');

                  case 62:
                    ev.emit('load');
                    resolve();
                    _context5.next = 70;
                    break;

                  case 66:
                    _context5.prev = 66;
                    _context5.t2 = _context5['catch'](5);

                    commit('setLoadState', 'failid');
                    reject(_context5.t2);

                  case 70:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this, [[5, 66], [15, 43, 47, 55], [22, 26, 30, 38], [31,, 33, 37], [48,, 50, 54]]);
          }));

          return function (_x7, _x8) {
            return _ref16.apply(this, arguments);
          };
        }());
      }
    },

    mutations: {

      setLoadState: function setLoadState(state, loadState) {
        state.loadState = loadState;
      },

      setCategories: function setCategories(state, _categories) {
        _categories = _categories.filter(function (category) {
          if (!category.open) return false;
          category.subjects = category.subjects.filter(function (subject) {
            return subject.open;
          });
          return category.open && !!category.subjects.length;
        });

        var categories = [],
            subjects = [];
        var _iteratorNormalCompletion12 = true;
        var _didIteratorError12 = false;
        var _iteratorError12 = undefined;

        try {
          for (var _iterator12 = _categories[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
            var _category = _step12.value;

            var category = {
              id: _category.id,
              name: _category.name
            };

            var _iteratorNormalCompletion13 = true;
            var _didIteratorError13 = false;
            var _iteratorError13 = undefined;

            try {
              for (var _iterator13 = _category.subjects[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
                var _subject = _step13.value;

                subjects.push({
                  id: _subject.id,
                  categoryId: _category.id,
                  name: _subject.name,
                  max: _subject.max
                });
              }
            } catch (err) {
              _didIteratorError13 = true;
              _iteratorError13 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion13 && _iterator13.return) {
                  _iterator13.return();
                }
              } finally {
                if (_didIteratorError13) {
                  throw _iteratorError13;
                }
              }
            }

            categories.push(category);
          }
        } catch (err) {
          _didIteratorError12 = true;
          _iteratorError12 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion12 && _iterator12.return) {
              _iterator12.return();
            }
          } finally {
            if (_didIteratorError12) {
              throw _iteratorError12;
            }
          }
        }

        _vue2.default.set(state, 'categories', categories);
        _vue2.default.set(state, 'subjects', subjects);
      },

      appendChildSubjects: function appendChildSubjects(state, _ref19) {
        var subjectId = _ref19.subjectId,
            xml = _ref19.xml;

        var children = [];
        var $children = $(xml).find('kamoku');

        $children.each(function () {
          var $child = $(this);
          var $parts = $child.find('item');

          var child = {
            id: $child.find('id').text(),
            subjectId: subjectId,
            name: $child.find('name').text(),
            max: parseInt($child.find('max_score').text(), 10),
            parts: []
          };

          $parts.each(function () {
            child.parts.push(parseInt($(this).text(), 10));
          });

          children.push(child);
        });

        _vue2.default.set(state.childSubjects, subjectId, children);
      }
    }
  };
}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(453)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(456),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4145e57e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(457)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(460),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d242a16",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Core = function Core(moduleName) {
  _classCallCheck(this, Core);

  this.moduleName = moduleName;
  this.path = new Path(this);
  this.PRODUCTION_DOMAIN = 'benesse.ne.jp';
  this.COOKIE_DOMAIN = this.path.getRootDomain(this.PRODUCTION_DOMAIN);
  this.IS_PRODUCTION = this.COOKIE_DOMAIN === this.PRODUCTION_DOMAIN;
  this.IS_DEVELOP = !this.IS_PRODUCTION;
};

exports.default = Core;

var Path = function () {
  _createClass(Path, [{
    key: '_currentScriptPath',
    get: function get() {
      if (document.currentScript) {
        return document.currentScript.src;
      } else {
        var scripts = document.getElementsByTagName('script'),
            script = scripts[scripts.length - 1];

        if (script.src) return script.src;
      }
    }
  }]);

  function Path(context) {
    _classCallCheck(this, Path);

    this.context = context;
    this.currentScriptPath = this._currentScriptPath;
    this.sharedRootPath = window._bcSharedRootPath || this.currentScriptPath.split('?')[0].replace(/\/((?!\/).)+\/((?!\/).)+\.js/, '');
    this.dir = this.join(this.sharedRootPath, this.context.moduleName);
    this.script = this.join(this.moduleDir, this.context.moduleName + '.js');
  }

  _createClass(Path, [{
    key: 'join',
    value: function join() {
      return Array.prototype.join.call(arguments, '/').replace(/\/+/g, '/').replace(/(http:|https:)/, '$1/');
    }
  }, {
    key: 'getRootDomain',
    value: function getRootDomain(baseDomain) {
      var hostname = location.hostname;
      if (hostname.indexOf(baseDomain) !== -1) return baseDomain;
      if (hostname.match(/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/)) return hostname;
      var domain = hostname.replace(/^(((?!\.).)*?\.)/, '');
      return domain;
    }
  }]);

  return Path;
}();

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractSegment2 = __webpack_require__(57);

var _AbstractSegment3 = _interopRequireDefault(_AbstractSegment2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DELIMITER = '_';

var SchoolChoices = function (_AbstractSegment) {
  _inherits(SchoolChoices, _AbstractSegment);

  _createClass(SchoolChoices, [{
    key: 'MAX_REGIST',
    get: function get() {
      return this.config && this.config.maxRegist;
    }

    /**
     * constructor
     */

  }]);

  function SchoolChoices(context) {
    _classCallCheck(this, SchoolChoices);

    var _this = _possibleConstructorReturn(this, (SchoolChoices.__proto__ || Object.getPrototypeOf(SchoolChoices)).call(this, context));

    _this.requireYear = true;
    _this.name = 'school_choices';
    return _this;
  }

  /**
   * find
   */


  _createClass(SchoolChoices, [{
    key: 'find',
    value: function find() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var list = this._getList();
      if (typeof filter === 'function') {
        list = list.filter(filter);
      } else if (filter instanceof RegExp) {
        list = list.filter(function (code) {
          return filter.test(code);
        });
      }
      return list;
    }

    /**
     * validate cord
     */

  }, {
    key: 'validate',
    value: function validate(data) {
      data = typeof data === 'string' ? [data] : data;
      var errors = [];
      data.forEach(function (code) {
        if (code.match(new RegExp(DELIMITER))) {
          errors.push(new Error(code + ' \u306F\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u304C\u6B63\u3057\u304F\u3042\u308A\u307E\u305B\u3093\u3002'));
        }
      });
      return errors.length ? errors : null;
    }

    /**
     * push
     */

  }, {
    key: 'push',
    value: function push(code) {
      var errors = this.validate(code);
      if (errors) return errors;
      var list = this._getList();

      if (this.MAX_REGIST && list.length >= this.MAX_REGIST) {
        return [new RangeError('Has reached the upper limit. (max is ' + this.MAX_REGIST + ')')];
      }

      list.push(code.trim());
      this.setList(list);
    }

    /**
     * 指定の値のリスト上の位置を、指定の位置へ移動する
     */

  }, {
    key: 'move',
    value: function move(code, moveTo) {
      var list = this._getList(),
          index = list.indexOf(code);

      if (index === -1) return;

      if (moveTo === 'up') {
        moveTo = index - 1;
      } else if (moveTo === 'down') {
        moveTo = index + 1;
      }

      if (moveTo < 0 || moveTo >= list.length) return;

      // まず自分を削除
      list.splice(index, 1);

      // で目的の場所へ挿入
      list.splice(moveTo, 0, code);

      this.setList(list);
    }

    /**
     * remove by code
     */

  }, {
    key: 'remove',
    value: function remove(code) {
      var list = this._getList(),
          index = list.indexOf(code);

      if (index === -1) return;

      list.splice(index, 1);
      this.setList(list);
    }

    /**
     * remove by index
     */

  }, {
    key: 'removeIndex',
    value: function removeIndex(index) {
      var list = this._getList();
      list.splice(index, 1);
      this.setList(list);
    }

    /**
     * set list
     */

  }, {
    key: 'setList',
    value: function setList(list) {
      var data = list.join(DELIMITER);
      this._set(data);
    }

    /**
     * get list
     */

  }, {
    key: '_getList',
    value: function _getList() {
      var data = this._get('').trim();
      return data === '' ? [] : data.split(DELIMITER);
    }
  }]);

  return SchoolChoices;
}(_AbstractSegment3.default);

exports.default = SchoolChoices;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractSegment2 = __webpack_require__(57);

var _AbstractSegment3 = _interopRequireDefault(_AbstractSegment2);

var _subjectScores = __webpack_require__(484);

var _subjectScores2 = _interopRequireDefault(_subjectScores);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var subjectDefault = {
  type: 'direct',
  state: 'pending',
  direct: null,
  selfcheck: null
};

var Scores = function (_AbstractSegment) {
  _inherits(Scores, _AbstractSegment);

  function Scores() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Scores);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scores.__proto__ || Object.getPrototypeOf(Scores)).call.apply(_ref, [this].concat(args))), _this), _this.requireYear = true, _this.name = 'scores', _this._perCache = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Scores, [{
    key: 'getTotalPer',


    /**
     * 得点率を取得する
     * 科目の完了状態等を問わず、セグメントに保持されていれば全て加算対象
     */
    value: function getTotalPer() {
      if (this._perCache !== null) return this._perCache;

      var subjects = this.getSubjects();

      var total = 0;
      var totalMax = 0;

      for (var id in subjects) {
        var define = _subjectScores2.default[id];
        if (!define) continue;

        var score = subjects[id][subjects[id].type];
        if (score !== null) {
          total += score;
          totalMax += define.max;
        }
      }

      this._perCache = totalMax === 0 ? 0 : Math.round(total / totalMax * 100);
      return this._perCache;
    }
  }, {
    key: 'onEraseAfter',
    value: function onEraseAfter() {
      this._perCache = null;
    }

    /**
     * 複数の科目情報をcookieに保存する
     */

  }, {
    key: 'putSubjects',
    value: function putSubjects() {
      var subjects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var targets = this.getSubjects();

      for (var id in subjects) {
        if (!_subjectScores2.default[id]) continue;
        var subject = subjects[id];
        var target = targets[id] || Object.assign({ id: id }, subjectDefault);
        targets[id] = Object.assign(target, subject);
      }

      this.storeSubjects(targets);
    }

    /**
     * データを同期して同期完了後のデータを取得する
     *   DNサイトでローカルストレージを更新するため、
     *   もしくはセグメントに未登録のローカルストレージの科目を保存するために利用する
     *
     *   元データの科目IDがセグメントになければ上書き
     *   セグメント側にデータがあった場合には、変更のあったキーのみを返却する
     *   受け取り側には変更のあった科目、キーのみがレスポンスされるので
     *   ローカルストレージに同期を行う
     */

  }, {
    key: 'syncAndGetUpdateData',
    value: function syncAndGetUpdateData(subjects) {
      var targets = this.getSubjects();
      var result = {};

      var needUpdateSegment = false;

      for (var id in subjects) {
        if (!_subjectScores2.default[id]) continue;
        var subject = subjects[id];
        var target = targets[id];

        if (target) {
          var updateValues = {};
          for (var key in target) {
            if (target[key] !== subject[key]) {
              updateValues[key] = target[key];
            }
          }
          if (Object.keys(updateValues).length) result[id] = updateValues;
        } else {
          needUpdateSegment = true;
          targets[id] = Object.assign({}, subject);
        }
      }

      if (needUpdateSegment) this.storeSubjects(targets);
      return result;
    }

    /**
     * 複数の科目情報のハッシュを保存する
     */

  }, {
    key: 'storeSubjects',
    value: function storeSubjects(subjects) {
      this._perCache = null;
      var cookieString = this.jsonToCookieString(subjects);
      this._set(cookieString);
    }

    /**
     * cookie文字列中の全科目情報をjsonで取得する
     */

  }, {
    key: 'getSubjects',
    value: function getSubjects() {
      return this.cookieStringToJson(this._get(''));
    }

    /**
     * 複数の科目情報のハッシュをcookie用文字列にパースして返却する
     */

  }, {
    key: 'jsonToCookieString',
    value: function jsonToCookieString(subjects) {
      var subjectStrings = [];
      for (var id in subjects) {
        subjectStrings.push(this.jsonToSubjectString(subjects[id]));
      }
      return subjectStrings.join(',');
    }

    /**
     * 科目1つ分のjsonをcookie文字列にパースして返却する
     *   【科目ID】_【種別】_【状態】_【点数入力】_【解答入力】
     */

  }, {
    key: 'jsonToSubjectString',
    value: function jsonToSubjectString(subject) {
      var type = this.constructor.getTypeIdByName(subject.type);
      var state = this.constructor.getStateIdByName(subject.state);
      var direct = subject.direct === null ? 'n' : subject.direct;
      var selfcheck = subject.selfcheck === null ? 'n' : subject.selfcheck;

      return subject.id + '_' + type + '_' + state + '_' + direct + '_' + selfcheck;
    }

    /**
     * cookie文字列をjsonにパースして返却する
     */

  }, {
    key: 'cookieStringToJson',
    value: function cookieStringToJson(str) {
      var _this2 = this;

      var subjects = {};

      var subjectStrings = str.split(',');
      subjectStrings = subjectStrings.length === 1 && subjectStrings[0] === '' ? [] : subjectStrings;

      subjectStrings.forEach(function (subjectString) {
        var subject = _this2.subjectStringToJson(subjectString);
        subjects[subject.id] = subject;
      });
      return subjects;
    }

    /**
     * cookie文字列中の科目1つ分の文字列をjsonにパースして返却する
     *   【科目ID】_【種別】_【状態】_【点数入力】_【解答入力】
     */

  }, {
    key: 'subjectStringToJson',
    value: function subjectStringToJson(str) {
      var tmp = str.split('_');
      tmp = tmp.length === 1 && tmp[0] === '' ? [] : tmp;

      if (tmp.length < 5) return;

      var direct = tmp[3] === 'n' ? null : parseInt(tmp[3], 10);
      var selfcheck = tmp[4] === 'n' ? null : parseInt(tmp[4], 10);

      return {
        id: tmp[0],
        type: this.constructor.getTypeNameById(tmp[1]),
        state: this.constructor.getStateNameById(tmp[2]),
        direct: isNaN(direct) ? null : direct,
        selfcheck: isNaN(selfcheck) ? null : selfcheck
      };
    }
  }], [{
    key: 'getStateNameById',
    value: function getStateNameById(id) {
      return this.STATES.find(function (state) {
        return state.id === id;
      }).name;
    }
  }, {
    key: 'getStateIdByName',
    value: function getStateIdByName(name) {
      return this.STATES.find(function (state) {
        return state.name === name;
      }).id;
    }
  }, {
    key: 'getTypeNameById',
    value: function getTypeNameById(id) {
      return this.TYPES.find(function (type) {
        return type.id === id;
      }).name;
    }
  }, {
    key: 'getTypeIdByName',
    value: function getTypeIdByName(name) {
      return this.TYPES.find(function (type) {
        return type.name === name;
      }).id;
    }
  }]);

  return Scores;
}(_AbstractSegment3.default);

Scores.STATES = [{ id: '0', name: 'pending' }, { id: '1', name: 'selected' }, { id: '2', name: 'fixed' }];
Scores.TYPES = [{ id: '0', name: 'direct' }, { id: '1', name: 'selfcheck' }];
exports.default = Scores;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractSegment2 = __webpack_require__(57);

var _AbstractSegment3 = _interopRequireDefault(_AbstractSegment2);

var _UserAttributeModel = __webpack_require__(163);

var _UserAttributeModel2 = _interopRequireDefault(_UserAttributeModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var model = new _UserAttributeModel2.default();
var DEFINE = model.data;

var UserType = function (_AbstractSegment) {
  _inherits(UserType, _AbstractSegment);

  _createClass(UserType, [{
    key: 'model',
    get: function get() {
      return model;
    }
  }, {
    key: 'define',
    get: function get() {
      return DEFINE;
    }

    /**
     * constructor
     */

  }]);

  function UserType(context) {
    _classCallCheck(this, UserType);

    var _this = _possibleConstructorReturn(this, (UserType.__proto__ || Object.getPrototypeOf(UserType)).call(this, context));

    _this.name = 'user_type';
    return _this;
  }

  /**
   * get
   */


  _createClass(UserType, [{
    key: 'get',
    value: function get() {
      var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var id = this._get();
      if (!id) return defaultValue;

      var define = this.getDefineById(id);
      return {
        id: define.id,
        category: define.category,
        label: define.label
      };
    }

    /**
     * get id
     */

  }, {
    key: 'getId',
    value: function getId() {
      var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var id = this._get();
      return id || defaultValue;
    }

    /**
     * get category
     */

  }, {
    key: 'getCategory',
    value: function getCategory() {
      var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var id = this._get();
      if (!id) return defaultValue;
      return this.model.getCategoryById(id);
    }

    /**
     * get label
     */

  }, {
    key: 'getLabel',
    value: function getLabel() {
      var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var id = this._get();
      if (!id) return defaultValue;
      return this.model.getLabelById(id);
    }

    /**
     * get define by id
     */

  }, {
    key: 'getDefineById',
    value: function getDefineById(id) {
      return this.define.find(function (row) {
        return row.id === id;
      });
    }

    /**
     * validate
     */

  }, {
    key: 'validate',
    value: function validate(id) {
      return this.getDefineById(id) ? null : [new Error('\u30E6\u30FC\u30B6\u30FC\u7A2E\u5225 ' + id + ' \u306F\u5B9A\u7FA9\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002')];
    }

    /**
     * set
     */

  }, {
    key: 'set',
    value: function set(id) {
      var errors = this.validate(id);
      if (errors) return errors;
      this._set(id);
    }
  }]);

  return UserType;
}(_AbstractSegment3.default);

exports.default = UserType;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
*
*	VALIDATE: integer-array
*
*
*	DESCRIPTION:
*		- Validates if a value is an integer array.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2015. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2015.
*
*/



// MODULES //

var isArray = __webpack_require__( 99 ),
	isInteger = __webpack_require__( 493 );


// IS INTEGER ARRAY //

/**
* FUNCTION: isIntegerArray( value )
*	Validates if a value is an integer array.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating if a value is an integer array
*/
function isIntegerArray( value ) {
	var len;
	if ( !isArray( value ) ) {
		return false;
	}
	len = value.length;
	if ( !len ) {
		return false;
	}
	for ( var i = 0; i < len; i++ ) {
		if ( !isInteger( value[i] ) ) {
			return false;
		}
	}
	return true;
} // end FUNCTION isIntegerArray()


// EXPORTS //

module.exports = isIntegerArray;


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
*
*	VALIDATE: function
*
*
*	DESCRIPTION:
*		- Validates if a value is a function.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/



/**
* FUNCTION: isFunction( value )
*	Validates if a value is a function.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is a function
*/
function isFunction( value ) {
	return ( typeof value === 'function' );
} // end FUNCTION isFunction()


// EXPORTS //

module.exports = isFunction;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImageManager = function () {

  /**
   * constructor
   */
  function ImageManager() {
    _classCallCheck(this, ImageManager);

    this.caches = {};
  }

  /**
   * to data uri
   */


  _createClass(ImageManager, [{
    key: 'toDataUri',
    value: function toDataUri(src) {
      var cacheKey = encodeURIComponent(src);

      if (this.caches[cacheKey]) return this.caches[cacheKey].promise;

      var cache = {
        src: src,
        dataUri: null
      };

      cache.promise = new Promise(function (resolve, reject) {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var img = document.createElement('img');

        var cleanUp = function cleanUp() {
          canvas = null;
          ctx = null;
          img = null;
        };

        var onDone = function onDone() {
          cleanUp();
          resolve(cache.dataUri);
        };

        var onError = function onError(e) {
          cleanUp();
          reject(e);
        };

        img.onload = function () {
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0);

          try {
            cache.dataUri = canvas.toDataURL('image/png');
          } catch (e) {
            return onError(e);
          }

          return onDone();
        };

        img.onerror = function () {
          onError(new Error('画像が読み込めませんでした'));
        };

        img.src = src;
      });

      this.caches[cacheKey] = cache;
      return cache.promise;
    }
  }]);

  return ImageManager;
}();

exports.default = ImageManager;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var BARRAGE_SAFE_INTERVAL = 500;

exports.default = {
  props: {
    screen: {
      type: [Array, String],
      default: null
    },
    type: {
      type: [Array, String],
      default: null
    },
    firstIndex: {
      type: [Number, String],
      default: 'random'
    },
    size: {
      type: [Object],
      default: null
    },
    forceMq: {
      type: String,
      default: null
    },
    onMq: {
      type: Function,
      default: function _default() {}
    },
    onExist: {
      type: Function,
      default: function _default() {}
    },
    onBeforeDestroy: {
      type: Function,
      default: function _default() {}
    },
    onDestroyed: {
      type: Function,
      default: function _default() {}
    },
    visibilityJudge: {
      type: Number,
      default: 1
    },
    expelFixed: Boolean
  },

  data: function data() {
    return {
      count: 0,
      needs: 1,
      index: null,
      items: [],
      _before: null,
      isPause: false,
      visible: { width: 0, height: 0 },
      barrageSafeTimerId: null,
      clickDisabled: false
    };
  },


  computed: {
    mq: function mq() {
      return this.forceMq || this.$store.getters['banner/mq/current'];
    },
    typeSetting: function typeSetting() {
      return this.$store.getters['banner/config/typeSetting'](this.type);
    },
    rotateInterval: function rotateInterval() {
      var typeSetting = this.typeSetting;
      return typeSetting && typeSetting.interval && typeSetting.interval * 1000 || 5000;
    },
    condition: function condition() {
      var condition = {
        screen: this.screen,
        type: this.type,
        needs: this.needs,
        mq: this.forceMq,
        segments: {
          userCategory: this.$store.getters['banner/segments/userCategory'],
          schools: this.$store.getters['banner/segments/schools'],
          scorePer: this.$store.getters['banner/segments/scorePer']
        }
      };

      ['screen', 'type'].forEach(function (key) {
        if (typeof condition[key] === 'string') {
          condition[key] = condition[key].replace(/\s/g, '').split(',');
        }
      });
      return condition;
    },
    firstIndexIsRandom: function firstIndexIsRandom() {
      return this.firstIndex === 'random';
    },
    isExist: function isExist() {
      return this.count > 0;
    },
    visibleArea: function visibleArea() {
      return this.visible.width * this.visible.height;
    },
    isVisible: function isVisible() {
      return this.visibleArea >= this.visibilityJudge;
    },
    _bcb_uid_: function _bcb_uid_() {
      return 'bc-banner-' + this._uid;
    },
    currentItem: function currentItem() {
      var _this = this;

      return this.items.find(function (item) {
        return item.index === _this.index;
      });
    }
  },

  watch: {
    mq: function mq() {
      if (!this.forceMq) this.onMq(this.mq);
    },
    count: function count() {
      this.onExist(this.isExist);
      if (!this.isExist) {
        this.resetVisible();
      }
    },

    condition: {
      handler: function handler() {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var beforeIsPause;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  beforeIsPause = _this2.isPause;


                  if (!_this2.isPause) _this2.pause();

                  _context.next = 4;
                  return _this2.fetch();

                case 4:

                  requestAnimationFrame(function () {
                    _this2.updateVisible();
                    _this2.judgeVisibilityAndPause();
                  });

                case 5:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2);
        }))();
      },

      deep: true
    },
    index: function index() {
      var _this3 = this;

      if (this.index === null || !this.currentItem) return;

      var item = this.currentItem;

      if (this.isVisible) {
        this.sendViewLog(item);
      } else {
        this.$once('visible', function () {
          _this3.sendViewLog(item);
        });
      }
    }
  },

  methods: {
    resetVisible: function resetVisible() {
      this.visible.width = 0;
      this.visible.height = 0;
    },
    sendLog: function sendLog(type, item) {
      return this.$store.dispatch('banner/data/sendLog', { type: type, item: item });
    },
    sendClickLog: function sendClickLog(item) {
      return this.sendLog('click', item);
    },
    sendViewLog: function sendViewLog(item) {
      return this.sendLog('view', item);
    },
    fetch: function fetch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var items, current;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.$store.getters['banner/data/search'](_this4.condition);

              case 2:
                items = _context3.sent;
                current = JSON.stringify(items);

                if (!(_this4._before === current)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt('return');

              case 6:
                _context3.next = 8;
                return _this4.emitCustomHook('beforeItemsUpdate');

              case 8:

                _this4.count = items.length;
                _this4.index = _this4.count === 0 ? null : _this4.firstIndexIsRandom ? Math.floor(Math.random() * _this4.count) : 0;
                _this4.items = items;
                _this4._before = current;

                _context3.next = 14;
                return new Promise(function (resolve, reject) {
                  _this4.$nextTick(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return _this4.emitCustomHook('afterItemsUpdate');

                          case 2:
                            resolve();

                          case 3:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this4);
                  })));
                });

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    emitCustomHook: function emitCustomHook(name) {
      var _this5 = this;

      return new Promise(function (resolve, reject) {
        _this5.$emit(name);
        if (typeof _this5[name] === 'function') {
          var promise = _this5[name]();
          if (promise && (typeof promise === 'undefined' ? 'undefined' : _typeof(promise)) === 'object' && typeof promise.then === 'function') {
            promise.then(resolve).catch(reject);
          } else {
            resolve(promise);
          }
        }
      });
    },
    clearBarrageSafeTimer: function clearBarrageSafeTimer() {
      if (this.barrageSafeTimerId !== null) {
        clearTimeout(this.barrageSafeTimerId);
        this.barrageSafeTimerId = null;
      }
    },
    onItemClick: function onItemClick(item, e) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var targetIsSelf, url;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!_this6.clickDisabled) {
                  _context4.next = 3;
                  break;
                }

                e.preventDefault();
                return _context4.abrupt('return');

              case 3:
                if (!(_this6.barrageSafeTimerId !== null)) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt('return');

              case 5:
                _this6.barrageSafeTimerId = setTimeout(function () {
                  _this6.clearBarrageSafeTimer();
                }, BARRAGE_SAFE_INTERVAL);

                targetIsSelf = !item.blankWindow || item.blankWindow === '_self';
                url = item['url_' + _this6.mq];


                if (targetIsSelf) e.preventDefault();

                _context4.next = 11;
                return _this6.sendClickLog(item);

              case 11:

                if (targetIsSelf) {
                  location.href = url;
                }

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    updateVisible: function updateVisible() {
      var rect = this.$el.getBoundingClientRect();
      var visible = {
        width: rect.width || 1,
        height: rect.height || 1
      };

      var beforeIsVisible = this.isVisible;

      if (rect.top < 0) {
        visible.height += rect.top;
      }

      if (rect.bottom > this.$window.height) {
        visible.height -= rect.bottom - this.$window.height;
      }

      if (rect.left < 0) {
        visible.width += rect.left;
      }

      if (rect.right > this.$window.width) {
        visible.width -= rect.right - this.$window.width;
      }

      this.visible.width = visible.width;
      this.visible.height = visible.height;

      if (this.isVisible !== beforeIsVisible) {
        this.$emit(this.isVisible ? 'visible' : 'hidden');
        this.$emit('visibilityChange', this.isVisible);

        if (this.expelFixed) {
          this.emitExpelFixedVisibledChangeForRoot(this.isVisible);
        }
      }
    },
    emitExpelFixedVisibledChangeForRoot: function emitExpelFixedVisibledChangeForRoot(visible) {
      this.$root.$emit('expelFixedItemVisibledChange', { _uid: this._uid, visible: visible });
    },
    judgeVisibilityAndPause: function judgeVisibilityAndPause() {
      if (this.$window.isHide) return;
      if (this.isVisible) {
        this.resume();
      } else {
        this.pause();
      }
    },
    startVisibilityListeners: function startVisibilityListeners() {
      var _this7 = this;

      this.updateVisible();

      // IE、EDGEで正しく初期値が取れない事があるのでウェイト
      setTimeout(function () {
        _this7.updateVisible();
      }, 500);

      this.$window.on('resize.' + this._bcb_uid_, function () {
        if (_this7.isPause) return;
        _this7.updateVisible();
      });
      this.$window.on('scrollEnd.' + this._bcb_uid_, function () {
        _this7.updateVisible();
      });
      this.$on('visibilityChange', function (isVisible) {
        _this7.judgeVisibilityAndPause();
      });
      this.judgeVisibilityAndPause();
    },
    stopVisibilityListeners: function stopVisibilityListeners() {
      this.$window.off('resize.' + this._bcb_uid_);
      this.$window.off('scrollEnd.' + this._bcb_uid_);
    },
    startWindowVisibilityListeners: function startWindowVisibilityListeners() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this8.$window.isHide) _this8.pause();
                _context5.next = 3;
                return _this8.$window.ready();

              case 3:
                _this8.$window.on('hide.' + _this8._bcb_uid_, function () {
                  _this8.pause();
                });
                _this8.$window.on('show.' + _this8._bcb_uid_, function () {
                  _this8.resume();
                  _this8.updateVisible();
                });
                _this8.startVisibilityListeners();

              case 6:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this8);
      }))();
    },
    removeWindowListeners: function removeWindowListeners() {
      this.$window.off('.' + this._bcb_uid_);
    },
    pause: function pause() {
      if (this.isPause) return;
      this.isPause = true;
      if (typeof this.pauseAfter === 'function') {
        this.pauseAfter();
      }
    },
    resume: function resume() {
      if (!this.isPause) return;
      this.isPause = false;
      this.startVisibilityListeners();
      if (typeof this.resumeAfter === 'function') {
        this.resumeAfter();
      }
    }
  },

  created: function created() {
    var _this9 = this;

    new _ddEventManager2.default(this);

    return new Promise(function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve, reject) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this9.fetch();
                _context6.next = 3;
                return _this9.$nextTickPromise();

              case 3:
                _context6.next = 5;
                return _this9.startWindowVisibilityListeners();

              case 5:
                _this9.emit('created');

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this9);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }());
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    this.emitExpelFixedVisibledChangeForRoot(false);
    this.removeWindowListeners();
    this.onBeforeDestroy();
    this.clearBarrageSafeTimer();
  },
  destroyed: function destroyed() {
    this.onDestroyed();
  }
};

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(155);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueScrollto = __webpack_require__(229);

var _vueScrollto2 = _interopRequireDefault(_vueScrollto);

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

var _http = __webpack_require__(41);

var _http2 = _interopRequireDefault(_http);

var _bootstrap = __webpack_require__(248);

var _bootstrap2 = _interopRequireDefault(_bootstrap);

var _ui = __webpack_require__(385);

var _ui2 = _interopRequireDefault(_ui);

var _dn = __webpack_require__(392);

var _dn2 = _interopRequireDefault(_dn);

var _store = __webpack_require__(169);

var _store2 = _interopRequireDefault(_store);

var _dnAnalyticsTagLoader = __webpack_require__(478);

var _dnAnalyticsTagLoader2 = _interopRequireDefault(_dnAnalyticsTagLoader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// load bc-shared banner
window._bcSharedRootPath = _store2.default.getters['path/$join']('root', 'bc-shared');
__webpack_require__(479);

_vue2.default.use(_ui2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vueScrollto2.default);

// Set for global
window.Vue = _vue2.default;
window.EventManager = _ddEventManager2.default;
window.$http = _http2.default;
window.dn = new _vue2.default(_dn2.default);
$(_bootstrap2.default);

(0, _dnAnalyticsTagLoader2.default)(dn);

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global['vue-scrollto'] = factory());
}(this, (function () { 'use strict';

/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

function binarySubdivide (aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
   var currentSlope = getSlope(aGuessT, mX1, mX2);
   if (currentSlope === 0.0) {
     return aGuessT;
   }
   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
   aGuessT -= currentX / currentSlope;
 }
 return aGuessT;
}

var index = function bezier (mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing (x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    }
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};

var easings = {
    ease: [0.25, 0.1, 0.25, 1.0],
    linear: [0.00, 0.0, 1.00, 1.0],
    "ease-in": [0.42, 0.0, 1.00, 1.0],
    "ease-out": [0.00, 0.0, 0.58, 1.0],
    "ease-in-out": [0.42, 0.0, 0.58, 1.0]
};

// https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
var supportsPassive = false;
try {
    var opts = Object.defineProperty({}, "passive", {
        get: function get() {
            supportsPassive = true;
        }
    });
    window.addEventListener("test", null, opts);
} catch (e) {}

var _ = {
    $: function $(selector) {
        if (typeof selector !== "string") {
            return selector;
        }
        return document.querySelector(selector);
    },
    on: function on(element, events, handler) {
        var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : { passive: false };

        if (!(events instanceof Array)) {
            events = [events];
        }
        for (var i = 0; i < events.length; i++) {
            element.addEventListener(events[i], handler, supportsPassive ? opts : false);
        }
    },
    off: function off(element, events, handler) {
        if (!(events instanceof Array)) {
            events = [events];
        }
        for (var i = 0; i < events.length; i++) {
            element.removeEventListener(events[i], handler);
        }
    },
    cumulativeOffset: function cumulativeOffset(element) {
        var top = 0;
        var left = 0;

        do {
            top += element.offsetTop || 0;
            left += element.offsetLeft || 0;
            element = element.offsetParent;
        } while (element);

        return {
            top: top,
            left: left
        };
    }
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





















var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var abortEvents = ["mousedown", "wheel", "DOMMouseScroll", "mousewheel", "keyup", "touchmove"];

var defaults$$1 = {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    cancelable: true,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
};

function setDefaults(options) {
    defaults$$1 = _extends({}, defaults$$1, options);
}

var scroller = function scroller() {
    var element = void 0; // element to scroll to
    var container = void 0; // container to scroll
    var duration = void 0; // duration of the scrolling
    var easing = void 0; // easing to be used when scrolling
    var offset = void 0; // offset to be added (subtracted)
    var cancelable = void 0; // indicates if user can cancel the scroll or not.
    var onDone = void 0; // callback when scrolling is done
    var onCancel = void 0; // callback when scrolling is canceled / aborted
    var x = void 0; // scroll on x axis
    var y = void 0; // scroll on y axis

    var initialX = void 0; // initial X of container
    var targetX = void 0; // target X of container
    var initialY = void 0; // initial Y of container
    var targetY = void 0; // target Y of container
    var diffX = void 0; // difference
    var diffY = void 0; // difference

    var abort = void 0; // is scrolling aborted

    var abortEv = void 0; // event that aborted scrolling
    var abortFn = function abortFn(e) {
        if (!cancelable) return;
        abortEv = e;
        abort = true;
    };
    var easingFn = void 0;

    var timeStart = void 0; // time when scrolling started
    var timeElapsed = void 0; // time elapsed since scrolling started

    var progress = void 0; // progress

    function scrollTop(container) {
        var scrollTop = container.scrollTop;

        if (container.tagName.toLowerCase() === "body") {
            // in firefox body.scrollTop always returns 0
            // thus if we are trying to get scrollTop on a body tag
            // we need to get it from the documentElement
            scrollTop = scrollTop || document.documentElement.scrollTop;
        }

        return scrollTop;
    }

    function scrollLeft(container) {
        var scrollLeft = container.scrollLeft;

        if (container.tagName.toLowerCase() === "body") {
            // in firefox body.scrollLeft always returns 0
            // thus if we are trying to get scrollLeft on a body tag
            // we need to get it from the documentElement
            scrollLeft = scrollLeft || document.documentElement.scrollLeft;
        }

        return scrollLeft;
    }

    function step(timestamp) {
        if (abort) return done();
        if (!timeStart) timeStart = timestamp;

        timeElapsed = timestamp - timeStart;

        progress = Math.min(timeElapsed / duration, 1);
        progress = easingFn(progress);

        topLeft(container, initialY + diffY * progress, initialX + diffX * progress);

        timeElapsed < duration ? window.requestAnimationFrame(step) : done();
    }

    function done() {
        if (!abort) topLeft(container, targetY, targetX);
        timeStart = false;

        _.off(container, abortEvents, abortFn);
        if (abort && onCancel) onCancel(abortEv);
        if (!abort && onDone) onDone();
    }

    function topLeft(element, top, left) {
        if (y) element.scrollTop = top;
        if (x) element.scrollLeft = left;
        if (element.tagName.toLowerCase() === "body") {
            // in firefox body.scrollTop doesn't scroll the page
            // thus if we are trying to scrollTop on a body tag
            // we need to scroll on the documentElement
            if (y) document.documentElement.scrollTop = top;
            if (x) document.documentElement.scrollLeft = left;
        }
    }

    function scrollTo(target, _duration) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if ((typeof _duration === "undefined" ? "undefined" : _typeof(_duration)) === "object") {
            options = _duration;
        } else if (typeof _duration === "number") {
            options.duration = _duration;
        }

        element = _.$(target);

        if (!element) {
            return console.warn("[vue-scrollto warn]: Trying to scroll to an element that is not on the page: " + target);
        }

        container = _.$(options.container || defaults$$1.container);
        duration = options.duration || defaults$$1.duration;
        easing = options.easing || defaults$$1.easing;
        offset = options.offset || defaults$$1.offset;
        cancelable = options.hasOwnProperty("cancelable") ? options.cancelable !== false : defaults$$1.cancelable;
        onDone = options.onDone || defaults$$1.onDone;
        onCancel = options.onCancel || defaults$$1.onCancel;
        x = options.x === undefined ? defaults$$1.x : options.x;
        y = options.y === undefined ? defaults$$1.y : options.y;

        var cumulativeOffsetContainer = _.cumulativeOffset(container);
        var cumulativeOffsetElement = _.cumulativeOffset(element);

        if (typeof offset === "function") {
            offset = offset();
        }

        initialY = scrollTop(container);
        targetY = cumulativeOffsetElement.top - cumulativeOffsetContainer.top + offset;

        initialX = scrollLeft(container);
        targetX = cumulativeOffsetElement.left - cumulativeOffsetContainer.left + offset;

        abort = false;

        diffY = targetY - initialY;
        diffX = targetX - initialX;

        if (typeof easing === "string") {
            easing = easings[easing] || easings["ease"];
        }

        easingFn = index.apply(index, easing);

        if (!diffY && !diffX) return;

        _.on(container, abortEvents, abortFn, { passive: true });

        window.requestAnimationFrame(step);

        return function () {
            abortEv = null;
            abort = true;
        };
    }

    return scrollTo;
};

var _scroller = scroller();

var bindings = []; // store binding data

function deleteBinding(el) {
    for (var i = 0; i < bindings.length; ++i) {
        if (bindings[i].el === el) {
            bindings.splice(i, 1);
            return true;
        }
    }
    return false;
}

function findBinding(el) {
    for (var i = 0; i < bindings.length; ++i) {
        if (bindings[i].el === el) {
            return bindings[i];
        }
    }
}

function getBinding(el) {
    var binding = findBinding(el);

    if (binding) {
        return binding;
    }

    bindings.push(binding = {
        el: el,
        binding: {}
    });

    return binding;
}

function handleClick(e) {
    e.preventDefault();
    var ctx = getBinding(this).binding;

    if (typeof ctx.value === "string") {
        return _scroller(ctx.value);
    }
    _scroller(ctx.value.el || ctx.value.element, ctx.value);
}

var VueScrollTo$1 = {
    bind: function bind(el, binding) {
        getBinding(el).binding = binding;
        _.on(el, "click", handleClick);
    },
    unbind: function unbind(el) {
        deleteBinding(el);
        _.off(el, "click", handleClick);
    },
    update: function update(el, binding) {
        getBinding(el).binding = binding;
    },

    scrollTo: _scroller,
    bindings: bindings
};

var install = function install(Vue, options) {
    if (options) setDefaults(options);
    Vue.directive("scroll-to", VueScrollTo$1);
    Vue.prototype.$scrollTo = VueScrollTo$1.scrollTo;
};

if (typeof window !== "undefined" && window.Vue) {
    window.VueScrollTo = VueScrollTo$1;
    window.VueScrollTo.setDefaults = setDefaults;
    Vue.use(install);
}

VueScrollTo$1.install = install;

return VueScrollTo$1;

})));


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);
var bind = __webpack_require__(156);
var Axios = __webpack_require__(232);
var defaults = __webpack_require__(97);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(160);
axios.CancelToken = __webpack_require__(246);
axios.isCancel = __webpack_require__(159);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(247);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 231 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(97);
var utils = __webpack_require__(23);
var InterceptorManager = __webpack_require__(241);
var dispatchRequest = __webpack_require__(242);
var isAbsoluteURL = __webpack_require__(244);
var combineURLs = __webpack_require__(245);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(158);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);
var transformData = __webpack_require__(243);
var isCancel = __webpack_require__(159);
var defaults = __webpack_require__(97);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(23);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(160);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = bootstrap;

var _index = __webpack_require__(161);

var _index2 = _interopRequireDefault(_index);

var _helpers = __webpack_require__(168);

var _helpers2 = _interopRequireDefault(_helpers);

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APP_ID = 'dn-app';
var childComponents = [{ name: 'dn-attribute-dialog', options: { ref: 'attributeDialog' } }, { name: 'dn-alert-dialog', options: { ref: 'alertDialog' } }, { name: 'dn-confirm-dialog', options: { ref: 'confirmDialog' } }, { name: 'dn-db-manager', options: { ref: 'dbManager' } }, { name: 'dn-loading', options: { ref: 'loading' } }];

var getApp = function getApp() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : APP_ID;


  // linksetとoutputStatusを新機能に置き換える
  var $linkSets = $('.linkSet');
  $linkSets.each(function () {
    var $el = $(this);
    var id = $el.attr('data-url_id');
    $el.removeClass('linkSet');
    $el.removeAttr('data-url_id');
    $el.attr('v-linkset', '\'' + id + '\'');
    $el.attr('data-lazy-mount', '');
  });

  var $outputStatuses = $('.outputStatus');
  $outputStatuses.each(function () {
    var $el = $(this);
    var id = $el.attr('data-id');
    $el.removeClass('outputStatus');
    $el.removeAttr('data-id');
    $el.attr('v-html', '$store.getters[\'status/displayAt\'](\'' + id + '\')');
    $el.attr('data-lazy-mount', '');
  });

  // 「先輩からの入試直前アドバイス」用
  var $outputStatusesSenpai = $('.outputStatusSenpai');
  $outputStatusesSenpai.each(function () {
    var $el = $(this);
    var id = $el.attr('data-id');
    $el.removeClass('outputStatusSenpai');
    $el.removeAttr('data-id');
    $el.attr('v-html', '$store.getters[\'status/displayAtSenpai\'](\'' + id + '\')');
    $el.attr('data-lazy-mount', '');
  });

  // 得点調整の文言表示非表示調整用
  var $outputStatusChosei = $('.outputStatusChosei');
  $outputStatusChosei.each(function () {
    var $el = $(this);
    var id = $el.attr('data-id');
    $el.removeClass('outputStatusChosei');
    $el.removeAttr('data-id');
    $el.attr(':style', '$store.getters[\'status/displayAtChosei\'](\'' + id + '\')');
    $el.attr('data-lazy-mount', '');
  });

  var $app = document.getElementById(id) || function () {
    var $app = document.createElement('div');
    $app.id = id;
    $app.setAttribute('data-dn-app', '');
    $app.setAttribute('v-cloak', '');
    document.body.appendChild($app);

    var $lazyMounts = Array.prototype.slice.call(document.querySelectorAll('[data-lazy-mount]'));
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = $lazyMounts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var el = _step.value;

        var is = el.getAttribute('is');
        if (!is) {
          var vm = new _vue2.default({ parent: window.dn, template: el.outerHTML });
          vm.$mount(el);
          continue;
        }

        var name = _helpers2.default.snake2camel(is.replace(/^dn-/, ''), true);
        var options = _index2.default[name];

        if (options) {
          var _vm = new _vue2.default(Object.assign({ parent: window.dn, template: el.innerHTML }, options));
          _vm.$mount(el);
        } else {
          console.error('vue \u30B3\u30F3\u30DD\u30FC\u30CD\u30F3\u30C8\u300C' + name + '\u300D\u306F\u5B9A\u7FA9\u3055\u308C\u3066\u3044\u307E\u305B\u3093');
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return $app;
  }();

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = childComponents[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var c = _step2.value;

      var el = document.createElement('div');
      el.setAttribute('is', c.name);
      el.setAttribute('ref', c.options.ref);
      $app.appendChild(el);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return $app;
};

function bootstrap() {
  var dn = window.dn;
  var $app = getApp();
  dn.$mount($app);
  // 大学検索は遅れてマウントさせる /center/bible/search/ から /bible/search/ に条件変更。dn2022などかこのアーカイブ化で問題になったため
  var currentUrl = location.href;
  if (currentUrl.includes('/bible/search')) {
    var script_cunk = document.createElement('script');
    script_cunk.src = '../../resources/bible/search/js/chunk-vendors.js';
    var script_app = document.createElement('script');
    script_app.src = '../../resources/bible/search/js/app.js';
    document.body.appendChild(script_cunk);
    document.body.appendChild(script_app);
  }
}

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Btn = __webpack_require__(250);

var _Btn2 = _interopRequireDefault(_Btn);

var _ChkBtn = __webpack_require__(254);

var _ChkBtn2 = _interopRequireDefault(_ChkBtn);

var _RadioBtn = __webpack_require__(258);

var _RadioBtn2 = _interopRequireDefault(_RadioBtn);

var _LsChkBtn = __webpack_require__(261);

var _LsChkBtn2 = _interopRequireDefault(_LsChkBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Btn: _Btn2.default,
  ChkBtn: _ChkBtn2.default,
  RadioBtn: _RadioBtn2.default,
  LsChkBtn: _LsChkBtn2.default
};

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(251),
  /* template */
  __webpack_require__(253),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _linkset = __webpack_require__(252);

var _linkset2 = _interopRequireDefault(_linkset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_linkset2.default],

  props: {

    // color
    plain: Boolean,
    flat: Boolean,
    primary: Boolean,
    accent: Boolean,
    strong: Boolean,

    // size
    sm: Boolean,
    lg: Boolean,
    icon: String,
    block: Boolean,
    blockPc: Boolean,
    blockSp: Boolean,

    // width
    widthLg: Boolean,
    widthLgPc: Boolean,
    widthLgSp: Boolean,

    // font size
    textLg: Boolean,

    // icon
    iconLeft: String,
    iconRight: String,

    // control
    autofocus: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'dn-btn': true,
        'dn-btn--plain': this.plain,
        'dn-btn--flat': this.flat,
        'dn-btn--primary': this.primary,
        'dn-btn--accent': this.accent,
        'dn-btn--strong': this.strong,
        'dn-btn--disabled': this.linkIsDisabled,
        'dn-btn--sm': this.sm,
        'dn-btn--lg': this.lg,
        'dn-btn--icon': !!this.icon,
        'dn-btn--block': this.block,
        'dn-btn--block-pc': this.blockPc,
        'dn-btn--block-sp': this.blockSp,
        'dn-btn--width-lg': this.widthLg,
        'dn-btn--width-lg-pc': this.widthLgPc,
        'dn-btn--width-lg-sp': this.widthLgSp,
        'dn-btn--text-lg': this.textLg,
        'dn-btn--has-icon': this.hasIcon,
        'dn-btn--has-content': this.hasContent
      };
    },
    hasContent: function hasContent() {
      return this.$slots.content !== undefined;
    },


    // flags
    hasIcon: function hasIcon() {
      return this.iconLeft !== undefined || this.iconRight !== undefined;
    },


    // values
    iconPosition: function iconPosition() {
      if (this.iconLeft) return 'left';
      if (this.iconRight) return 'right';
    }
  },

  methods: {
    onClick: function onClick(e) {
      if (this.linkIsDisabled) {
        e.preventDefault();
        return;
      }

      this.$emit('click', e);
    },
    focus: function focus() {
      this.$el.focus();
    }
  },

  mounted: function mounted() {
    if (this.autofocus) this.focus();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DEFAULT_DATA = {
  id: false,
  defaultHref: false,
  defaultTarget: false
};

exports.default = {
  props: {
    disabled: Boolean,

    linkset: {
      type: [String, Object],
      default: null
    },

    href: {
      type: String,
      default: 'javascript:void(0);'
    },

    target: {
      type: String,
      default: '_self'
    }
  },

  computed: {
    hasLinkData: function hasLinkData() {
      return !!this.linkset;
    },
    linkData: function linkData() {
      var assignData = typeof this.linkset === 'string' ? { id: this.linkset } : this.linkset;
      return Object.assign({}, DEFAULT_DATA, assignData);
    },
    linkId: function linkId() {
      return this.linkData.id;
    },
    linkHref: function linkHref() {
      if (this.linkIsDisabled) {
        return 'javascript:void(0)';
      }
      return this.linkSetIsEnabled ? this.linkOriginHref : this.linkData.defaultHref;
    },
    linkTarget: function linkTarget() {
      if (this.linkIsDisabled) {
        return null;
      }
      return this.linkSetIsEnabled ? this.linkOriginTarget : this.linkData.defaultTarget;
    },
    linkIsDisabled: function linkIsDisabled() {
      return !this.linkSetIsEnabled || this.disabled;
    },
    linkSetIsEnabled: function linkSetIsEnabled() {
      return !this.hasLinkData || this.$store.getters['links/enabled'](this.linkId);
    }
  },

  data: function data() {
    return {
      linkOriginHref: this.href,
      linkOriginTarget: this.target
    };
  }
};

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.classes,
    attrs: {
      "href": _vm.linkHref,
      "target": _vm.linkTarget
    },
    on: {
      "touchend": _vm.$dn.blurActiveElement,
      "mouseup": _vm.$dn.blurActiveElement,
      "click": _vm.onClick
    }
  }, [(_vm.iconLeft) ? _c('dn-icon', {
    staticClass: "dn-btn__icon dn-btn__icon--left",
    attrs: {
      "icon": _vm.iconLeft
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('dn-icon', {
    staticClass: "dn-btn__icon dn-btn__icon--center",
    attrs: {
      "icon": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.iconRight) ? _c('dn-icon', {
    staticClass: "dn-btn__icon dn-btn__icon--right",
    attrs: {
      "icon": _vm.iconRight
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasContent) ? _c('div', {
    staticClass: "dn-btn__content"
  }, [_vm._t("content")], 2) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(255),
  /* template */
  __webpack_require__(257),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _selectable = __webpack_require__(256);

var _selectable2 = _interopRequireDefault(_selectable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_selectable2.default],

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    classes: function classes() {
      return {
        'dn-chk-btn': true,
        'dn-chk-btn--checked': this.isActive,
        'dn-chk-btn--disabled': this.disabled,
        'dn-chk-btn--noaction': this.noaction
      };
    }
  }
}; //
//
//
//
//
//
//
//
//

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    noaction: {
      type: Boolean,
      default: false
    },
    inputValue: null,
    falseValue: null,
    trueValue: null,
    value: {
      required: false
    }
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  methods: {
    toggle: function toggle() {
      if (this.disabled || this.noaction) return;

      var input = this.inputValue;

      if (Array.isArray(input)) {
        input = input.slice();

        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
};

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.classes,
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.toggle($event)
      }
    }
  }, [_c('span', {
    staticClass: "dn-chk-btn__faux"
  }, [_c('dn-icon', {
    attrs: {
      "icon": "check"
    }
  })], 1), _vm._v(" "), (_vm.$slots.default) ? _c('span', {
    staticClass: "dn-chk-btn__label"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(259),
  /* template */
  __webpack_require__(260),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//

exports.default = {
  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    inputValue: {},
    value: {}
  },

  data: function data() {
    return {};
  },


  computed: {
    classes: function classes() {
      return {
        'dn-radio-btn': true,
        'dn-radio-btn--checked': this.isActive,
        'dn-radio-btn--disabled': this.disabled
      };
    },
    isActive: function isActive() {
      return this.inputValue === this.value;
    }
  },

  methods: {
    select: function select() {
      if (this.disabled) return;
      this.$emit('change', this.value);
    }
  }
};

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.classes,
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.select($event)
      }
    }
  }, [_c('span', {
    staticClass: "dn-radio-btn__faux"
  }), _vm._v(" "), (_vm.$slots.default) ? _c('span', {
    staticClass: "dn-radio-btn__label"
  }, [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(263),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    value: Boolean,
    name: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    linkset: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dn-ls-chk-btn': true
      };
    },
    linkIsDisabled: function linkIsDisabled() {
      return !!this.linkset && this.$store.getters['links/disabled'](this.linkset);
    },
    isDisabled: function isDisabled() {
      return this.disabled || this.linkIsDisabled;
    },


    checked: {
      get: function get() {
        return this.$ls.get(this.name, false);
      },
      set: function set(val) {
        this.$ls.set(this.name, val);
        this.$emit('input', val);
      }
    }
  },

  watch: {
    value: function value(val) {
      this.checked = val;
    }
  },

  created: function created() {
    if (this.value) {
      this.checked = true;
    }
  }
};

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-chk-btn', {
    class: _vm.classes,
    attrs: {
      "disabled": _vm.isDisabled
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LsTextField = __webpack_require__(265);

var _LsTextField2 = _interopRequireDefault(_LsTextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  LsTextField: _LsTextField2.default
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(266),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  props: {
    value: String,
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    autofocus: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    required: Boolean,
    tabindex: String,
    manual: Boolean,
    number: Boolean
  },

  data: function data() {
    return {
      state: 'pending',
      internalLastCommitValue: '',
      hasUnCommit: false,
      internalInputValue: null
      // firstSet: false,
    };
  },


  computed: {
    classes: function classes() {
      return _defineProperty({
        'dn-ls-text-field': true
      }, 'dn-ls-text-field--has-un-commit', this.hasUnCommit);
    },
    isReady: function isReady() {
      return this.state === 'ready';
    },


    inputValue: {
      get: function get() {
        return this.internalInputValue;
        // return this.value;
      },
      set: function set(val) {
        this.internalInputValue = val;
        // this.$emit('input', val);
      }
    },

    lastCommitValue: {
      get: function get() {
        return this.internalLastCommitValue === undefined || this.internalLastCommitValue === null ? '' : this.internalLastCommitValue;
      },
      set: function set(val) {
        this.internalLastCommitValue = val;
      }
    },

    isNumber: function isNumber() {
      return this.number || this.type === 'number';
    }
  },

  watch: {
    isReady: function isReady() {
      this.$emit('ready', this.internalInputValue);
    },
    value: function value() {
      this.internalInputValue = this.value;
    },
    internalInputValue: function internalInputValue() {
      if (this.manual) {
        this.updateHasUnCommit();
      } else {
        this.commit();
      }

      this.$emit('input', this.internalInputValue);
    },
    hasUnCommit: function hasUnCommit() {
      this.$emit('change-has-un-commit', this.hasUnCommit);
    }
  },

  methods: {
    updateHasUnCommit: function updateHasUnCommit() {
      var internalInputValue = this.internalInputValue;
      if (internalInputValue === null || internalInputValue === undefined) internalInputValue = '';
      this.hasUnCommit = this.lastCommitValue !== internalInputValue;
    },
    commit: function commit() {
      dn.$ls.set(this.name, this.internalInputValue);
      this.updateFromLs();
      this.$emit('commit', this.internalInputValue);
    },
    init: function init() {
      var _this = this;

      this.updateFromLs();

      dn.window.on('show', function () {
        _this.updateFromLs();
      });

      this.state = 'ready';
    },
    updateFromLs: function updateFromLs() {
      this.internalInputValue = dn.$ls.get(this.name, null);
      this.lastCommitValue = this.internalInputValue;
      this.hasUnCommit = false;
    },
    onInput: function onInput(e) {
      if (this.isNumber) {
        var val = parseFloat(e.target.value);
        this.internalInputValue = isNaN(val) ? null : val;
      } else {
        this.internalInputValue = e.target.value;
      }
    },
    blur: function blur(e) {
      if (document.activeElement === this.$refs.input) {
        this.$refs.input.blur();
      }
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      if (document.activeElement !== this.$refs.input) {
        this.$refs.input.focus();
      }
      this.$emit('focus', e);
    }
  },

  created: function created() {
    this.init();
  },
  render: function render(h) {
    var _this2 = this;

    if (!this.isReady) return;

    var listeners = this.$listeners || {};
    var nodeOptions = {
      class: this.classes,
      domProps: {
        type: this.type,
        autofocus: this.autofocus,
        disabled: this.disabled,
        required: this.required,
        value: this.internalInputValue
        // pattern  : this.isNumber ? '\\d*' : void(0),
      },
      attrs: _extends({}, this.$attrs, {
        readonly: this.readonly,
        tabindex: this.tabindex
      }),
      on: Object.assign({}, listeners, {
        input: this.onInput,
        focus: this.focus,
        blur: this.blur,
        keyup: function keyup(e) {
          if (e.which === 13) {
            _this2.$emit('enter', e);

            if (!_this2.manual) {
              _this2.commit();
              _this2.blur();
            } else {
              _this2.$nextTick(function () {
                if (!e.defaultPrevented) {
                  _this2.blur();
                }
              });
            }
          }
        }
      }),
      ref: 'input'
    };

    if (this.$attrs.min !== undefined || this.$attrs.max !== undefined) {
      nodeOptions.directives = [{
        name: 'number-range'
      }];
    }

    if (this.placeholder) {
      nodeOptions.domProps.placeholder = this.placeholder;
    }

    var $node = h('input', nodeOptions);
    return $node;
  }
};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Datepicker = __webpack_require__(268);

var _Datepicker2 = _interopRequireDefault(_Datepicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Datepicker: _Datepicker2.default
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(269)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(272),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-310d56c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(270);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("b007d046", content, true, {});

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".datepicker-overlay[data-v-310d56c3]{position:fixed;width:100%;height:100%;z-index:10000;top:0;left:0;overflow:hidden;-webkit-animation:a-data-v-310d56c3 .5s;animation:a-data-v-310d56c3 .5s}@-webkit-keyframes a{0%{opacity:0}to{opacity:1}}@keyframes a-data-v-310d56c3{0%{opacity:0}to{opacity:1}}.cov-date-body[data-v-310d56c3]{display:inline-block;background:#0aa0d7;overflow:hidden;position:relative;font-size:14px;position:fixed;display:block;width:320px;max-width:100%;z-index:10001;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);box-shadow:0 1px 3px 0 rgba(0,0,0,.2);border-radius:5px}.cov-picker-box[data-v-310d56c3]{background:#fff;width:100%;display:inline-block;padding:15px 20px;box-sizing:border-box!important;width:400px;max-width:100%;height:260px;text-align:start!important}.cov-picker-box td[data-v-310d56c3]{height:34px;width:34px;padding:0;line-height:34px;color:#000;background:#fff;text-align:center;cursor:pointer}.cov-picker-box td[data-v-310d56c3]:hover{background:#e6e6e6}table[data-v-310d56c3]{border-collapse:collapse;border-spacing:0;width:100%}.day[data-v-310d56c3]{width:14.2857143%;display:inline-block;text-align:center;cursor:pointer;height:34px;padding:0;line-height:34px;color:#000;background:#fff;vertical-align:middle}.week ul[data-v-310d56c3]{margin:0 0 8px;padding:0;list-style:none}.week ul li[data-v-310d56c3]{width:14.2%;display:inline-block;text-align:center;background:transparent;color:#000;font-weight:700}.passive-day[data-v-310d56c3]{color:#bbb}.checked[data-v-310d56c3]{color:#fff!important;border-radius:3px;background:#0aa0d7!important}.unavailable[data-v-310d56c3]{color:#ccc;cursor:not-allowed}.cov-date-monthly[data-v-310d56c3]{height:60px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:streach;-webkit-align-items:streach;-ms-flex-align:streach;align-items:streach;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between}.cov-date-monthly__column[data-v-310d56c3]{display:block;padding:0;margin:0;color:#fff;text-align:center}.cov-date-next[data-v-310d56c3],.cov-date-previous[data-v-310d56c3]{position:relative;width:20%!important;text-indent:-300px;overflow:hidden;color:#fff;cursor:pointer}.cov-date-caption[data-v-310d56c3]{width:60%;padding:0!important;box-sizing:border-box;font-size:16px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}.cov-date-caption__month.is-disabled[data-v-310d56c3],.cov-date-caption__year.is-disabled[data-v-310d56c3]{pointer-events:none}.cov-date-caption__year[data-v-310d56c3]{display:inline-block}.cov-date-caption__month[data-v-310d56c3]{display:inline-block;margin-left:.5em}.cov-date-caption span[data-v-310d56c3]:hover{color:hsla(0,0%,100%,.7)}.cov-date-next[data-v-310d56c3]:hover,.cov-date-previous[data-v-310d56c3]:hover{background:hsla(0,0%,100%,.1)}.day[data-v-310d56c3]:hover{background:#eaeaea}.unavailable[data-v-310d56c3]:hover{background:none}.cov-date-next[data-v-310d56c3]:before,.cov-date-previous[data-v-310d56c3]:before{margin-top:-4px;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.cov-date-next[data-v-310d56c3]:after,.cov-date-next[data-v-310d56c3]:before,.cov-date-previous[data-v-310d56c3]:after,.cov-date-previous[data-v-310d56c3]:before{width:12px;height:2px;text-align:center;position:absolute;background:#fff;top:50%;margin-left:-7px;left:50%;line-height:0;content:\"\"}.cov-date-next[data-v-310d56c3]:after,.cov-date-previous[data-v-310d56c3]:after{margin-top:3px;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.cov-date-previous[data-v-310d56c3]:after{-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)}.cov-date-previous[data-v-310d56c3]:before{-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)}.date-item[data-v-310d56c3]{text-align:center;font-size:20px;padding:10px 0;cursor:pointer}.date-item[data-v-310d56c3]:hover{background:#e0e0e0}.date-list[data-v-310d56c3]{overflow:auto;vertical-align:top;padding:0}.cov-vue-date[data-v-310d56c3]{display:inline-block;vertical-align:middle;color:#5d5d5d}.button-box[data-v-310d56c3]{background:#fff;vertical-align:top;height:50px;line-height:50px;text-align:right;padding-right:20px}.button-box span[data-v-310d56c3]{cursor:pointer;padding:10px 20px}.watch-box[data-v-310d56c3]{height:100%;overflow:hidden}.hour-box[data-v-310d56c3],.min-box[data-v-310d56c3]{display:inline-block;width:50%;text-align:center;height:100%;overflow:auto;float:left}.hour-box ul[data-v-310d56c3],.min-box ul[data-v-310d56c3]{list-style:none;margin:0;padding:0}.hour-item[data-v-310d56c3],.min-item[data-v-310d56c3]{padding:10px;font-size:36px;cursor:pointer}.hour-item[data-v-310d56c3]:hover,.min-item[data-v-310d56c3]:hover{background:#e3e3e3}.hour-box .active[data-v-310d56c3],.min-box .active[data-v-310d56c3]{background:#f50057;color:#fff!important}[data-v-310d56c3]::-webkit-scrollbar{width:2px}[data-v-310d56c3]::-webkit-scrollbar-track{background:#e3e3e3}[data-v-310d56c3]::-webkit-scrollbar-thumb{background:#c1c1c1;border-radius:2px}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/ui/components/datepicker/style.scss"],"names":[],"mappings":"AACA,qCAAqC,eAAe,WAAW,YAAY,cAAc,MAAM,OAAO,gBAAgB,wCAAwC,+BAA+B,CAC5L,AACD,qBACA,GAAG,SAAS,CACX,AACD,GAAG,SAAS,CACX,CACA,AACD,6BACA,GAAG,SAAS,CACX,AACD,GAAG,SAAS,CACX,CACA,AACD,gCAAgC,qBAAqB,mBAAmB,gBAAgB,kBAAkB,eAAe,eAAe,cAAc,YAAY,eAAe,cAAc,QAAQ,SAAS,uCAAuC,mCAAmC,+BAA+B,sCAAsC,iBAAiB,CAC/W,AACD,iCAAiC,gBAAgB,WAAW,qBAAqB,kBAAkB,gCAAgC,YAAY,eAAe,aAAa,0BAA0B,CACpM,AACD,oCAAoC,YAAY,WAAW,UAAU,iBAAiB,WAAW,gBAAgB,kBAAkB,cAAc,CAChJ,AACD,0CAA0C,kBAAkB,CAC3D,AACD,uBAAuB,yBAAyB,iBAAiB,UAAU,CAC1E,AACD,sBAAsB,kBAAkB,qBAAqB,kBAAkB,eAAe,YAAY,UAAU,iBAAiB,WAAW,gBAAgB,qBAAqB,CACpL,AACD,0BAA0B,eAAe,UAAU,eAAe,CACjE,AACD,6BAA6B,YAAY,qBAAqB,kBAAkB,uBAAuB,WAAW,eAAe,CAChI,AACD,8BAA8B,UAAU,CACvC,AACD,0BAA0B,qBAAqB,kBAAkB,4BAA4B,CAC5F,AACD,8BAA8B,WAAW,kBAAkB,CAC1D,AACD,mCAAmC,YAAY,oBAAoB,qBAAqB,oBAAoB,aAAa,0BAA0B,4BAA4B,uBAAuB,oBAAoB,yBAAyB,sCAAsC,sBAAsB,6BAA6B,CAC3U,AACD,2CAA2C,cAAc,UAAU,SAAS,WAAW,iBAAiB,CACvG,AACD,oEAAoE,kBAAkB,oBAAoB,mBAAmB,gBAAgB,WAAW,cAAc,CACrK,AACD,mCAAmC,UAAU,oBAAoB,sBAAsB,eAAe,oBAAoB,qBAAqB,oBAAoB,aAAa,yBAAyB,2BAA2B,sBAAsB,mBAAmB,wBAAwB,+BAA+B,qBAAqB,sBAAsB,CAC9W,AACD,2GAA2G,mBAAmB,CAC7H,AACD,yCAAyC,oBAAoB,CAC5D,AACD,0CAA0C,qBAAqB,gBAAgB,CAC9E,AACD,8CAA8C,wBAAwB,CACrE,AACD,gFAAgF,6BAA6B,CAC5G,AACD,4BAA4B,kBAAkB,CAC7C,AACD,oCAAoC,eAAe,CAClD,AACD,kFAAkF,gBAAgB,gCAAgC,4BAA4B,uBAAuB,CACpL,AACD,kKAAkK,WAAW,WAAW,kBAAkB,kBAAkB,gBAAgB,QAAQ,iBAAiB,SAAS,cAAc,UAAU,CACrS,AACD,gFAAgF,eAAe,iCAAiC,6BAA6B,wBAAwB,CACpL,AACD,0CAA0C,gCAAgC,4BAA4B,uBAAuB,CAC5H,AACD,2CAA2C,iCAAiC,6BAA6B,wBAAwB,CAChI,AACD,4BAA4B,kBAAkB,eAAe,eAAe,cAAc,CACzF,AACD,kCAAkC,kBAAkB,CACnD,AACD,4BAA4B,cAAc,mBAAmB,SAAS,CACrE,AACD,+BAA+B,qBAAqB,sBAAsB,aAAa,CACtF,AACD,6BAA6B,gBAAgB,mBAAmB,YAAY,iBAAiB,iBAAiB,kBAAkB,CAC/H,AACD,kCAAkC,eAAe,iBAAiB,CACjE,AACD,4BAA4B,YAAY,eAAe,CACtD,AACD,qDAAqD,qBAAqB,UAAU,kBAAkB,YAAY,cAAc,UAAU,CACzI,AACD,2DAA2D,gBAAgB,SAAS,SAAS,CAC5F,AACD,uDAAuD,aAAa,eAAe,cAAc,CAChG,AACD,mEAAmE,kBAAkB,CACpF,AACD,qEAAqE,mBAAmB,oBAAoB,CAC3G,AACD,qCAAqC,SAAS,CAC7C,AACD,2CAA2C,kBAAkB,CAC5D,AACD,2CAA2C,mBAAmB,iBAAiB,CAC9E","file":"style.scss","sourcesContent":["\n.datepicker-overlay[data-v-310d56c3]{position:fixed;width:100%;height:100%;z-index:10000;top:0;left:0;overflow:hidden;-webkit-animation:a-data-v-310d56c3 .5s;animation:a-data-v-310d56c3 .5s\n}\n@-webkit-keyframes a{\n0%{opacity:0\n}\nto{opacity:1\n}\n}\n@keyframes a-data-v-310d56c3{\n0%{opacity:0\n}\nto{opacity:1\n}\n}\n.cov-date-body[data-v-310d56c3]{display:inline-block;background:#0aa0d7;overflow:hidden;position:relative;font-size:14px;position:fixed;display:block;width:320px;max-width:100%;z-index:10001;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);transform:translate(-50%,-50%);box-shadow:0 1px 3px 0 rgba(0,0,0,.2);border-radius:5px\n}\n.cov-picker-box[data-v-310d56c3]{background:#fff;width:100%;display:inline-block;padding:15px 20px;box-sizing:border-box!important;width:400px;max-width:100%;height:260px;text-align:start!important\n}\n.cov-picker-box td[data-v-310d56c3]{height:34px;width:34px;padding:0;line-height:34px;color:#000;background:#fff;text-align:center;cursor:pointer\n}\n.cov-picker-box td[data-v-310d56c3]:hover{background:#e6e6e6\n}\ntable[data-v-310d56c3]{border-collapse:collapse;border-spacing:0;width:100%\n}\n.day[data-v-310d56c3]{width:14.2857143%;display:inline-block;text-align:center;cursor:pointer;height:34px;padding:0;line-height:34px;color:#000;background:#fff;vertical-align:middle\n}\n.week ul[data-v-310d56c3]{margin:0 0 8px;padding:0;list-style:none\n}\n.week ul li[data-v-310d56c3]{width:14.2%;display:inline-block;text-align:center;background:transparent;color:#000;font-weight:700\n}\n.passive-day[data-v-310d56c3]{color:#bbb\n}\n.checked[data-v-310d56c3]{color:#fff!important;border-radius:3px;background:#0aa0d7!important\n}\n.unavailable[data-v-310d56c3]{color:#ccc;cursor:not-allowed\n}\n.cov-date-monthly[data-v-310d56c3]{height:60px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:streach;-webkit-align-items:streach;-ms-flex-align:streach;align-items:streach;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between\n}\n.cov-date-monthly__column[data-v-310d56c3]{display:block;padding:0;margin:0;color:#fff;text-align:center\n}\n.cov-date-next[data-v-310d56c3],.cov-date-previous[data-v-310d56c3]{position:relative;width:20%!important;text-indent:-300px;overflow:hidden;color:#fff;cursor:pointer\n}\n.cov-date-caption[data-v-310d56c3]{width:60%;padding:0!important;box-sizing:border-box;font-size:16px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center\n}\n.cov-date-caption__month.is-disabled[data-v-310d56c3],.cov-date-caption__year.is-disabled[data-v-310d56c3]{pointer-events:none\n}\n.cov-date-caption__year[data-v-310d56c3]{display:inline-block\n}\n.cov-date-caption__month[data-v-310d56c3]{display:inline-block;margin-left:.5em\n}\n.cov-date-caption span[data-v-310d56c3]:hover{color:hsla(0,0%,100%,.7)\n}\n.cov-date-next[data-v-310d56c3]:hover,.cov-date-previous[data-v-310d56c3]:hover{background:hsla(0,0%,100%,.1)\n}\n.day[data-v-310d56c3]:hover{background:#eaeaea\n}\n.unavailable[data-v-310d56c3]:hover{background:none\n}\n.cov-date-next[data-v-310d56c3]:before,.cov-date-previous[data-v-310d56c3]:before{margin-top:-4px;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)\n}\n.cov-date-next[data-v-310d56c3]:after,.cov-date-next[data-v-310d56c3]:before,.cov-date-previous[data-v-310d56c3]:after,.cov-date-previous[data-v-310d56c3]:before{width:12px;height:2px;text-align:center;position:absolute;background:#fff;top:50%;margin-left:-7px;left:50%;line-height:0;content:\"\"\n}\n.cov-date-next[data-v-310d56c3]:after,.cov-date-previous[data-v-310d56c3]:after{margin-top:3px;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)\n}\n.cov-date-previous[data-v-310d56c3]:after{-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg)\n}\n.cov-date-previous[data-v-310d56c3]:before{-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg)\n}\n.date-item[data-v-310d56c3]{text-align:center;font-size:20px;padding:10px 0;cursor:pointer\n}\n.date-item[data-v-310d56c3]:hover{background:#e0e0e0\n}\n.date-list[data-v-310d56c3]{overflow:auto;vertical-align:top;padding:0\n}\n.cov-vue-date[data-v-310d56c3]{display:inline-block;vertical-align:middle;color:#5d5d5d\n}\n.button-box[data-v-310d56c3]{background:#fff;vertical-align:top;height:50px;line-height:50px;text-align:right;padding-right:20px\n}\n.button-box span[data-v-310d56c3]{cursor:pointer;padding:10px 20px\n}\n.watch-box[data-v-310d56c3]{height:100%;overflow:hidden\n}\n.hour-box[data-v-310d56c3],.min-box[data-v-310d56c3]{display:inline-block;width:50%;text-align:center;height:100%;overflow:auto;float:left\n}\n.hour-box ul[data-v-310d56c3],.min-box ul[data-v-310d56c3]{list-style:none;margin:0;padding:0\n}\n.hour-item[data-v-310d56c3],.min-item[data-v-310d56c3]{padding:10px;font-size:36px;cursor:pointer\n}\n.hour-item[data-v-310d56c3]:hover,.min-item[data-v-310d56c3]:hover{background:#e3e3e3\n}\n.hour-box .active[data-v-310d56c3],.min-box .active[data-v-310d56c3]{background:#f50057;color:#fff!important\n}\n[data-v-310d56c3]::-webkit-scrollbar{width:2px\n}\n[data-v-310d56c3]::-webkit-scrollbar-track{background:#e3e3e3\n}\n[data-v-310d56c3]::-webkit-scrollbar-thumb{background:#c1c1c1;border-radius:2px\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//

exports.default = {
  props: {
    required: false,
    date: {
      type: Object,
      required: true
    },
    option: {
      type: Object,
      default: function _default() {
        return {
          type: 'day',
          SundayFirst: true,
          week: ['日', '月', '火', '水', '木', '金', '土'],
          month: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          format: 'YYYY/MM/DD',
          // color: {
          //   checked: '#F50057',
          //   header: '#3f51b5',
          //   headerText: '#fff'
          // },
          inputStyle: {
            width: '150px'
          },
          // inputStyle: {
          //   'display': 'inline-block',
          //   'padding': '6px',
          //   'line-height': '22px',
          //   'font-size': '16px',
          //   'border': '2px solid #fff',
          //   'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
          //   'border-radius': '2px',
          //   'color': '#5F5F5F'
          // },
          placeholder: null,
          // buttons: {
          //   ok: '決定',
          //   cancel: 'キャンセル'
          // },
          overlayOpacity: 0.5,
          dismissible: true,
          controllable: false
        };
      }
    },
    limit: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    function hours() {
      var list = [];
      var hour = 24;
      while (hour > 0) {
        hour--;
        list.push({
          checked: false,
          value: hour < 10 ? '0' + hour : hour
        });
      }
      return list;
    }
    function mins() {
      var list = [];
      var min = 60;
      while (min > 0) {
        min--;
        list.push({
          checked: false,
          value: min < 10 ? '0' + min : min
        });
      }
      return list;
    }
    return {
      hours: hours(),
      mins: mins(),
      showInfo: {
        hour: false,
        day: false,
        month: false,
        year: false,
        check: false
      },
      displayInfo: {
        month: ''
      },
      library: {
        week: this.option.week,
        month: this.option.month,
        year: []
      },
      checked: {
        oldtime: '',
        currentMoment: null,
        year: '',
        month: '',
        day: '',
        hour: '00',
        min: '00'
      },
      dayList: [],
      selectedDays: []
    };
  },

  methods: {
    pad: function pad(n) {
      n = Math.floor(n);
      return n < 10 ? '0' + n : n;
    },
    nextMonth: function nextMonth(type) {
      var next = null;
      type === 'next' ? next = moment(this.checked.currentMoment).add(1, 'M') : next = moment(this.checked.currentMoment).add(-1, 'M');
      this.showDay(next);
    },
    showDay: function showDay(time) {
      if (time === undefined || !Date.parse(time)) {
        this.checked.currentMoment = moment();
      } else {
        this.checked.currentMoment = moment(time, this.option.format);
      }
      this.showOne('day');
      this.checked.year = moment(this.checked.currentMoment).format('YYYY');
      this.checked.month = moment(this.checked.currentMoment).format('MM');
      this.checked.day = moment(this.checked.currentMoment).format('DD');
      this.displayInfo.month = this.library.month[moment(this.checked.currentMoment).month()];
      var days = [];
      var currentMoment = this.checked.currentMoment;
      var firstDay = moment(currentMoment).date(1).day();
      // gettting previous and next month
      // let currentMonth = moment(currentMoment)
      var previousMonth = moment(currentMoment);
      var nextMonth = moment(currentMoment);
      nextMonth.add(1, 'months');
      previousMonth.subtract(1, 'months');
      var monthDays = moment(currentMoment).daysInMonth();
      var oldtime = this.checked.oldtime;
      for (var i = 1; i <= monthDays; ++i) {
        days.push({
          value: i,
          inMonth: true,
          unavailable: false,
          checked: false,
          moment: moment(currentMoment).date(i)
        });
        if (i === Math.ceil(moment(currentMoment).format('D')) && moment(oldtime, this.option.format).year() === moment(currentMoment).year() && moment(oldtime, this.option.format).month() === moment(currentMoment).month()) {
          days[i - 1].checked = true;
        }
        this.checkBySelectDays(i, days);
      }
      if (firstDay === 0) firstDay = 7;
      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
        var passiveDay = {
          value: previousMonth.daysInMonth() - _i,
          inMonth: false,
          action: 'previous',
          unavailable: false,
          checked: false,
          moment: moment(currentMoment).date(1).subtract(_i + 1, 'days')
        };
        days.unshift(passiveDay);
      }
      var passiveDaysAtFinal = 42 - days.length;
      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
        var _passiveDay = {
          value: _i2,
          inMonth: false,
          action: 'next',
          unavailable: false,
          checked: false,
          moment: moment(currentMoment).add(1, 'months').date(_i2)
        };
        days.push(_passiveDay);
      }
      if (this.limit.length > 0) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.limit[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var li = _step.value;

            switch (li.type) {
              case 'fromto':
                days = this.limitFromTo(li, days);
                break;
              case 'weekday':
                days = this.limitWeekDay(li, days);
                break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      this.dayList = days;
    },
    checkBySelectDays: function checkBySelectDays(d, days) {
      var _this = this;

      this.selectedDays.forEach(function (day) {
        if (_this.checked.year === moment(day).format('YYYY') && _this.checked.month === moment(day).format('MM') && d === Math.ceil(moment(day).format('D'))) {
          days[d - 1].checked = true;
        }
      });
    },
    limitWeekDay: function limitWeekDay(limit, days) {
      days.map(function (day) {
        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
          day.unavailable = true;
        }
      });
      return days;
    },
    limitFromTo: function limitFromTo(limit, days) {
      var _this2 = this;

      if (limit.from || limit.to) {
        days.map(function (day) {
          if (_this2.getLimitCondition(limit, day)) {
            day.unavailable = true;
          }
        });
      }
      return days;
    },
    getLimitCondition: function getLimitCondition(limit, day) {
      // let tmpMoment = moment(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value))
      var tmpMoment = day.moment;

      if (limit.from && !limit.to) {
        return !tmpMoment.isSameOrAfter(limit.from);
      } else if (!limit.from && limit.to) {
        return !tmpMoment.isSameOrBefore(limit.to);
      } else {
        // return !(tmpMoment.isSameOrAfter(limit.from) && tmpMoment.isSameOrBefore(limit.to))
        return !tmpMoment.isBetween(limit.from, limit.to);
      }
    },
    checkDay: function checkDay(obj) {
      if (obj.unavailable || obj.value === '') {
        return false;
      }
      if (!obj.inMonth) {
        this.nextMonth(obj.action);
      }
      if (this.option.type === 'day' || this.option.type === 'min') {
        this.dayList.forEach(function (x) {
          x.checked = false;
        });
        this.checked.day = this.pad(obj.value);
        obj.checked = true;
      } else {
        var day = this.pad(obj.value);
        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
        if (obj.checked === true) {
          obj.checked = false;
          this.selectedDays.$remove(ctime);
        } else {
          this.selectedDays.push(ctime);
          obj.checked = true;
        }
      }
      switch (this.option.type) {
        case 'day':
          this.picked();
          break;
        case 'min':
          this.showOne('hour');
          // shift activated time items to visible position.
          this.shiftActTime();
          break;
      }
    },
    showYear: function showYear() {
      var _this3 = this;

      var year = moment(this.checked.currentMoment).year();
      this.library.year = [];
      var yearTmp = [];
      for (var i = year - 100; i < year + 5; ++i) {
        yearTmp.push(i);
      }
      this.library.year = yearTmp;
      this.showOne('year');
      this.$nextTick(function () {
        var listDom = document.getElementById('yearList');
        listDom.scrollTop = listDom.scrollHeight - 100;
        _this3.addYear();
      });
    },
    showOne: function showOne(type) {
      switch (type) {
        case 'year':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = true;
          this.showInfo.month = false;
          break;
        case 'month':
          this.showInfo.hour = false;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = true;
          break;
        case 'day':
          this.showInfo.hour = false;
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        case 'hour':
          this.showInfo.hour = true;
          this.showInfo.day = false;
          this.showInfo.year = false;
          this.showInfo.month = false;
          break;
        default:
          this.showInfo.day = true;
          this.showInfo.year = false;
          this.showInfo.month = false;
          this.showInfo.hour = false;
      }
    },
    showMonth: function showMonth() {
      this.showOne('month');
    },
    addYear: function addYear() {
      var _this4 = this;

      var listDom = document.getElementById('yearList');
      listDom.addEventListener('scroll', function (e) {
        if (listDom.scrollTop < listDom.scrollHeight - 100) {
          var len = _this4.library.year.length;
          var lastYear = _this4.library.year[len - 1];
          _this4.library.year.push(lastYear + 1);
        }
      }, false);
    },
    setYear: function setYear(year) {
      this.checked.currentMoment = moment(year + '-' + this.checked.month + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    setMonth: function setMonth(month) {
      var mo = this.library.month.indexOf(month) + 1;
      if (mo < 10) {
        mo = '0' + '' + mo;
      }
      this.checked.currentMoment = moment(this.checked.year + '-' + mo + '-' + this.checked.day);
      this.showDay(this.checked.currentMoment);
    },
    showCheck: function showCheck(e) {
      if (this.date.time === '') {
        this.showDay();
      } else {
        if (this.option.type === 'day' || this.option.type === 'min') {
          this.checked.oldtime = this.date.time;
          this.showDay(this.date.time);
        } else {
          this.selectedDays = JSON.parse(this.date.time);
          if (this.selectedDays.length) {
            this.checked.oldtime = this.selectedDays[0];
            this.showDay(this.selectedDays[0]);
          } else {
            this.showDay();
          }
        }
      }
      this.showInfo.check = true;
    },
    setTime: function setTime(type, obj, list) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = list[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          item.checked = false;
          if (item.value === obj.value) {
            item.checked = true;
            this.checked[type] = item.value;
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    },
    picked: function picked() {
      if (this.option.type === 'day' || this.option.type === 'min') {
        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
        this.checked.currentMoment = moment(ctime, 'YYYY-MM-DD HH:mm');
        this.date.time = moment(this.checked.currentMoment).format(this.option.format);
      } else {
        this.date.time = JSON.stringify(this.selectedDays);
      }
      this.showInfo.check = false;
      this.$emit('change', this.date.time);
    },
    dismiss: function dismiss(evt) {
      if (evt.target.className === 'datepicker-overlay') {
        if (this.option.dismissible === undefined || this.option.dismissible) {
          this.showInfo.check = false;
          this.$emit('cancel');
        }
      }
    },
    shiftActTime: function shiftActTime() {
      // shift activated time items to visible position.
      this.$nextTick(function () {
        if (!document.querySelector('.hour-item.active')) {
          return false;
        }
        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
      });
    }
  }
};

/***/ }),
/* 272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cov-vue-date"
  }, [_c('div', {
    staticClass: "datepickbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.date.time),
      expression: "date.time"
    }],
    staticClass: "cov-datepicker",
    style: (_vm.option.inputStyle ? _vm.option.inputStyle : {}),
    attrs: {
      "type": "text",
      "title": "input date",
      "readonly": "readonly",
      "placeholder": _vm.option.placeholder,
      "required": _vm.required
    },
    domProps: {
      "value": (_vm.date.time)
    },
    on: {
      "focus": _vm.showCheck,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.date, "time", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
    staticClass: "datepicker-overlay",
    style: ({
      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
    }),
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.dismiss($event)
      }
    }
  }, [_c('div', {
    staticClass: "cov-date-body"
  }, [_c('div', {
    staticClass: "cov-date-monthly"
  }, [_c('div', {
    staticClass: "cov-date-monthly__column cov-date-previous",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextMonth('pre')
      }
    }
  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-monthly__column cov-date-caption",
    style: ({
      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
    })
  }, [_c('span', {
    staticClass: "cov-date-caption__year",
    class: {
      'is-disabled': !_vm.option.controllable
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showYear($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.checked.year) + "年")]), _vm._v(" "), _c('span', {
    staticClass: "cov-date-caption__month",
    class: {
      'is-disabled': !_vm.option.controllable
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showMonth($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
    staticClass: "cov-date-monthly__column cov-date-next",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextMonth('next')
      }
    }
  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
    staticClass: "cov-date-box"
  }, [_c('div', {
    staticClass: "cov-picker-box"
  }, [_c('div', {
    staticClass: "week"
  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
    return _c('li', [_vm._v(_vm._s(weekie))])
  }))]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
    return _c('div', {
      staticClass: "day",
      class: {
        checked: day.checked,
          unavailable: day.unavailable,
          'passive-day': !(day.inMonth)
      },
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.checkDay(day)
        }
      }
    }, [_vm._v(_vm._s(day.value))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list",
    attrs: {
      "id": "yearList"
    }
  }, _vm._l((_vm.library.year), function(yearItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setYear(yearItem)
        }
      }
    }, [_vm._v(_vm._s(yearItem))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, _vm._l((_vm.library.month), function(monthItem) {
    return _c('div', {
      staticClass: "date-item",
      attrs: {
        "track-by": "$index"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setMonth(monthItem)
        }
      }
    }, [_vm._v(_vm._s(monthItem))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
    staticClass: "cov-date-box list-box"
  }, [_c('div', {
    staticClass: "cov-picker-box date-list"
  }, [_c('div', {
    staticClass: "watch-box"
  }, [_c('div', {
    staticClass: "hour-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
    return _c('li', {
      staticClass: "hour-item",
      class: {
        'active': hitem.checked
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setTime('hour', hitem, _vm.hours)
        }
      }
    }, [_vm._v(_vm._s(hitem.value))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "min-box"
  }, [_c('div', {
    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
    return _c('div', {
      staticClass: "min-item",
      class: {
        'active': mitem.checked
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setTime('min', mitem, _vm.mins)
        }
      }
    }, [_vm._v(_vm._s(mitem.value))])
  })], 2)])])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Icon = __webpack_require__(274);

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Icon: _Icon2.default
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(276),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  props: {
    icon: {
      type: String,
      required: true
    },
    btn: {
      type: [Boolean],
      default: false
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'dn-icon': true,
        'dn-icon--btn': this.btn
      }, 'dn-icon-' + this.icon, true);
    }
  }
};

/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.btn) ? _c('a', {
    class: _vm.classes,
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._t("default")], 2) : _c('span', {
    class: _vm.classes
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tabs = __webpack_require__(278);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _TabsBar = __webpack_require__(279);

var _TabsBar2 = _interopRequireDefault(_TabsBar);

var _TabsItem = __webpack_require__(280);

var _TabsItem2 = _interopRequireDefault(_TabsItem);

var _TabsContent = __webpack_require__(283);

var _TabsContent2 = _interopRequireDefault(_TabsContent);

var _SwitchTabs = __webpack_require__(286);

var _SwitchTabs2 = _interopRequireDefault(_SwitchTabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabsItems = {
  name: 'tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'dn-tabs__items': true } }, [this.$slots.default]);
  }
};

exports.default = {
  Tabs: _Tabs2.default,
  TabsBar: _TabsBar2.default,
  TabsItem: _TabsItem2.default,
  TabsItems: TabsItems,
  TabsContent: _TabsContent2.default,
  SwitchTabs: _SwitchTabs2.default
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: String
  },

  data: function data() {
    return {
      target: null,
      activeIndex: null
    };
  },


  computed: {
    classes: function classes() {
      return {
        'dn-tabs': true
      };
    }
  },

  methods: {
    set: function set(target) {
      var _this = this;

      this.target = target;
      this.activeIndex = this.$refs.content.$children.findIndex(function (i) {
        return i.id === _this.target;
      });
      this.$emit('input', target);
    },
    onItemDisabledChange: function onItemDisabledChange(target, disabled) {
      var _this2 = this;

      if (!disabled) return;
      if (this.target === target) {
        this.set(null);
        this.$nextTick(function () {
          _this2.setInitialIndex();
        });
      }
    },
    setInitialIndex: function setInitialIndex() {
      var activators = this.$slots.activators;
      if (!activators || !activators.length || !activators[0].componentInstance.$children) return;

      var bar = activators[0].componentInstance.$children;
      var i = bar.findIndex(function (t) {
        return t.$el.classList.contains('dn-tabs__item--active') && !t.$el.classList.contains('dn-tabs__item--disabled');
      });

      var defaultIndex = i !== -1 ? i : bar.findIndex(function (t) {
        return !t.$el.classList.contains('dn-tabs__item--disabled');
      });

      var tab = this.value || (bar[defaultIndex !== -1 ? defaultIndex : 0] || {}).action;
      tab && this.set(tab);
    }
  },

  watch: {
    value: function value() {
      this.set(this.value);
    }
  },

  mounted: function mounted() {
    this.setInitialIndex();
  },
  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) {
        slot.push(c);
      } else if (c.componentOptions.tag === 'dn-tabs-content') {
        content.push(c);
      } else {
        slot.push(c);
      }
    });

    var tabs = content.length ? h('dn-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes
    }, [slot, this.$slots.activators, tabs]);
  }
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  computed: {
    classes: function classes() {
      return {
        'dn-tabs__bar': true
      };
    }
  },

  render: function render(h) {
    var container = h('div', {
      'class': 'dn-tabs__container',
      ref: 'container'
    }, this.$slots.default);

    return h('div', {
      'class': this.classes
    }, [container]);
  }
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(281),
  /* template */
  __webpack_require__(282),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//


exports.default = {
  props: {
    href: {
      type: String,
      required: true
    },
    disabled: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'dn-tabs__item': true,
        'dn-tabs__item--active': this.isActive,
        'dn-tabs__item--disabled': this.disabled
      };
    },
    action: function action() {
      return this.href.replace(/^#/, '');
    },
    tabs: function tabs() {
      return this.$parent.$parent;
    },
    isActive: function isActive() {
      return this.tabs.value === this.action;
    }
  },

  watch: {
    disabled: function disabled() {
      this.emitDisabled();
    }
  },

  methods: {
    emitDisabled: function emitDisabled() {
      this.tabs.onItemDisabledChange(this.action, this.disabled);
    },
    onTap: function onTap(e) {
      e.preventDefault();
      if (this.disabled) return;
      this.tabs.set(this.action);
    },
    created: function created() {
      this.emitDisabled();
    }
  }
};

/***/ }),
/* 282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    class: _vm.classes,
    attrs: {
      "href": _vm.href
    },
    on: {
      "click": _vm.onTap
    }
  }, [_c('span', {
    staticClass: "dn-tabs__item-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(284),
  /* template */
  __webpack_require__(285),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    id: {
      type: String,
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dn-tabs__content': true,
        'dn-tabs__content--active': this.isActive
      };
    },
    tabs: function tabs() {
      return this.$parent.$parent;
    },
    isActive: function isActive() {
      return this.tabs.value === this.id;
    }
  }
};

/***/ }),
/* 285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "id": _vm.id
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(287),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  props: {
    value: true,
    pc: {
      type: String,
      default: 'tabs'
    },
    sp: {
      type: String,
      default: 'accordion'
    }
  },

  data: function data() {
    return {
      lazyTabSelected: this.value
    };
  },


  computed: {
    currentType: function currentType() {
      return this[this.$store.getters['mq/group']];
    },
    classes: function classes() {
      return _defineProperty({
        'dn-switch-tabs': true
      }, 'dn-switch-tabs--' + this.currentType, true);
    },

    tabSelected: {
      get: function get() {
        return this.lazyTabSelected;
      },
      set: function set(val) {
        if (val === this.lazyTabSelected) return;
        this.lazyTabSelected = val;
        this.$emit('input', val);
      }
    }
  },

  watch: {
    value: function value(val) {
      this.lazyTabSelected = val;
    }
  },

  methods: {
    genTabs: function genTabs(items) {
      var _this = this;

      var $tabs = this.$createElement('dn-tabs', {
        props: {
          value: this.tabSelected
        },
        on: {
          input: function input(e) {
            _this.tabSelected = e;
          }
        }
      }, [this.$createElement('dn-tabs-bar', { slot: 'activators' }, items.map(function (item) {
        return _this.$createElement('dn-tabs-item', {
          props: {
            href: '#' + item.id
          }
        }, item.$label.children);
      }))].concat(_toConsumableArray(items.map(function (item) {
        var $accordion = _this.$createElement('dn-accordion', {}, [_this.$createElement('template', { slot: 'trigger' }, item.$label.children), _this.$createElement('template', { slot: 'body' }, item.$content.children)]);

        return _this.$createElement('dn-tabs-content', {
          props: {
            id: item.id
          }
        }, [$accordion]);
      }))));
      return [$tabs];
    },
    genAccordions: function genAccordions(items) {
      var _this2 = this;

      return items.map(function (item) {
        return _this2.$createElement('dn-accordion', {}, [_this2.$createElement('template', { slot: 'trigger' }, item.$label.children), _this2.$createElement('template', { slot: 'body' }, item.$content.children)]);
      });
    }
  },

  render: function render(h) {
    var $wrapper = h('div', {
      'class': this.classes
    });

    var items = [];

    var $items = this.$slots.default.filter(function ($slot) {
      return $slot.tag === 'dn-switch-tabs-item';
    });
    $items.forEach(function ($item) {
      var item = {
        $el: $item,
        id: $item.data.attrs.id
      };
      item.$label = $item.children.find(function ($child) {
        return $child.tag === 'dn-switch-tabs-label';
      });
      item.$content = $item.children.find(function ($child) {
        return $child.tag === 'dn-switch-tabs-content';
      });
      items.push(item);
    });

    $wrapper.children = this.genTabs(items);
    return $wrapper;
  }
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Accordion = __webpack_require__(289);

var _Accordion2 = _interopRequireDefault(_Accordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Accordion: _Accordion2.default
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(290),
  /* template */
  __webpack_require__(291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toggleable = __webpack_require__(162);

var _toggleable2 = _interopRequireDefault(_toggleable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ACTIVATE_DURATION = 350; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_toggleable2.default],

  data: function data() {
    return {
      initialOpen: false
    };
  },


  computed: {
    classes: function classes() {
      return {
        'dn-accordion': true,
        'dn-accordion--open': this.isActive || this.initialOpen
      };
    },
    icon: function icon() {
      return this.isActive ? 'arrow-up-lg' : 'arrow-down-lg';
    }
  },

  watch: {
    isActive: function isActive(_isActive) {
      var $body = $(this.$refs.body);
      $body.stop();
      $body[_isActive ? 'slideDown' : 'slideUp'](ACTIVATE_DURATION);
    }
  },

  methods: {
    toggle: function toggle() {
      this.isActive = !this.isActive;
    }
  },

  created: function created() {
    this.initialOpen = this.value;
  }
};

/***/ }),
/* 291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    class: _vm.classes
  }, [_c('dt', {
    staticClass: "dn-accordion__trigger",
    on: {
      "click": _vm.toggle
    }
  }, [_c('div', {
    staticClass: "dn-accordion__trigger-inner"
  }, [_vm._t("trigger")], 2), _vm._v(" "), _c('div', {
    staticClass: "dn-accordion__trigger-icon-container"
  }, [_c('dn-icon', {
    staticClass: "dn-accordion__trigger-icon",
    attrs: {
      "icon": _vm.icon
    }
  })], 1)]), _vm._v(" "), _c('dd', {
    ref: "body",
    staticClass: "dn-accordion__body"
  }, [_vm._t("body")], 2)])
},staticRenderFns: []}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Dialog = __webpack_require__(293);

var _Dialog2 = _interopRequireDefault(_Dialog);

var _AttributeDialog = __webpack_require__(295);

var _AttributeDialog2 = _interopRequireDefault(_AttributeDialog);

var _AlertDialog = __webpack_require__(298);

var _AlertDialog2 = _interopRequireDefault(_AlertDialog);

var _ConfirmDialog = __webpack_require__(303);

var _ConfirmDialog2 = _interopRequireDefault(_ConfirmDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Dialog: _Dialog2.default,
  AttributeDialog: _AttributeDialog2.default,
  AlertDialog: _AlertDialog2.default,
  ConfirmDialog: _ConfirmDialog2.default
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _detachable = __webpack_require__(294);

var _detachable2 = _interopRequireDefault(_detachable);

var _toggleable = __webpack_require__(162);

var _toggleable2 = _interopRequireDefault(_toggleable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  mixins: [_detachable2.default, _toggleable2.default],

  props: {
    disabled: Boolean,
    persistent: {
      type: Boolean,
      default: false
    },
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    },
    scrollStop: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'default'
    },
    btnClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: [String, Number],
      default: null
    },
    limitVw: {
      type: Boolean,
      default: true
    },
    beforeHide: {
      type: Function
    },
    system: Boolean
  },

  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, ('dn-dialog dn-dialog--' + this.type + ' ' + this.contentClass).trim(), true), _defineProperty(_ref, 'dn-dialog--system', this.system), _defineProperty(_ref, 'dn-dialog--active', this.isActive), _defineProperty(_ref, 'dn-dialog--limit-vw', this.limitVw), _ref;
    }
  },

  watch: {
    isActive: function isActive(_isActive) {
      if (_isActive) {
        this.$emit('before-show');

        if (this.scrollStop) {
          this.hideScroll();
        }
      } else {
        this.$emit('before-hide');
        this.showScroll();
      }
    }
  },

  methods: {
    toggle: function toggle() {
      if (!this.disabled) this.isActive = !this.isActive;
    },
    show: function show() {
      this.isActive = true;
    },
    hide: function hide() {
      var beforeHide = void 0;
      if (typeof this.beforeHide === 'function') beforeHide = this.beforeHide();
      if (beforeHide !== false) this.isActive = false;
    },
    closeConditional: function closeConditional(e) {
      return !this.persistent;
    },
    showScroll: function showScroll() {
      dn.window.setScrollDisabled(false);
    },
    hideScroll: function hideScroll() {
      dn.window.setScrollDisabled();
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.showScroll();
  },
  render: function render(h) {
    var _this = this;

    var my = this;
    var children = [];

    if (this.$slots.activator) {
      var $activator = h('div', {
        'class': 'dn-dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.toggle();
          }
        }
      }, [this.$slots.activator]);
      children.push($activator);
    }

    var bodyWrapperChildren = [];
    var bodyChildren = [];

    if (this.$slots.header) {
      bodyChildren.push(h('div', {
        'class': 'dn-dialog__header'
      }, this.$slots.header));
    }

    bodyChildren.push(this.$slots.default);

    if (this.$slots.footer) {
      bodyChildren.push(h('div', {
        'class': 'dn-dialog__footer'
      }, this.$slots.footer));
    }

    bodyWrapperChildren.push(h('div', {
      'class': 'dn-dialog__body',
      style: {
        width: this.width ? isNaN(this.width) ? this.width : this.width + 'px' : null
      }
    }, bodyChildren));

    if (this.btnClose) {
      bodyWrapperChildren.push(h('a', {
        'class': 'dn-dialog__btn-close',
        attrs: {
          href: 'javascript:void(0);'
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.hide();
          }
        },
        ref: 'btn-close'
      }, [h('dn-icon', {
        props: { icon: 'close-box' }
      })]));
    }

    var $body = h('div', {
      'class': 'dn-dialog__body-wrapper',
      directives: [{
        name: 'click-outside',
        value: this.closeConditional
      }]
    }, bodyWrapperChildren);

    var $inner = h('div', {
      'class': 'dn-dialog__inner'
    }, [$body]);

    var $table = h('div', {
      'class': 'dn-dialog__table'
    }, [$inner]);

    var $dialog = h('div', {
      'class': this.classes,
      ref: 'content',
      directives: [{ name: 'show', value: this.isActive }]
    }, [$table]);

    var $transition = h('transition', {
      props: { name: this.transition }
    }, [$dialog]);

    children.push($transition);

    var $container = h('div', {
      'class': 'dn-dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || 'inline-block'
      }
    }, children);

    return $container;
  }
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$dn.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-dn-app]');

      if (!app) {
        return console.warn('Application is missing <dn-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(296),
  /* template */
  __webpack_require__(297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _UserAttributeModel = __webpack_require__(163);

var _UserAttributeModel2 = _interopRequireDefault(_UserAttributeModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
	data: function data() {
		return {
			columnSets: [],
			selected: null
		};
	},
	created: function created() {
		var userAttribute = new _UserAttributeModel2.default();
		this.columnSets = dn.h.arraySplitter(userAttribute.findAll(), 2);
	},


	computed: {
		dialog: function dialog() {
			return this.$refs.dialog;
		},
		lineUrl: function lineUrl() {
			return this.$store.getters["path/$join"]("root", "line.html");
		}
	},

	methods: {
		toggle: function toggle() {
			return this.dialog.toggle();
		},
		show: function show() {
			return this.dialog.show();
		},
		hide: function hide() {
			return this.dialog.hide();
		},
		apply: function apply() {
			if (this.selected === null) {
				dn.$alert("ご利用される方を選択してください。");
				return false;
			}

			try {
				dataLayer.push({ 'event': 'event_track', 'event_cat': 'ユーザー属性', 'event_act': '登録', 'event_lab': dn.segments.userType.model.getLabelById(this.selected) });
			} catch (e) {
				console.log(e);
			};

			this.$store.dispatch("segments/user/setId", this.selected);
			this.dialog.hide();
		},
		onBeforeShow: function onBeforeShow() {
			this.selected = dn.$store.getters["segments/user/id"];
			this.$forceUpdate();
		}
	}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-dialog', {
    ref: "dialog",
    attrs: {
      "content-class": "dn-attribute-dialog",
      "btn-close": false,
      "persistent": ""
    },
    on: {
      "before-show": _vm.onBeforeShow
    }
  }, [(_vm.$slots.activator) ? _c('template', {
    slot: "activator"
  }, [_vm._t("activator")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dn-attribute-dialog__header"
  }, [_vm._v("\n\t\tご利用される方は\n\t\t"), _c('br'), _vm._v("どなたですか？\n\t")]), _vm._v(" "), _c('div', {
    staticClass: "dn-attribute-dialog__choices"
  }, [_c('div', {
    staticClass: "dn-attribute-dialog__choices-header"
  }, [_c('span', {
    staticClass: "dn-attribute-dialog__label"
  }, [_vm._v("属性")])]), _vm._v(" "), _vm._l((_vm.columnSets), function(columns, index) {
    return _c('div', {
      key: index,
      staticClass: "dn-attribute-dialog__choices-col"
    }, _vm._l((columns), function(column, index) {
      return _c('label', {
        key: index
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.selected),
          expression: "selected"
        }],
        attrs: {
          "type": "radio",
          "name": "dn-user-attribute"
        },
        domProps: {
          "value": column.id,
          "checked": _vm._q(_vm.selected, column.id)
        },
        on: {
          "change": function($event) {
            _vm.selected = column.id
          }
        }
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(column.label))])])
    }))
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "dn-attribute-dialog__footer"
  }, [_c('p', {
    staticClass: "dn-attribute-dialog__footer-notice"
  }, [_vm._v("※各属性に適した画面が表示されます")]), _vm._v(" "), _c('a', {
    staticClass: "dn-attribute-dialog__btn-apply dn-btn dn-btn--primary dn-btn--text-lg",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("決定")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(299)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(302),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-386912f4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(300);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4454fdc1", content, true, {});

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-body[data-v-386912f4]{margin-top:15px}.my-btn[data-v-386912f4]{margin:5px}@media (max-width:320px){.my-btn[data-v-386912f4]{width:100%}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/ui/components/dialogs/AlertDialog.vue"],"names":[],"mappings":"AACA,0BAA0B,eAAe,CACxC,AACD,yBAAyB,UAAU,CAClC,AACD,yBACA,yBAAyB,UAAU,CAClC,CACA","file":"AlertDialog.vue","sourcesContent":["\n.my-body[data-v-386912f4]{margin-top:15px\n}\n.my-btn[data-v-386912f4]{margin:5px\n}\n@media (max-width:320px){\n.my-btn[data-v-386912f4]{width:100%\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var DEFAULT_OPTIONS = {
  body: null,
  ok: 'OK'
};

exports.default = {
  data: function data() {
    return {
      body: null,
      okLabel: null
    };
  },


  computed: {
    dialog: function dialog() {
      return this.$refs.dialog;
    },
    bodyHtml: function bodyHtml() {
      return this.body && this.body.trim().replace(/\n/g, '<br>');
    }
  },

  methods: {
    reset: function reset() {
      if (this._resolver) {
        this._resolver();
        this._resolver = null;
        delete this._resolver;
      }
      this.body = null;
      this.okLabel = null;
      this.removeEscKeyHandler();
    },
    show: function show() {
      var _this = this;

      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (resolve) {
        _this.reset();
        _this._resolver = resolve;

        opt = typeof opt === 'string' ? { body: opt } : opt;
        opt = Object.assign({}, DEFAULT_OPTIONS, opt);

        _this.body = opt.body;
        _this.okLabel = opt.ok;
        return _this.dialog.show();
      });
    },
    onBeforeShow: function onBeforeShow() {
      var _this2 = this;

      this.addEscKeyHandler();
      this.$nextTick(function () {
        _this2.$refs.ok.focus();
      });
    },
    onBeforeHide: function onBeforeHide() {
      this.removeEscKeyHandler();
    },
    hide: function hide() {
      return this.dialog.hide();
    },
    resolve: function resolve() {
      if (this._resolver) {
        this._resolver();
        this._resolver = null;
        delete this._resolver;
      }
    },
    ok: function ok() {
      this.resolve();
      this.hide();
    },
    addEscKeyHandler: function addEscKeyHandler() {
      var _this3 = this;

      if (this._escKeyHandler) return;
      this._escKeyHandler = function (e) {
        if (e.keyCode === 27) {
          _this3.ok();
        }
      };
      document.addEventListener('keyup', this._escKeyHandler, false);
    },
    removeEscKeyHandler: function removeEscKeyHandler() {
      if (this._escKeyHandler) {
        document.removeEventListener('keyup', this._escKeyHandler);
        this._escKeyHandler = null;
        delete this._escKeyHandler;
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.reset();
  }
};

/***/ }),
/* 302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-dialog', {
    ref: "dialog",
    attrs: {
      "content-class": "dn-alert-dialog",
      "system": ""
    },
    on: {
      "before-show": _vm.onBeforeShow,
      "before-hide": _vm.onBeforeHide
    }
  }, [(_vm.body) ? _c('p', {
    staticClass: "my-body",
    domProps: {
      "innerHTML": _vm._s(_vm.bodyHtml)
    }
  }) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "my-btns"
  }, [_c('dn-btn', {
    ref: "ok",
    staticClass: "my-btn",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okLabel))])], 1)])], 2)
},staticRenderFns: []}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(304)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(306),
  /* template */
  __webpack_require__(307),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6faf3d58",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(305);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6507c10f", content, true, {});

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-body[data-v-6faf3d58]{margin-top:5px}.my-btn[data-v-6faf3d58]{margin:5px;min-width:120px}@media (max-width:320px){.my-btn[data-v-6faf3d58]{width:100%}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/ui/components/dialogs/ConfirmDialog.vue"],"names":[],"mappings":"AACA,0BAA0B,cAAc,CACvC,AACD,yBAAyB,WAAW,eAAe,CAClD,AACD,yBACA,yBAAyB,UAAU,CAClC,CACA","file":"ConfirmDialog.vue","sourcesContent":["\n.my-body[data-v-6faf3d58]{margin-top:5px\n}\n.my-btn[data-v-6faf3d58]{margin:5px;min-width:120px\n}\n@media (max-width:320px){\n.my-btn[data-v-6faf3d58]{width:100%\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var DEFAULT_OPTIONS = {
  body: null,
  ok: 'OK',
  cancel: 'キャンセル'
};

exports.default = {
  data: function data() {
    return {
      body: null,
      okLabel: null,
      cancelLabel: null
    };
  },


  computed: {
    dialog: function dialog() {
      return this.$refs.dialog;
    },
    bodyHtml: function bodyHtml() {
      return this.body && this.body.trim().replace(/\n/g, '<br>');
    }
  },

  methods: {
    reset: function reset() {
      if (this._resolver) {
        this._resolver();
        this._resolver = null;
        delete this._resolver;
      }
      this.body = null;
      this.okLabel = null;
      this.cancelLabel = null;
      this.removeEscKeyHandler();
    },
    show: function show() {
      var _this = this;

      var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (resolve) {
        _this.reset();
        _this._resolver = resolve;

        opt = typeof opt === 'string' ? { body: opt } : opt;
        opt = Object.assign({}, DEFAULT_OPTIONS, opt);

        _this.body = opt.body;
        _this.okLabel = opt.ok;
        _this.cancelLabel = opt.cancel;
        return _this.dialog.show();
      });
    },
    onBeforeShow: function onBeforeShow() {
      var _this2 = this;

      this.addEscKeyHandler();
      this.$nextTick(function () {
        _this2.$refs.cancel.focus();
      });
    },
    onBeforeHide: function onBeforeHide() {
      this.removeEscKeyHandler();
    },
    hide: function hide() {
      return this.dialog.hide();
    },
    resolve: function resolve(value) {
      if (this._resolver) {
        this._resolver(value);
        this._resolver = null;
        delete this._resolver;
      }
    },
    ok: function ok() {
      this.resolve(true);
      this.hide();
    },
    cancel: function cancel() {
      this.resolve(false);
      this.hide();
    },
    addEscKeyHandler: function addEscKeyHandler() {
      var _this3 = this;

      if (this._escKeyHandler) return;
      this._escKeyHandler = function (e) {
        if (e.keyCode === 27) {
          _this3.cancel();
        }
      };
      document.addEventListener('keyup', this._escKeyHandler, false);
    },
    removeEscKeyHandler: function removeEscKeyHandler() {
      if (this._escKeyHandler) {
        document.removeEventListener('keyup', this._escKeyHandler);
        this._escKeyHandler = null;
        delete this._escKeyHandler;
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.reset();
  }
};

/***/ }),
/* 307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-dialog', {
    ref: "dialog",
    attrs: {
      "content-class": "dn-confirm-dialog",
      "btn-close": false,
      "persistent": "",
      "system": ""
    },
    on: {
      "before-show": _vm.onBeforeShow,
      "before-hide": _vm.onBeforeHide
    }
  }, [(_vm.body) ? _c('p', {
    staticClass: "my-body",
    domProps: {
      "innerHTML": _vm._s(_vm.bodyHtml)
    }
  }) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "my-btns"
  }, [_c('dn-btn', {
    ref: "cancel",
    staticClass: "my-btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelLabel))]), _vm._v(" "), _c('dn-btn', {
    ref: "ok",
    staticClass: "my-btn",
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okLabel))])], 1)])], 2)
},staticRenderFns: []}

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = __webpack_require__(309);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Pagination: _Pagination2.default
};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(310),
  /* template */
  __webpack_require__(311),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  props: {
    disabled: Boolean,
    length: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    classes: function classes() {
      return {
        'dn-pagination': true,
        'dn-pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) return this.range(1, this.length);

      var min = this.value - 3;
      min = min > 0 ? min : 1;
      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) min = this.length - 6;

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) range.splice(0, 2, 1, '…');

      if (this.value + 3 < this.length && this.length > 6) range.splice(range.length - 2, 2, '…', this.length);

      return range;
    }
  },

  methods: {
    set: function set(index) {
      this.$emit('input', index);
    },
    next: function next() {
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    prev: function prev() {
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    onClickNumber: function onClickNumber(index) {
      if (this.disabled) return false;
      this.set(index);
      this.$dn.blurActiveElement();
    },
    onClickPrev: function onClickPrev() {
      if (this.disabled) return false;
      this.prev();
      this.$dn.blurActiveElement();
    },
    onClickNext: function onClickNext() {
      if (this.disabled) return false;
      this.next();
      this.$dn.blurActiveElement();
    },
    range: function range(from, to) {
      var range = [];
      from = from > 0 ? from : 1;
      for (var i = from; i <= to; i++) {
        range.push(i);
      }
      return range;
    }
  }
};

/***/ }),
/* 311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.length > 1),
      expression: "length > 1"
    }],
    class: _vm.classes
  }, [(_vm.value > 1) ? _c('a', {
    staticClass: "dn-pagination__item dn-pagination__prev",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickPrev($event)
      }
    }
  }, [_c('dn-icon', {
    class: {
      'is-disabled': _vm.disabled
    },
    attrs: {
      "icon": "arrow-left"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(n) {
    return (!isNaN(n)) ? _c('a', {
      class: {
        'dn-pagination__item dn-pagination__number': true, 'dn-pagination__number--active': n === _vm.value
      },
      attrs: {
        "href": "javascript:void(0);"
      },
      domProps: {
        "textContent": _vm._s(n)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.onClickNumber(n)
        }
      }
    }) : _c('span', {
      staticClass: "dn-pagination__item dn-pagination__more",
      domProps: {
        "textContent": _vm._s(n)
      }
    })
  }), _vm._v(" "), (_vm.value !== _vm.length) ? _c('a', {
    staticClass: "dn-pagination__item dn-pagination__next",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickNext($event)
      }
    }
  }, [_c('dn-icon', {
    class: {
      'is-disabled': _vm.disabled
    },
    attrs: {
      "icon": "arrow-right"
    }
  })], 1) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProgressBar = __webpack_require__(313);

var _ProgressBar2 = _interopRequireDefault(_ProgressBar);

var _Circle = __webpack_require__(318);

var _Circle2 = _interopRequireDefault(_Circle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  ProgressBar: _ProgressBar2.default,
  Circle2: _Circle2.default
};

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(314)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(316),
  /* template */
  __webpack_require__(317),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a5e728e4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(315);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("0d65a747", content, true, {});

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".dn-progress-bar[data-v-a5e728e4]{width:100%;height:10px;font-size:inherit;background:#adc4cc;position:relative}.dn-progress-bar__inner[data-v-a5e728e4]{position:absolute;top:0;left:0;bottom:0;background:#0aa0d7;-webkit-transition:width .25s;transition:width .25s}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/ui/components/progresses/ProgressBar.vue"],"names":[],"mappings":"AACA,kCAAkC,WAAW,YAAY,kBAAkB,mBAAmB,iBAAiB,CAC9G,AACD,yCAAyC,kBAAkB,MAAM,OAAO,SAAS,mBAAmB,8BAA8B,qBAAqB,CACtJ","file":"ProgressBar.vue","sourcesContent":["\n.dn-progress-bar[data-v-a5e728e4]{width:100%;height:10px;font-size:inherit;background:#adc4cc;position:relative\n}\n.dn-progress-bar__inner[data-v-a5e728e4]{position:absolute;top:0;left:0;bottom:0;background:#0aa0d7;-webkit-transition:width .25s;transition:width .25s\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  props: {
    value: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {};
  },


  computed: {
    classes: function classes() {
      return {
        'dn-progress-bar': true
      };
    },
    innerStyle: function innerStyle() {
      return {
        width: Number((Math.min(this.value, 1) * 100).toFixed(2)) + '%'
      };
    }
  }
};

/***/ }),
/* 317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "dn-progress-bar__inner",
    style: (_vm.innerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(319)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(322),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a78ebeec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(320);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("271ce63d", content, true, {});

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".spinner[data-v-a78ebeec]{box-sizing:border-box;border-radius:100%;border:10px solid hsla(0,0%,100%,.2);-webkit-animation:a-data-v-a78ebeec 1s infinite linear;animation:a-data-v-a78ebeec 1s infinite linear}@-webkit-keyframes a{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes a-data-v-a78ebeec{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/node_modules/vue-loading-spinner/src/components/Circle2.vue"],"names":[],"mappings":"AACA,0BAA0B,sBAAsB,mBAAmB,qCAAqC,uDAAuD,8CAA8C,CAC5M,AACD,qBACA,GAAG,gCAAgC,uBAAuB,CACzD,CACA,AACD,6BACA,GAAG,gCAAgC,uBAAuB,CACzD,CACA","file":"Circle2.vue","sourcesContent":["\n.spinner[data-v-a78ebeec]{box-sizing:border-box;border-radius:100%;border:10px solid hsla(0,0%,100%,.2);-webkit-animation:a-data-v-a78ebeec 1s infinite linear;animation:a-data-v-a78ebeec 1s infinite linear\n}\n@-webkit-keyframes a{\nto{-webkit-transform:rotate(1turn);transform:rotate(1turn)\n}\n}\n@keyframes a-data-v-a78ebeec{\nto{-webkit-transform:rotate(1turn);transform:rotate(1turn)\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//

exports.default = {
  props: {
    size: {
      default: '40px'
    },
    background: {
      default: '#41b883'
    },
    color: {
      default: '#35495e'
    },
    stroke: {
      default: '5px'
    }
  },
  computed: {
    styles: function styles() {
      return {
        width: this.size,
        height: this.size,
        border: this.stroke + ' solid ' + this.background,
        borderTopColor: this.color
      };
    }
  }
};

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--circle-2",
    style: (_vm.styles)
  })
},staticRenderFns: []}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Spinner = __webpack_require__(324);

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Loading = __webpack_require__(329);

var _Loading2 = _interopRequireDefault(_Loading);

var _LoadingSpinner = __webpack_require__(334);

var _LoadingSpinner2 = _interopRequireDefault(_LoadingSpinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Spinner: _Spinner2.default,
  Loading: _Loading2.default,
  LoadingSpinner: _LoadingSpinner2.default
};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(325)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(328),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f448e8c6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(326);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("34141a26", content, true, {});

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".dn-spinner[data-v-f448e8c6]{display:inline-block}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/ui/components/loadings/Spinner.vue"],"names":[],"mappings":"AACA,6BAA6B,oBAAoB,CAChD","file":"Spinner.vue","sourcesContent":["\n.dn-spinner[data-v-f448e8c6]{display:inline-block\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  props: {
    size: {
      type: [String, Number],
      default: 50
    },
    color: {
      type: String,
      default: '#0aa0d7'
    },
    background: {
      type: String,
      default: 'rgba(0, 0, 0, 0.25)'
    }
  },

  computed: {
    computedSize: function computedSize() {
      return typeof this.size === 'string' ? this.size.replace('px', '') + 'px' : this.size + 'px';
    }
  }
};

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-circle2', {
    staticClass: "dn-spinner",
    attrs: {
      "size": _vm.computedSize,
      "color": _vm.color,
      "background": _vm.background
    }
  })
},staticRenderFns: []}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(330)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(333),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56b91d80",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("931c8a92", content, true, {});

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".dn-loading[data-v-56b91d80]{position:fixed;z-index:327677;top:-40px;left:-40px;right:-40px;bottom:-40px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=)}.myfade-enter-active[data-v-56b91d80],.myfade-leave-active[data-v-56b91d80]{-webkit-transition:opacity .5s;transition:opacity .5s}.myfade-enter[data-v-56b91d80],.myfade-leave-to[data-v-56b91d80]{opacity:0}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/ui/components/loadings/Loading.vue"],"names":[],"mappings":"AACA,6BAA6B,eAAe,eAAe,UAAU,WAAW,YAAY,aAAa,oBAAoB,qBAAqB,oBAAoB,aAAa,yBAAyB,2BAA2B,sBAAsB,mBAAmB,wBAAwB,+BAA+B,qBAAqB,uBAAuB,wIAAwI,CAC1f,AACD,4EAA4E,+BAA+B,sBAAsB,CAChI,AACD,iEAAiE,SAAS,CACzE","file":"Loading.vue","sourcesContent":["\n.dn-loading[data-v-56b91d80]{position:fixed;z-index:327677;top:-40px;left:-40px;right:-40px;bottom:-40px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=)\n}\n.myfade-enter-active[data-v-56b91d80],.myfade-leave-active[data-v-56b91d80]{-webkit-transition:opacity .5s;transition:opacity .5s\n}\n.myfade-enter[data-v-56b91d80],.myfade-leave-to[data-v-56b91d80]{opacity:0\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  data: function data() {
    return {
      active: false
    };
  },


  computed: {
    classes: function classes() {
      return {
        'dn-loading': true
      };
    }
  },

  methods: {
    show: function show() {
      this.active = true;
    },
    hide: function hide() {
      this.active = false;
    }
  }
};

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "myfade"
    }
  }, [(_vm.active) ? _c('div', {
    class: _vm.classes
  }, [_c('dn-spinner')], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(338),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f075672e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(336);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("9a65942c", content, true, {});

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".dn-loading-spinner[data-v-f075672e]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/ui/components/loadings/LoadingSpinner.vue"],"names":[],"mappings":"AACA,qCAAqC,oBAAoB,qBAAqB,oBAAoB,aAAa,yBAAyB,2BAA2B,sBAAsB,mBAAmB,wBAAwB,+BAA+B,qBAAqB,sBAAsB,CAC7S","file":"LoadingSpinner.vue","sourcesContent":["\n.dn-loading-spinner[data-v-f075672e]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


exports.default = {
  data: function data() {
    return {};
  },


  computed: {
    classes: function classes() {
      return {
        'dn-loading-spinner': true
      };
    }
  },

  methods: {}
};

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('dn-spinner')], 1)
},staticRenderFns: []}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DbDownloader = __webpack_require__(340);

var _DbDownloader2 = _interopRequireDefault(_DbDownloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  DbDownloader: _DbDownloader2.default
};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(341)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(344),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-661537c1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(342);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4ffb6ec6", content, true, {});

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".dn-db-downloader[data-v-661537c1]{background:#fff;border:2px solid #0aa0d7;padding:28px 20px}.dn-db-downloader__lead[data-v-661537c1]{color:#f09405;text-align:center;font-weight:700;font-size:inherit}.dn-db-downloader--has-missing[data-v-661537c1]{text-align:center}.dn-db-downloader--has-missing .my-message[data-v-661537c1]{display:inline-block;text-align:left}.my-about-data[data-v-661537c1]{font-size:90%}.my-about-data p[data-v-661537c1]{margin-top:10px;text-indent:-1em;padding-left:1em}.my-about-data p[data-v-661537c1]:before{content:\"\\30FB\"}.my-message[data-v-661537c1]{font-size:90%}.my-actions[data-v-661537c1],.my-message[data-v-661537c1]{margin-top:20px;text-align:center}@media (max-width:709px){.my-actions[data-v-661537c1]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.my-btn-download[data-v-661537c1]{margin-bottom:20px}}@media (min-width:710px){.my-btn-download[data-v-661537c1]{min-width:200px;margin-left:15px}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/ui/components/downloader/DbDownloader.vue"],"names":[],"mappings":"AAEA,mCAAmC,gBAAgB,yBAAyB,iBAAiB,CAC5F,AACD,yCAAyC,cAAc,kBAAkB,gBAAgB,iBAAiB,CACzG,AACD,gDAAgD,iBAAiB,CAChE,AACD,4DAA4D,qBAAqB,eAAe,CAC/F,AACD,gCAAgC,aAAa,CAC5C,AACD,kCAAkC,gBAAgB,iBAAiB,gBAAgB,CAClF,AACD,yCAAyC,eAAW,CACnD,AACD,6BAA6B,aAAa,CACzC,AACD,0DAA0D,gBAAgB,iBAAiB,CAC1F,AACD,yBACA,6BAA6B,oBAAoB,qBAAqB,oBAAoB,aAAa,4BAA4B,8BAA8B,sCAAsC,kCAAkC,6BAA6B,CACrQ,AACD,kCAAkC,kBAAkB,CACnD,CACA,AACD,yBACA,kCAAkC,gBAAgB,gBAAgB,CACjE,CACA","file":"DbDownloader.vue","sourcesContent":["\n@charset \"UTF-8\";\n.dn-db-downloader[data-v-661537c1]{background:#fff;border:2px solid #0aa0d7;padding:28px 20px\n}\n.dn-db-downloader__lead[data-v-661537c1]{color:#f09405;text-align:center;font-weight:700;font-size:inherit\n}\n.dn-db-downloader--has-missing[data-v-661537c1]{text-align:center\n}\n.dn-db-downloader--has-missing .my-message[data-v-661537c1]{display:inline-block;text-align:left\n}\n.my-about-data[data-v-661537c1]{font-size:90%\n}\n.my-about-data p[data-v-661537c1]{margin-top:10px;text-indent:-1em;padding-left:1em\n}\n.my-about-data p[data-v-661537c1]:before{content:\"・\"\n}\n.my-message[data-v-661537c1]{font-size:90%\n}\n.my-actions[data-v-661537c1],.my-message[data-v-661537c1]{margin-top:20px;text-align:center\n}\n@media (max-width:709px){\n.my-actions[data-v-661537c1]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:reverse;-webkit-flex-direction:column-reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse\n}\n.my-btn-download[data-v-661537c1]{margin-bottom:20px\n}\n}\n@media (min-width:710px){\n.my-btn-download[data-v-661537c1]{min-width:200px;margin-left:15px\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    status: {
      type: Object,
      default: {}
    },

    target: {
      type: [Array, String],
      required: true
    },

    autoRequire: {
      type: Boolean,
      default: true
    }
  },

  model: {
    prop: 'status',
    event: 'change'
  },

  data: function data() {
    return {
      statusName: 'pending',
      progress: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'dn-db-downloader': true,
        'dn-db-downloader--has-update': this.hasUpdate,
        'dn-db-downloader--has-missing': this.hasMissing,
        'dn-db-downloader--has-notexist': this.hasNotexist,
        'dn-db-downloader--has-data': this.hasData
      };
    },
    targetTables: function targetTables() {
      return typeof this.target === 'string' ? [this.target] : this.target;
    },
    isPending: function isPending() {
      return this.statusName === 'pending';
    },
    isReady: function isReady() {
      return this.statusName === 'exist';
    },
    hasUpdate: function hasUpdate() {
      return this.statusName === 'update';
    },
    hasMissing: function hasMissing() {
      return this.statusName === 'missing';
    },
    hasNotexist: function hasNotexist() {
      return this.statusName === 'notexist';
    },
    needShow: function needShow() {
      return !this.isReady && !this.isPending;
    },
    hasData: function hasData() {
      return !this.hasMissing && !this.hasNotexist;
    },
    computedStatus: function computedStatus() {
      return {
        result: this.statusName,
        isPending: this.isPending,
        isReady: this.isReady,
        hasUpdate: this.hasUpdate,
        hasMissing: this.hasMissing,
        hasNotexist: this.hasNotexist,
        needShow: this.needShow,
        hasData: this.hasData,
        progress: this.progress
      };
    }
  },

  mounted: function mounted() {
    if (this.autoRequire) this.require();
  },


  watch: {
    statusName: function statusName(a) {
      this.$emit('change', this.computedStatus);
      if (this.hasData) this.$emit('data-ready');
    },
    progress: function progress() {
      this.$emit('change', this.computedStatus);
    }
  },

  methods: {
    require: function require() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var status;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dn.loading.show();

                _context.prev = 1;
                _context.next = 4;
                return dn.db.getTablesStatus(_this.targetTables);

              case 4:
                status = _context.sent;

                _this.statusName = status.result;

                if (!_this.needShow) {
                  _context.next = 9;
                  break;
                }

                _context.next = 9;
                return _this.download();

              case 9:
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                dn.loading.hide();
                throw new Error(_context.t0);

              case 15:

                dn.loading.hide();

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 11]]);
      }))();
    },
    download: function download() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var downloadResult;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return dn.db.download(_this2.targetTables, {
                  onProgress: function onProgress(e) {
                    _this2.progress = e.value;
                  }
                });

              case 2:
                downloadResult = _context2.sent;

                _this2.statusName = 'exist';
                _this2.$emit('download');

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    showAbout: function showAbout() {
      return this.$refs['dialog-about'].show();
    },
    hideAbout: function hideAbout() {
      return this.$refs['dialog-about'].hide();
    }
  }
};

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (false) ? _c('div', {
    class: _vm.classes
  }, [_c('p', {
    staticClass: "dn-db-downloader__lead"
  }, [(_vm.hasNotexist) ? _c('span', [_vm._v("このページを閲覧するには"), _c('wbr'), _vm._v("データのダウンロードが"), _c('wbr'), _vm._v("必要です")]) : _vm._e(), _vm._v(" "), (_vm.hasUpdate) ? _c('span', [_vm._v("このページのデータに"), _c('wbr'), _vm._v("更新があります。")]) : _vm._e(), _vm._v(" "), (_vm.hasMissing) ? _c('span', [_vm._v("データの再ダウンロードが"), _c('wbr'), _vm._v("必要です")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "my-message"
  }, [(_vm.hasUpdate) ? _c('div', [_c('p', [_vm._v("再度データをダウンロードしてください。")])]) : _vm._e(), _vm._v(" "), (_vm.hasMissing) ? _c('div', [_c('p', [_vm._v("このメッセージが表示される場合以下の原因が考えられます。")]), _vm._v(" "), _vm._m(0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "my-actions"
  }, [_c('dn-btn', {
    staticClass: "my-btn-about dn-btn--block-sp",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showAbout($event)
      }
    }
  }, [_vm._v("データについて")]), _vm._v(" "), _c('dn-btn', {
    staticClass: "my-btn-download dn-btn--block-sp",
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.download($event)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.hasUpdate ? '更新' : 'ダウンロード') + "する\n    ")])], 1), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-about"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("ダウンロードデータについて")]), _vm._v(" "), _c('div', {
    staticClass: "my-about-data"
  }, [_c('p', [_vm._v("お使いの端末の空き容量が不足している場合、データのダウンロードができない場合があります。"), _c('br'), _vm._v("不要なデータを削除の上再度お試し頂くか、十分な空き容量のある端末でお試しください。")]), _vm._v(" "), _c('p', [_vm._v("一度ダウンロードしたデータは、お使いの端末の空き容量が少なくなった際、ブラウザによって自動的に削除される事があります。"), _c('br'), _vm._v("再度ダウンロードをお試しください。")]), _vm._v(" "), _c('p', [_vm._v("Internet Explorerをお使いの場合、データダウンロード中に画面下部に容量拡張を許可するためのダイアログが表示される事があります。このダイアログが表示された場合「はい」を押して容量の拡張を許可してください。"), _c('br'), _vm._v("この許可を行わずにダイアログを閉じるとダウンロードが行えません。")]), _vm._v(" "), _c('p', [_vm._v("Cookie等のブラウザのストレージ機能を有効にしておかないと、正常にダウンロードできない可能性があります。")]), _vm._v(" "), _c('p', [_vm._v("プライベートブラウズモードでは、正常にダウンロードできない可能性があります。")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    staticClass: "dn-btn--block-sp",
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideAbout($event)
      }
    }
  }, [_vm._v("閉じる")])], 1)])], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "mt10"
  }, [_c('li', [_vm._v("・当サイトを含む過去閲覧されたサイトでの保存データが増えた")]), _vm._v(" "), _c('li', [_vm._v("・お使いの端末のストレージの空き容量が不足した")])])
}]}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BcBanner = __webpack_require__(346);

var _BcBanner2 = _interopRequireDefault(_BcBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  BcBanner: _BcBanner2.default
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(348),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    ui: String,
    screen: String,
    type: String,
    size: Object,
    forceMq: String,
    fixed: Boolean,
    expelFixed: Boolean,
    zIndex: [String, Number]
  },

  data: function data() {
    return {
      exist: false
    };
  },


  computed: {
    classes: function classes() {
      return {
        'dn-bc-banner': true
      };
    }
  },

  methods: {
    onExist: function onExist(exist) {
      this.exist = exist;
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return bcBanner.applyElement(_this.$refs.banner, {
                parent: _this,
                onExist: function onExist(exist) {
                  _this.onExist(exist);
                }
              });

            case 2:
              _this.banner = _context.sent;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.banner) this.banner.onBeforeDestroy();
  },
  destroyed: function destroyed() {
    if (this.banner) this.banner.onDestroyed();
    this.banner = null;
    delete this.banner;
  }
};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes,
    attrs: {
      "data-exist": _vm.exist
    }
  }, [_c('div', {
    ref: "banner",
    attrs: {
      "data-is": "bc-banner",
      "data-autoload": "false",
      "data-ui": _vm.ui,
      "data-screen": _vm.screen,
      "data-type": _vm.type,
      "data-size": _vm.size,
      "data-force-mq": _vm.forceMq,
      "data-fixed": _vm.fixed,
      "data-expel-fixed": _vm.expelFixed,
      "data-z-index": _vm.zIndex
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__(350);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Select: _Select2.default
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(352),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    value: {},
    name: String,
    placeholder: String,
    autofocus: Boolean,
    disabled: Boolean,
    readonly: Boolean,
    required: Boolean,
    tabindex: String
  },

  data: function data() {
    return {
      lazyValue: this.value,
      isFocused: false
    };
  },


  computed: {
    classes: function classes() {
      return {
        'dn-select': true,
        'dn-select--focused': this.isFocused,
        'dn-select--disabled': this.disabled
      };
    },


    inputValue: {
      get: function get() {
        return this.lazyValue;
      },
      set: function set(val) {
        this.lazyValue = val;
        this.$emit('input', val);
      }
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  methods: {
    onFocus: function onFocus(e) {
      this.isFocused = true;
      this.$emit('focus', e);
    },
    onBlur: function onBlur(e) {
      this.isFocused = false;
      this.$emit('blur', e);
    }
  },

  created: function created() {}
};

/***/ }),
/* 352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.classes
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "dn-select__node",
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "autofocus": _vm.autofocus,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "required": _vm.required,
      "tabindex": _vm.tabindex
    },
    on: {
      "focus": _vm.onFocus,
      "blur": _vm.onBlur,
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.inputValue = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _c('span', {
    staticClass: "dn-select__icon"
  }, [_c('dn-icon', {
    attrs: {
      "icon": "arrow-down"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _helpers = __webpack_require__(164);

var _expandTransition = __webpack_require__(354);

var _expandTransition2 = _interopRequireDefault(_expandTransition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandTransition = (0, _helpers.createJavaScriptTransition)('expand-transition', (0, _expandTransition2.default)());

exports.default = {
  ExpandTransition: ExpandTransition
};

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var expandedParentClass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    enter: function enter(el, done) {
      el._parent = el.parentNode;

      (0, _helpers.addOnceEventListener)(el, 'transitionend', done);

      el.style.overflow = 'hidden';
      el.style.height = 0;
      el.style.display = 'block';
      expandedParentClass && el._parent.classList.add(expandedParentClass);

      setTimeout(function () {
        return el.style.height = el.scrollHeight + 'px';
      }, 0);
    },
    afterEnter: function afterEnter(el) {
      el.style.overflow = null;
      el.style.height = null;
    },
    leave: function leave(el, done) {
      (0, _helpers.addOnceEventListener)(el, 'transitionend', done);

      el.style.overflow = 'hidden';
      el.style.height = el.offsetHeight + 'px';

      setTimeout(function () {
        return el.style.height = 0;
      }, 100);
    },
    afterLeave: function afterLeave(el) {
      expandedParentClass && el._parent.classList.remove(expandedParentClass);
    }
  };
};

var _helpers = __webpack_require__(164);

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Gnavi = __webpack_require__(356);

var _Gnavi2 = _interopRequireDefault(_Gnavi);

var _LocalNavi = __webpack_require__(366);

var _LocalNavi2 = _interopRequireDefault(_LocalNavi);

var _Submenu = __webpack_require__(369);

var _Submenu2 = _interopRequireDefault(_Submenu);

var _LinkGroups = __webpack_require__(372);

var _LinkGroups2 = _interopRequireDefault(_LinkGroups);

var _LinkGroup = __webpack_require__(165);

var _LinkGroup2 = _interopRequireDefault(_LinkGroup);

var _NavigationPaging = __webpack_require__(373);

var _NavigationPaging2 = _interopRequireDefault(_NavigationPaging);

var _PanelLinkGroup = __webpack_require__(374);

var _PanelLinkGroup2 = _interopRequireDefault(_PanelLinkGroup);

var _NavigationTags = __webpack_require__(166);

var _NavigationTags2 = _interopRequireDefault(_NavigationTags);

var _NavigationTag = __webpack_require__(167);

var _NavigationTag2 = _interopRequireDefault(_NavigationTag);

var _NavigationInfo = __webpack_require__(375);

var _NavigationInfo2 = _interopRequireDefault(_NavigationInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Gnavi: _Gnavi2.default,
  LocalNavi: _LocalNavi2.default,
  Submenu: _Submenu2.default,
  LinkGroups: _LinkGroups2.default,
  LinkGroup: _LinkGroup2.default,
  NavigationPaging: _NavigationPaging2.default,
  PanelLinkGroup: _PanelLinkGroup2.default,
  NavigationTags: _NavigationTags2.default,
  NavigationTag: _NavigationTag2.default,
  NavigationInfo: _NavigationInfo2.default
};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Gnavi = __webpack_require__(357);

var _Gnavi2 = _interopRequireDefault(_Gnavi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Gnavi2.default;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(365),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GnaviInner = __webpack_require__(359);

var _GnaviInner2 = _interopRequireDefault(_GnaviInner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'dn-gnavi',

  components: {
    MyInner: _GnaviInner2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(364),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _GnaviCategory = __webpack_require__(361);

var _GnaviCategory2 = _interopRequireDefault(_GnaviCategory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'dn-gnavi-inner',

  props: {
    device: {
      type: String,
      required: true
    },
    dumped: Boolean
  },

  components: {
    MyCategory: _GnaviCategory2.default
  },

  data: function data() {
    return {
      categoryStates: {}
    };
  },


  computed: {
    classes: function classes() {
      return _defineProperty({
        'dn-gnavi__inner': true,
        'dn-gnavi__inner--dumped': this.dumped
      }, 'dn-gnavi__inner--' + this.device, true);
    },
    categories: function categories() {
      var categories = this.$store.getters['navigation/gnaviCategories'];
      var categoryStates = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = categories[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var category = _step.value;

          if (this.categoryStates[category.id] === undefined) {
            categoryStates[category.id] = category.default || !category.disabled && !!this.dumped || !!category.matched;
          } else {
            categoryStates[category.id] = this.categoryStates[category.id];
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.$set(this, 'categoryStates', categoryStates);

      if (!this.$store.getters['config/isManabi']) {
        // 現在のURLにマッチしたカテゴリを上位表示したければ、、、
        categories.sort(function (a, b) {
          if (a.matched) return -1;
          if (b.matched) return 1;
          return 0;
        });
      }

      return categories;
    }
  }
};

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(363),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'dn-gnavi-inner',

  props: {
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    groups: {
      type: Array,
      required: true
    },
    disabled: Boolean,
    default: Boolean,
    value: Boolean
  },

  data: function data() {
    return {
      innerValue: this.value
    };
  },


  computed: {
    classes: function classes() {
      return _defineProperty({
        'dn-gnavi__category': true,
        'dn-gnavi__category--default': this.default,
        'dn-gnavi__category--disabled': this.disabled,
        'dn-gnavi__category--open': this.opend
      }, 'dn-gnavi__category--' + this.id, true);
    },
    computedGroups: function computedGroups() {
      var groups = [];
      this.groups.forEach(function (group) {
        var links = group.links.filter(function (link) {
          return !link.data.gnaviIgnore && link.data.gnaviIgnore !== '';
        });
        if (links.length > 0) {
          groups.push(Object.assign({}, group, { links: links }));
        }
      });
      return groups;
    },


    opend: {
      get: function get() {
        return this.innerValue;
      },
      set: function set(val) {
        this.innerValue = val;
        this.$emit('input', val);
      }
    }
  },

  watch: {
    value: function value(val) {
      this.innerValue = val;
    }
  },

  methods: {
    toggle: function toggle() {
      if (this.disabled) return;
      this.opend = !this.opend;
    }
  }
};

/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    class: _vm.classes
  }, [(_vm.$store.getters['config/isManabi']) ? [(_vm.id === 'seiseki') ? [_c('dt', {
    staticClass: "dn-gnavi__category-name",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dn-icon dn-icon-arrow-down is-white"
  })]), _vm._v(" "), _c('dn-expand-transition', [_c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "dn-gnavi__category-body"
  }, [_vm._l((_vm.computedGroups), function(group) {
    return [(group.label) ? _c('span', {
      key: group.id + '-label',
      staticClass: "dn-gnavi__link dn-gnavi__label",
      domProps: {
        "innerHTML": _vm._s(group.label)
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((group.links), function(link) {
      return _c('a', {
        directives: [{
          name: "linkset",
          rawName: "v-linkset",
          value: (link.url_id),
          expression: "link.url_id"
        }],
        key: link.id,
        staticClass: "dn-gnavi__link",
        class: {
          'dn-gnavi__link--auth': link.auth,
            'dn-gnavi__link--matched': link.matched,
            'dn-gnavi__link--index-matched': (link.data.groupIndex || link.data.groupIndex === '') && link.group.matched,
        },
        attrs: {
          "href": link.href,
          "target": link.target
        }
      }, [_c('i', {
        staticClass: "dn-gnavi__link__bg"
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-gnavi__text",
        domProps: {
          "innerHTML": _vm._s(link.label)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-icon dn-icon-arrow-right"
      })])
    })]
  })], 2)])] : (_vm.id === 'TOP' || _vm.id === 'myuniv_bible' || _vm.id === 'exam_bible' || _vm.id === 'self_check') ? [_c('dt', {
    staticClass: "dn-gnavi__category-name",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])] : (_vm.id === 'manabi' || 'dn') ? [_c('dt', {
    staticClass: "dn-gnavi__category-name"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  })])] : _vm._e()] : [_c('dt', {
    staticClass: "dn-gnavi__category-name",
    on: {
      "click": _vm.toggle
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dn-icon dn-icon-arrow-right is-white"
  }), _vm._v(" "), _c('span', {
    staticClass: "dn-icon dn-icon-arrow-up is-white"
  })]), _vm._v(" "), _c('dn-expand-transition', [_c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opend),
      expression: "opend"
    }],
    staticClass: "dn-gnavi__category-body"
  }, [_vm._l((_vm.computedGroups), function(group) {
    return [(group.label) ? _c('span', {
      key: group.id + '-label',
      staticClass: "dn-gnavi__link dn-gnavi__label",
      domProps: {
        "innerHTML": _vm._s(group.label)
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((group.links), function(link) {
      return _c('a', {
        directives: [{
          name: "linkset",
          rawName: "v-linkset",
          value: (link.url_id),
          expression: "link.url_id"
        }],
        key: link.id,
        staticClass: "dn-gnavi__link",
        class: {
          'dn-gnavi__link--auth': link.auth,
            'dn-gnavi__link--matched': link.matched,
            'dn-gnavi__link--current': link.current,
            'dn-gnavi__link--index-matched': (link.data.groupIndex || link.data.groupIndex === '') && link.group.matched,
        },
        attrs: {
          "href": link.href,
          "target": link.target
        }
      }, [_c('i', {
        staticClass: "dn-gnavi__link__bg"
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-gnavi__text",
        domProps: {
          "innerHTML": _vm._s(link.label)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-icon dn-icon-arrow-right"
      })])
    })]
  })], 2)])]], 2)
},staticRenderFns: []}

/***/ }),
/* 364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, _vm._l((_vm.categories), function(category) {
    return _c('my-category', {
      key: category.id,
      attrs: {
        "id": category.id,
        "default": category.default,
        "disabled": category.disabled,
        "label": category.label,
        "groups": category.groups
      },
      model: {
        value: (_vm.categoryStates[category.id]),
        callback: function($$v) {
          _vm.$set(_vm.categoryStates, category.id, $$v)
        },
        expression: "categoryStates[category.id]"
      }
    })
  }))
},staticRenderFns: []}

/***/ }),
/* 365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "dn-gnavi"
  }, [_c('my-inner', {
    attrs: {
      "device": "pc",
      "dumped": !_vm.$store.getters['config/isManabi']
    }
  }), _vm._v(" "), _c('my-inner', {
    attrs: {
      "device": "sp"
    }
  }), _vm._v(" "), _c('dn-bc-banner', {
    staticClass: "dn-gnavi__bc-banner",
    attrs: {
      "screen": "103",
      "type": "04,05"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(368),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'dn-local-navi',

  computed: {
    data: function data() {
      return this.$store.getters['navigation/localNaviCategory'];
    },
    id: function id() {
      return this.data && this.data.id;
    },
    label: function label() {
      return this.data && this.data.label;
    },
    groups: function groups() {
      return this.data && this.data.groups;
    }
  }
};

/***/ }),
/* 368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.data) ? _c('nav', {
    class: ("dn-local-navi dn-local-navi--" + _vm.id)
  }, [_c('h3', {
    staticClass: "dn-local-navi__ttl",
    domProps: {
      "innerHTML": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dn-local-navi__body"
  }, [_vm._l((_vm.groups), function(group) {
    return [(group.label) ? _c('span', {
      key: group.id + '-label',
      staticClass: "dn-local-navi__link dn-local-navi__label",
      domProps: {
        "innerHTML": _vm._s(group.label)
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((group.links), function(link) {
      return _c('a', {
        directives: [{
          name: "linkset",
          rawName: "v-linkset",
          value: (link.url_id),
          expression: "link.url_id"
        }],
        key: link.id,
        staticClass: "dn-local-navi__link",
        class: {
          'dn-local-navi__link--active': link.matched
        },
        attrs: {
          "href": link.href,
          "target": link.target
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(link.label)
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "dn-icon dn-icon-arrow-right"
      })])
    })]
  })], 2)]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(371),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'dn-submenu',

  computed: {
    items: function items() {
      return this.$store.getters['navigation/submenus'];
    }
  },

  methods: {
    showAttributeDialog: function showAttributeDialog() {
      dn.attributeDialog.show();
    }
  }
};

/***/ }),
/* 371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "dn-submenu"
  }, [_vm._l((_vm.items), function(item, index) {
    return _c('a', {
      directives: [{
        name: "linkset",
        rawName: "v-linkset",
        value: (item.url_id),
        expression: "item.url_id"
      }],
      key: index,
      class: ("dn-submenu__item" + (item.className ? ' ' + item.className : '')),
      attrs: {
        "href": item.href,
        "target": item.target
      }
    }, [_c('span', {
      staticClass: "dn-icon dn-icon-arrow-right"
    }), _c('span', {
      staticClass: "dn-submenu__text",
      domProps: {
        "innerHTML": _vm._s(item.label)
      }
    })])
  }), _vm._v(" "), _c('a', {
    staticClass: "dn-submenu__item",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.showAttributeDialog
    }
  }, [_c('span', {
    staticClass: "dn-icon dn-icon-arrow-right"
  }), _c('span', {
    staticClass: "dn-submenu__text"
  }, [_vm._v("属性確認")])])], 2)
},staticRenderFns: []}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _LinkGroup = __webpack_require__(165);

var _LinkGroup2 = _interopRequireDefault(_LinkGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'dn-link-groups',

  props: {
    category: {
      type: String,
      required: true
    },
    ignore: {
      type: [String, Array]
    }
  },

  computed: {
    computedIgnore: function computedIgnore() {
      var ignore = this.ignore;

      if (!ignore) return [];
      return Array.isArray(ignore) ? ignore : [ignore];
    },
    computedCategory: function computedCategory() {
      return this.$store.getters['navigation/category'](this.category);
    }
  },

  render: function render(h) {
    var _this = this;

    var category = this.computedCategory;
    if (!category) return;

    var ignore = this.computedIgnore;
    var groups = category.groups.filter(function (group) {
      return group.links.length > 0 && !ignore.includes(group.id);
    });

    return h('div', {
      staticClass: 'dn-link-groups'
    }, groups.map(function (group) {
      return h(_LinkGroup2.default, {
        props: {
          category: _this.category,
          group: group.id
        },
        key: group.id
      });
    }));
  }
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = {
  name: 'dn-navigation-paging',

  props: {
    category: {
      type: String,
      required: true
    },
    group: {
      type: String,
      required: true
    }
  },

  computed: {
    computedGroup: function computedGroup() {
      return this.$store.getters['navigation/categoryGroup'](this.category, this.group);
    }
  },

  methods: {
    genLink: function genLink(link, type) {
      var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.$createElement;

      var tag = link ? 'a' : 'span';
      var attrs = link ? {
        href: link.href
      } : undefined;

      if (link && link.target) {
        attrs.target = link.target;
      }

      var typeName = type === 'prev' ? '前の' : '次の';
      var children = link ? [h('span', {
        staticClass: 'dn-navigation-paging__link__ttl',
        domProps: {
          innerHTML: '<span class="dn-navigation-paging__link__ttl__inner">' + typeName + '<br>ページ</span>'
        }
      }), h('span', {
        staticClass: 'dn-navigation-paging__link__label'
      }, [h('span', {
        staticClass: 'dn-navigation-paging__link__label__box'
      }, [h('span', {
        staticClass: 'dn-navigation-paging__link__label__box__inner'
      }, [h('span', {
        // domProps: {
        //   innerHTML: link.label.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, ''),
        // },
        directives: [{
          name: 'line-clamp',
          value: {
            lines: 2,
            text: link.label.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g, '')
          }
        }]
      })])])]), h('i', {
        staticClass: 'dn-navigation-paging__link__tri'
      })] : undefined;

      return h(tag, {
        staticClass: 'dn-navigation-paging__link',
        class: _defineProperty({}, 'dn-navigation-paging__link--' + type, true),
        attrs: attrs,
        style: {
          visibility: link ? 'visible' : 'hidden'
        },
        key: type
      }, children);
    }
  },

  render: function render(h) {
    var group = this.computedGroup;
    if (!group) return;

    var current = group.links.find(function (l) {
      return l.matched;
    });
    if (!current) return;

    var currentIndex = group.links.indexOf(current);
    var prev = group.links[currentIndex - 1];
    var next = group.links[currentIndex + 1];
    prev = prev && !prev.data.groupIndex && prev.data.groupIndex !== '' ? prev : null;
    next = next && !next.data.groupIndex && next.data.groupIndex !== '' ? next : null;

    if (!prev && !next) return;

    return h('nav', {
      staticClass: 'dn-navigation-paging'
    }, [this.genLink(prev, 'prev'), this.genLink(next, 'next')]);
  }
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'dn-panel-link-group',

  props: {
    category: {
      type: String,
      required: true
    },
    group: {
      type: String,
      required: true
    }
  },

  computed: {
    computedGroup: function computedGroup() {
      return this.$store.getters['navigation/categoryGroup'](this.category, this.group);
    },
    computedLinks: function computedLinks() {
      var group = this.computedGroup;
      if (!group) return [];

      return group.links.slice().sort(function (a, b) {
        if (a.created && b.created) {
          if (a.created.timestamp > b.created.timestamp) return -1;
          if (a.created.timestamp < b.created.timestamp) return 1;
          return -1;
        }
        if (a.created) return -1;
        if (b.created) return 1;
        return 0;
      });
    }
  },

  render: function render(h) {
    var group = this.computedGroup;
    if (!group) return;

    var links = this.computedLinks;
    var label = group.label;

    var $children = [];

    if (this.title) {
      $children.push(h('h3', {
        staticClass: 'dn-link-group__title',
        class: {
          'dn-heading-3': this.isList
        },
        domProps: {
          innerHTML: label + (this.isBlock ? ' 関連ページ' : '')
        }
      }));
    }

    var $links = links.filter(function (link) {
      return !link.data.groupIndex && link.data.groupIndex !== '';
    }).map(function (link) {
      var updateChildren = [link[link.publishState].fullLabel + ' ' + (link.publishState === 'created' ? '公開' : '更新')];

      // if (link.created.latest) {
      //   updateChildren.push(h('span', {
      //     staticClass: 'dn-panel-link-group__update-new',
      //   }, 'NEW'));
      // }

      var $update = link.publishState ? h('span', {
        staticClass: 'dn-panel-link-group__update-label'
        // class: {
        //   'dn-panel-link-group__update-latest': link.created.latest,
        // },
      }, updateChildren) : null;

      var $icon = h('span', {
        staticClass: 'dn-panel-link-group__icon'
      }, [h('dn-icon', { props: { icon: 'arrow-right' } })]);

      var $label = h('span', {
        staticClass: 'dn-panel-link-group__label',
        domProps: {
          innerHTML: link.label
        }
      });

      var $title = h('div', {
        staticClass: 'dn-panel-link-group__ttl'
      }, [$icon, $label]);

      var $tags = link.tags ? link.tags.map(function (tag, index) {
        tag = typeof tag === 'string' ? { color: 'default', text: tag } : tag;
        return h('dn-navigation-tag', {
          props: {
            tag: 'li',
            color: tag.color
          },
          key: index
        }, tag.text);
      }) : null;

      var infoChildren = [$update];
      if ($tags) {
        infoChildren.unshift(h('ul', {
          staticClass: 'dn-panel-link-group__tags'
        }, $tags));
      }

      var $info = h('div', {
        staticClass: 'dn-panel-link-group__info'
      }, infoChildren);

      var domProps = {
        href: link.href
      };

      if (link.target) {
        domProps.target = link.target;
      }

      var linkChildren = [$title, $info];

      return h('a', {
        staticClass: 'dn-panel-link-group__link',
        domProps: domProps
      }, linkChildren);
    });

    return h('nav', {
      staticClass: 'dn-panel-link-group'
    }, $links);
  }
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationTags = __webpack_require__(166);

var _NavigationTags2 = _interopRequireDefault(_NavigationTags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'dn-navigation-info',

  props: {
    link: [Object, String],
    tags: {
      type: Boolean
      // default: true,
    }
  },

  computed: {
    computedLink: function computedLink() {
      var link = this.link;

      if (!link) {
        link = this.$store.getters['navigation/matchedLink'];
      } else if (link === 'latest') {
        var group = this.$store.getters['navigation/matchedGroup'];
        if (!group) return;
        link = group.links.find(function (l) {
          return l.created && !!l.created.latest;
        });
      }

      return link || null;
    }
  },

  render: function render(h) {
    var link = this.computedLink;
    if (!link) return;

    var children = [];

    if (link.publishState) {
      var publishinfo = link[link.publishState];
      var suffix = link.publishState === 'created' ? '公開' : '更新';
      var time = publishinfo.hours + ':' + String(publishinfo.minutes).padStart(2, '0');
      var label = publishinfo.shortLabel + ' ' + time + ' ' + suffix;
      children.push(h('p', {
        staticClass: 'mdTxtUpdate01 tar mb10'
      }, label));
    }

    if (this.tags && link.tags) {
      children.push(h(_NavigationTags2.default, {
        props: {
          lg: true,
          title: 'ジャンル',
          link: link
        }
      }));
    }

    if (children.length === 0) return;

    return h('div', {
      staticClass: 'dn-navigation-info'
    }, children);
  }
};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TopMessages = __webpack_require__(377);

var _TopMessages2 = _interopRequireDefault(_TopMessages);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  TopMessages: _TopMessages2.default
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(379),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'dn-top-messages',

  computed: {
    messages: function messages() {
      return this.$store.getters['notices/notices'];
    },
    isExist: function isExist() {
      return this.$store.getters['notices/exist'];
    }
  }
};

/***/ }),
/* 379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isExist) ? _c('div', {
    staticClass: "dn-top-messages"
  }, _vm._l((_vm.messages), function(message, index) {
    return _c('p', {
      key: index,
      class: message.className || '',
      domProps: {
        "innerHTML": _vm._s(message.body)
      }
    })
  })) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Static = __webpack_require__(381);

var _Static2 = _interopRequireDefault(_Static);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Static: _Static2.default
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'dn-static',

  data: function data() {
    return {
      tag: null,
      directives: [],
      attributes: {},
      html: null,
      text: null
    };
  },


  methods: {
    getMyContextValue: function getMyContextValue(str) {
      var value = void 0;
      try {
        return eval('(' + str + ')');
      } catch (e) {}

      try {
        return function () {
          return eval('(this.' + str + ')');
        }.call(this);
      } catch (e) {}
    }
  },

  render: function render(h) {
    if (!this.tag) {
      this.tag = this.$el.tagName.toLowerCase();
      this.id = this.$el.id;
      this.staticClass = this.$el.className;
      this.staticStyle = this.$el.getAttribute('style');

      for (var i = 0, attrs = this.$el.attributes, l = attrs.length; i < l; i++) {
        var attr = attrs[i],
            name = attr.nodeName,
            value = attr.value;

        if (name === 'is') continue;
        if (name === 'v-html') {
          this.html = value;
          continue;
        }
        if (name === 'v-text') {
          this.text = value;
          continue;
        }

        if (name.indexOf('v-') === 0) {
          this.directives.push({ name: name.replace(/^v-/, ''), value: value });
        } else {
          this.attributes[name] = value;
        }
      }
    }

    var rowHtml = void 0;
    if (this.html) {
      rowHtml = this.getMyContextValue(this.html);
    }

    var children = !rowHtml && this.text || this.$slots.default;
    return h(this.tag, {
      attrs: this.attributes,
      directives: this.directives,
      domProps: {
        innerHTML: rowHtml ? rowHtml : undefined
      }
    }, children);
  }
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// import CenterCounter from './CenterCounter';
// import TwitterTimeline from './TwitterTimeline';
// import ShareWidget from './ShareWidget';

// export default {
// TODO 0717非表示
// CenterCounter,
// TwitterTimeline,
// ShareWidget,
// }


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = arraySplitter;
function arraySplitter(array, column) {
  var result = [];

  var max = Math.round(array.length / column),
      current = -1;

  array.forEach(function (col, index) {
    if (index % max === 0) {
      current++;
    }
    if (result[current] === undefined) {
      result[current] = [];
    }
    result[current].push(col);
  });

  return result;
}

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (str) {
  var upper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  str = str || '';
  str = str.replace(/^[\-_ ]/g, '').replace(/[\-_ ]./g, function (match) {
    return match.charAt(1).toUpperCase();
  });

  return upper ? str.replace(/^[a-z]/g, function (match) {
    return match.toUpperCase();
  }) : str;
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _http = __webpack_require__(41);

var _http2 = _interopRequireDefault(_http);

var _index = __webpack_require__(161);

var _index2 = _interopRequireDefault(_index);

var _index3 = __webpack_require__(386);

var _index4 = _interopRequireDefault(_index3);

var _load = __webpack_require__(391);

var _load2 = _interopRequireDefault(_load);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PREFIX_SETTING = {
  componentPrefix: 'dn',
  directivePrefix: ''
};

function plugin(Vue) {

  // Directives
  Object.keys(_index4.default).forEach(function (key) {
    Vue.directive('' + PREFIX_SETTING.directivePrefix + key, _index4.default[key]);
  });

  // Components
  Object.keys(_index2.default).forEach(function (key) {
    Vue.component('' + PREFIX_SETTING.componentPrefix + key, _index2.default[key]);
  });

  Vue.prototype.$dn = {
    load: _load2.default,
    blurActiveElement: blurActiveElement,
    sleep: function sleep(ammount) {
      return new Promise(function (resolve) {
        return setTimeout(resolve, ammount);
      });
    }
  };

  Vue.prototype.$scrollToTop = function () {
    blurActiveElement();
    return this.$scrollTo(document.body);
  };

  function blurActiveElement() {
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
  }

  // Global Methods
  Vue.prototype.$delay = function (ammount) {
    var _this = this;

    var canceled = false,
        canceller = function canceller() {
      canceled = true;
    };

    var promise = new Promise(function (resolve, reject) {
      setTimeout(function () {
        if (!_this._isDestroyed && !canceled) resolve();
      }, ammount);
    });

    return {
      cancel: canceller,
      promise: promise
    };
  };

  Vue.prototype.$confirm = function (opt) {
    return dn.$refs.confirmDialog.show(opt);
  };

  Vue.prototype.$alert = function (opt) {
    return dn.$refs.alertDialog.show(opt);
  };

  // @TODO : ちゃんとファイルわける
  var $ls = {
    get: function get(keyMap, defaultValue) {
      return dn.$store.getters['ls/at'](keyMap, defaultValue);
    },
    set: function set(keyMap, value) {
      return dn.$store.dispatch('ls/set', { keyMap: keyMap, value: value });
    },
    delete: function _delete(keyMap) {
      return dn.$store.dispatch('ls/delete', keyMap);
    }
  };

  Vue.prototype.$ls = $ls;

  var $status = {
    display: function display(id, divider) {
      return dn.$store.getters['status/displayAt'](id, divider);
    }
  };
  Vue.prototype.$status = $status;
  Vue.prototype.$http = _http2.default;
}

exports.default = plugin;

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _clickOutside = __webpack_require__(387);

var _clickOutside2 = _interopRequireDefault(_clickOutside);

var _linkset = __webpack_require__(388);

var _linkset2 = _interopRequireDefault(_linkset);

var _numberRange = __webpack_require__(389);

var _numberRange2 = _interopRequireDefault(_numberRange);

var _lineClamp = __webpack_require__(390);

var _lineClamp2 = _interopRequireDefault(_lineClamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  ClickOutside: _clickOutside2.default,
  Linkset: _linkset2.default,
  NumberRange: _numberRange2.default,
  LineClamp: _lineClamp2.default
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var getBindingValues = function getBindingValues(binding) {
  var _values = binding.value || {},
      values = {};

  if (typeof _values === 'function') {
    values.callback = _values;
  } else if ((typeof _values === 'undefined' ? 'undefined' : _typeof(_values)) === 'object') {
    values.callback = _values.callback;
    values.outside = _values.outside;
  }

  if (!values.outside) {
    values.outside = document.documentElement;
  }

  return values;
};

var getPositionByEvent = function getPositionByEvent(e) {
  var point = e.changedTouches ? e.changedTouches[0] : e;
  return { x: point.pageX, y: point.pageY };
};

var getLengthByPosition = function getLengthByPosition(startPosition, endPosition) {
  var x2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var y2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var x1 = void 0,
      y1 = void 0;
  if (x2 === null) {
    x1 = startPosition.x;
    y1 = startPosition.y;
    x2 = endPosition.x;
    y2 = endPosition.y;
  } else {
    x1 = startPosition;
    y1 = endPosition;
  }
  return Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
};

var JUDGE_TAP_CANCEL_RANGE = 44;

exports.default = {
  bind: function bind(el, binding, v) {
    v.context.$dn.load(function () {
      var bindingValues = getBindingValues(binding);
      var outside = bindingValues.outside;

      var isTouch = false,
          isCancel = false,
          moveLength = 0,
          startPosition = null;

      var touchStart = function touchStart(e) {
        isTouch = true;
        isCancel = false;
        moveLength = 0;
        startPosition = getPositionByEvent(e);
      };

      var touchMove = function touchMove(e) {
        if (!isTouch || !startPosition || isCancel) return;

        var currentPosition = getPositionByEvent(e),
            length = getLengthByPosition(startPosition, currentPosition);

        moveLength += length;

        if (moveLength >= JUDGE_TAP_CANCEL_RANGE) isCancel = true;
      };

      var touchEnd = function touchEnd(e) {
        if (!isTouch || isCancel) return;
        isTouch = false;
        isCancel = false;
        startPosition = null;

        var cb = function cb() {
          return true;
        };

        if (bindingValues.callback) cb = bindingValues.callback;

        if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
          if (typeof v.context.hide === 'function') {
            v.context.hide();
          } else {
            v.context.isActive = false;
          }
        }
      };

      outside.addEventListener('touchstart', touchStart, false);
      outside.addEventListener('mousedown', touchStart, false);
      outside.addEventListener('touchmove', touchMove, false);
      outside.addEventListener('mousemove', touchMove, false);
      outside.addEventListener('touchend', touchEnd, false);
      outside.addEventListener('mouseup', touchEnd, false);

      el.touchStartOutside = touchStart;
      el.touchMoveOutside = touchMove;
      el.touchEndOutside = touchEnd;
    });
  },
  unbind: function unbind(el, binding) {
    var bindingValues = getBindingValues(binding);
    var outside = bindingValues.outside;

    if (outside) {
      outside.removeEventListener('touchstart', el.touchStartOutside, false);
      outside.removeEventListener('mousedown', el.touchStartOutside, false);
      outside.removeEventListener('touchmove', el.touchMoveOutside, false);
      outside.removeEventListener('mousemove', el.touchMoveOutside, false);
      outside.removeEventListener('touchend', el.touchEndOutside, false);
      outside.removeEventListener('mouseup', el.touchEndOutside, false);
    }
  }
};

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DISABLED_CLASS_NAME = 'dn-link--disabled';

var defaultOptions = function defaultOptions() {
  return {
    defaultHref: null,
    defaultTarget: null,
    enabledClass: null,
    disabledClass: null,
    disabled: false
  };
};

var functions = {
  enabled: {
    a: function a($el, options, useDefault) {
      var href = useDefault ? options.defaultHref : options.href,
          target = useDefault ? options.defaultTarget : options.target;

      $el.data('href-origin', null);
      $el.data('target-origin', null);
      $el.removeAttr('nohref');
      $el.attr('href', href);
      if (target) $el.attr('target', target);
      $el.removeClass(DISABLED_CLASS_NAME);

      if (options.enabledClass) $el.addClass(options.enabledClass);
      if (options.disabledClass) $el.removeClass(options.disabledClass);
    }
  },

  disabled: {
    a: function a($el, options) {
      $el.data('href-origin', options.href);
      $el.data('target-origin', options.target);

      $el.removeAttr('href');
      $el.attr('nohref', 'nohref');
      $el.addClass(DISABLED_CLASS_NAME);

      if (options.enabledClass) $el.removeClass(options.enabledClass);
      if (options.disabledClass) $el.addClass(options.disabledClass);
    }
  }
};

exports.default = {
  bind: function bind(el, binding, v) {
    if (!binding.value) return;
    var $el = $(el),
        href = $el.prop('href'),
        target = $el.prop('target'),
        options = Object.assign(defaultOptions(), { href: href, target: target }, typeof binding.value === 'string' ? { id: binding.value } : binding.value),
        id = options.id,
        tagName = el.tagName.toLowerCase();

    var currentEnabled = false;

    // オリジナルの情報をエレメントに保持しておく
    el.setAttribute('data-dn-linkset-origin-id', id);
    el.setAttribute('data-dn-linkset-origin-href', href);

    // まず無効化しておく
    functions.disabled[tagName]($el, options);

    var tick = function tick() {
      var hasDefault = options.defaultHref;

      var isEnabled = !options.disabled && (hasDefault || v.context.$store.getters['links/enabled'](id));
      if (isEnabled === currentEnabled) return;
      if (isEnabled && !currentEnabled) {
        functions.enabled[tagName]($el, options, hasDefault);
      } else if (!isEnabled && currentEnabled) {
        functions.disabled[tagName]($el, options);
      }
      currentEnabled = isEnabled;
    };

    tick();
    el._dn_linkset_unwatcher = v.context.$watch('$store.state.links.links', tick, { deep: true });
  },
  unbind: function unbind(el) {
    if (el._dn_linkset_unwatcher) {
      el._dn_linkset_unwatcher();
      el._dn_linkset_unwatcher = null;
      delete el._dn_linkset_unwatcher;
    }
  }
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function onInput(e) {
  var el = e.target;

  var min = parseInt(el.min, 10),
      max = parseInt(el.max, 10),
      originalValue = el.value + '',
      value = originalValue;

  // 全角数字を半角に変換
  value = value.replace(/[！-～]/g, function (tmpStr) {

    // 文字コードをシフト
    return String.fromCharCode(tmpStr.charCodeAt(0) - 0xFEE0);
  });

  // 数字以外を削除
  value = value.replace(/[^0-9]/g, '');

  // 0処理
  //   0以外の入力があれば先頭の0を全部削除
  //   0だけであれば連続0を1つにする
  value = value.replace(/^0+/, /[1-9]/.test(value) ? '' : '0');

  value = parseInt(value, 10);

  min = isNaN(min) ? null : min;
  max = isNaN(max) ? null : max;
  value = isNaN(value) ? null : value;

  if (value === null) {
    value = '';
  } else {
    if (min !== null && value < min) {
      value = min;
    } else if (max !== null && value > max) {
      value = max;
    }
    value = String(value);
  }

  if (value !== originalValue) {
    el.value = value;
    var event = document.createEvent('Event');
    event.initEvent('input', true, true);
    el.dispatchEvent(event);
  }
}

function bindNumberInRange(el, binding, vnode) {
  el.addEventListener('input', onInput, false);
}

exports.default = {
  bind: function bind(el, binding, vnode) {
    bindNumberInRange(el, binding, vnode);
  },
  componentUpdated: function componentUpdated(el, binding, vnode) {
    bindNumberInRange(el, binding, vnode);
  }
};

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function truncateTextNode(textNode, rootElement, maximumHeight, ellipsisCharacter) {
  var lastIndexOfWhitespace;
  var textContent = textNode.textContent;
  while (textContent.length > 1) {
    lastIndexOfWhitespace = textContent.lastIndexOf(' ');
    if (lastIndexOfWhitespace === -1) {
      break;
    }
    textNode.textContent = textContent.substring(0, lastIndexOfWhitespace);
    if (rootElement.scrollHeight <= maximumHeight) {
      textNode.textContent = textContent;
      break;
    }
    textContent = textNode.textContent;
  }
  return truncateTextNodeByCharacter(textNode, rootElement, maximumHeight, ellipsisCharacter);
}

var TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX = /[ .,;!?'‘’“”\-–—]+$/;
function truncateTextNodeByCharacter(textNode, rootElement, maximumHeight, ellipsisCharacter) {
  var textContent = textNode.textContent;
  var length = textContent.length;
  while (length > 1) {
    // Trim off one trailing character and any trailing punctuation and whitespace.
    textContent = textContent.substring(0, length - 1).replace(TRAILING_WHITESPACE_AND_PUNCTUATION_REGEX, '');
    length = textContent.length;
    textNode.textContent = textContent + ellipsisCharacter;
    if (rootElement.scrollHeight <= maximumHeight) {
      return true;
    }
  }
  return false;
}

function truncateElementNode(element, rootElement, maximumHeight, ellipsisCharacter) {
  var childNodes = element.childNodes;
  var i = childNodes.length - 1;
  while (i > -1) {
    var childNode = childNodes[i--];
    var nodeType = childNode.nodeType;
    if (nodeType === 1 && truncateElementNode(childNode, rootElement, maximumHeight, ellipsisCharacter) || nodeType === 3 && truncateTextNode(childNode, rootElement, maximumHeight, ellipsisCharacter)) {
      return true;
    }
    element.removeChild(childNode);
  }
  return false;
}

var ELLIPSIS_CHARACTER = '\u2026';

function lineClamp(rootElement, lineCount, options) {
  rootElement.style.cssText += 'overflow:hidden;overflow-wrap:break-word;word-wrap:break-word';

  var maximumHeight = (lineCount || 1) * parseInt(window.getComputedStyle(rootElement).lineHeight, 10) + 4; // @todo: IE11 fix

  // Exit if text does not overflow `rootElement`.
  if (rootElement.scrollHeight <= maximumHeight) {
    return;
  }

  truncateElementNode(rootElement, rootElement, maximumHeight, options && options.ellipsis || ELLIPSIS_CHARACTER);
}

function setup(el, binding) {
  if (el.__lineClampFn__) return;
  var options = binding.value && _typeof(binding.value) === 'object' ? binding.value : { lines: binding.value };
  if (options.text === undefined) options.text = el.innerHTML;
  var lines = options.lines || 3;
  var retryCount = 0;
  el.__lineClampOriginalContent__ = options.text;
  el.__lineClampFn__ = function () {
    el.innerHTML = el.__lineClampOriginalContent__;
    lineClamp(el, lines);
    retryCount++;

    if (retryCount < 10) {
      var result = (el.innerHTML || '').trim();
      if (!result) {
        setTimeout(function () {
          el.__lineClampFn__ && el.__lineClampFn__();
        }, 250);
      }
    }
  };

  window.addEventListener('resize', el.__lineClampFn__, false);
  window.addEventListener('load', el.__lineClampFn__, false);
}

function reset(el) {
  if (!el.__lineClampFn__) return;
  window.removeEventListener('resize', el.__lineClampFn__, false);
  window.removeEventListener('load', el.__lineClampFn__, false);
  delete el.__lineClampFn__;
  delete el.__lineClampOriginalContent__;
}

exports.default = {
  inserted: function inserted(el, binding) {
    setup(el, binding);
    el.__lineClampFn__();
  },
  componentUpdated: function componentUpdated(el, binding) {
    if (el.__lineClampOriginalContent__ !== el.innerHTML) {
      reset(el);
      setup(el, binding);
      el.__lineClampFn__();
    }
  },
  unbind: function unbind(el, binding) {
    reset(el, binding);
  }
};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  $(cb);
  // if (document.readyState === 'complete') {
  //   return setTimeout(cb, 0)
  // }

  // if (document.readyState === 'interactive' && i <= 10) {
  //   return setTimeout(() => load(cb, i + 1), 200)
  // }

  // window.addEventListener('load', cb)
}

exports.default = load;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueRouter = __webpack_require__(155);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vuexRouterSync = __webpack_require__(393);

var _store = __webpack_require__(169);

var _store2 = _interopRequireDefault(_store);

var _helpers = __webpack_require__(168);

var _helpers2 = _interopRequireDefault(_helpers);

var _windowManager = __webpack_require__(175);

var _windowManager2 = _interopRequireDefault(_windowManager);

var _WebPushManager = __webpack_require__(425);

var _WebPushManager2 = _interopRequireDefault(_WebPushManager);

var _DbManager = __webpack_require__(426);

var _DbManager2 = _interopRequireDefault(_DbManager);

var _GaManager = __webpack_require__(472);

var _GaManager2 = _interopRequireDefault(_GaManager);

var _oldModules = __webpack_require__(473);

var _oldModules2 = _interopRequireDefault(_oldModules);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var router = new _vueRouter2.default({
  mode: 'history',
  fallback: false
});

var unsync = (0, _vuexRouterSync.sync)(_store2.default, router);

var dnSettings = {
  router: router,
  store: _store2.default,

  components: {
    'dn-db-manager': _DbManager2.default
  },

  data: function data() {
    return {};
  },


  computed: {
    attributeDialog: function attributeDialog() {
      return this.$refs.attributeDialog;
    },
    loading: function loading() {
      return this.$refs.loading;
    },
    db: function db() {
      return this.$refs.dbManager;
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.push.load();

                _context.next = 3;
                return _this.segments.ready();

              case 3:
                if (!_this.segments.userType.get()) {
                  _this.attributeDialog.show();
                }

                // タブレットの場合はviewportをアジャストする
                if (_this.$store.getters['ua/is']('tablet')) _this.window.viewportAdjust();
                _this.emit('init');

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    ready: function ready() {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.hasAndOne('mount', resolve);
      });
    },
    debug: function debug() {
      var scriptPath = this.$store.getters['path/$join']('resources', 'js/debugger.js');
      this.$http.get(scriptPath);
    },
    checkLoginStatus: function checkLoginStatus() {
      // if (this.$store.getters['config/envIs']('develop')) return;
      if (!this.$store.getters['config/isManabi']) return;

      var currentUrl = this.$route.fullPath;

      if (currentUrl.includes('center/home') || currentUrl.includes('jikosaiten/index.html') || currentUrl.includes('jikosaiten/hantei') || currentUrl.includes('center/bible/mock') || currentUrl.includes('center/bible/myuniv') || currentUrl.includes('center/bible/search')) {
        var memberTypeKey = this.segments.cookies.get('member_type_key');
        // let gaValue = this.segments.cookies.get('ga-value03');
        // マナビ認証
        if (memberTypeKey !== '"RElHSQ=="') {
          // 認証無しの場合はマナビジョンログイン画面へ遷移
          window.location.href = 'https://manabi.benesse.ne.jp/wi/jsp/gy1_toroku/login_failure.jsp';
          // } else if(gaValue !== "3" && gaValue !== "4") { // 学年判定
          //   // 高校3年、既卒以外の場合はマナビジョンTOPへ遷移
          //   alert('マナビジョンCompassは高校3年生より使用可能となります');
          //   window.location.href = 'https://manabi.benesse.ne.jp/';
        }
        // メアド登録認証対応
        // DN2021ではメアド登録必須を外す DN_2021-97
        /**
        window.fetch(
          "https://manabi.benesse.ne.jp/cmp/services/public/stdtShibokoInfo",
          {
            credentials: "include",
            headers: {
              "Accept": "application/json",
              "Content-Type": "application/json"
            },
            referrer: "https://dn-sundai.benesse.ne.jp/manabi/",
            referrerPolicy: "no-referrer-when-downgrade",
            body: "{\"serviceId\":2,\"examId\":\"20200118K3DN2020308_\"}",
            method: "POST",
            mode: "cors"
        }).then(() => {
          console.log("メールアドレス認証OK");
        //   // 参照した登録志望校情報をcookieに書き込み
        //   return shiboko_response.json();
        // }).then(res => {
        //   if (!res.stdt.seiseki.details.shiboList.cmpsSiboList) {
        //     return;
        //   }
        //   const shibokoList = res.stdt.seiseki.details.shiboList.cmpsSiboList;
        //   var schoolChoices = "";
        //   shibokoList.forEach(ary => {
        //     schoolChoices += ary.bosyutaniCd + "_";
        //   });
        //   // 末尾の'_'を削除
        //   schoolChoices = schoolChoices.substring(0,schoolChoices.length-1);
        //   this.segments.cookies.set('bcs_1_2019_school_choices', schoolChoices);
        }).catch(() => {
          // 通信失敗
          console.log("メールアドレス認証NG");
          // OK押下でメールアドレス登録画面へ遷移
          alert("マナビジョンCompassをご活用いただくにはメールアドレス登録が必要です");
          window.location.href = 'https://manabi.benesse.ne.jp/wi/portfolio/agree/InputAction.do';
        });
        */
      }
    }
  },

  mounted: function mounted() {
    new _oldModules2.default();
    this.emit('mount');
  },
  created: function created() {
    new EventManager(this);

    Object.defineProperty(this, 'h', {
      get: function get() {
        return this.helpers;
      }
    });

    this.banner = window.bcBanner;
    this.segments = this.banner.segments;

    // Initialize segments
    this.banner.setYear(2025);
    this.$store.dispatch('segments/init');

    this.push = new _WebPushManager2.default();
    this.helpers = _helpers2.default;
    this.window = _windowManager2.default;
    this.ga = new _GaManager2.default(this);

    if (this.$store.getters['config/envIs']('develop')) {
      this.debug();
    }

    this.init();
    this.checkLoginStatus();
  }
};

exports.default = dnSettings;

/***/ }),
/* 393 */
/***/ (function(module, exports) {

exports.sync = function (store, router, options) {
  var moduleName = (options || {}).moduleName || 'route'

  store.registerModule(moduleName, {
    namespaced: true,
    state: cloneRoute(router.currentRoute),
    mutations: {
      'ROUTE_CHANGED': function ROUTE_CHANGED (state, transition) {
        store.state[moduleName] = cloneRoute(transition.to, transition.from)
      }
    }
  })

  var isTimeTraveling = false
  var currentPath

  // sync router on store change
  var storeUnwatch = store.watch(
    function (state) { return state[moduleName]; },
    function (route) {
      var fullPath = route.fullPath;
      if (fullPath === currentPath) {
        return
      }
      if (currentPath != null) {
        isTimeTraveling = true
        router.push(route)
      }
      currentPath = fullPath
    },
    { sync: true }
  )

  // sync store on router navigation
  var afterEachUnHook = router.afterEach(function (to, from) {
    if (isTimeTraveling) {
      isTimeTraveling = false
      return
    }
    currentPath = to.fullPath
    store.commit(moduleName + '/ROUTE_CHANGED', { to: to, from: from })
  })

  return function unsync () {
    // On unsync, remove router hook
    if (afterEachUnHook != null) {
      afterEachUnHook()
    }

    // On unsync, remove store watch
    if (storeUnwatch != null) {
      storeUnwatch()
    }

    // On unsync, unregister Module with store
    store.unregisterModule(moduleName)
  }
}

function cloneRoute (to, from) {
  var clone = {
    name: to.name,
    path: to.path,
    hash: to.hash,
    query: to.query,
    params: to.params,
    fullPath: to.fullPath,
    meta: to.meta
  }
  if (from) {
    clone.from = cloneRoute(from)
  }
  return Object.freeze(clone)
}



/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ua = __webpack_require__(171);

var _ua2 = _interopRequireDefault(_ua);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VERSION_DETECTS = {
  ie: { low: 7, high: 11 },
  safari: { low: 5, high: 15 }
};

var state = {};
state.parsed = _ua2.default;
state.matchs = [];
state.browser = {
  name: state.parsed.browser.name.toLowerCase(),
  major: parseInt(state.parsed.browser.major, 10),
  version: parseInt(state.parsed.browser.version, 10)
};
if (state.browser.name === 'mobile safari') state.browser.name = 'safari';
state.browser.totalName = state.browser.name + state.browser.version;

state.device = {
  model: state.parsed.device.model ? state.parsed.device.model.toLowerCase() : null,
  type: state.parsed.device.type ? state.parsed.device.type.toLowerCase() : 'console'
};

state.device.type = state.device.type === 'mobile' ? 'phone' : state.device.type;

state.os = {
  name: state.parsed.os.name.toLowerCase().split(' ')[0],
  version: parseInt(state.parsed.os.version, 10)
};
state.os.version = isNaN(state.os.version) ? null : state.os.version;
state.os.totalName = state.os.version ? state.os.name + state.os.version : state.os.name;

state.matchs.push(state.browser.name);
state.matchs.push(state.browser.totalName);
state.matchs.push(state.device.type);
state.matchs.push(state.os.name);

if (state.parsed.device.type) {
  if (state.device.model) state.matchs.push(state.device.model);
  state.matchs.push('mobile');
}
if (state.os.version) state.matchs.push(state.os.totalName);

var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = state.matchs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var match = _step.value;

    if (match.match(/^windows/)) state.matchs.push(match.replace(/^windows/, 'win'));
  }

  // detect version
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

for (var key in VERSION_DETECTS) {
  if (state.browser.name === key) {
    var target = VERSION_DETECTS[key];
    state.matchs.push('gte-' + state.browser.name + state.browser.version);
    state.matchs.push('lte-' + state.browser.name + state.browser.version);
    for (var i = target.low; i < state.browser.version; i++) {
      state.matchs.push('gt-' + state.browser.name + i);
    }
    for (var _i = state.browser.version; _i < target.high; _i++) {
      state.matchs.push('lt-' + state.browser.name + (_i + 1));
    }
  }
}

var $html = document.documentElement;
$html.className = ($html.className || '') + ' ' + state.matchs.map(function (match) {
  return 'ua-' + match;
}).join(' ');

exports.default = {
  namespaced: true,

  state: state,

  getters: {
    is: function is(state) {
      return function (key) {
        return state.matchs.includes(key.toLowerCase());
      };
    },
    isAny: function isAny(state, getters) {
      return function (keys) {
        keys = Array.isArray(keys) ? keys : [keys];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = keys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var _key = _step2.value;

            if (getters['is'](_key)) return true;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return false;
      };
    },
    isAll: function isAll(state, getters) {
      return function (keys) {
        keys = Array.isArray(keys) ? keys : [keys];
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = keys[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _key2 = _step3.value;

            if (!getters['is'](_key2)) return false;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        return true;
      };
    }
  }
};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// パスのルートを探すために自身のスクリプトのパスから辿る
// なので、このスクリプトまでの位置関係が変わる場合は変更が必要
var CURRENT_SCRIPT_PATH = function () {
  if (document.currentScript) return document.currentScript.src;
  var scripts = document.getElementsByTagName('script');
  for (var i = 0, l = scripts.length; i < l; i++) {
    var script = scripts[i];
    var src = script.src;
    if (src.match(/\/resources\/js\/dn\.js.*/)) {
      return src;
    }
  }
}();

var ROOT_PATH = CURRENT_SCRIPT_PATH.replace(/\/resources\/js\/dn\.js.*/, '');

var LOCATION_IS_MATCH_BACKUP = !/^\/(dn|dev)\/center/.test(location.pathname);
var LOCATION_IS_MATCH_CMS_VENDOR = /^\/sokuhou\/mondai_k/.test(location.pathname);

/**
 * path join
 */
function pathJoin() {
  return Array.prototype.join.call(arguments, '/').replace(/\/+/g, '/').replace(/(http:|https:)/, '$1/');
}

exports.default = {
  namespaced: true,

  state: {
    root: ROOT_PATH,
    locationIsMatchBackup: LOCATION_IS_MATCH_BACKUP,
    locationIsMatchCmsVendor: LOCATION_IS_MATCH_CMS_VENDOR
  },

  getters: {
    join: function join() {
      return function () {
        return pathJoin.apply(undefined, arguments);
      };
    },
    $join: function $join(state, getters) {
      return function (base, paths) {
        return pathJoin(getters[base], typeof paths === 'string' ? paths : paths.join('/'));
      };
    },
    $resolve: function $resolve(state, getters, rootState, rootGetters) {
      return function (href) {
        var matchs = href.match(/\{\{.+?\}\}/g);
        if (!matchs) return href;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = matchs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var match = _step.value;

            var key = match.match(/\{\{(.+?)\}\}/)[1];
            var myModuleValue = getters[key];
            var val = myModuleValue !== undefined ? myModuleValue : rootGetters['config/' + key];
            if (!key) return 'javascript:void(0);';
            href = href.replace(match, '' + val);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return href.replace(/\/+/g, '/').replace(/(http:|https:)/, '$1/');
      };
    },
    root: function root(state) {
      return state.root;
    },
    firstDir: function firstDir(state) {
      return state.root.match(/\/(((?!\/).)*?)$/)[1];
    },
    resources: function resources(state) {
      return pathJoin(state.root, 'resources');
    },
    conf: function conf(state, getters) {
      return pathJoin(getters['resources'], 'conf');
    },
    locationIsMatchBackup: function locationIsMatchBackup(state) {
      return state.locationIsMatchBackup;
    },
    locationIsMatchCmsVendor: function locationIsMatchCmsVendor(state) {
      return state.locationIsMatchCmsVendor;
    },

    // 強制的にDNのルートを返却する
    // ※DN内マナビのパスにいる時とかに利用
    dnRoot: function dnRoot(state, getters) {
      var tmp = getters['root'].split('/');
      tmp[tmp.length - 2] = tmp[tmp.length - 2].replace(/^manabi/, 'dn');
      return tmp.join('/');
    },

    firstDirNameByYear: function firstDirNameByYear(state, getters, rootState, rootGetters) {
      return function (year) {
        return year === rootGetters['config/year'] ? getters['firstDir'] : 'dn' + year;
      };
    },

    // 指定された年度のルートパスを返却する
    // もちろんマナビ側であればマナビ側で返却する
    // 指定年度が最新の場合はcenterで返却する
    yearRoot: function yearRoot(state, getters) {
      return function (year) {
        var dirName = getters['firstDirNameByYear'](year);
        var anchor = document.createElement('a');
        anchor.href = getters['$join']('root', ['..', dirName]);
        return anchor.href;
      };
    },

    yearedHref: function yearedHref(state, getters) {
      return function (year, path) {
        var dirName = getters['firstDirNameByYear'](year);
        var anchor = document.createElement('a');
        anchor.href = getters['$join']('root', ['..', dirName, path]);
        return anchor.href;
      };
    },

    prevYearedHref: function prevYearedHref(state, getters, rootState, rootGetters) {
      return function (path) {
        var year = rootGetters['config/year'] - 1;
        return getters['yearedHref'](year, path);
      };
    },

    switchedDnManabiFullPath: function switchedDnManabiFullPath(state, getters, rootState, rootGetters) {
      return getters[rootGetters['config/isManabi'] ? 'convertedDnFullPath' : 'convertedManabiFullPath'];
    },

    convertedManabiFullPath: function convertedManabiFullPath(state, getters, rootState, rootGetters) {
      var tmp = rootState.route.fullPath.split('/');
      tmp[1] = tmp[1].replace(/^dn/, 'manabi');
      return tmp.join('/');
    },

    convertedDnFullPath: function convertedDnFullPath(state, getters, rootState, rootGetters) {
      var tmp = rootState.route.fullPath.split('/');
      tmp[1] = tmp[1].replace(/^manabi/, 'dn');
      return tmp.join('/');
    }
  }
};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(397);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _config2.default;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

var _http = __webpack_require__(41);

var _http2 = _interopRequireDefault(_http);

var _envs = __webpack_require__(398);

var _envs2 = _interopRequireDefault(_envs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var FILE_NAME = 'siteconfig.xml';
var DEFAULT_ENVS = [{ name: '本番', type: 'public', path: 'https://dn-sundai.benesse.ne.jp/(dn|manabi)/' }, { name: '仮', type: 'staging', path: 'https://dn-sundai.benesse.ne.jp/(dev|manabi_dev)/' }, { name: '開発', type: 'develop', path: 'https?://(localhost|www\\d.test-server02.com|\\d{1,3}\\.\\d{1,3}\\.\\d{1,3}\\.\\d{1,3})' }];
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = DEFAULT_ENVS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var env = _step.value;

    _envs2.default.add(env);
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

var preConfig = window._dnConfig || {};
var ev = {};
new _ddEventManager2.default(ev);

exports.default = {
  namespaced: true,

  state: {
    originalHost: location.host,
    originalHostname: location.hostname,
    host: location.host,
    hostname: location.hostname,
    year: 2025,
    envs: _envs2.default,
    judgementApis: [],
    ssinfo: {},
    kai: "",
    checkerOpenFlg: {},
    seisekiApi: {},
    loaded: false,
    isManabi: preConfig.isManabi === undefined ? false : preConfig.isManabi,
    selectedEnv: null
  },

  getters: {
    year: function year(state) {
      return state.year;
    },
    isManabi: function isManabi(state) {
      return state.isManabi;
    },
    isDn: function isDn(state, getters) {
      return !getters['isManabi'];
    },
    isBene: function isBene(state) {
      return (/\.benesse\.ne\.jp$/.test(state.hostname)
      );
    },
    filepath: function filepath(state, getters, rootState, rootGetters) {
      return rootGetters['path/$join']('conf', FILE_NAME);
    },
    envList: function envList(state) {
      state.loaded;
      var envs = [];
      for (var key in state.envs.envs) {
        envs.push(state.envs.envs[key]);
      }
      return envs;
    },
    selectedEnv: function selectedEnv(state) {
      state.loaded;
      if (!state.selectedEnv) return;
      return state.envs.envs[state.selectedEnv];
    },
    currentEnv: function currentEnv(state, getters) {
      return getters['selectedEnv'] || state.envs.current;
    },
    env: function env(state, getters) {
      state.loaded;
      return getters['currentEnv'] && getters['currentEnv'].type || null;
    },
    envIs: function envIs(state, getters) {
      return function (type) {
        return getters['env'] === type;
      };
    },
    judgementApiUrl: function judgementApiUrl(state, getters) {
      var env = getters['env'];
      var info = state.judgementApis.find(function (info) {
        return info.envs.includes(env);
      });
      var api = info || state.judgementApis[state.judgementApis.length - 1];
      return api && api.path;
    },
    judgementApiNendo: function judgementApiNendo(state, getters) {
      var env = getters['env'];
      var info = state.judgementApis.find(function (info) {
        return info.envs.includes(env);
      });
      var api = info || state.judgementApis[state.judgementApis.length - 1];
      return api && api.nendo;
    },
    ssinfo: function ssinfo(state) {
      return state.ssinfo;
    },
    kai: function kai(state, getters) {
      return state.kai;
    },
    checkerOpenFlg: function checkerOpenFlg(state) {
      return state.checkerOpenFlg;
    },
    seisekiApi: function seisekiApi(state) {
      return state.seisekiApi;
    },

    // マナビの時はリンク制御しない
    forceLinkEnabled: function forceLinkEnabled(state, getters) {
      return getters['isManabi'];
    },

    // マナビの時はステータス更新表示はしない
    dontUseStatusDisplay: function dontUseStatusDisplay(state, getters) {
      return getters['isManabi'];
    }
  },

  actions: {
    load: function load(_ref) {
      var _this = this;

      var commit = _ref.commit,
          getters = _ref.getters;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _http2.default.get(getters['filepath']);

              case 2:
                res = _context.sent;

                commit('setData', res.data);
                ev.emit('load');

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    ready: function ready() {
      return new Promise(function (resolve) {
        ev.hasAndOn('load', resolve);
      });
    },
    setEnv: function setEnv(_ref2, type) {
      var commit = _ref2.commit;

      commit('setEnv', type);
    }
  },

  mutations: {
    setEnv: function setEnv(state, type) {
      state.selectedEnv = type;
    },
    setData: function setData(state, xml) {
      var $xml = $(xml);

      // 環境設定（仮仮のみ定義されています）
      var $envs = $xml.find('environments > env');
      $envs.each(function () {
        var $env = $(this);
        var data = {
          name: $env.attr('name'),
          type: $env.attr('type'),
          path: $env.attr('path')
        };

        // test「仮仮」環境はデフォルトとして追加する
        _envs2.default.add(data, { isDefault: data.type === 'test' });
      });

      // 判定チェッカーAPI
      var $checkerApis = $xml.find('checker api-list api');
      $checkerApis.each(function () {
        var $api = $(this);
        var data = {
          name: $api.attr('name'),
          envs: $api.attr('env').replace(/\s/g, '').split(','),
          path: $api.attr('path'),
          nendo: $api.attr('nendo')
        };
        state.judgementApis.push(data);
      });

      // 判定チェッカー10記の得点⇔偏差値パラメータ
      var $ssinfo = $xml.find('checker ssinfo');
      $ssinfo.each(function () {
        var $ssinfo = $(this);
        var data = {
          url: $ssinfo.attr('url'),
          gakunen: $ssinfo.attr('gakunen'),
          kai: $ssinfo.attr('kai'),
          nendo: $ssinfo.attr('nendo')
        };
        state.ssinfo = data;
      });

      // 試験回
      var $kai = $xml.find('univsearch');
      $kai.each(function () {
        var $univsearch = $(this);
        var kai = $univsearch.attr('kai');
        state.kai = kai;
      });

      // 判定チェッカー各画面開閉フラグ
      var $checkerOpenFlg = $xml.find('checker open-flg');
      $checkerOpenFlg.each(function () {
        var $flg = $(this);
        var data = {
          mock: $flg.attr('mock'),
          myuniv: $flg.attr('myuniv'),
          search: $flg.attr('search'),
          jikosaiten: $flg.attr('jikosaiten'),
          hantei: $flg.attr('hantei')
        };
        state.checkerOpenFlg = data;
      });

      // 成績APIの各種設定
      var $seisekiApiDomain = $xml.find('seiseki-api domain');
      $seisekiApiDomain.each(function () {
        var $domain = $(this);
        var data = {
          manabi: $domain.attr('manabi'),
          dn: $domain.attr('dn')
        };
        state.seisekiApi["domain"] = data;
      });
      var $seisekiApiExamId = $xml.find('seiseki-api exam-id');
      $seisekiApiExamId.each(function () {
        var $examId = $(this);
        var data = {
          moshi: $examId.attr('moshi'),
          dn: $examId.attr('dn')
        };
        state.seisekiApi["examId"] = data;
      });

      state.loaded = true;
    }
  }
};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Env = __webpack_require__(399);

var _Env2 = _interopRequireDefault(_Env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var envs = {
  current: null,
  envs: {},
  add: function add(data) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$isDefault = _ref.isDefault,
        isDefault = _ref$isDefault === undefined ? false : _ref$isDefault;

    var env = new _Env2.default(data);
    this.envs[env.type] = env;
    if (env.matched) {
      this.current = env;
      if (env.type !== 'public') {
        console.info('「' + env.name + '」環境で起動しました');
      }
    }

    if (isDefault && !this.current) {
      this.current = env;
      console.warn('環境判定に一致するものがなかったので「' + env.name + '」で起動しました');
    }
  },
  get: function get(type) {
    return this.envs[type];
  },
  matchType: function matchType(type) {
    return this.current && this.current.type === type || false;
  }
};

exports.default = envs;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Env = function () {
  function Env(data) {
    _classCallCheck(this, Env);

    this.name = data.name;
    this.type = data.type;
    this.path = data.path;

    this._matched = null;
  }

  _createClass(Env, [{
    key: "matched",
    get: function get() {
      if (this._matched !== null) return this._matched;
      var re = new RegExp(this.path);
      var loc = location.href;
      this._matched = re.test(loc);
      return this._matched;
    }
  }]);

  return Env;
}();

exports.default = Env;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _http = __webpack_require__(41);

var _http2 = _interopRequireDefault(_http);

var _util = __webpack_require__(172);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var FILE_NAME = 'navigation.html';

exports.default = {
  namespaced: true,

  state: {
    loaded: false,
    categories: [],
    submenus: []
  },

  getters: {
    filepath: function filepath(state, getters, rootState, rootGetters) {
      return rootGetters['path/$join']('conf', FILE_NAME);
    },
    matchedCategory: function matchedCategory(state, getters) {
      return getters['categories'].find(function (c) {
        return c.matched;
      }) || null;
    },
    matchedGroup: function matchedGroup(state, getters) {
      var category = getters['matchedCategory'];
      if (!category) return null;
      return category.groups.find(function (g) {
        return g.matched;
      }) || null;
    },
    matchedLink: function matchedLink(state, getters) {
      var group = getters['matchedGroup'];
      if (!group) return null;
      return group.links.find(function (l) {
        return l.matched;
      }) || null;
    },
    categories: function categories(state, getters, rootState, rootGetters) {
      var userIsReady = rootGetters['segments/user/ready'];
      var userTypeId = rootGetters['segments/user/id'];

      var currentLocation = (0, _util.getRoundedHref)(location.href);

      var currentLink = void 0,
          currentLinkScore = 0;

      var linkFilter = function linkFilter(_link, group) {
        var userAttribute = _link.data.userAttribute;

        var isHidden = userAttribute !== undefined && (!userIsReady || userTypeId !== String(userAttribute));

        var tags = [].concat(_toConsumableArray(_link.tags));
        !!userAttribute && tags.push({ text: '高２年向け', color: 'accent' });

        var link = Object.assign({}, _link, {
          href: rootGetters['path/$resolve'](_link.href),
          group: group,
          matched: false,
          current: false,
          isHidden: isHidden,
          tags: tags
        });

        var linkLocation = (0, _util.getRoundedHref)(link.href);
        var myHitScore = linkLocation.split('/').length;
        link.current = currentLocation === linkLocation;
        var isMatch = link.current || currentLocation.indexOf(linkLocation) === 0;

        if (isMatch && myHitScore >= currentLinkScore) {
          currentLink = link;
          currentLinkScore = myHitScore;
        }
        if (dn.$store.getters['config/isManabi']) {
          // サイドメニュー：判定の確認画面でマーク模試取得画面が開かれていることになる対策
          if (currentLocation.match(/hantei/)) {
            currentLink = false;
          }
        }

        if (link.data.created && !link.data.updated) {
          link.data.updated = link.data.created;
        } else if (!link.data.created && link.data.updated) {
          link.data.created = link.data.updated;
        }

        if (link.data.created) {
          link.created = (0, _util.parseDateString)(link.data.created);
          link.updated = (0, _util.parseDateString)(link.data.updated);
          link.publishState = link.created.timestamp === link.updated.timestamp ? 'created' : 'updated';
        }

        return link;
      };

      var categories = state.categories.map(function (_category) {
        var category = Object.assign({ matched: false }, _category);
        var groups = category.groups.map(function (_group) {
          var group = Object.assign({}, _group, {
            category: category,
            matched: false
          });
          var hasPublishState = false;
          var latestCreatedLink = null;
          var latestUpdatedLink = null;
          group.links = _group.links.map(function (_link) {
            var link = linkFilter(_link, group);
            if (link.publishState && !link.isHidden) {
              hasPublishState = true;
              if (!latestCreatedLink || link.created.timestamp > latestCreatedLink.created.timestamp) {
                latestCreatedLink = link;
              }
              if (!latestUpdatedLink || link.updated.timestamp > latestUpdatedLink.updated.timestamp) {
                latestUpdatedLink = link;
              }
            }
            return link;
          }).filter(function (link) {
            return !link.isHidden;
          });

          if (hasPublishState) {
            group.links.forEach(function (link) {
              if (link.publishState) {
                link.created.latest = link === latestCreatedLink || link.created.timestamp === latestCreatedLink.created.timestamp;
                link.updated.latest = link === latestUpdatedLink || link.updated.timestamp === latestCreatedLink.updated.timestamp;
              }
            });
          }
          return group;
        });
        category.groups = groups;
        return category;
      });

      if (currentLink) {
        currentLink.matched = true;
        currentLink.group.matched = true;
        currentLink.group.category.matched = true;
      }
      return categories;
    },
    category: function category(state, getters) {
      return function (id) {
        return getters['categories'].find(function (category) {
          return category.id === id;
        });
      };
    },
    categoryGroup: function categoryGroup(state, getters) {
      return function (categoryId, groupId) {
        var category = getters['category'](categoryId);
        if (category) {
          return category.groups.find(function (group) {
            return group.id === groupId;
          });
        }
      };
    },
    submenus: function submenus(state, getters, rootState, rootGetters) {
      return state.submenus.map(function (menu) {
        return Object.assign({}, menu, { href: rootGetters['path/$resolve'](menu.href) });
      });
    },
    gnaviCategories: function gnaviCategories(state, getters) {
      return getters.categories.filter(function (category) {
        return !category.data.gnaviIgnore && category.data.gnaviIgnore !== '';
      });
    },
    localNaviCategory: function localNaviCategory(state, getters) {
      return getters.categories.find(function (category) {
        return category.matched;
      });
    }
  },

  actions: {
    load: function load(_ref) {
      var _this = this;

      var commit = _ref.commit,
          getters = _ref.getters;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _http2.default.get(getters['filepath']);

              case 2:
                res = _context.sent;

                commit('setData', res.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  mutations: {
    setData: function setData(state, html) {
      var categories = [],
          submenus = [];
      var $data = $('<div>' + html + '</div>');

      var $categories = $data.find('dn-categories').children('dn-category');
      $categories.each(function () {
        var $category = $(this);
        var disabled = $category.attr('disabled');
        var isDefault = $category.attr('default');
        var category = {
          id: $category.attr('id'),
          data: $category.data(),
          label: dn.$store.getters['path/$resolve']((0, _util.htmlGetter)($category.children('dn-label'))),
          disabled: disabled !== undefined && disabled !== 'false',
          default: isDefault !== undefined && isDefault !== 'false',
          groups: []
        };

        var defaultLinks = [];
        var $links = $category.children('dn-link');
        $links.each(function () {
          defaultLinks.push((0, _util.linkParser)($(this), 'default'));
        });
        category.groups.push({
          id: 'default',
          label: null,
          links: defaultLinks
        });

        var $groups = $category.children('dn-link-group');
        $groups.each(function () {
          var $group = $(this);
          var $label = $group.children('dn-label');
          var group = {
            id: $group.attr('id'),
            label: $label.get(0) ? (0, _util.htmlGetter)($label) : null,
            links: []
          };
          var $links = $group.children('dn-link');
          $links.each(function () {
            group.links.push((0, _util.linkParser)($(this), 'default'));
          });
          category.groups.push(group);
        });

        categories.push(category);
      });

      var $submenus = $data.find('dn-submenus').children('dn-link');
      $submenus.each(function () {
        submenus.push((0, _util.linkParser)($(this)));
      });

      state.categories = categories;
      state.submenus = submenus;
      state.loaded = true;
    }
  }
};

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _http = __webpack_require__(41);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var FILE_NAME = 'links.json';
var FORCE_ENABLED_ID = '__enabled__';
var STATES_TYPES = {
  ng: '0',
  ok: '1'
};

exports.default = {
  namespaced: true,

  state: {
    loaded: false,
    links: {}
  },

  getters: {
    loaded: function loaded(state) {
      return state.loaded;
    },
    filepath: function filepath(state, getters, rootState, rootGetters) {
      return rootGetters['path/$join']('conf', FILE_NAME);
    },
    state: function state(_state) {
      return function (id) {
        return _state.links[id];
      };
    },
    keys: function keys(state) {
      return Object.keys(state.links);
    },
    enabled: function enabled(state, getters, rootState, rootGetters) {
      return function (id) {
        return rootGetters['config/forceLinkEnabled'] || state.links[id] === STATES_TYPES.ok || id === FORCE_ENABLED_ID;
      };
    },
    disabled: function disabled(state, getters) {
      return function (id) {
        return !getters['enabled'](id);
      };
    }
  },

  actions: {
    load: function load(_ref) {
      var _this = this;

      var commit = _ref.commit,
          getters = _ref.getters,
          rootGetters = _ref.rootGetters;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!rootGetters['config/forceLinkEnabled']) {
                  _context.next = 4;
                  break;
                }

                _context.t0 = { data: null };
                _context.next = 7;
                break;

              case 4:
                _context.next = 6;
                return _http2.default.get(getters['filepath']);

              case 6:
                _context.t0 = _context.sent;

              case 7:
                res = _context.t0;

                commit('setData', res.data);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    setEnabled: function setEnabled(_ref2, id) {
      var commit = _ref2.commit;

      commit('setState', { id: id, linkState: STATES_TYPES.ok });
    },
    setDisabled: function setDisabled(_ref3, id) {
      var commit = _ref3.commit;

      commit('setState', { id: id, linkState: STATES_TYPES.ng });
    },
    allEnabled: function allEnabled(_ref4) {
      var commit = _ref4.commit;

      commit('setAll', STATES_TYPES.ok);
    },
    allDisabled: function allDisabled(_ref5) {
      var commit = _ref5.commit;

      commit('setAll', STATES_TYPES.ng);
    }
  },

  mutations: {
    setState: function setState(state, _ref6) {
      var id = _ref6.id,
          linkState = _ref6.linkState;

      state.links[id] = linkState;
    },
    setData: function setData(state, json) {
      if (json) {
        var links = {};
        for (var key in json) {
          links[key] = json[key].status;
        }
        state.links = links;
      }
      state.loaded = true;
    },
    setAll: function setAll(state, val) {
      for (var id in state.links) {
        state.links[id] = val;
      }
    }
  }
};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _http = __webpack_require__(41);

var _http2 = _interopRequireDefault(_http);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var FILE_NAME = 'status.xml';

exports.default = {
  namespaced: true,

  state: {
    loaded: false,
    statuses: {}
  },

  getters: {
    filepath: function filepath(state, getters, rootState, rootGetters) {
      return rootGetters['path/$join']('conf', FILE_NAME);
    },
    at: function at(state) {
      return function (id) {
        return state.statuses[id] || {};
      };
    },
    displayAt: function displayAt(state, getters) {
      return function (id) {
        var divider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

        var status = getters['at'](id);
        return status && [status.date, status.time, status.status, status.text].filter(function (s) {
          return !!s;
        }).join(divider);
      };
    },
    // 「先輩からの入試直前アドバイス」用
    displayAtSenpai: function displayAtSenpai(state, getters) {
      return function (id) {
        var divider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

        var status = getters['at'](id);
        return status && [status.date, status.time, status.status, status.text].filter(function (s) {
          return !!s;
        }).join(divider) || "準備中";
      };
    },
    // 得点調整の非表示用
    displayAtChosei: function displayAtChosei(state, getters) {
      return function (id) {
        var divider = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ' ';

        var status = getters['at'](id);
        return status && status.status ? {} : { display: "none" };
      };
    },
    statuses: function statuses(state) {
      return state.statuses;
    },
    keys: function keys(state, getters) {
      return Object.keys(getters['statuses']);
    }
  },

  actions: {
    load: function load(_ref) {
      var _this = this;

      var commit = _ref.commit,
          getters = _ref.getters,
          rootGetters = _ref.rootGetters;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!rootGetters['config/dontUseStatusDisplay']) {
                  _context.next = 4;
                  break;
                }

                _context.t0 = { data: null };
                _context.next = 7;
                break;

              case 4:
                _context.next = 6;
                return _http2.default.get(getters['filepath'], { responseType: 'document' });

              case 6:
                _context.t0 = _context.sent;

              case 7:
                res = _context.t0;

                commit('setData', res.data);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    set: function set(_ref2, _ref3) {
      var commit = _ref2.commit,
          getters = _ref2.getters;
      var id = _ref3.id,
          _ref3$data = _ref3.data,
          data = _ref3$data === undefined ? {} : _ref3$data;

      var nowdata = getters['at'](id);
      var newData = Object.assign({}, nowdata, data);
      commit('set', { id: id, data: newData });
    }
  },

  mutations: {
    set: function set(state, _ref4) {
      var id = _ref4.id,
          data = _ref4.data;

      _vue2.default.set(state.statuses, id, data);
    },
    setData: function setData(state, xml) {
      if (xml) {
        var statuses = {};
        var $xml = $(xml);

        $xml.find('item').each(function () {
          var $item = $(this),
              id = $item.find('id').text();

          var status = {
            date: $item.find('date').text(),
            time: $item.find('time').text(),
            status: $item.find('status').text(),
            text: $item.find('text').text()
          };

          statuses[id] = status;
        });

        // ダミーデータを設定しておく
        statuses._dummy = {
          date: '●/●',
          status: 'ダミー',
          text: '',
          time: 'HH:MM'
        };
        state.statuses = statuses;
      }

      state.loaded = true;
    }
  }
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _http = __webpack_require__(41);

var _http2 = _interopRequireDefault(_http);

var _util = __webpack_require__(172);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var FILE_NAME = 'notices.html';

exports.default = {
  namespaced: true,

  state: {
    loaded: false,
    notices: []
  },

  getters: {
    filepath: function filepath(state, getters, rootState, rootGetters) {
      return rootGetters['path/$join']('conf', FILE_NAME);
    },
    notices: function notices(state, getters, rootState, rootGetters) {
      var notices = state.notices.slice();
      if (getters['needShowLatestLink']) {
        notices.unshift({
          className: 'dn-top-messages__linkto-latest',
          body: '最新の大学入学共通テスト情報は<a href="{{root}}/../center/index.html">こちら</a>から！'
        });
      }
      return notices.map(function (notice) {
        return Object.assign({}, notice, { body: rootGetters['path/$resolve'](notice.body) });
      });
    },
    exist: function exist(state, getters) {
      return getters['notices'].length > 0;
    },
    needShowLatestLink: function needShowLatestLink(state, getters, rootState, rootGetters) {
      return rootGetters['path/locationIsMatchBackup'] && !rootGetters['path/locationIsMatchCmsVendor'];
    }
  },

  actions: {
    load: function load(_ref) {
      var _this = this;

      var commit = _ref.commit,
          getters = _ref.getters;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _http2.default.get(getters['filepath']);

              case 2:
                res = _context.sent;

                commit('setData', res.data);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  mutations: {
    setData: function setData(state, html) {
      var my = this;
      var notices = [];
      var $data = $('<div>' + html + '</div>');

      var $notices = $data.find('dn-notices').children('dn-notice');
      $notices.each(function () {
        notices.push({
          body: (0, _util.htmlGetter)($(this))
        });
      });

      state.notices = notices;
      state.loaded = true;
    }
  }
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _matchMedia = __webpack_require__(173);

var _matchMedia2 = _interopRequireDefault(_matchMedia);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_TAG = 'dn-mq-store';
var keys = [];
var state = {};
var getters = {

  // 2パターンしかないので、SPじゃなければPCを返す
  group: function group(state, getters) {
    return getters.sp ? 'sp' : 'pc';
  }
};

_matchMedia2.default.conditions.forEach(function (condition) {
  keys.push(condition.key);
  state[condition.key] = condition.mql.matches || false;
  getters[condition.key] = function (state) {
    return state[condition.key];
  };
});

getters.current = function (state) {};

exports.default = {
  namespaced: true,

  state: state,

  getters: getters,

  actions: {
    start: function start(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      keys.forEach(function (key) {
        _matchMedia2.default.hasAndOn('change-' + key + '.' + EVENT_TAG, function (isMatch) {
          if (isMatch !== undefined) {
            commit('updateKey', { key: key, isMatch: isMatch });
          }
        });
      });
      dispatch('update');
    },
    update: function update(_ref2) {
      var commit = _ref2.commit;

      _matchMedia2.default.conditions.forEach(function (condition) {
        if (condition.mql.matches !== undefined) {
          commit('updateKey', { key: condition.key, isMatch: condition.mql.matches });
        }
      });
    }
  },

  mutations: {
    updateKey: function updateKey(state, _ref3) {
      var key = _ref3.key,
          isMatch = _ref3.isMatch;

      state[key] = isMatch;
    }
  }
};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DDMatchMedia = function () {

  /**
   * constructor
   */
  function DDMatchMedia(settings) {
    _classCallCheck(this, DDMatchMedia);

    new _ddEventManager2.default(this);

    this.settings = settings;
    this.conditions = [];
    this.states = {};

    this.setup();
  }

  /**
   * setup
   */


  _createClass(DDMatchMedia, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      this.settings.breakPoints.forEach(function (breakPoint) {
        _this.states[breakPoint.key] = false;

        var conditions = ['' + _this.settings.target];
        ['min', 'max'].forEach(function (key) {
          if (breakPoint[key]) conditions.push('(' + key + '-width: ' + breakPoint[key] + 'px)');
        });

        _this.conditions.push({ type: 'key', key: breakPoint.key, condition: conditions.join(' and ') });
      });

      var _loop = function _loop(key) {
        var conditions = ['' + _this.settings.target],
            group = _this.settings.groups[key],
            target = group.min ? 'min' : 'max',
            keyValue = group[target],
            value = _this.settings.breakPoints.find(function (breakPoint) {
          return breakPoint.key === keyValue;
        })[target],
            condition = '(' + target + '-width: ' + value + 'px)';

        _this.states[key] = false;
        conditions.push(condition);
        if (group.orientation) conditions.push('(orientation: ' + group.orientation + ')');
        _this.conditions.push({ type: 'group', key: key, condition: conditions.join(' and ') });
      };

      for (var key in this.settings.groups) {
        _loop(key);
      }

      this.conditions.forEach(function (condition) {
        if (typeof window === 'undefined') {
          condition.mql = { matches: false };
        } else {
          condition.mql = window.matchMedia(condition.condition);
          condition.mql.addListener(function () {
            return _this.checkCondition(condition);
          });
        }
        _this.checkCondition(condition);
      });
    }

    /**
     * check condition
     */

  }, {
    key: 'checkCondition',
    value: function checkCondition(condition) {
      var isMatch = condition.mql.matches;
      this.set(condition, isMatch);
      return isMatch;
    }

    /**
     * get condition by key
     */

  }, {
    key: 'getConditionByKey',
    value: function getConditionByKey(key) {
      return this.conditions.find(function (condition) {
        return condition.key === key;
      });
    }

    /**
     * set condition or key
     */

  }, {
    key: 'set',
    value: function set(condition, isMatch) {
      condition = typeof condition === 'string' ? this.getConditionByKey(condition) : condition;

      var key = condition.key,
          old = this.states[key];

      this.states[key] = isMatch;

      if (old !== isMatch) {
        this.emit('change', condition);
        this.emit('change-' + key, isMatch);
      }
    }
  }]);

  return DDMatchMedia;
}();

exports.default = DDMatchMedia;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var baseSettings = __webpack_require__(407);
var DDMatchMediaSettings = __webpack_require__(408);

module.exports = DDMatchMediaSettings(baseSettings);

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var mediaQuerySettings = {
  mediaTarget: 'all',

  breakPoints: {
    xs: null, // 0   ~ 320 : Phone (Narrow)
    sm: 321, // 321 ~ 709 : Phone
    md: 710 // 710 ~     : Desktop
  },

  groups: {
    sp: { max: 'sm' }, // Phone
    pc: { min: 'md' }, // Tablet, Desktop
    spLandscape: { max: 'md', orientation: 'landscape' }
  }
};

module.exports = mediaQuerySettings;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function DDMatchMediaSettings(baseSettings) {
  var breakPoints = [];

  for (var key in baseSettings.breakPoints) {
    breakPoints.push({
      key: key,
      min: baseSettings.breakPoints[key]
    });
  }

  breakPoints = breakPoints.sort(function (a, b) {
    return !b.min || a.min > b.min;
  });
  breakPoints.forEach(function (row, index) {
    var prev = breakPoints[index - 1];
    var next = breakPoints[index + 1];

    if (prev) {
      row.prev = prev.key;
    }

    if (next) {
      row.next = next.key;
      row.max = next.min - 1;
    }
  });

  return {
    target: baseSettings.mediaTarget || 'all',
    groups: baseSettings.groups,
    breakPoints: breakPoints
  };
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _factory = __webpack_require__(174);

var _factory2 = _interopRequireDefault(_factory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ls = (0, _factory2.default)(2025); // const LS_DEBUG = true;
// import cookies from 'browser-cookies';
// cookies.erase('bcs_1_2018_school_choices');


exports.default = ls;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NO_SCROLL_TAG = 'dn-no-scroll';
var SCROLL_EVENT = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
var SCROLL_JUDGE_INTERVAL = 500;

var WindowManager = function () {
  _createClass(WindowManager, null, [{
    key: 'RESIZE_EVENT_TAG',
    get: function get() {
      return 'window_resize_handle';
    }
  }, {
    key: 'SCROLL_EVENT_TAG',
    get: function get() {
      return 'window_scroll_handle';
    }
  }]);

  /**
   * constructor
   */
  function WindowManager() {
    var _this = this;

    _classCallCheck(this, WindowManager);

    this.$h = null;
    this.$w = null;
    this.$d = null;
    this.sizeInitialized = false;
    this.scrollInitialized = false;
    this.allInitialized = false;
    this.width = null;
    this.height = null;
    this.scroll = { top: null, left: null };
    this.scrollDiff = { start: { top: null, left: null }, top: null, left: null };
    this.scrollTimerId = null;
    this.nowScroll = false;
    this.loaded = false;
    this.hiddenKey = null;
    this.visibilityChangeKey = null;

    new _ddEventManager2.default(this);

    this.$w = $(window);
    this.$h = $('html');
    this.$d = $(document);

    this.updateSize();

    var tag = WindowManager.RESIZE_EVENT_TAG;

    this.$w.on('load.loadCheck', function () {
      _this.$w.off('.loadCheck');
      _this.loaded = true;
      _this.emit('load', _this);
    });

    this.$w.on('load.' + tag + ' resize.' + tag + ' orientationchange.' + tag, function () {
      _this._updateScrollParams();
      _this.updateSize();
    });

    this.$w.on('scroll.' + WindowManager.SCROLL_EVENT, function () {
      _this._onScroll();
    });

    // this.$w.on(`storage.${tag}`, e => {
    //   this.emit('storage', e);
    // });

    this.setupVisibilityEvent();
  }

  /**
   * check all initialized
   */


  _createClass(WindowManager, [{
    key: '_checkAllInitialized',
    value: function _checkAllInitialized() {
      if (this.allInitialized) return;

      if (this.sizeInitialized && this.scrollInitialized) {
        this.allInitialized = true;
        this.emit('allInitialized');
      }
    }

    /**
     * on scrll callback
     */

  }, {
    key: '_onScroll',
    value: function _onScroll() {
      var _this2 = this;

      if (!this.nowScroll) {
        this.scrollDiff.start.top = this.scroll.top;
        this.scrollDiff.start.left = this.scroll.left;
      }

      this._updateScrollParams();

      this.scrollDiff.top = this.scroll.top - this.scrollDiff.start.top;
      this.scrollDiff.left = this.scroll.left - this.scrollDiff.start.left;

      if (!this.nowScroll) {
        this.nowScroll = true;
        this.emit('scrollStart', this);
      }

      this.emit('scroll', this);

      if (this.scrollTimerId !== null) {
        clearTimeout(this.scrollTimerId);
        this.scrollTimerId = null;
      }

      this.scrollTimerId = setTimeout(function () {
        _this2.nowScroll = false;
        _this2.emit('scrollEnd', _this2);
      }, SCROLL_JUDGE_INTERVAL);
    }

    /**
     * update scroll params
     */

  }, {
    key: '_updateScrollParams',
    value: function _updateScrollParams() {
      this.scroll.top = this.$w.scrollTop();
      this.scroll.left = this.$w.scrollLeft();
      this.scrollInitialized = true;
      this._checkAllInitialized();
    }

    /**
     * adjust viewport
     */

  }, {
    key: 'viewportAdjust',
    value: function viewportAdjust() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3.hasAndOn('load', function () {
          var ww = _this3.$w.width(),
              dw = _this3.$d.width(),
              diff = dw - ww;

          if (diff < 0) return;

          var $head = $('head'),
              $vp = $head.find('meta[name="viewport"]'),
              attr = $vp.attr('content'),
              scale = ww / dw;

          attr = attr.replace(/initial-scale=1.0/, 'initial-scale=' + scale);
          attr = attr.replace(/maximum-scale=1/, 'maximum-scale=' + scale);
          $vp.attr('content', attr);
          attr = attr.replace('maximum-scale=' + scale, 'maximum-scale=1');
          $vp.attr('content', attr);
        });
      });
    }

    /**
     * set scroll disabled
     */

  }, {
    key: 'setScrollDisabled',
    value: function setScrollDisabled() {
      var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (disabled) {
        this.$h.addClass(NO_SCROLL_TAG);
      } else {
        this.$h.removeClass(NO_SCROLL_TAG);
      }
    }

    /**
     * setup visibility event
     */

  }, {
    key: 'setupVisibilityEvent',
    value: function setupVisibilityEvent() {
      var _this4 = this;

      var handleVisibilityChange = function handleVisibilityChange(e) {
        if (document[_this4.hiddenKey]) {
          _this4.emit('hide', _this4);
        } else {
          _this4.emit('show', _this4);
        }
      };

      if (document.hidden !== undefined) {
        this.hiddenKey = 'hidden';
        this.visibilityChangeKey = 'visibilitychange';
      } else if (document.mozHidden !== undefined) {
        this.hiddenKey = 'mozHidden';
        this.visibilityChangeKey = 'mozvisibilitychange';
      } else if (document.msHidden !== undefined) {
        this.hiddenKey = 'msHidden';
        this.visibilityChangeKey = 'msvisibilitychange';
      } else if (document.webkitHidden !== undefined) {
        this.hiddenKey = 'webkitHidden';
        this.visibilityChangeKey = 'webkitvisibilitychange';
      }

      if (!this.hiddenKey) {
        console.warn('ブラウザが `Page Visibility API` に対応していないため、イベントの発行を行いません。');
        return;
      }

      if (document.addEventListener === undefined || !this.hiddenKey) {
        console.warn('ブラウザが `Page Visibility API` に対応していないため、イベントの発行を行いません。');
        return;
      }

      document.addEventListener(this.visibilityChangeKey, handleVisibilityChange, false);
    }

    /**
     * update size params
     */

  }, {
    key: 'updateSize',
    value: function updateSize() {
      var bw = this.width,
          bh = this.height;

      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.sizeInitialized = true;
      this._checkAllInitialized();

      if (bw !== this.width || bh !== this.height) {
        this.emit('resize', this);
      }
    }
  }]);

  return WindowManager;
}();

exports.default = WindowManager;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.restore = exports.deepSetState = exports.deepGetState = undefined;

var _deepGetState = __webpack_require__(412);

var _deepGetState2 = _interopRequireDefault(_deepGetState);

var _deepSetState = __webpack_require__(413);

var _deepSetState2 = _interopRequireDefault(_deepSetState);

var _restore = __webpack_require__(414);

var _restore2 = _interopRequireDefault(_restore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.deepGetState = _deepGetState2.default;
exports.deepSetState = _deepSetState2.default;
exports.restore = _restore2.default;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = deepGetState;
function deepGetState(state, keyMap, defaultValue) {
  var tmp = keyMap.split('.');
  var topKey = tmp[0];
  var currentKey = topKey;
  var data = void 0;

  if (tmp.length === 1) {
    data = state[topKey];
    return data === undefined ? defaultValue : data;
  }

  var check = function check() {
    if (data === '___dn-ls-undefined___' || data === undefined) {
      data = {};
    } else if (data === null || (typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
      console.warn(state);
      throw new Error('\u300C' + keyMap + '\u300D\u306E\u5024\u3092\u53C2\u7167\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u300C' + currentKey + '\u300D\u306B\u306F\u30AA\u30D6\u30B8\u30A7\u30AF\u30C8\u306B\u89E3\u6C7A\u3067\u304D\u306A\u3044\u5024\u304C\u5165\u3063\u3066\u3044\u307E\u3059\u3002');
    }
  };

  data = state[topKey];
  data = data === undefined ? '___dn-ls-undefined___' : data;
  check();

  for (var i = 1, l = tmp.length - 1; i < l; i++) {
    data = data[tmp[i]];
    currentKey += '.' + tmp[i];
    check();
  }

  data = data[tmp[tmp.length - 1]];
  return data === undefined ? defaultValue : data;
}

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = deepSetValue;

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function deepSetValue(state, keyMap, value) {
  var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

  var tmp = keyMap.split('.');
  if (tmp.length === 1) {
    if (value === undefined) {
      $ls.deleteKey(prefix + keyMap);
      _vue2.default.delete(state, keyMap);
    } else {
      $ls.set(prefix + keyMap, value);
      _vue2.default.set(state, keyMap, value);
    }
    return;
  }

  var topKey = tmp[0];
  var currentKey = topKey;
  var data = void 0,
      topData = void 0,
      parent = null,
      _key = null;

  var check = function check() {
    if (data === undefined || data === '___dn-ls-undefined___') {
      if (parent === null) {
        _vue2.default.set(state, topKey, {});
        parent = state[topKey];
        data = parent;
      } else {
        _vue2.default.set(parent, _key, {});
        data = parent[_key];
      }
    } else if (data === null || (typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') {
      throw new Error('ローカルストレージ「' + currentKey + '」にはオブジェクトに解決できない値が入っているためデータをコミットできません。');
    }
  };

  data = state[topKey];
  data = data === undefined ? '___dn-ls-undefined___' : data;
  check();

  topData = data;

  for (var i = 1, l = tmp.length - 1; i < l; i++) {
    _key = tmp[i];
    parent = data;
    data = data[_key];
    currentKey += '.' + tmp[i];
    check();
  }

  _vue2.default.set(data, tmp[tmp.length - 1], value);
  $ls.set(prefix + topKey, state[topKey]);
}

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = restore;

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _selfCheckDefaults = __webpack_require__(176);

var _selfCheckDefaults2 = _interopRequireDefault(_selfCheckDefaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var re_my_ans = /^my_ans_/;

function restore(state, LS_PREFIX) {
  var needSwitch = false;

  var newStates = {};
  var isSwitchTargetPrefix = LS_PREFIX === '2018_';
  var keys = $ls.index() || [];
  var re = new RegExp('^(default_)?' + LS_PREFIX);
  var subjects = {};

  var getSubject = function getSubject(id) {
    if (subjects[id]) return subjects[id];
    var subject = (0, _selfCheckDefaults2.default)();
    subjects[id] = subject;
    if (isSwitchTargetPrefix) needSwitch = true;
    return subject;
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var realKey = _step.value;

      if (!re.test(realKey)) continue;

      var _key3 = realKey.replace(re, '');
      var value = $ls.get(realKey);

      if (re_my_ans.test(_key3)) {
        var subjectId = _key3.replace(re_my_ans, '');
        var subject = getSubject(subjectId);
        for (var _key4 in value) {
          subject.inputs[_key4] = value[_key4].val;
        }
        continue;
      }

      if (_key3 === 'selects') {
        for (var _subjectId in value) {
          var data = value[_subjectId];
          var _subject = getSubject(_subjectId);
          _subject.selected = data.selected === undefined ? _subject.selected : data.selected;
          _subject.type = data.type || _subject.type;
        }
        continue;
      }

      if (_key3 === 'totals') {
        for (var _subjectId2 in value) {
          var _data = value[_subjectId2];
          var _subject2 = getSubject(_subjectId2);
          _subject2.selfcheckScore = typeof _data.score === 'number' ? _data.score : _subject2.selfcheckScore;
          _subject2.directScore = typeof _data.directScore === 'number' ? _data.directScore : _subject2.directScore;
          _subject2.selfCheckIsFinished = _data.status === undefined ? _subject2.selfCheckIsFinished : _data.status;
        }
        continue;
      }

      if (value !== undefined) newStates[_key3] = JSON.parse(JSON.stringify(value));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var subjectIds = Object.keys(subjects);

  if (needSwitch) {
    var deleteKeys = ['2018_selects', '2018_totals'].concat(_toConsumableArray(subjectIds.map(function (id) {
      return '2018_my_ans_' + id;
    })));

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = deleteKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var key = _step2.value;

        $ls.deleteKey(key);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }

    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = subjectIds[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var id = _step3.value;

        $ls.set('2018_selfcheck-subject-' + id, subjects[id]);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }

  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = subjectIds[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var _id = _step4.value;

      var _value = subjects[_id];
      if (_value !== undefined) {
        newStates['selfcheck-subject-' + _id] = JSON.parse(JSON.stringify(_value));
      }
    }

    // lsに存在するキーはsetして、ないキーはdeleteする
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }

  for (var _key in state) {
    if (newStates[_key] === undefined) _vue2.default.delete(state, _key);
  }
  for (var _key2 in newStates) {
    _vue2.default.set(state, _key2, newStates[_key2]);
  }
}

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var ev = {};
new _ddEventManager2.default(ev);

var LS_ENABLED = false;

try {
  if (_typeof(window.localStorage) === 'object' && window.localStorage !== null) {
    localStorage.setItem('__dnls_detect__', 'enabled');
    if (localStorage.getItem('__dnls_detect__') === 'enabled') {
      localStorage.removeItem('__dnls_detect__');
      LS_ENABLED = true;
    }
  }
} catch (e) {}

exports.default = {
  namespaced: true,

  state: {
    initialized: false,
    localStorageEnabled: LS_ENABLED,
    cookieEnabled: navigator.cookieEnabled,
    isPrivateBrowse: null
  },

  getters: {
    localStorageEnabled: function localStorageEnabled(state) {
      return state.localStorageEnabled;
    },
    cookieEnabled: function cookieEnabled(state) {
      return state.cookieEnabled;
    },
    isPrivateBrowse: function isPrivateBrowse(state) {
      return state.isPrivateBrowse;
    },
    storageEnabled: function storageEnabled(state) {
      return state.localStorageEnabled && state.cookieEnabled;
    },
    isIdbNotSupport: function isIdbNotSupport(state, getters, rootState, rootGetters) {
      return rootGetters['ua/isAny'](['lte-ie10', 'lt-safari10']) || rootGetters['ua/is']('ios') && rootState.ua.os.version <= 9;
    },
    idbEnabled: function idbEnabled(state, getters) {
      return !state.isPrivateBrowse && getters['storageEnabled'] && !getters['isIdbNotSupport'];
    }
  },

  actions: {
    init: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2) {
        var dispatch = _ref2.dispatch,
            commit = _ref2.commit;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch('detectPrivateBrowse');

              case 2:
                commit('setInitialized');

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function init(_x) {
        return _ref.apply(this, arguments);
      };
    }(),
    ready: function ready() {
      return new Promise(function (resolve) {
        ev.hasAndOn('init', resolve);
      });
    },
    detectPrivateBrowse: function detectPrivateBrowse(_ref3) {
      var state = _ref3.state,
          dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          getters = _ref3.getters,
          rootGetters = _ref3.rootGetters;

      var maxRetry = 50,
          interval = 10;

      var retry = function retry(isDone, next) {
        var currentTrial = 0,
            isTimeout = false;

        var intervalId = window.setInterval(function () {
          if (isDone()) {
            window.clearInterval(intervalId);
            next(typeof next !== 'function' ? next : isTimeout);
          }

          if (currentTrial++ > maxRetry) {
            window.clearInterval(intervalId);
            isTimeout = true;
            next(isTimeout);
          }
        }, interval);
      };

      return new Promise(function (resolve) {
        if (rootGetters['ua/is']('chrome')) {

          // >>> Chrome
          if (window.webkitRequestFileSystem) {
            return window.webkitRequestFileSystem(window.TEMPORARY, 1, function () {
              commit('setIsPrivateBrowse', false);
              return resolve();
            }, function (e) {
              commit('setIsPrivateBrowse', true);
              return resolve();
            });
          }
        } else if (rootGetters['ua/is']('firefox')) {

          // >>> Firefox
          try {
            if (window.indexedDB) {
              var db = window.indexedDB.open('dn_detect_db');

              return retry(function () {
                return db.readyState === 'done' ? true : false;
              }, function (isTimeout) {
                if (!isTimeout) {
                  commit('setIsPrivateBrowse', db.result ? false : true);
                  return resolve();
                }
              });
            } else {
              commit('setIsPrivateBrowse', true);
              return resolve();
            }
          } catch (e) {
            commit('setIsPrivateBrowse', true);
            return resolve();
          }
        } else if (rootGetters['ua/is']('gte-ie10')) {

          // >>> get IE10
          var isPrivate = false;

          try {
            if (!window.indexedDB) {
              isPrivate = true;
            }
          } catch (e) {
            isPrivate = true;
          }

          commit('setIsPrivateBrowse', isPrivate);
          return resolve();
        } else if (rootGetters['ua/is']('safari')) {

          // >>> Safari
          commit('setIsPrivateBrowse', !getters['localStorageEnabled']);
          return resolve();
        }

        commit('setIsPrivateBrowse', false);
        resolve();
      });
    }
  },
  mutations: {
    setInitialized: function setInitialized(state) {
      var initialized = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      state.initialized = initialized;
      if (initialized) {
        ev.emit('init');
      }
    },
    setIsPrivateBrowse: function setIsPrivateBrowse(state, isPrivateBrowse) {
      state.isPrivateBrowse = isPrivateBrowse;
    }
  }
};

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _segments = __webpack_require__(417);

var _segments2 = _interopRequireDefault(_segments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _segments2.default;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

var _user = __webpack_require__(418);

var _user2 = _interopRequireDefault(_user);

var _device = __webpack_require__(419);

var _device2 = _interopRequireDefault(_device);

var _schoolChoices = __webpack_require__(420);

var _schoolChoices2 = _interopRequireDefault(_schoolChoices);

var _score = __webpack_require__(421);

var _score2 = _interopRequireDefault(_score);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var $seg = void 0;
var ev = {};

new _ddEventManager2.default(ev);

exports.default = {
  namespaced: true,

  state: {
    ready: false
  },

  getters: {
    ready: function ready(state) {
      return state.ready;
    }
  },

  modules: {
    user: _user2.default,
    device: _device2.default,
    schoolChoices: _schoolChoices2.default,
    score: _score2.default
  },

  actions: {
    init: function init(_ref) {
      var _this = this;

      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          getters = _ref.getters,
          state = _ref.state;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                $seg = window.bcBanner.segments;
                _context.next = 3;
                return $seg.ready();

              case 3:
                dispatch('user/init');
                dispatch('device/init');
                dispatch('schoolChoices/init');
                dispatch('score/init');
                commit('setReady', true);
                ev.emit('init');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    ready: function ready() {
      return new Promise(function (resolve) {
        ev.hasAndOn('init', resolve);
      });
    }
  },

  mutations: {
    setReady: function setReady(state, ready) {
      state.ready = ready;
    }
  }
};

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LISTEN_TAG = 'dn-store';

var $seg = void 0;

exports.default = {
  namespaced: true,

  state: {
    category: null,
    id: null,
    label: null
  },

  getters: {
    category: function category(state) {
      return state.category;
    },
    id: function id(state) {
      return state.id;
    },
    label: function label(state) {
      return state.label;
    },
    ready: function ready(state) {
      return !!state.id;
    }
  },

  actions: {
    init: function init(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          rootGetters = _ref.rootGetters;

      $seg = window.bcBanner.segments;

      // DN側のマナビジョンページでは属性未設定の場合は「受験生（2）」をデフォルト値として設定する
      // @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-252#comment-1183840434
      if (rootGetters['config/isManabi']) {
        $seg.userType.set('2');
      }

      commit('restore');
      dispatch('startWatch');
    },
    startWatch: function startWatch(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      var firstWatched = false;
      $seg.userType.listen(function (e) {
        commit('restore');

        if (!firstWatched) {
          firstWatched = true;
        } else {

          // 変更があったのでGAに通知する
          dispatch('sendIdForGa');
        }
      }, LISTEN_TAG);
    },
    setId: function setId(_ref3, id) {
      var commit = _ref3.commit;

      commit('setId', id);
    },
    sendIdForGa: function sendIdForGa(_ref4) {
      var state = _ref4.state;

      var label = state.label;
      if (dn && dn.ga && dn.ga.send) {
        return dn.ga.send({
          category: 'ユーザー属性',
          action: '登録',
          label: label
        });
      }
    }
  },

  mutations: {
    restore: function restore(state) {
      var data = $seg.userType.get();
      if (data) {
        state.category = data.category;
        state.id = data.id;
        state.label = data.label;
      }
    },

    setId: function setId(state, id) {
      $seg.userType.set(id);
    }
  }
};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LISTEN_TAG = 'dn-store';

var $seg = void 0;

exports.default = {
  namespaced: true,

  state: {
    uid: null,
    type: null
  },

  getters: {
    uid: function uid(state) {
      return state.uid;
    },
    type: function type(state) {
      return state.type;
    },
    typeName: function typeName(state) {
      return state.type == 1 ? 'PC' : 'SP';
    }
  },

  actions: {
    init: function init(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      $seg = window.bcBanner.segments;
      commit('restore');
      dispatch('startWatch');
    },
    startWatch: function startWatch(_ref2) {
      var commit = _ref2.commit;

      $seg.device.listen(function (e) {
        commit('restore');
      }, LISTEN_TAG);
    }
  },

  mutations: {
    restore: function restore(state) {
      var data = $seg.device.get();
      state.uid = data.uid;
      state.type = data.type;
    }
  }
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LISTEN_TAG = 'dn-store';

var $seg = void 0;

exports.default = {
  namespaced: true,

  state: {
    choices: []
  },

  getters: {
    choices: function choices(state) {
      return state.choices;
    },
    needBeforeYearSync: function needBeforeYearSync(state, getters, rootState, rootGetters) {
      return rootGetters['config/year'] === 2019;
    },
    beforeYear: function beforeYear(state, getters, rootState, rootGetters) {
      return rootGetters['config/year'] - 1;
    }
  },

  actions: {
    init: function init(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          rootGetters = _ref.rootGetters;

      $seg = window.bcBanner.segments;

      dispatch('checkAndSync2018Data');
      commit('restore');
      dispatch('startWatch');
    },
    checkAndSync2018Data: function checkAndSync2018Data(_ref2) {
      var getters = _ref2.getters;

      if (!getters.needBeforeYearSync) return;

      var syncCheckKey = $seg.schoolChoices.key + '_synced';
      var isSynced = $seg.cookies.get(syncCheckKey) === '1';
      if (isSynced) return;

      $seg.schoolChoices.copyFromAnotherYear(getters.beforeYear, {
        cancelWhenHasValue: true,
        onlyCookie: true
      });
      $seg.cookies.set(syncCheckKey, '1');
    },
    startWatch: function startWatch(_ref3) {
      var commit = _ref3.commit,
          getters = _ref3.getters;

      $seg.schoolChoices.listen(function (e) {
        commit('restore');

        if (getters.needBeforeYearSync) {
          $seg.schoolChoices.copyToAnotherYear(getters.beforeYear);
        }
      }, LISTEN_TAG);
    },
    push: function push(_ref4, choice) {
      var commit = _ref4.commit;

      commit('push', choice);
    },
    removeChoice: function removeChoice(_ref5, choice) {
      var commit = _ref5.commit;

      commit('removeChoice', choice);
    },
    clear: function clear(_ref6) {
      var commit = _ref6.commit;
      commit('clear');
    }
  },

  mutations: {
    restore: function restore(state) {
      var choices = $seg.schoolChoices.find();
      _vue2.default.set(state, 'choices', choices);
    },

    push: function push(state, choice) {
      $seg.schoolChoices.push(choice);
    },

    removeChoice: function removeChoice(state, choice) {
      $seg.schoolChoices.remove(choice);
    },

    clear: function clear(state) {
      $seg.schoolChoices.erase();
    }
  }
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LISTEN_TAG = 'dn-store';

var $seg = void 0;

exports.default = {
  namespaced: true,

  state: {
    totalPer: null,
    subjects: {}
  },

  getters: {
    totalPer: function totalPer(state) {
      return state.totalPer;
    },
    subjects: function subjects(state) {
      return state.subjects;
    }
  },

  actions: {
    init: function init(_ref) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch,
          rootGetters = _ref.rootGetters;

      $seg = window.bcBanner.segments;

      commit('restore');
      dispatch('startWatch');
    },
    startWatch: function startWatch(_ref2) {
      var commit = _ref2.commit;

      $seg.scores.listen(function (e) {
        commit('restore');
      }, LISTEN_TAG);
    }
  },

  mutations: {
    restore: function restore(state) {
      var subjects = $seg.scores.getSubjects();
      var totalPer = $seg.scores.getTotalPer();
      _vue2.default.set(state, 'subjects', subjects);
      _vue2.default.set(state, 'totalPer', totalPer);
    }
  }
};

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _selfcheckFactory = __webpack_require__(177);

var _selfcheckFactory2 = _interopRequireDefault(_selfcheckFactory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selfcheck = (0, _selfcheckFactory2.default)(2025);

exports.default = selfcheck;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = subjectSelectionValidater;
function subjectSelectionValidater(selectedIds) {
  'use strict';

  var errors = [];

  var hash = {};
  var tmp1 = void 0,
      tmp2 = void 0;
  selectedIds.forEach(function (id) {
    hash[id] = true;
  });

  if (hash['411'] && hash['412']) errors.push('地理歴史のうち「世界史A」「世界史B」はどちらか一方しか選択できません。');
  if (hash['421'] && hash['422']) errors.push('地理歴史のうち「日本史A」「日本史B」はどちらか一方しか選択できません。');
  if (hash['431'] && hash['432']) errors.push('地理歴史のうち「地理A」「地理B」はどちらか一方しか選択できません。');
  if (hash['452'] && hash['454']) errors.push('公民のうち「政治・経済」「倫理、政治・経済」はどちらか一方しか選択できません。');
  if (hash['451'] && hash['454']) errors.push('公民のうち「倫理」「倫理、政治・経済」はどちらか一方しか選択できません。');

  // 地理歴史の選択数
  var chiriRekishiCount = ['411', '412', '421', '422', '431', '432'].filter(function (id) {
    return selectedIds.includes(id);
  }).length;

  // 公民の選択数
  var kouminCount = ['451', '452', '453', '454'].filter(function (id) {
    return selectedIds.includes(id);
  }).length;

  if (chiriRekishiCount > 2) errors.push('地理歴史は2科目までしか選択できません。');
  if (kouminCount > 2) errors.push('公民は2科目までしか選択できません。');
  if (chiriRekishiCount && kouminCount && chiriRekishiCount + kouminCount > 2) errors.push('地理歴史・公民は合わせて最大２科目までしか選べません。');

  // 外国語の数
  var langCount = ['301', '911', '912', '913', '914'].filter(function (id) {
    return selectedIds.includes(id);
  }).length;

  if (langCount > 1) errors.push('外国語は1科目までしか選択できません。');
  if (hash['311'] && !hash['301'] && langCount > 0) {
    errors.push('外国語のうち「英語（リーディング）」以外を選択した場合「英語（リスニング）」は選択できません。');
  } else if (hash['311'] && !hash['301']) {
    errors.push('外国語のうち「英語（リーディング）」を選択していない場合「英語（リスニング）」は選択できません。');
  }

  // 理科1の選択数
  var rika1Count = ['512', '522', '532', '542'].filter(function (id) {
    return selectedIds.includes(id);
  }).length;

  // 理科2の選択数
  var rika2Count = ['513', '523', '533', '543'].filter(function (id) {
    return selectedIds.includes(id);
  }).length;

  if (rika1Count > 2) errors.push('理科1は2科目までしか選択できません。');
  if (rika2Count > 2) errors.push('理科2は2科目までしか選択できません。');

  if (rika1Count && rika2Count) {
    if (rika1Count > 2 || rika2Count > 1) errors.push('理科1と理科2を選択する場合、\n理科1は2科目、理科2は1科目までしか選択できません。');
  }

  // 数学1の選択数
  var sugaku1Count = ['221', '222'].filter(function (id) {
    return selectedIds.includes(id);
  }).length;

  // 数学2の選択数
  var sugaku2Count = ['223', '224', '901', '902', '903'].filter(function (id) {
    return selectedIds.includes(id);
  }).length;

  if (sugaku1Count > 1) errors.push('数学1は1科目までしか選択できません。');
  if (sugaku2Count > 1) errors.push('数学2は1科目までしか選択できません。');

  return errors.length ? errors : null;
}

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = parseXml;
function parseXml(xml) {
  var categories = [];
  var $xml = $(xml);
  var $categories = $xml.find('category');
  $categories.each(function () {
    var $category = $(this);
    var $subjects = $category.find('subjects subject');
    var category = {
      id: $category.attr('id'),
      name: $category.attr('name'),
      open: $category.attr('open') === 'true',
      subjects: []
    };
    $subjects.each(function () {
      var $subject = $(this);
      var childrenId = $subject.attr('children');
      var subject = {
        id: $subject.attr('id'),
        name: $subject.attr('name'),
        max: parseInt($subject.attr('max'), 10),
        childrenId: childrenId === 'null' ? null : childrenId,
        open: $subject.attr('open') === 'true'
      };
      category.subjects.push(subject);
    });
    categories.push(category);
  });
  return categories;
}

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SCRIPT_TOKEN = '1f250369725168ea72253d897dfd69a18867993e18bf52fce354ade16d6d7213';

var WebPushManager = function () {

  /**
   * constructor
   */
  function WebPushManager() {
    _classCallCheck(this, WebPushManager);
  }

  /**
   * load script
   */


  _createClass(WebPushManager, [{
    key: 'load',
    value: function load() {
      var script = document.createElement('script');
      script.setAttribute('async', '');
      script.setAttribute('charset', 'utf-8');
      script.setAttribute('data-wptoken', SCRIPT_TOKEN);
      script.setAttribute('src', 'https://cdn.webpush.jp/js/webpush.js');
      document.getElementsByTagName('head')[0].appendChild(script);
    }
  }]);

  return WebPushManager;
}();

exports.default = WebPushManager;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DbManager = __webpack_require__(427);

var _DbManager2 = _interopRequireDefault(_DbManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DbManager2.default;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _DbApiCaller = __webpack_require__(428);

var _DbApiCaller2 = _interopRequireDefault(_DbApiCaller);

var _DialogDownload = __webpack_require__(429);

var _DialogDownload2 = _interopRequireDefault(_DialogDownload);

var _DialogQuotaExceededError = __webpack_require__(444);

var _DialogQuotaExceededError2 = _interopRequireDefault(_DialogQuotaExceededError);

var _DialogExceptionError = __webpack_require__(449);

var _DialogExceptionError2 = _interopRequireDefault(_DialogExceptionError);

var _DialogNotCompatibleError = __webpack_require__(462);

var _DialogNotCompatibleError2 = _interopRequireDefault(_DialogNotCompatibleError);

var _DialogStorageDisabledError = __webpack_require__(467);

var _DialogStorageDisabledError2 = _interopRequireDefault(_DialogStorageDisabledError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var TABLE_NAME_RESOLVES = {
  '@offers': ['offers', 'offers_moshi']
};

var resolveTableNames = function resolveTableNames(names) {
  names = typeof names === 'string' ? [names] : names;

  var results = [];
  names.forEach(function (name) {
    var alias = TABLE_NAME_RESOLVES[name];
    if (alias) {
      alias.forEach(function (row) {
        results.push(row);
      });
    } else {
      results.push(name);
    }
  });
  return results;
};

var NOT_SUPPORT_ERROR_MESSAGE = 'IndexedDB の動作保証環境でありません';

exports.default = {
  data: function data() {
    return {
      detectState: 'pending',
      support: true,
      privateBrowse: false,
      browserVersionIsNotSupport: false,
      storageIsDisabled: false,

      progress: {
        message: null,
        value: 0
      }
    };
  },


  computed: {
    isDetcting: function isDetcting() {
      return this.detectState === 'detcting';
    },
    isDetcted: function isDetcted() {
      return this.detectState === 'detcted';
    }
  },

  methods: {

    /**
     * 進捗をセットする
     */
    setProgress: function setProgress() {
      var _this = this;

      var progress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { message: null, value: 0 };

      progress = typeof progress === 'number' ? { value: progress } : progress;
      ['message', 'value'].forEach(function (key) {
        if (progress[key] !== undefined) _this.$set(_this.progress, key, progress[key]);
      });
    },


    /**
     * テーブルのステータスを確認する
     */
    getTablesStatus: function getTablesStatus(names) {
      var _this2 = this;

      return new Promise(function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
          var result;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 3;
                  return _this2.checkNotSupport();

                case 3:
                  _context.next = 8;
                  break;

                case 5:
                  _context.prev = 5;
                  _context.t0 = _context['catch'](0);
                  return _context.abrupt('return', reject(_context.t0));

                case 8:

                  names = resolveTableNames(names);
                  _context.prev = 9;
                  _context.next = 12;
                  return _this2.api.call('getTablesStatus', { tables: names });

                case 12:
                  result = _context.sent;
                  return _context.abrupt('return', resolve(result));

                case 16:
                  _context.prev = 16;
                  _context.t1 = _context['catch'](9);

                  _this2.showErrorDialog();
                  return _context.abrupt('return', reject(_context.t1));

                case 20:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this2, [[0, 5], [9, 16]]);
        }));

        return function (_x2, _x3) {
          return _ref.apply(this, arguments);
        };
      }());
    },


    /**
     * データをダウンロードする
     * ※完了するまでダイアログを表示
     */
    download: function download(names) {
      var _this3 = this;

      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _ref2, _ref3, dbStates, currentStatus, targets, downloadResult, description, name;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.checkNotSupport();

              case 2:

                names = resolveTableNames(names);

                _this3.setProgress();
                _this3.$refs['dialog-download'].show();

                // 現在のテーブルのステータスを取得する
                _context2.next = 7;
                return Promise.all([new Promise(function (resolve, reject) {
                  resolve(JSON.parse(JSON.stringify(dn.$ls.get('db_states', {}))));
                }), _this3.getTablesStatus(names)]);

              case 7:
                _ref2 = _context2.sent;
                _ref3 = _slicedToArray(_ref2, 2);
                dbStates = _ref3[0];
                currentStatus = _ref3[1];
                targets = [];

                // ダウンロードの必要のない物はスキップする

                names.forEach(function (name) {
                  // if (!currentStatus.exist.includes(name)) targets.push(name);
                  // DN回の場合、模試回のマスタもダウンロードする
                  if (name !== "offers_moshi" || dn.$store.getters['config/kai'].substr(4, 3) === "308") {
                    targets.push(name);
                  }
                });

                // ダウンロード対象のローカルストレージのテーブルの状態を削除しておく
                targets.forEach(function (name) {
                  delete dbStates[name];
                });
                dn.$ls.set('db_states', dbStates);

                downloadResult = void 0;
                _context2.prev = 16;
                _context2.next = 19;
                return _this3.api.call('download', { tables: targets, skipSyncDbStates: true }, {
                  onProgress: function onProgress(e) {
                    _this3.setProgress(e);
                    if (typeof opt.onProgress === 'function') return opt.onProgress(e);
                  }
                });

              case 19:
                downloadResult = _context2.sent;
                _context2.next = 33;
                break;

              case 22:
                _context2.prev = 22;
                _context2.t0 = _context2['catch'](16);

                _this3.$refs['dialog-download'].hide();

                description = _context2.t0.description || '';

                if (!description.match('QuotaExceededError')) {
                  _context2.next = 31;
                  break;
                }

                // >>> 容量不足のエラー
                _this3.showErrorDialog('quota-exceeded');
                throw new Error(_context2.t0.description);

              case 31:

                // >>> 例外エラー
                _this3.showErrorDialog();
                throw new Error(_context2.t0);

              case 33:

                // ダウンロード完了後にテーブル状態をローカルストレージに保持する
                // ※スキップされているテーブルもあるかもしれないので、返却されたキーのものだけにする
                for (name in downloadResult) {
                  dbStates[name] = downloadResult[name];
                }

                dn.$ls.set('db_states', dbStates);

                _this3.$refs['dialog-download'].hide();
                return _context2.abrupt('return', downloadResult);

              case 37:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[16, 22]]);
      }))();
    },


    /**
     * 募集単位を検索する
     */
    searchOffers: function searchOffers(conditions) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.checkNotSupport();

              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return _this4.api.call('searchOffers', { conditions: conditions });

              case 5:
                return _context3.abrupt('return', _context3.sent);

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](2);

                _this4.showErrorDialog();
                throw new Error(_context3.t0);

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[2, 8]]);
      }))();
    },


    /**
     * 合格者最低点・平均点一覧を募集単位基準で検索する
     */
    searchOfferWithPassingScores: function searchOfferWithPassingScores(conditions) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.checkNotSupport();

              case 2:
                _context4.prev = 2;
                _context4.next = 5;
                return _this5.api.call('searchOfferWithPassingScores', { conditions: conditions });

              case 5:
                return _context4.abrupt('return', _context4.sent);

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](2);

                _this5.showErrorDialog();
                throw new Error(_context4.t0);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[2, 8]]);
      }))();
    },


    /**
     * エラーダイアログを表示する
     */
    showErrorDialog: function showErrorDialog() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'exception';

      // 新大学データダウンロード対応
      if (type === 'exception') {
        var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        var request = indexedDB.deleteDatabase('dn_db_2019');
        request = indexedDB.deleteDatabase('dn_db_2018');
        if (sessionStorage.getItem("error") == undefined) {
          location.reload();
          sessionStorage.setItem("error", "1");
        } else {
          sessionStorage.setItem("error", "0");
          return this.$refs['dialog-' + type + '-error'].show();
        }
        return;
      } else {
        return this.$refs['dialog-' + type + '-error'].show();
      }
    },


    /**
     * 容量チェック（デバッグ用）
     */
    checkSize: function checkSize() {
      var onError = function onError(e) {
        console.error(e);
        alert('容量のチェックができませんでした。');
      };

      try {
        navigator.webkitTemporaryStorage.queryUsageAndQuota(function (usedBytes, grantedBytes) {
          var usedMb = Math.round(usedBytes * 10 / 1000 / 1000) / 10;
          var usedGb = Math.round(usedMb * 10 / 1000) / 10;
          var totalMb = Math.round(grantedBytes * 10 / 1000 / 1000) / 10;
          var totalGb = Math.round(totalMb * 10 / 1000) / 10;

          console.log('we are using ', usedBytes, ' of ', grantedBytes, 'bytes');

          alert('使ってる容量: ' + usedMb + 'MB（' + usedGb + 'GB）\n' + '使える容量: ' + totalMb + 'MB（' + totalGb + 'GB）\n');
        }, onError);
      } catch (e) {
        onError(e);
      }
    },


    /**
     * サポート状況をチェック＆保持する
     */
    detectSupport: function detectSupport() {
      var _this6 = this;

      if (this.isDetcted) return Promise.resolve(this.support);

      return new Promise(function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(resolve) {
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _this6.on('detect', function () {
                    resolve(_this6.support);
                  });

                  if (!_this6.isDetcting) {
                    _context5.next = 3;
                    break;
                  }

                  return _context5.abrupt('return');

                case 3:

                  _this6.detectState = 'detcting';

                  _context5.next = 6;
                  return dn.$store.dispatch('browser/ready');

                case 6:

                  if (!dn.$store.getters['browser/idbEnabled']) {
                    _this6.support = false;

                    if (dn.$store.getters['browser/isPrivateBrowse']) {
                      _this6.privateBrowse = true;
                    } else if (!dn.$store.getters['browser/storageEnabled']) {
                      _this6.storageIsDisabled = true;
                    } else if (dn.$store.getters['browser/isIdbNotSupport']) {
                      _this6.browserVersionIsNotSupport = true;
                    }
                  }

                  _this6.detectState = 'detcted';
                  _this6.emit('detect');

                case 9:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, _this6);
        }));

        return function (_x6) {
          return _ref4.apply(this, arguments);
        };
      }());
    },


    /**
     * 未サポートをチェックしてそうであればエラーをスローする
     */
    checkNotSupport: function checkNotSupport() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this7.detectSupport();

              case 2:
                if (_context6.sent) {
                  _context6.next = 5;
                  break;
                }

                _this7.showNotSupportDialog();
                throw new Error(NOT_SUPPORT_ERROR_MESSAGE);

              case 5:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },


    /**
     * 未サポートダイアログを表示
     */
    showNotSupportDialog: function showNotSupportDialog() {
      var dialogName = void 0;
      if (this.browserVersionIsNotSupport) dialogName = 'not-compatible';
      if (this.storageIsDisabled || this.privateBrowse) dialogName = 'storage-disabled';

      return this.showErrorDialog(dialogName);
    }
  },

  created: function created() {
    var _this8 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              new EventManager(_this8);

              _this8.api = new _DbApiCaller2.default();
              _context7.next = 4;
              return _this8.detectSupport();

            case 4:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this8);
    }))();
  },
  render: function render(h) {
    var $container = h('div', {
      attrs: {
        class: 'dn-db-manager'
      }
    }, [h(_DialogDownload2.default, {
      ref: 'dialog-download',

      props: {
        message: this.progress.message,
        value: this.progress.value
      }
    }), h(_DialogNotCompatibleError2.default, {
      ref: 'dialog-not-compatible-error'
    }), h(_DialogStorageDisabledError2.default, {
      ref: 'dialog-storage-disabled-error',
      props: {
        privateBrowse: this.privateBrowse,
        storageIsDisabled: this.storageIsDisabled
      }
    }), h(_DialogExceptionError2.default, {
      ref: 'dialog-exception-error'
    }), h(_DialogQuotaExceededError2.default, {
      ref: 'dialog-quota-exceeded-error'
    })]);
    return $container;
  }
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var requestConnectId = 0;
var USE_WEB_WORKER = false;

var DbApiCaller = function () {
  _createClass(DbApiCaller, [{
    key: 'workerPath',
    get: function get() {
      return dn.$store.getters['path/$join']('resources', 'js/db/' + (USE_WEB_WORKER ? 'web-' : '') + 'worker.js');
    }
  }, {
    key: 'isConnecting',
    get: function get() {
      return this.state === 'connecting';
    }
  }, {
    key: 'isConnected',
    get: function get() {
      return this.state === 'connected';
    }

    /**
     * constructor
     */

  }]);

  function DbApiCaller() {
    _classCallCheck(this, DbApiCaller);

    new EventManager(this);

    this._callIndex = 0;
    this.worker = null;
    this.state = 'pending';
  }

  /**
   * terminate
   */


  _createClass(DbApiCaller, [{
    key: 'terminate',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!USE_WEB_WORKER) {
                  _context.next = 4;
                  break;
                }

                _context.next = 3;
                return this.call('terminate');

              case 3:
                try {
                  this.worker.terminate();
                } catch (e) {}

              case 4:

                this.worker = null;
                this.state = 'pending';

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function terminate() {
        return _ref.apply(this, arguments);
      }

      return terminate;
    }()

    /**
     * initialize
     */

  }, {
    key: 'requestConnect',
    value: function requestConnect() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (_this.isConnected) return resolve();

        var myRequestConnectId = ++requestConnectId;

        _this.one('connect.' + myRequestConnectId, function () {
          resolve();
        });

        if (_this.isConnecting) return;

        _this.state = 'connecting';

        var onSuccess = function onSuccess() {
          _this.call('init', { config: { year: dn.$store.state.config.year, rootPath: dn.$store.getters['path/$join']('root', 'db') } }).then(function () {
            _this.state = 'connected';
            _this.emit('connect');
            return null;
          }).catch(onError);
        };

        var onError = function onError(e) {
          _this.state = 'connecterror';
          _this.emit('connecterror');
          _this.off('connect.' + myRequestConnectId);
          reject(e);
        };

        if (USE_WEB_WORKER) {
          _this.worker = new Worker(_this.workerPath);
          onSuccess();
        } else {
          dn.$http.get(_this.workerPath).then(function (res) {
            _this.worker = window._DnDbApiReciever;
            return onSuccess();
          }).catch(onError);
        }
      });
    }

    /**
     * call worker method
     */

  }, {
    key: 'call',
    value: function call(action) {
      var _this2 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return new Promise(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(resolve, reject) {
          var dbStates, onError, callIndex, listenerNames, callbackRecievers, name, onWorkerError, removeWebWorkerListener, onMessage, workerParams, res;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  dbStates = void 0;

                  onError = function onError(e) {
                    return reject(e);
                  };

                  if (!params.skipSyncDbStates) {
                    dbStates = dn.$store.getters['ls/at']('db_states', {});
                  }

                  if (!(action !== 'init')) {
                    _context2.next = 12;
                    break;
                  }

                  _context2.prev = 4;
                  _context2.next = 7;
                  return _this2.requestConnect();

                case 7:
                  _context2.next = 12;
                  break;

                case 9:
                  _context2.prev = 9;
                  _context2.t0 = _context2['catch'](4);
                  return _context2.abrupt('return', onError(_context2.t0));

                case 12:
                  callIndex = ++_this2._callIndex;
                  listenerNames = [];
                  callbackRecievers = {};

                  for (name in callbacks) {
                    listenerNames.push(name);
                    if (!USE_WEB_WORKER) callbackRecievers[name] = callbacks[name];
                  }

                  onWorkerError = function onWorkerError(e) {
                    removeWebWorkerListener();
                    return onError(e);
                  };

                  removeWebWorkerListener = function removeWebWorkerListener() {
                    if (!USE_WEB_WORKER) return;
                    _this2.worker.removeEventListener('message', onMessage, false);
                    _this2.worker.removeEventListener('error', onWorkerError, false);
                  };

                  onMessage = function onMessage(message) {
                    var _data = message.data || {},
                        recieveIndex = _data._callIndex;

                    if (recieveIndex !== callIndex) return;

                    var type = _data.type,
                        data = _data.data;

                    var callbackMatch = type.match(/^cb\.(.*)$/);
                    if (callbackMatch) {
                      var callbackName = callbackMatch[1];
                      return callbacks[callbackName](data);
                    }

                    removeWebWorkerListener();

                    if (type === 'error') {
                      return onError(new Error(data.message || data));
                    }
                    if (type === 'cb') return resolve(data);
                  };

                  workerParams = Object.assign({}, {
                    action: action,
                    _callIndex: callIndex,
                    _listenerNames: listenerNames,
                    _callbackRecievers: callbackRecievers,
                    _dbStates: dbStates
                  }, params);

                  if (!USE_WEB_WORKER) {
                    _context2.next = 26;
                    break;
                  }

                  _this2.worker.addEventListener('message', onMessage, false);
                  _this2.worker.addEventListener('error', onWorkerError, false);
                  _this2.worker.postMessage(workerParams);
                  _context2.next = 30;
                  break;

                case 26:
                  _context2.next = 28;
                  return _this2.worker({ data: workerParams });

                case 28:
                  res = _context2.sent;

                  onMessage(res);

                case 30:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2, [[4, 9]]);
        }));

        return function (_x3, _x4) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }]);

  return DbApiCaller;
}();

exports.default = DbApiCaller;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(430)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-e81af6d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(431);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("7d3ae40a", content, true, {});

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-lead[data-v-e81af6d8]{margin-bottom:15px}.my-message[data-v-e81af6d8]{font-size:90%;text-align:right}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/DialogDownload.vue"],"names":[],"mappings":"AACA,0BAA0B,kBAAkB,CAC3C,AACD,6BAA6B,cAAc,gBAAgB,CAC1D","file":"DialogDownload.vue","sourcesContent":["\n.my-lead[data-v-e81af6d8]{margin-bottom:15px\n}\n.my-message[data-v-e81af6d8]{font-size:90%;text-align:right\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialogMixin = __webpack_require__(66);

var _dialogMixin2 = _interopRequireDefault(_dialogMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    value: {
      type: Number,
      default: 0
    },
    message: {
      type: String,
      default: null
    }
  },

  mixins: [_dialogMixin2.default],

  data: function data() {
    return {
      inputValue: this.value
    };
  },


  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(434)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(437),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3c375f46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("43377dad", content, true, {});

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-header[data-v-3c375f46]{line-height:1.7;color:#0f9cec;text-align:center;font-size:14px}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/DialogBase.vue"],"names":[],"mappings":"AACA,4BAA4B,gBAAgB,cAAc,kBAAkB,cAAc,CACzF","file":"DialogBase.vue","sourcesContent":["\n.my-header[data-v-3c375f46]{line-height:1.7;color:#0f9cec;text-align:center;font-size:14px\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-dialog', {
    ref: "dialog",
    attrs: {
      "content-class": "dn-db-manager-dialog",
      "persistent": "",
      "btnClose": false
    }
  }, [_c('h3', {
    staticClass: "my-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(439)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(442),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-65a90bed",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(440);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("58012a2c", content, true, {});

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-header[data-v-65a90bed]{line-height:1.7;color:#0f9cec;text-align:center;font-size:14px}.my-message[data-v-65a90bed]{color:red;text-align:center}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/ErrorDialogBase.vue"],"names":[],"mappings":"AACA,4BAA4B,gBAAgB,cAAc,kBAAkB,cAAc,CACzF,AACD,6BAA6B,UAAU,iBAAiB,CACvD","file":"ErrorDialogBase.vue","sourcesContent":["\n.my-header[data-v-65a90bed]{line-height:1.7;color:#0f9cec;text-align:center;font-size:14px\n}\n.my-message[data-v-65a90bed]{color:red;text-align:center\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dn-dialog', {
    ref: "dialog",
    attrs: {
      "content-class": "dn-db-manager-dialog dn-db-manager-error-dialog"
    }
  }, [_c('h3', {
    staticClass: "my-header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [(_vm.$slots.header) ? _vm._t("header") : _c('div', [_vm._v("エラーが発生しました")])], 2), _vm._v(" "), _c('div', {
    staticClass: "my-message"
  }, [_vm._t("message")], 2), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "my-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    staticClass: "my-btn--apply",
    attrs: {
      "block-sp": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs.dialog.hide($event)
      }
    }
  }, [_vm._v("閉じる")])], 1)])
},staticRenderFns: []}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dialog-base', {
    ref: "base"
  }, [_c("template", {
    tag: "div",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("データをダウンロード中です")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "my-lead"
  }, [_vm._v("画面を閉じずに、そのままお待ちください")]), _vm._v(" "), _c('dn-progress-bar', {
    staticClass: "my-progress",
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(445)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(448),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47c4f12e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(446);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("4b9015ba", content, true, {});

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-lead[data-v-47c4f12e]{margin-bottom:15px;color:red}.my-ie-message[data-v-47c4f12e]{margin-top:10px}.my-ie-message__guide[data-v-47c4f12e]{font-size:90%}.my-step-list>li[data-v-47c4f12e]{margin-top:.5em}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/DialogQuotaExceededError.vue"],"names":[],"mappings":"AACA,0BAA0B,mBAAmB,SAAS,CACrD,AACD,gCAAgC,eAAe,CAC9C,AACD,uCAAuC,aAAa,CACnD,AACD,kCAAkC,eAAe,CAChD","file":"DialogQuotaExceededError.vue","sourcesContent":["\n.my-lead[data-v-47c4f12e]{margin-bottom:15px;color:red\n}\n.my-ie-message[data-v-47c4f12e]{margin-top:10px\n}\n.my-ie-message__guide[data-v-47c4f12e]{font-size:90%\n}\n.my-step-list>li[data-v-47c4f12e]{margin-top:.5em\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialogMixin = __webpack_require__(66);

var _dialogMixin2 = _interopRequireDefault(_dialogMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  mixins: [_dialogMixin2.default]
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('error-dialog-base', {
    ref: "base"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("お使いの端末の"), _c('wbr'), _vm._v("ストレージの空き容量が"), _c('wbr'), _vm._v("不足しています")]), _vm._v(" "), _c("template", {
    tag: "div",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v("不要なデータを削除頂く、もしくは他の端末で再度お試しください。")]), _vm._v(" "), _c('div', {
    staticClass: "my-ie-message"
  }, [_c('p', {
    staticClass: "my-ie-message__guide"
  }, [_vm._v("※Internet Explorerをお使いの場合、このエラーはブラウザの設定によって表示されている可能性があります。"), _c('br'), _vm._v("以下の手順をお試しください。")]), _vm._v(" "), _c('ol', {
    staticClass: "my-step-list"
  }, [_c('li', [_vm._v("[インターネットオプション]を開く")]), _vm._v(" "), _c('li', [_vm._v("[全般]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("[閲覧の履歴]の[設定]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("[キャッシュおよびデータベース]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("[Web サイトのキャッシュおよびデータベースを許可する]にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("一覧表示の中からWEBサイト「dn-sundai.benesse.ne.jp」をクリックする")]), _vm._v(" "), _c('li', [_vm._v("[制限の拡張]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("[OK]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("ブラウザを再起動する")])])])])
},staticRenderFns: []}

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(450)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(461),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2d071f85",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(451);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("25cef9f9", content, true, {});

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-lead[data-v-2d071f85]{margin-bottom:15px;color:red}.my-section[data-v-2d071f85]{margin-top:20px}.my-small-guide[data-v-2d071f85]{font-size:90%}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/DialogExceptionError.vue"],"names":[],"mappings":"AACA,0BAA0B,mBAAmB,SAAS,CACrD,AACD,6BAA6B,eAAe,CAC3C,AACD,iCAAiC,aAAa,CAC7C","file":"DialogExceptionError.vue","sourcesContent":["\n.my-lead[data-v-2d071f85]{margin-bottom:15px;color:red\n}\n.my-section[data-v-2d071f85]{margin-top:20px\n}\n.my-small-guide[data-v-2d071f85]{font-size:90%\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialogMixin = __webpack_require__(66);

var _dialogMixin2 = _interopRequireDefault(_dialogMixin);

var _CompatibleTable = __webpack_require__(178);

var _CompatibleTable2 = _interopRequireDefault(_CompatibleTable);

var _HowToCookie = __webpack_require__(179);

var _HowToCookie2 = _interopRequireDefault(_HowToCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import HowToClear from './partials/HowToClear';


var DB_NAME_PREFIX = 'dn_db_'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_dialogMixin2.default],

  components: {
    'my-compatibleTable': _CompatibleTable2.default,
    'my-howtocookie': _HowToCookie2.default
    // 'my-howtoclear': HowToClear,
  },

  methods: {
    clearData: function clearData() {
      var dbName = '' + DB_NAME_PREFIX + dn.$store.getters['config/year'];
      var indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
      var request = indexedDB.deleteDatabase(dbName);

      dn.loading.show();

      request.onerror = function (event) {
        dn.loading.hide();
        alert('データを削除できませんでした。');
      };

      request.onsuccess = function (event) {
        dn.$ls.delete('db_states');
        dn.loading.hide();
        setTimeout(function () {
          alert('削除に成功しました。ブラウザをリロードして再度データをダウンロードしてください。');
        }, 250);
      };
    }
  }
};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(454);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("73143c50", content, true, {});

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-device-define>dt[data-v-4145e57e]{margin-top:20px}.my-device-define>dt[data-v-4145e57e]:before{content:\"\\25A0\"}.my-link-list>li[data-v-4145e57e]{margin-top:.5em}.my-link-list dfn[data-v-4145e57e]{font-style:normal;display:block;font-weight:400}.my-link-list dfn[data-v-4145e57e]:before{content:\"\\30FB\"}.my-guide[data-v-4145e57e]{margin-bottom:.5em;padding-left:1em;font-size:90%}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/partials/CompatibleTable.vue"],"names":[],"mappings":"AAEA,sCAAsC,eAAe,CACpD,AACD,6CAA6C,eAAW,CACvD,AACD,kCAAkC,eAAe,CAChD,AACD,mCAAmC,kBAAkB,cAAc,eAAe,CACjF,AACD,0CAA0C,eAAW,CACpD,AACD,2BAA2B,mBAAmB,iBAAiB,aAAa,CAC3E","file":"CompatibleTable.vue","sourcesContent":["\n@charset \"UTF-8\";\n.my-device-define>dt[data-v-4145e57e]{margin-top:20px\n}\n.my-device-define>dt[data-v-4145e57e]:before{content:\"■\"\n}\n.my-link-list>li[data-v-4145e57e]{margin-top:.5em\n}\n.my-link-list dfn[data-v-4145e57e]{font-style:normal;display:block;font-weight:400\n}\n.my-link-list dfn[data-v-4145e57e]:before{content:\"・\"\n}\n.my-guide[data-v-4145e57e]{margin-bottom:.5em;padding-left:1em;font-size:90%\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dl', {
    staticClass: "my-device-define"
  }, [_c('dt', [_vm._v("PCをお使いの方")]), _vm._v(" "), _c('dd', [_c('ul', {
    staticClass: "my-link-list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://www.google.co.jp/chrome/browser/desktop/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Chrome（最新版）")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.mozilla.org/ja/firefox/",
      "target": "_blank"
    }
  }, [_vm._v("Firefox（最新版）")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://support.microsoft.com/ja-jp/help/17621/internet-explorer-downloads",
      "target": "_blank"
    }
  }, [_vm._v("Internet Explorer（11以降）※Windowsのみ")])])])]), _vm._v(" "), _c('dt', [_vm._v("スマートフォンをお使いの方")]), _vm._v(" "), _c('dd', [_c('ul', {
    staticClass: "my-link-list"
  }, [_c('li', [_c('dfn', [_vm._v("iPhone")]), _vm._v(" "), _c('p', {
    staticClass: "my-guide"
  }, [_vm._v("iOS10以上へアップデートした状態のSafariでご利用ください。")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://support.apple.com/ja-jp/HT204204",
      "target": "_blank"
    }
  }, [_vm._v("※アップデート方法")])]), _vm._v(" "), _c('li', [_c('dfn', [_vm._v("Android")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.android.chrome&hl=ja",
      "target": "_blank"
    }
  }, [_vm._v("Chrome（最新版）")])])])])])])
}]}

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(458);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("35982efb", content, true, {});

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-browser-define>dt[data-v-7d242a16]{margin-top:20px}.my-browser-define>dt[data-v-7d242a16]:before{content:\"\\25A0\"}.my-step-list>li[data-v-7d242a16]{margin-top:.5em}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/partials/HowToCookie.vue"],"names":[],"mappings":"AAEA,uCAAuC,eAAe,CACrD,AACD,8CAA8C,eAAW,CACxD,AACD,kCAAkC,eAAe,CAChD","file":"HowToCookie.vue","sourcesContent":["\n@charset \"UTF-8\";\n.my-browser-define>dt[data-v-7d242a16]{margin-top:20px\n}\n.my-browser-define>dt[data-v-7d242a16]:before{content:\"■\"\n}\n.my-step-list>li[data-v-7d242a16]{margin-top:.5em\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {};

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('dl', {
    staticClass: "my-browser-define"
  }, [_c('dt', [_vm._v("Chrome（PC）をお使いの場合")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DDesktop&hl=ja",
      "target": "_blank"
    }
  }, [_vm._v("設定方法")])]), _vm._v(" "), _c('dt', [_vm._v("Firefox（PC）をお使いの場合")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "https://support.mozilla.org/ja/kb/enable-and-disable-cookies-website-preferences",
      "target": "_blank"
    }
  }, [_vm._v("設定方法")])]), _vm._v(" "), _c('dt', [_vm._v("Internet Explorerをお使いの場合")]), _vm._v(" "), _c('dd', [_c('ol', {
    staticClass: "my-step-list"
  }, [_c('li', [_vm._v("[インターネットオプション]を開く")]), _vm._v(" "), _c('li', [_vm._v("[詳細設定]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("セキュリティの[DOMストレージを有効にする]にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("[全般]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("[閲覧の履歴]の[設定]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("[キャッシュおよびデータベース]タブを開く")]), _vm._v(" "), _c('li', [_vm._v("[Web サイトのキャッシュおよびデータベースを許可する]にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("[OK]をクリックする")]), _vm._v(" "), _c('li', [_vm._v("Windows (PC) を再起動する")])])]), _vm._v(" "), _c('dt', [_vm._v("Safari(iOS)をお使いの場合")]), _vm._v(" "), _c('dd', [_c('ol', {
    staticClass: "my-step-list"
  }, [_c('li', [_vm._v("設定 > Safari > Cookieをブロック へ進む")]), _vm._v(" "), _c('li', [_vm._v("「常にブロック」以外を選択する")])])]), _vm._v(" "), _c('dt', [_vm._v("Chrome（Android）をお使いの場合")]), _vm._v(" "), _c('dd', [_c('a', {
    attrs: {
      "href": "https://support.google.com/chrome/answer/95647?co=GENIE.Platform%3DAndroid&hl=ja",
      "target": "_blank"
    }
  }, [_vm._v("設定方法")])])])])
}]}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('error-dialog-base', {
    ref: "base"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("データ接続中に"), _c('wbr'), _vm._v("予期せぬエラーが"), _c('wbr'), _vm._v("発生しました")]), _vm._v(" "), _c("template", {
    tag: "div",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v("画面を再度読み込んで頂き、再度お試しください。"), _c('br'), _vm._v("何度かこのエラーが続く場合は以下をご確認ください。")]), _vm._v(" "), _c('section', {
    staticClass: "my-section pb10"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("ダウンロードデータのクリアをお試しください")]), _vm._v(" "), _c('p', {
    staticClass: "my-small-guide"
  }, [_vm._v("\n        以下のボタンを押してデータのクリアをお試しください。※データの再ダウンロードが必要になります\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt10 tac"
  }, [_c('dn-btn', {
    attrs: {
      "sm": "",
      "accent": ""
    },
    on: {
      "click": _vm.clearData
    }
  }, [_vm._v("データを削除する")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "my-section"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("お使いのブラウザをご確認ください")]), _vm._v(" "), _c('p', {
    staticClass: "my-small-guide"
  }, [_vm._v("以下のブラウザでこのページを表示可能です。")]), _vm._v(" "), _c('my-compatibleTable')], 1), _vm._v(" "), _c('section', {
    staticClass: "my-section"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("プライベートブラウズモードで表示されていないかご確認ください")]), _vm._v(" "), _c('p', {
    staticClass: "my-small-guide"
  }, [_vm._v("プライベートブラウズ状態でページが表示されている場合データの保存ができません。"), _c('br'), _vm._v("通常の状態でページを開き直してお試しください。")])]), _vm._v(" "), _c('section', {
    staticClass: "my-section"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("Cookieやストレージ機能が無効設定されていないかご確認ください")]), _vm._v(" "), _c('p', {
    staticClass: "my-small-guide"
  }, [_vm._v("ブラウザのストレージ設定が無効化されている場合データの保存ができません。"), _c('br'), _vm._v("お使いのブラウザごとに以下の手順をお試しください。")]), _vm._v(" "), _c('my-howtocookie')], 1)])
},staticRenderFns: []}

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(466),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-a6176266",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(464);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("55ff5286", content, true, {});

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-lead[data-v-a6176266]{margin-bottom:15px;color:red}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/DialogNotCompatibleError.vue"],"names":[],"mappings":"AACA,0BAA0B,mBAAmB,SAAS,CACrD","file":"DialogNotCompatibleError.vue","sourcesContent":["\n.my-lead[data-v-a6176266]{margin-bottom:15px;color:red\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialogMixin = __webpack_require__(66);

var _dialogMixin2 = _interopRequireDefault(_dialogMixin);

var _CompatibleTable = __webpack_require__(178);

var _CompatibleTable2 = _interopRequireDefault(_CompatibleTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_dialogMixin2.default],

  components: {
    'my-compatibleTable': _CompatibleTable2.default
  }
};

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('error-dialog-base', {
    ref: "base"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("お使いのブラウザでは"), _c('wbr'), _vm._v("このページを"), _c('wbr'), _vm._v("表示できません。")]), _vm._v(" "), _c("template", {
    tag: "div",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v("以下のブラウザでこのページを表示可能です。")]), _vm._v(" "), _c('my-compatibleTable')], 1)
},staticRenderFns: []}

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(471),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2fb1d886",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(469);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6c38525f", content, true, {});

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my-lead[data-v-2fb1d886]{margin-bottom:15px;color:red}.my-ie-message[data-v-2fb1d886]{margin-top:10px}.my-ie-message__guide[data-v-2fb1d886]{font-size:90%}.my-step-list>li[data-v-2fb1d886]{margin-top:.5em}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/manager/DbManager/dialogs/DialogStorageDisabledError.vue"],"names":[],"mappings":"AACA,0BAA0B,mBAAmB,SAAS,CACrD,AACD,gCAAgC,eAAe,CAC9C,AACD,uCAAuC,aAAa,CACnD,AACD,kCAAkC,eAAe,CAChD","file":"DialogStorageDisabledError.vue","sourcesContent":["\n.my-lead[data-v-2fb1d886]{margin-bottom:15px;color:red\n}\n.my-ie-message[data-v-2fb1d886]{margin-top:10px\n}\n.my-ie-message__guide[data-v-2fb1d886]{font-size:90%\n}\n.my-step-list>li[data-v-2fb1d886]{margin-top:.5em\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dialogMixin = __webpack_require__(66);

var _dialogMixin2 = _interopRequireDefault(_dialogMixin);

var _HowToCookie = __webpack_require__(179);

var _HowToCookie2 = _interopRequireDefault(_HowToCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_dialogMixin2.default],

  components: {
    'my-howtocookie': _HowToCookie2.default
  },

  props: {
    privateBrowse: Boolean,
    storageIsDisabled: Boolean
  }
};

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('error-dialog-base', {
    ref: "base"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("ブラウザの設定により"), _c('wbr'), _vm._v("データの保存が"), _c('wbr'), _vm._v("無効化されています")]), _vm._v(" "), _c('div', [_c('p', [_vm._v("プライベートブラウズ状態でページが表示されている、もしくはブラウザのストレージ設定が無効化されているためデータの保存ができません。"), _c('br'), _vm._v("\n    プライベートブラウズ状態を解除して頂くか、お使いのブラウザごとに以下の手順をお試しください。")]), _vm._v(" "), _c('my-howtocookie')], 1)])
},staticRenderFns: []}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleAnalyticsObject = 'dnga';
var DEFINES = [

/**
 * 旧GA
 * @todo
 *   2019/3の年度更新時に削除する
 * @see
 *   https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2019-25
 */
{
  name: 'dnold',
  id: 'UA-103561119-1',
  pageview: false,
  rule: function rule(gaManager) {
    return gaManager.context.$store.getters['config/isBene'];
  }
},

/**
 * 最新GA
 * DN2019の本番用資材公開時からの利用
 * @see
 *   https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2019-25
 */
{
  name: 'dn',
  id: 'UA-127678425-1',
  pageview: true,
  rule: function rule(gaManager) {
    return gaManager.context.$store.getters['config/isBene'];
  }
},

/**
 * 開発時用のGAID
 * 環境設定でドメインがbenesseのものでなかった場合に採用される
 * UA-1614455-19
 */
{
  name: 'dev',
  pageview: true,
  cookieDomain: 'none',
  get id() {
    return decaesar('VB.2725566.2:', 1);
  },
  rule: function rule(gaManager) {
    return !gaManager.context.$store.getters['config/isBene'];
  }
},

// 複数GAのテスト用
{
  name: 'dev2',
  pageview: true,
  cookieDomain: 'none',
  get id() {
    return decaesar('VB.2725566.2:', 1);
  },
  rule: function rule(gaManager) {
    return !gaManager.context.$store.getters['config/isBene'];
  }
}];

// // シーザーー暗号化
// function caesar(val, key) {
//   let = encodeURIComponent(val);
//   let result = '';
//   for (let i = 0; i < val.length; i++) {
//     result += String.fromCharCode(val.charCodeAt(i) + key);
//   }
//   return result;
// }

// シーザー復号化
function decaesar(val, key) {
  var result = '';
  for (var i = 0; i < val.length; i++) {
    result += String.fromCharCode(val.charCodeAt(i) - key);
  }
  return decodeURIComponent(result);
}

var GaManager = function () {
  _createClass(GaManager, [{
    key: 'isEmpty',


    // getters
    get: function get() {
      return this.uses.length === 0;
    }

    /**
     * constructor
     */

  }]);

  function GaManager(context) {
    _classCallCheck(this, GaManager);

    this.context = context;
    this.loaded = false;
    this.uses = [];
    this.setuped = false;
    this.sendPv();
  }

  _createClass(GaManager, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      if (this.setuped) return;
      DEFINES.forEach(function (DEFINE) {
        var isUse = DEFINE.rule ? DEFINE.rule(_this) : true;
        if (isUse) {
          _this.uses.push(Object.assign({}, DEFINE));
        }
      });
      this.setuped = true;
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      if (this.loaded) return;
      this.loaded = true;
      this.setup();
      this.loadGa();
      this.uses.forEach(function (use) {
        _this2.createGa(use);
      });
    }

    /**
     * GAのトラッキングスクリプトを読み込む
     */

  }, {
    key: 'loadGa',
    value: function loadGa() {
      (function (i, s, o, g, r, a, m) {
        i['GoogleAnalyticsObject'] = r;i[r] = i[r] || function () {
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();a = s.createElement(o), m = s.getElementsByTagName(o)[0];a.async = 1;a.src = g;m.parentNode.insertBefore(a, m);
      })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', GoogleAnalyticsObject);
    }
  }, {
    key: 'createGa',
    value: function createGa(define) {
      var ga = window[GoogleAnalyticsObject];
      var options = {
        name: define.name
      };
      if (define.cookieDomain) {
        options.cookieDomain = define.cookieDomain;
      }
      ga('create', define.id, 'auto', options);
    }
  }, {
    key: 'sendFor',
    value: function sendFor(target, data) {
      return new Promise(function (resolve, reject) {
        var ga = window[GoogleAnalyticsObject];
        if (typeof ga !== 'function') return reject(new Error('GA\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3002\u6050\u3089\u304F\u30ED\u30FC\u30C9\u3055\u308C\u3066\u3044\u307E\u305B\u3093'));

        var sendData = typeof data === 'string' ? data : Object.assign({}, data, {
          hitCallback: resolve,
          hitCallbackFail: reject
        });

        ga(target.name + '.send', sendData);
      });
    }
  }, {
    key: 'sendPv',
    value: function sendPv() {
      var _this3 = this;

      this.load();
      var sendData = 'pageview';
      try {
        this.uses.filter(function (use) {
          return use.pageview;
        }).map(function (use) {
          return _this3.sendFor(use, sendData);
        });
      } catch (err) {
        console.warn(err);
      }
    }

    /**
     * イベント送信
     */

  }, {
    key: 'send',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(category, action, label) {
        var _this4 = this;

        var log, sendData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!Array.isArray(category)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return', this.sends(category));

              case 2:
                this.load();

                if (!this.isEmpty) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt('return');

              case 5:
                log = this.context.$store.getters['config/envIs']('develop');


                if ((typeof category === 'undefined' ? 'undefined' : _typeof(category)) === 'object') {
                  action = category.action;
                  label = category.label;
                  log = category.log === undefined ? log : category.log;
                  category = category.category;
                }

                sendData = {
                  hitType: 'event',
                  // page: '●●●',
                  eventCategory: category,
                  eventAction: action,
                  eventLabel: label,
                  eventValue: null
                  // dimension1: '●●●',
                };
                _context.prev = 8;
                _context.next = 11;
                return Promise.all(this.uses.map(function (use) {
                  return _this4.sendFor(use, sendData);
                }));

              case 11:
                if (log) {
                  this.logSuccess(sendData);
                }
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](8);

                this.logError(sendData);
                throw _context.t0;

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 14]]);
      }));

      function send(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return send;
    }()

    /**
     * イベント複数送信
     */

  }, {
    key: 'sends',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(rows) {
        var _this5 = this;

        var log = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context.$store.getters['config/envIs']('develop');
        var promiseList;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.load();

                if (!(this.isEmpty || rows.length === 0)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                promiseList = rows.map(function (row) {
                  return _this5.send(Object.assign({ log: false }, row));
                });
                _context2.prev = 4;
                _context2.next = 7;
                return Promise.all(promiseList);

              case 7:
                if (log) {
                  this.logSuccess(rows);
                }
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                this.logError(rows);
                throw _context2.t0;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function sends(_x4) {
        return _ref2.apply(this, arguments);
      }

      return sends;
    }()
  }, {
    key: 'logSuccess',
    value: function logSuccess(sendData) {
      console.group('Pushd GA Event.');
      console.log('targets: ' + this.uses.map(function (use) {
        return use.id;
      }).join(', '));
      console.log(sendData);
      console.groupEnd();
    }
  }, {
    key: 'logError',
    value: function logError(sendData, err) {
      console.group('Failed push GA Event.');
      console.log('targets: ' + this.uses.map(function (use) {
        return use.id;
      }).join(', '));
      console.log(sendData);
      if (err) console.warn(err);
      console.groupEnd();
    }
  }]);

  return GaManager;
}();

exports.default = GaManager;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OldModuleManager = __webpack_require__(474);

var _OldModuleManager2 = _interopRequireDefault(_OldModuleManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _OldModuleManager2.default;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DNTile = __webpack_require__(475);

var _DNTile2 = _interopRequireDefault(_DNTile);

var _DnTab = __webpack_require__(476);

var _DnTab2 = _interopRequireDefault(_DnTab);

var _DnPageAnchor = __webpack_require__(477);

var _DnPageAnchor2 = _interopRequireDefault(_DnPageAnchor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OldModuleManager = function OldModuleManager() {
  _classCallCheck(this, OldModuleManager);

  new _DNTile2.default().init();
  new _DnTab2.default().init();
  new _DnPageAnchor2.default().init();
};

exports.default = OldModuleManager;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _matchMedia = __webpack_require__(173);

var _matchMedia2 = _interopRequireDefault(_matchMedia);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tile = function () {
  function Tile() {
    _classCallCheck(this, Tile);
  }

  _createClass(Tile, [{
    key: 'trim',
    value: function trim(data) {
      var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
      return data.replace(rtrim, '');
    }
  }, {
    key: 'render',
    value: function render(element) {
      this.$element = element;
      var selector = this.trim(this.$element.data('tile')).split('|'),
          i = 0,
          sl = selector.length;

      for (; i < sl; i++) {
        var $children = this.$element.find(selector[i]),
            maxheight = 0,
            heights = [],
            j = 0,
            cl = $children.length;

        if (dn.$store.getters['mq/pc']) {
          for (; j < cl; j++) {
            (function ($element) {
              var addHeight = 0;
              $($element).find('.mdAddHeight').each(function () {
                addHeight += $(this).get(0).offsetHeight;
              });
              heights.push($element.height() + addHeight);
            })($children.eq(j));
          }$children.css('height', Math.max.apply({}, heights));
        } else {
          $children.css('height', 'auto');
        }
      }
    }
  }]);

  return Tile;
}();

var DNTile = function () {
  function DNTile() {
    _classCallCheck(this, DNTile);

    this.renderer = new Tile();
    this.$targets = null;
  }

  _createClass(DNTile, [{
    key: 'init',
    value: function init() {
      var _this = this;

      this.$targets = $('[data-tile]').filter(function (index) {
        return !$(this).parents('pre').length;
      });

      if (!this.$targets.get(0)) return;

      _matchMedia2.default.hasAndOn('change-pc.dn-tile', function () {
        _this.update();
      });
    }
  }, {
    key: 'update',
    value: function update() {
      var my = this;

      my.$targets.each(function () {
        my.renderer.render($(this));
      });
    }
  }]);

  return DNTile;
}();

exports.default = DNTile;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DnTab = function () {
  function DnTab() {
    _classCallCheck(this, DnTab);
  }

  _createClass(DnTab, [{
    key: 'init',
    value: function init() {

      var $tabs = $('.mdToggleTab');
      if (!$tabs.get(0)) return;

      // 初期表示
      $tabs.each(function () {
        var $el = $(this),
            init = $el.data('init');

        $('.mdToggleBody[data-index="' + init + '"]').css('display', 'table-row-group');
        $('.mdToggleTab a[data-target="' + init + '"]').parent().addClass('current');
      });

      // タブクリック
      $(document).on('click', '.mdToggleTab li a', function (e) {
        var $el = $(this);

        var $parent = $el.parent().parent(),
            now = $parent.attr('data-init'),
            $now = $('.mdToggleBody[data-index="' + now + '"]'),
            target = $el.data('target'),
            $target = $('.mdToggleBody[data-index="' + target + '"]');

        $now.hide();
        $target.css('display', 'table-row-group');
        $parent.attr('data-init', target);
        $parent.find('.current').removeClass('current');
        $el.parent().addClass('current');

        return false;
      });
    }
  }]);

  return DnTab;
}();

exports.default = DnTab;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DnPageAnchor = function () {
  function DnPageAnchor() {
    _classCallCheck(this, DnPageAnchor);
  }

  _createClass(DnPageAnchor, [{
    key: 'init',
    value: function init() {
      var path = location.href.split('?')[0];
      var $targets = $('.mdDnPageAnchor, .dn-link-page-top');
      $targets.each(function () {
        var $target = $(this),
            withQuery = $target.data('page-anchor-query');

        $target.find('a').attr('href', withQuery ? location.href : path);
      });
    }
  }]);

  return DnPageAnchor;
}();

exports.default = DnPageAnchor;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dnAnalyticsTagLoader;
function dnAnalyticsTagLoader(dn) {

  // 開発環境（ローカル）ではロードしない
  if (dn.$store.getters['config/envIs']('develop')) return;

  // DN2016から入っているGTMタグ（GTM-KTG5RS）
  // BC社で設置されているようで、利用意図は不明との事
  // <!-- Google Tag Manager -->
  // <noscript><iframe src="//www.googletagmanager.com/ns.html?id=GTM-KTG5RS" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript><script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-KTG5RS');</script>
  // <!-- End Google Tag Manager -->
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-KTG5RS');

  // DN2018の申し送り時から挿入するGTMタグ（GTM-PRBP28N）
  // 上記BC用のタグと並行して利用するとの事
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-PRBP28N');

  /**
   * DN2019新規追加 GTM (GTM-P63NX4T)
   * @todo
   *   上記の2つは2019/3の年度更新時に削除する事（こっちだけになる）
   */

  // ※オリジナルコード
  // <!-- Google Tag Manager -->
  // <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
  // new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
  // j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
  // 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  // })(window,document,'script','dataLayer','GTM-P63NX4T');</script>
  // <!-- End Google Tag Manager -->
  //
  // <!-- Google Tag Manager (noscript) -->
  // <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P63NX4T"
  // height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
  // <!-- End Google Tag Manager (noscript) -->
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-P63NX4T');
}

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(480);

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _root = __webpack_require__(485);

var _root2 = _interopRequireDefault(_root);

var _plugin = __webpack_require__(497);

var _plugin2 = _interopRequireDefault(_plugin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Vue.config.productionTip = false;
_vue2.default.use(_plugin2.default);

window.bcBanner = new _vue2.default(_root2.default);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(481);

__webpack_require__(482);

var _core = __webpack_require__(180);

var _core2 = _interopRequireDefault(_core);

var _browserCookies = __webpack_require__(80);

var _browserCookies2 = _interopRequireDefault(_browserCookies);

var _axios = __webpack_require__(79);

var _axios2 = _interopRequireDefault(_axios);

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var core = new _core2.default('bc-segments');
var segments = ['Device', 'UserType', 'SchoolChoices', 'Scores'];
var segmentClasses = segments.map(function (name) {
  return {
    name: name.charAt(0).toLowerCase() + name.slice(1),
    className: name,
    constructor: __webpack_require__(483)("./" + name).default
  };
});

var COOKIE_EXPIRES = 365;
var GLOBAL_SUFFIX = 'bcs_';
var CONFIG_FILE_NAME = 'config.json';
var WATCH_INTERVAL = 250;

var BcSegments = function () {
  _createClass(BcSegments, [{
    key: 'key',
    get: function get() {
      if (!this._key) {
        throw new Error('セグメントキーが設定されていないため処理を続行できません。');
      }
      return this.globalSuffix + this._key;
    }
  }, {
    key: 'year',
    get: function get() {
      if (!this._year) {
        throw new Error('入試年度が指定されていないため処理を続行できません。');
      }
      return this._year;
    }

    /**
     * constructor
     */

  }]);

  function BcSegments() {
    var _this = this;

    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, BcSegments);

    new _ddEventManager2.default(this);

    this.domain = core.COOKIE_DOMAIN;
    this.expires = COOKIE_EXPIRES;
    this.state = 'pending';
    this.globalSuffix = GLOBAL_SUFFIX;
    this.isProduction = core.IS_PRODUCTION;
    this.isDevelop = core.IS_DEVELOP;
    this.watchInterval = WATCH_INTERVAL;
    this._year = opt.year;
    this._key = null;
    this._test = null;
    this.cookies = _browserCookies2.default;
    this.enabled = navigator.cookieEnabled;

    // Set Cokkie Manager Defaults
    this.cookies.defaults.domain = this.domain;
    this.cookies.defaults.expires = this.expires;
    this.cookies.defaults.path = '/';
    this.cookies.defaults.secure = this.isProduction;
    this.cookies.defaults.httponly = false;

    this.path = {
      dir: core.path.dir,
      script: core.path.script,
      config: core.path.join(core.path.dir, CONFIG_FILE_NAME),
      join: core.path.join
    };

    // Set Segments
    segmentClasses.forEach(function (define) {
      _this[define.name] = new define.constructor(_this);
    });

    this._init();
  }

  /**
   * fire callback when loaded config
   */


  _createClass(BcSegments, [{
    key: 'ready',
    value: function ready(cb) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.hasAndOn('init', function () {
          if (typeof cb === 'function') cb();
          return resolve();
        });
      });
    }

    /**
     * initialize
     */

  }, {
    key: '_init',
    value: function _init() {
      var _this3 = this;

      return new Promise(function (resolve, reject) {
        _this3._setupVisibilityEvent();
        _this3._loadConfig().then(function (config) {
          _this3._setConfig(config);
          _this3.state = 'ready';
          _this3.emit('init');
          return resolve();
        }).catch(reject);
      });
    }

    /**
     * load config
     */

  }, {
    key: '_loadConfig',
    value: function _loadConfig() {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        (0, _axios2.default)({
          method: 'get',
          url: _this4.path.config,
          responseType: 'json'
        }).then(function (res) {
          return resolve(res.data);
        }).catch(reject);
      });
    }

    /**
     * set config
     */

  }, {
    key: '_setConfig',
    value: function _setConfig(config) {
      var _this5 = this;

      this._key = config.key;

      segmentClasses.forEach(function (define) {
        if (config[define.name] !== undefined) {
          _this5[define.name].setConfig(config[define.name]);
        }
      });
    }

    /**
     * set year
     */

  }, {
    key: 'setYear',
    value: function setYear(year) {
      this._year = year;
    }
  }, {
    key: '_setupVisibilityEvent',
    value: function _setupVisibilityEvent() {
      var _this6 = this;

      var hiddenKey = void 0,
          visibilityChangeKey = void 0;

      var handleVisibilityChange = function handleVisibilityChange(e) {
        if (document[hiddenKey]) {
          _this6.emit('hide', _this6);
        } else {
          _this6.emit('show', _this6);
        }
      };

      if (document.hidden !== undefined) {
        hiddenKey = 'hidden';
        visibilityChangeKey = 'visibilitychange';
      } else if (document.mozHidden !== undefined) {
        hiddenKey = 'mozHidden';
        visibilityChangeKey = 'mozvisibilitychange';
      } else if (document.msHidden !== undefined) {
        hiddenKey = 'msHidden';
        visibilityChangeKey = 'msvisibilitychange';
      } else if (document.webkitHidden !== undefined) {
        hiddenKey = 'webkitHidden';
        visibilityChangeKey = 'webkitvisibilitychange';
      }

      if (!hiddenKey || document.addEventListener === undefined) {
        console.warn('ブラウザが `Page Visibility API` に対応していないため、リスナの登録をキャンセルします。');
        return;
      }

      document.addEventListener(visibilityChangeKey, handleVisibilityChange, false);
    }
  }]);

  return BcSegments;
}();

// Set For Global


window.BcSegments = BcSegments;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// Console-polyfill. MIT license.
// https://github.com/paulmillr/console-polyfill
// Make it safe to do console.log() always.
(function(global) {
  'use strict';
  if (!global.console) {
    global.console = {};
  }
  var con = global.console;
  var prop, method;
  var dummy = function() {};
  var properties = ['memory'];
  var methods = ('assert,clear,count,debug,dir,dirxml,error,exception,group,' +
     'groupCollapsed,groupEnd,info,log,markTimeline,profile,profiles,profileEnd,' +
     'show,table,time,timeEnd,timeline,timelineEnd,timeStamp,trace,warn').split(',');
  while (prop = properties.pop()) if (!con[prop]) con[prop] = {};
  while (method = methods.pop()) if (!con[method]) con[method] = dummy;
  // Using `this` for web workers & supports Browserify / Webpack.
})(typeof window === 'undefined' ? this : window);


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  if (window.console) return;

  window.console = {
    log: function log() {},
    info: function info() {},
    warn: function warn() {},
    error: function error() {},
    dir: function dir() {}
  };
})();

if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

if (!Array.prototype.every) {
  Array.prototype.every = function (fun /*, thisp */) {
    "use strict";

    if (this == null) throw new TypeError();

    var t = Object(this);
    var len = t.length >>> 0;
    if (typeof fun != "function") throw new TypeError();

    var thisp = arguments[1];
    for (var i = 0; i < len; i++) {
      if (i in t && !fun.call(thisp, t[i], i, t)) return false;
    }

    return true;
  };
}

if (!Array.prototype.filter) {
  Array.prototype.filter = function (fun /*, thisp */) {
    "use strict";

    if (this == null) throw new TypeError();

    var t = Object(this),
        len = t.length >>> 0;

    if (typeof fun != "function") throw new TypeError();

    var res = [],
        thisp = arguments[1];

    for (var i = 0; i < len; i++) {
      if (i in t) {
        var val = t[i]; // fun が this を変化させた場合に備えて
        if (fun.call(thisp, val, i, t)) res.push(val);
      }
    }

    return res;
  };
}

if (!Array.prototype.find) {
  Array.prototype.find = function (predicate) {
    if (this === null) {
      throw new TypeError('Array.prototype.find called on null or undefined');
    }
    if (typeof predicate !== 'function') {
      throw new TypeError('predicate must be a function');
    }
    var list = Object(this);
    var length = list.length >>> 0;
    var thisArg = arguments[1];
    var value;

    for (var i = 0; i < length; i++) {
      value = list[i];
      if (predicate.call(thisArg, value, i, list)) {
        return value;
      }
    }
    return undefined;
  };
}

// Production steps of ECMA-262, Edition 5, 15.4.4.18
// Reference: http://es5.github.com/#x15.4.4.18
if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (callback, thisArg) {

    var T, k;

    if (this == null) {
      throw new TypeError(" this is null or not defined");
    }

    // 1. Let O be the result of calling ToObject passing the |this| value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0; // Hack to convert O.length to a UInt32

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if ({}.toString.call(callback) != "[object Function]") {
      throw new TypeError(callback + " is not a function");
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (thisArg) {
      T = thisArg;
    }

    // 6. Let k be 0
    k = 0;

    // 7. Repeat, while k < len
    while (k < len) {

      var kValue;

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then

      if (k in O) {

        // i. Let kValue be the result of calling the Get internal method of O with argument Pk.
        kValue = O[k];

        // ii. Call the Call internal method of callback with T as the this value and
        // argument list containing kValue, k, and O.
        callback.call(T, kValue, k, O);
      }
      // d. Increase k by 1.
      k++;
    }
    // 8. return undefined
  };
}

if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
    "use strict";

    if (this == null) {
      throw new TypeError();
    }

    var t = Object(this);
    var len = t.length >>> 0;

    if (len === 0) {
      return -1;
    }

    var n = 0;

    if (arguments.length > 0) {
      n = Number(arguments[1]);

      if (n != n) {
        // shortcut for verifying if it's NaN
        n = 0;
      } else if (n != 0 && n != Infinity && n != -Infinity) {
        n = (n > 0 || -1) * Math.floor(Math.abs(n));
      }
    }

    if (n >= len) {
      return -1;
    }

    var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);

    for (; k < len; k++) {
      if (k in t && t[k] === searchElement) {
        return k;
      }
    }
    return -1;
  };
}

// https://tc39.github.io/ecma262/#sec-array.prototype.includes
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function value(searchElement, fromIndex) {

      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        // NOTE: === provides the correct "SameValueZero" comparison needed here.
        if (o[k] === searchElement) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}

if (!Array.prototype.reduce) {
  Array.prototype.reduce = function reduce(accumulator) {
    if (this === null || this === undefined) throw new TypeError("Object is null or undefined");

    var i = 0,
        l = this.length >> 0,
        curr;

    if (typeof accumulator !== "function") // ES5 : "If IsCallable(callbackfn) is false, throw a TypeError exception."
      throw new TypeError("First argument is not callable");

    if (arguments.length < 2) {
      if (l === 0) throw new TypeError("Array length is 0 and no second argument");
      curr = this[0];
      i = 1; // start accumulating at the second element
    } else curr = arguments[1];

    while (i < l) {
      if (i in this) curr = accumulator.call(undefined, curr, this[i], i, this);
      ++i;
    }

    return curr;
  };
}

if (!Array.prototype.some) {
  Array.prototype.some = function (fun /*, thisp */) {
    "use strict";

    if (this == null) throw new TypeError();

    var t = Object(this),
        len = t.length >>> 0;

    if (typeof fun != "function") throw new TypeError();

    var thisp = arguments[1];

    for (var i = 0; i < len; i++) {
      if (i in t && fun.call(thisp, t[i], i, t)) return true;
    }

    return false;
  };
}

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./AbstractSegment": 57,
	"./AbstractSegment.js": 57,
	"./Device": 81,
	"./Device/": 81,
	"./Device/Device": 98,
	"./Device/Device.js": 98,
	"./Device/index": 81,
	"./Device/index.js": 81,
	"./SchoolChoices": 181,
	"./SchoolChoices.js": 181,
	"./Scores": 182,
	"./Scores.js": 182,
	"./UserType": 183,
	"./UserType.js": 183
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 483;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '106': { max: 200 },
  '113': { max: 100 },
  '133': { max: 50 },
  '143': { max: 50 },
  '221': { max: 100 },
  '222': { max: 100 },
  '223': { max: 100 },
  '224': { max: 100 },
  '901': { max: 100 },
  '902': { max: 100 },
  '903': { max: 100 },
  '301': { max: 100 },
  '311': { max: 100 },
  '911': { max: 200 },
  '912': { max: 200 },
  '913': { max: 200 },
  '914': { max: 200 },
  '411': { max: 100 },
  '412': { max: 100 },
  '421': { max: 100 },
  '422': { max: 100 },
  '431': { max: 100 },
  '432': { max: 100 },
  '451': { max: 100 },
  '452': { max: 100 },
  '453': { max: 100 },
  '454': { max: 100 },
  '512': { max: 50 },
  '522': { max: 50 },
  '532': { max: 50 },
  '542': { max: 50 },
  '513': { max: 100 },
  '523': { max: 100 },
  '533': { max: 100 },
  '543': { max: 100 }
};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _store = __webpack_require__(486);

var _store2 = _interopRequireDefault(_store);

var _domready2 = __webpack_require__(496);

var _domready3 = _interopRequireDefault(_domready2);

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var rootSettings = {
  store: _store2.default,

  data: function data() {
    return {
      state: 'pending',
      expelFixedItems: [],
      hasExpelFixed: false
    };
  },


  computed: {
    isInitialized: function isInitialized() {
      return this.state === 'initialized';
    },
    year: function year() {
      return this.$store.getters['banner/config/year'];
    },
    breakPoint: function breakPoint() {
      return this.$store.getters['banner/config/breakPoint'];
    }
  },

  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              new _ddEventManager2.default(_this);

              _this.segments = new BcSegments();
              _this.$store.dispatch('banner/config/load');
              _this.$store.dispatch('banner/data/load');
              _this.apply(document.documentElement, { autoload: true });

              _this.$on('expelFixedItemVisibledChange', function (child) {
                _this.onExpelFixedItemVisibledChange(child);
              });

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  watch: {
    year: function year() {
      if (this.year) {
        this.init();
      }
    },
    hasExpelFixed: function hasExpelFixed() {
      this.$emit('hasExpelFixedChange', this.hasExpelFixed);
    }
  },

  methods: {
    onExpelFixedItemVisibledChange: function onExpelFixedItemVisibledChange(child) {
      if (child.visible) {
        this.expelFixedItems.push(child._uid);
      } else {
        var targetIndex = this.expelFixedItems.indexOf(child._uid);
        if (targetIndex !== -1) this.expelFixedItems.splice(targetIndex, 1);
      }
      this.hasExpelFixed = this.expelFixedItems.length > 0;
    },
    ready: function ready() {
      var _this2 = this;

      if (this.isInitialized) return Promise.resolve();
      return new Promise(function (resolve) {
        _this2.hasAndOn('init.ready', function () {
          _this2.off('.ready');
          resolve();
        });
      });
    },
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Promise.all([_this3.domready(), _this3.segments.ready(), _this3.$store.dispatch('banner/data/ready'), _this3.$store.dispatch('banner/mq/ready')]);

              case 2:

                _this3.$store.dispatch('banner/segments/init', _this3.segments);

                _this3.state = 'initialized';
                _this3.emit('init');

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    setYear: function setYear(year) {
      this.segments.setYear(year);
      this.$store.commit('banner/config/setYear', year);
    },
    domready: function domready() {
      return new Promise(function (resolve) {
        (0, _domready3.default)(resolve);
      });
    },
    apply: function apply() {
      var _this4 = this;

      var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.documentElement;
      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var $items, $fixedItem, $normalItems, normalPromiseList, contexts, allCreatedPromiseList;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this4.ready();

              case 2:
                $items = context.getAttribute('data-is') === 'bc-banner' ? [context] : Array.prototype.slice.call(document.querySelectorAll('[data-is="bc-banner"]:not([data-mounted="true"])' + (opt.autoload ? ':not([data-autoload="false"])' : '')));

                // 先に「data-fixed」がついてないものをすべて初期化する
                // おっかけバナーの表示判定のため

                $fixedItem = $items.find(function ($item) {
                  return $item.dataset.fixed !== 'false' && $item.dataset.fixed !== undefined;
                });
                $normalItems = $items.filter(function ($item) {
                  return $item.dataset.fixed === undefined || $item.dataset.fixed === 'false';
                });

                if (!$normalItems.length) {
                  _context3.next = 15;
                  break;
                }

                normalPromiseList = $normalItems.map(function ($item) {
                  return _this4.applyElement($item, opt);
                });
                _context3.next = 9;
                return Promise.all(normalPromiseList);

              case 9:
                contexts = _context3.sent;
                allCreatedPromiseList = contexts.map(function (context) {
                  return new Promise(function (resolve, reject) {
                    context.$banner.hasAndOn('created', resolve);
                  });
                });
                _context3.next = 13;
                return Promise.all(allCreatedPromiseList);

              case 13:
                _context3.next = 15;
                return _this4.$nextTickPromise();

              case 15:
                if (!$fixedItem) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 18;
                return _this4.applyElement($fixedItem, opt);

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    applyElement: function applyElement(el) {
      var _this5 = this;

      var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var parent, data, ui, screen, type, forceMq, backgroundColor, size, fixed, expelFixed, zIndex, tag, context;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this5.ready();

              case 2:
                parent = opt.parent || _this5;
                data = el.dataset || {};
                ui = data.ui || 'rotate';
                screen = data.screen || null;
                type = data.type || null;
                forceMq = data.forceMq || null;
                backgroundColor = data.backgroundColor || null;
                size = {};
                fixed = data.fixed === 'false' ? false : data.fixed !== undefined;
                expelFixed = data.expelFixed === 'false' ? false : data.expelFixed !== undefined;
                zIndex = data.zIndex;
                tag = 'bc-banner-' + ui;

                ['pc', 'sp'].forEach(function (key) {
                  size[key] = {
                    width: parseInt(data[key + 'Width'], 10) || null,
                    height: parseInt(data[key + 'Height'], 10) || null
                  };
                });

                context = {
                  el: el,
                  _el: document.createElement('div'),
                  onMq: function onMq(mq) {
                    el.setAttribute('data-mq', mq);
                  },
                  onExist: function onExist(exist) {
                    el.setAttribute('data-exist', exist);
                    opt.onExist && opt.onExist(exist);
                  },
                  destroy: function destroy() {
                    if (context.$vm._isDestroyed) return;
                    context.$vm.$destroy();
                  },
                  onBeforeDestroy: function onBeforeDestroy() {},
                  onDestroyed: function onDestroyed() {
                    el.removeAttribute('data-mq');
                    el.removeAttribute('data-exist');
                    el.removeAttribute('data-mounted');
                    context.el = null;
                    context._el = null;
                    context.$vm = null;
                    delete context.el;
                    delete context._el;
                    delete context.$vm;
                    if (el.firstChild) el.removeChild(el.firstChild);
                    context = null;
                  }
                };

                el.appendChild(context._el);
                context.$vm = new _vue2.default({
                  store: _store2.default,
                  el: context._el,
                  parent: parent,

                  render: function render(h) {
                    return h(tag, {
                      props: {
                        screen: screen,
                        type: type,
                        size: size,
                        forceMq: forceMq,
                        fixed: fixed,
                        expelFixed: expelFixed,
                        zIndex: zIndex,
                        backgroundColor: backgroundColor,

                        onMq: context.onMq,
                        onExist: context.onExist,
                        onBeforeDestroy: context.onBeforeDestroy,
                        onDestroyed: context.onDestroyed
                      }
                    });
                  }
                });
                context.$banner = context.$vm.$children[0];

                el.setAttribute('data-mounted', true);

                return _context4.abrupt('return', context);

              case 21:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  }
};

exports.default = rootSettings;

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(170);

var _vuex2 = _interopRequireDefault(_vuex);

var _config = __webpack_require__(487);

var _config2 = _interopRequireDefault(_config);

var _mq = __webpack_require__(488);

var _mq2 = _interopRequireDefault(_mq);

var _data = __webpack_require__(490);

var _data2 = _interopRequireDefault(_data);

var _segments = __webpack_require__(495);

var _segments2 = _interopRequireDefault(_segments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
  modules: {
    banner: {
      namespaced: true,

      modules: {
        config: _config2.default,
        mq: _mq2.default,
        data: _data2.default,
        segments: _segments2.default
      }
    }
  },

  actions: {
    onLoadConfig: function onLoadConfig(_ref, data) {
      var dispatch = _ref.dispatch;

      dispatch('banner/mq/onLoadConfig');
    }
  },

  strict: false
});

exports.default = store;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _core = __webpack_require__(180);

var _core2 = _interopRequireDefault(_core);

var _axios = __webpack_require__(79);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var core = new _core2.default('bc-banner');
var DEFAULT_BREAK_POINT = 710;
var DEFAULT_LOG_DOMAIN = 'koukoku.benesse.ne.jp';
var IS_DEVELOP_ACCESS = /^(localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})/.test(location.host);
var DEFAULT_TYPE_SETTING = { interval: 5 };

var forceDateMatch = (location.search || '').match(/[\?&]forcedate=(\d{4})-?(\d{1,2})-?(\d{1,2})/);
var forceDate = forceDateMatch && forceDateMatch.length === 4 ? forceDateMatch[1] + '-' + ('00' + forceDateMatch[2]).slice(-2) + '-' + ('00' + forceDateMatch[3]).slice(-2) : null;
if (forceDate) {
  console.info('URL\u30D1\u30E9\u30E1\u30FC\u30BF\u300Cforcedate\u300D\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u306E\u3067\u8868\u793A\u671F\u9593\u691C\u7D22\u5024\u3092\u300C' + forceDate + '\u300D\u3067\u884C\u3044\u307E\u3059');
}

exports.default = {
  namespaced: true,

  state: {
    state: 'pending',
    dir: core.path.dir,
    IS_DEVELOP: core.IS_DEVELOP,
    IS_PRODUCTION: core.IS_PRODUCTION,
    IS_DEVELOP_ACCESS: IS_DEVELOP_ACCESS,
    year: null,
    breakPoint: DEFAULT_BREAK_POINT,
    logDomain: DEFAULT_LOG_DOMAIN,
    executionLogSendLocation: null,
    executionLogSend: null,

    // 過去設定ファイルで特定のURLの場合表示期間を無視できる機能実装を行っていたが機能削除となったため、
    // 本ステートは常にfalseとなる。
    // 念のため将来的に関連機能を実装する事になるかもしれないのでステート定義のみ残しておく。
    // 本ステートをtrueにするとdataモジュールの方で表示期間を無視してバナーをピックアップする
    // @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-287#comment-1191959773
    isIgnorePeriod: false,
    forceDate: forceDate,
    typeSettings: {},
    safeLogUrl: null
  },

  getters: {
    dir: function dir(state) {
      return state.dir;
    },
    year: function year(state) {
      return state.year;
    },
    breakPoint: function breakPoint(state) {
      return state.breakPoint;
    },
    configPath: function configPath(state) {
      return core.path.join(state.dir, 'config.json');
    },
    logUri: function logUri(state) {
      return location.protocol + '//' + core.path.join(state.logDomain, 'beacon', 'beacon.bcn');
    },
    safeLogUrl: function safeLogUrl(state) {
      return state.safeLogUrl;
    },
    joinedPath: function joinedPath(state) {
      return function (paths) {
        var _core$path;

        paths = typeof paths === 'string' ? [paths] : paths;
        return (_core$path = core.path).join.apply(_core$path, [state.dir].concat(_toConsumableArray(paths)));
      };
    },
    executionLogSend: function executionLogSend(state) {
      return state.executionLogSend;
    },
    isIgnorePeriod: function isIgnorePeriod(state) {
      return state.isIgnorePeriod;
    },
    forceDate: function forceDate(state) {
      return state.forceDate;
    },
    typeSetting: function typeSetting(state) {
      return function (typeMaps) {
        if (!typeMaps) return DEFAULT_TYPE_SETTING;

        var matched = void 0;
        var types = typeof typeMaps === 'string' ? (typeMaps + '').replace(/\s/g, '').split(',') : typeMaps;

        for (var keyMap in state.typeSettings) {
          var typeSetting = state.typeSettings[keyMap];

          if (typeSetting.keys.length !== types.length) continue;

          var matchCount = 0;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = types[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var key = _step.value;

              matchCount = matchCount + (typeSetting.keys.includes(key) ? 1 : -1);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          if (matchCount === types.length) {
            matched = typeSetting;
            break;
          }
        }

        return matched || DEFAULT_TYPE_SETTING;
      };
    }
  },

  actions: {
    load: function load(_ref) {
      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          state = _ref.state,
          getters = _ref.getters;

      return new Promise(function (resolve, reject) {
        var url = getters['configPath'];

        var onLoad = function onLoad(data) {
          commit('setConfig', data);
          dispatch('onLoadConfig', data, { root: true });
          return resolve(data);
        };

        var onLoadError = function onLoadError(error) {
          return reject(new Error(error));
        };

        _axios2.default.get(url).then(function (res) {
          var data = res.data;
          if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') return onLoadError('広告表示設定ファイルのフォーマットが正しくありません。');
          return onLoad(data);
        }).catch(onLoadError);
      });
    }
  },

  mutations: {
    setConfig: function setConfig(state, data) {
      ['logDomain', 'year', 'breakPoint'].forEach(function (key) {
        if (data[key] !== undefined) state[key] = data[key];
      });

      state.safeLogUrl = data.safeLogUrl;

      var executionLogSendLocation = data.executionLogSendLocation || null;
      state.executionLogSendLocation = typeof executionLogSendLocation === 'string' ? [executionLogSendLocation] : executionLogSendLocation;

      var executionLogSend = false;
      if (state.executionLogSendLocation) {
        for (var i = 0, l = state.executionLogSendLocation.length; i < l; i++) {
          var locationTarget = state.executionLogSendLocation[i];
          locationTarget = locationTarget.replace(/\*/, '(.*?)');
          if (new RegExp(locationTarget).test(location.href)) {
            executionLogSend = true;
            break;
          }
        }
      }

      state.executionLogSend = executionLogSend;

      if (!executionLogSend) {
        console.info('\u30A2\u30AF\u30BB\u30B9\u5143\u300C' + location.href + '\u300D\u306F\u30D0\u30CA\u30FC\u8A2D\u5B9A\u30D5\u30A1\u30A4\u30EB\u3067\u8A31\u53EF\u3055\u308C\u3066\u3044\u306A\u3044\u306E\u30ED\u30B0\u9001\u4FE1\u3092\u884C\u3044\u307E\u305B\u3093');
      }

      if (IS_DEVELOP_ACCESS) {
        state.logDomain = location.host;
      }

      if (data.typeSettings && _typeof(data.typeSettings) === 'object') {
        for (var types in data.typeSettings) {
          var keys = types.split(',');
          var typeSetting = Object.assign({ keys: keys }, data.typeSettings[types]);
          state.typeSettings[types] = typeSetting;
        }
      }
    },
    setYear: function setYear(state, year) {
      state.year = year;
    }
  }
};

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bcMatchMedia = __webpack_require__(489);

var _bcMatchMedia2 = _interopRequireDefault(_bcMatchMedia);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchMedia = new _bcMatchMedia2.default();
var state = { current: null };
var getters = { current: function current(state) {
    return state.current;
  } };
var mutations = { setCurrent: function setCurrent(state, current) {
    state.current = current;
  } };

_bcMatchMedia2.default.TARGETS.forEach(function (TARGET) {
  var key = TARGET.key;
  getters[key] = function (state) {
    return state.current === key;
  };
});

exports.default = {
  namespaced: true,

  state: state,
  getters: getters,
  mutations: mutations,

  actions: {
    ready: function ready() {
      return matchMedia.ready();
    },
    run: function run(_ref) {
      var dispatch = _ref.dispatch;

      matchMedia.on('change', function (key) {
        dispatch('update');
      });
      dispatch('update');
    },
    update: function update(_ref2) {
      var dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          state = _ref2.state;

      commit('setCurrent', matchMedia.current);
    },
    setBreakPoint: function setBreakPoint(_ref3, breakPoint) {
      var dispatch = _ref3.dispatch,
          commit = _ref3.commit,
          state = _ref3.state;

      matchMedia.setBreakPoint(breakPoint);
      dispatch('run');
    },
    onLoadConfig: function onLoadConfig(_ref4) {
      var dispatch = _ref4.dispatch,
          rootGetters = _ref4.rootGetters;

      dispatch('setBreakPoint', rootGetters['banner/config/breakPoint']);
    }
  }
};

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BcMatchMedia = function () {
  function BcMatchMedia(breakPoint) {
    _classCallCheck(this, BcMatchMedia);

    new _ddEventManager2.default(this);

    this.breakPoint = breakPoint;
    this.conditions = [];
    this.current = null;

    this.setup();
  }

  _createClass(BcMatchMedia, [{
    key: 'destroy',
    value: function destroy() {
      this.conditions.forEach(function (condition) {
        condition.stop();
      });
      this.conditions = [];
    }
  }, {
    key: 'setup',
    value: function setup(breakPoint) {
      var _this = this;

      if (breakPoint) this.breakPoint = breakPoint;

      if (!this.breakPoint) return;

      this.destroy();

      BcMatchMedia.TARGETS.forEach(function (TARGET) {
        var key = TARGET.key,
            attr = TARGET.attr,
            width = attr === 'min-width' ? _this.breakPoint : _this.breakPoint - 1,
            condition = { key: key, condition: '(' + attr + ': ' + width + 'px)' };

        condition.mql = window.matchMedia(condition.condition);
        condition.listener = function () {
          return _this.checkCondition(condition);
        };
        condition.run = function () {
          condition.mql.addListener(condition.listener);condition.listener();
        };
        condition.stop = function () {
          condition.mql.removeListener(condition.listener);
        };

        _this.conditions.push(condition);
      });

      this.conditions.forEach(function (condition) {
        condition.run();
      });
    }
  }, {
    key: 'ready',
    value: function ready() {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.hasAndOn('init', resolve);
      });
    }
  }, {
    key: 'setBreakPoint',
    value: function setBreakPoint(breakPoint) {
      this.setup(breakPoint);
    }
  }, {
    key: 'checkCondition',
    value: function checkCondition(condition) {
      if (condition.mql.matches) this.set(condition);
    }
  }, {
    key: 'getConditionByKey',
    value: function getConditionByKey(key) {
      return this.conditions.find(function (condition) {
        return condition.key === key;
      });
    }
  }, {
    key: 'set',
    value: function set(condition) {
      condition = typeof condition === 'string' ? this.getConditionByKey(condition) : condition;

      var key = condition.key,
          old = this.current;

      this.current = key;

      if (old === null) this.emit('init');

      if (old !== key) this.emit('change', key);
    }
  }]);

  return BcMatchMedia;
}();

BcMatchMedia.TARGETS = [{ key: 'pc', attr: 'min-width' }, { key: 'sp', attr: 'max-width' }];
exports.default = BcMatchMedia;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _axios = __webpack_require__(79);

var _axios2 = _interopRequireDefault(_axios);

var _computeLcm = __webpack_require__(491);

var _computeLcm2 = _interopRequireDefault(_computeLcm);

var _browserCookies = __webpack_require__(80);

var _browserCookies2 = _interopRequireDefault(_browserCookies);

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

var _ImageManager = __webpack_require__(186);

var _ImageManager2 = _interopRequireDefault(_ImageManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var $ev = {};
var imageManager = new _ImageManager2.default();

new _ddEventManager2.default($ev);

var SEARCH_MAPPINGS = [{ condition: 'screen', target: 'typeId' }, { condition: 'type', target: 'classId' }];

exports.default = {
  namespaced: true,

  state: {
    siteId: null,
    items: []
  },

  getters: {
    dataPath: function dataPath(state, getters, rootState, rootGetters) {
      return rootGetters['banner/config/joinedPath']('data');
    },
    jsonPath: function jsonPath(state, getters, rootState, rootGetters) {
      return rootGetters['banner/config/joinedPath'](['data', 'banner.json']);
    },
    search: function search(state, getters, rootState, rootGetters) {
      return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var items, myConditions, forceDate, nowDate, year, month, day, now, mqJudgments, userCategory, myUnivIds, myPer, counts, types, lcm, _loop2, i, toDataUriPromiseList, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _loop3, _iterator3, _step3;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  items = state.items;
                  myConditions = {};

                  SEARCH_MAPPINGS.forEach(function (MAPPING) {
                    if (condition[MAPPING.condition] !== undefined && condition[MAPPING.condition] !== null) {
                      var values = condition[MAPPING.condition];
                      if (typeof values === 'string') {
                        values = values.replace(/\s/g, '').split(',');
                      }
                      myConditions[MAPPING.condition] = values;
                    } else {
                      myConditions[MAPPING.condition] = null;
                    }
                  });

                  // 表示期間でふるい落す

                  if (rootGetters['banner/config/isIgnorePeriod']) {
                    _context.next = 13;
                    break;
                  }

                  forceDate = rootGetters['banner/config/forceDate'];
                  nowDate = forceDate ? new Date(forceDate) : new Date();
                  year = nowDate.getFullYear();
                  month = nowDate.getMonth();
                  day = nowDate.getDate();
                  now = new Date(year, month, day).getTime();

                  items = items.filter(function (item) {
                    return now >= item._dispPeriodFrom && now <= item._dispPeriodTo;
                  });

                  if (items.length) {
                    _context.next = 13;
                    break;
                  }

                  return _context.abrupt('return', items);

                case 13:

                  // PC、SPのどちらかの画像、及びURLが未指定であればふるいおとす
                  // ただしバナータグにメディアクエリ値の指定があれば、それだけをチェックする
                  // @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-136
                  mqJudgments = condition.mq ? [condition.mq] : ['pc', 'sp'];

                  items = items.filter(function (item) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                      for (var _iterator = mqJudgments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var mq = _step.value;

                        if (!item['originFileName_' + mq] || !item['url_' + mq]) {
                          return false;
                          break;
                        }
                      }
                    } catch (err) {
                      _didIteratorError = true;
                      _iteratorError = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                          _iterator.return();
                        }
                      } finally {
                        if (_didIteratorError) {
                          throw _iteratorError;
                        }
                      }
                    }

                    return true;
                  });

                  // 絞り込み
                  SEARCH_MAPPINGS.forEach(function (MAPPING) {
                    if (myConditions[MAPPING.condition] !== null) {
                      items = items.filter(function (item) {
                        return myConditions[MAPPING.condition].indexOf(item[MAPPING.target]) !== -1;
                      });
                    }
                  });

                  if (items.length) {
                    _context.next = 18;
                    break;
                  }

                  return _context.abrupt('return', items);

                case 18:

                  // セグメントで絞り込み
                  // (1)生徒 or 先生
                  userCategory = condition.segments.userCategory;

                  items = items.filter(function (item) {
                    if (item.segment1 === null) return true;
                    if (!userCategory) return false;
                    return userCategory === 'teacher' && item.segment1 === '1' || userCategory === 'student' && item.segment1 === '2';
                  });

                  if (items.length) {
                    _context.next = 22;
                    break;
                  }

                  return _context.abrupt('return', items);

                case 22:

                  // (2)志望校
                  myUnivIds = condition.segments.schools;

                  items = items.filter(function (item) {
                    if (item.segment2 === null) return true;
                    var univIds = item.segment2.split('|');

                    for (var i = 0, l = univIds.length; i < l; i++) {
                      var univId = univIds[i];
                      if (myUnivIds.indexOf(univId) !== -1) {
                        return true;
                        break;
                      }
                    }
                    return false;
                  });

                  if (items.length) {
                    _context.next = 26;
                    break;
                  }

                  return _context.abrupt('return', items);

                case 26:

                  // (3)学力（得点率帯）
                  // @TODO: ここの実装は4期でやる。なので今はセグメント3が設定してあるものは強制的に除外する
                  myPer = condition.segments.scorePer;

                  items = items.filter(function (item) {
                    if (item.segment3 === null) return true;

                    var pers = item.segment3.split('|').map(function (val) {
                      return parseInt(val, 10);
                    });

                    var _iteratorNormalCompletion2 = true;
                    var _didIteratorError2 = false;
                    var _iteratorError2 = undefined;

                    try {
                      for (var _iterator2 = pers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var per = _step2.value;

                        var from = per,
                            to = per === '90' ? 100 : per + 9;

                        if (from <= myPer && myPer <= to) return true;
                      }
                    } catch (err) {
                      _didIteratorError2 = true;
                      _iteratorError2 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                          _iterator2.return();
                        }
                      } finally {
                        if (_didIteratorError2) {
                          throw _iteratorError2;
                        }
                      }
                    }

                    return false;
                  });

                  if (items.length) {
                    _context.next = 30;
                    break;
                  }

                  return _context.abrupt('return', items);

                case 30:

                  // ↓↓↓ 以下は必ず1件以上データがある ↓↓↓
                  // ※以下はデータに対して破壊的変更が発生するのでクローンしておく
                  items = JSON.parse(JSON.stringify(items));

                  // @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-286#comment-1189911463
                  // ※表示順未設定のバナーにランダムで表示順を設定する
                  //   この際「dispOrder」は表示順ではなく管理システムでのID的な項目になるので、
                  //   データ読み込みの時に初期化済みの「order」値で決定する
                  items.forEach(function (item) {
                    if (item.order === null) {
                      var ok = false;

                      var _loop = function _loop() {
                        var myDispOrder = Math.floor(Math.random() * items.length) + 1;
                        if (!items.find(function (target) {
                          return target.order === myDispOrder;
                        })) {
                          item.order = myDispOrder;
                          ok = true;
                        }
                      };

                      while (!ok) {
                        _loop();
                      }
                    }
                  });

                  // 表示順でソートしておく
                  items.sort(function (a, b) {
                    if (a.order > b.order) return 1;
                    if (a.order < b.order) return -1;
                    return 0;
                  });

                  // 複数種別の指定がある場合、最小公倍数になるまで複製して指定の種別の順番ごとに交互に並べる
                  if (myConditions.type !== null && myConditions.type.length > 1) {
                    counts = [];
                    types = myConditions.type.map(function (type) {
                      var children = items.filter(function (item) {
                        return item.classId === type;
                      });
                      var count = children.length;

                      if (count) counts.push(count);

                      return {
                        type: type,
                        children: children,
                        count: count
                      };
                    }).filter(function (type) {
                      return type.count > 0;
                    });


                    if (types.length > 1) {
                      lcm = _computeLcm2.default.apply(undefined, counts);

                      types.forEach(function (type) {
                        var needs = lcm - type.count;
                        for (var i = 0; i < needs; i++) {
                          var clone = Object.assign({}, type.children[i % type.count]);
                          type.children.push(clone);
                        }
                      });

                      items = [];

                      _loop2 = function _loop2(i) {
                        types.forEach(function (type) {
                          items.push(type.children[i]);
                        });
                      };

                      for (i = 0; i < lcm; i++) {
                        _loop2(i);
                      }
                    }
                  }

                  // 必要個数が指定されていて、かつデータが1件以上あって、かつ足りない時は
                  // 足りるまで配列を複製する（表示回数の条件を揃えるために補填ではなく複製）
                  if (condition.needs && items.length < condition.needs) {
                    while (items.length < condition.needs) {
                      items = items.concat(items, items);
                    }
                  }

                  // ※複製されたアイテムが参照を共有している可能性があるのでJSONパースしなおしておく
                  items = JSON.parse(JSON.stringify(items));

                  // 全てのアイテムにインデックスをつける
                  items.forEach(function (item, i) {
                    item.index = i;
                  });

                  toDataUriPromiseList = [];
                  _iteratorNormalCompletion3 = true;
                  _didIteratorError3 = false;
                  _iteratorError3 = undefined;
                  _context.prev = 41;

                  _loop3 = function _loop3() {
                    var item = _step3.value;
                    var _iteratorNormalCompletion4 = true;
                    var _didIteratorError4 = false;
                    var _iteratorError4 = undefined;

                    try {
                      var _loop4 = function _loop4() {
                        var mq = _step4.value;

                        var imgKey = 'fileName_' + mq;
                        if (item[imgKey] === null) {
                          toDataUriPromiseList.push(new Promise(function (resolve, reject) {
                            imageManager.toDataUri(item['originFileName_' + mq]).then(function (dataUri) {
                              item[imgKey] = dataUri;
                              return resolve();
                            }).catch(reject);
                          }));
                        }
                      };

                      for (var _iterator4 = mqJudgments[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                        _loop4();
                      }
                    } catch (err) {
                      _didIteratorError4 = true;
                      _iteratorError4 = err;
                    } finally {
                      try {
                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                          _iterator4.return();
                        }
                      } finally {
                        if (_didIteratorError4) {
                          throw _iteratorError4;
                        }
                      }
                    }
                  };

                  for (_iterator3 = items[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    _loop3();
                  }
                  _context.next = 50;
                  break;

                case 46:
                  _context.prev = 46;
                  _context.t0 = _context['catch'](41);
                  _didIteratorError3 = true;
                  _iteratorError3 = _context.t0;

                case 50:
                  _context.prev = 50;
                  _context.prev = 51;

                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }

                case 53:
                  _context.prev = 53;

                  if (!_didIteratorError3) {
                    _context.next = 56;
                    break;
                  }

                  throw _iteratorError3;

                case 56:
                  return _context.finish(53);

                case 57:
                  return _context.finish(50);

                case 58:
                  if (!toDataUriPromiseList.length) {
                    _context.next = 61;
                    break;
                  }

                  _context.next = 61;
                  return Promise.all(toDataUriPromiseList);

                case 61:
                  return _context.abrupt('return', items);

                case 62:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, undefined, [[41, 46, 50, 58], [51,, 53, 57]]);
        }));

        return function () {
          return _ref.apply(this, arguments);
        };
      }();
    }
  },

  actions: {
    ready: function ready() {
      return new Promise(function (resolve) {
        $ev.hasAndOn('init', resolve);
      });
    },
    load: function load(_ref2) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch,
          getters = _ref2.getters,
          rootGetters = _ref2.rootGetters,
          rootState = _ref2.rootState,
          state = _ref2.state;

      return new Promise(function (resolve, reject) {
        var url = getters['jsonPath'];

        var onLoad = function onLoad(data) {
          var items = data.adlist || [];

          commit('setSiteId', data.siteId);

          // json値補正
          items.forEach(function (item) {

            // // 画像パスに設定がなければnullを挿入＆指定があれば絶対パスに変換
            // ['fileName_pc', 'fileName_sp'].forEach(key => {
            //   if (typeof item[key] !== 'string') {
            //     item[key] = null;
            //   } else if (!item[key].match(/^(http|\.|\/)/)) {
            //       item[key] = getters['dataPath'] + '/' + item[key];
            //   }
            // });

            // PC、SPのパラメータたちの準備
            ['pc', 'sp'].forEach(function (key) {

              // 画像URL周りの準備
              var imgKey = 'fileName_' + key;
              var originFileName = item[imgKey];
              if (typeof originFileName !== 'string') {
                originFileName = null;
              } else if (!originFileName.match(/^(http|\.|\/)/)) {
                originFileName = getters['dataPath'] + '/' + originFileName;
              }

              // 後でdata uriに変換するのでオリジンのキーをnullにしておく
              item['originFileName_' + key] = originFileName;
              item[imgKey] = null;

              // URLに指定がなければnullを挿入
              var urlKey = 'url_' + key;
              if (typeof item[urlKey] !== 'string') {
                item[urlKey] = null;
              }
            });

            // // URLに指定がなければnullを挿入
            // ['url_pc', 'url_sp'].forEach(key => {
            //   if (typeof item[key] !== 'string') {
            //     item[key] = null;
            //   }
            // });

            // blankWindow値にデフォルトを設定
            if (!item.blankWindow) {
              item.blankWindow = '_self';
            }

            // segment条件未設定であればnullを設定
            for (var i = 1; i < 11; i++) {
              var key = 'segment' + i;
              if (item[key] === undefined) item[key] = null;
            }

            // 表示期間値をユニックスタイムで保持
            ['From', 'To'].forEach(function (key) {
              var str = item['dispPeriod' + key];
              var year = parseInt(str.substr(0, 4), 10);
              var month = parseInt(str.substr(4, 2), 10) - 1;
              var day = parseInt(str.substr(6, 2), 10);
              item['_dispPeriod' + key] = new Date(year, month, day).getTime();
            });

            // 表示順設定が未設定であればnullを設定
            item.dispOrder = item.dispOrder === undefined ? null : item.dispOrder;

            // ※上記「dispOrder」は実際には表示順ではなく管理システムのID的に利用される項目で、
            //   画面表示の際は表示枠ごとに常にランダムに表示順を決定する
            //   @see: https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-286#comment-1189911463
            //   なので実際の表示順用に「order」値を初期化しておく
            item.order = null;
          });

          commit('setItems', items);
          return resolve(data);
        };

        var onLoadError = function onLoadError(error) {
          return reject(new Error(error));
        };

        _axios2.default.get(url).then(function (res) {
          var data = res.data;
          if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object') return onLoadError('広告設定ファイルのフォーマットが正しくありません。');
          return onLoad(data);
        }).catch(onLoadError);
      });
    },
    sendLog: function sendLog(_ref3, _ref4) {
      var _this = this;

      var commit = _ref3.commit,
          dispatch = _ref3.dispatch,
          getters = _ref3.getters,
          rootGetters = _ref3.rootGetters,
          rootState = _ref3.rootState,
          state = _ref3.state;
      var type = _ref4.type,
          item = _ref4.item;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, uibc, safeLogUrl;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (rootGetters['banner/config/executionLogSend']) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt('return');

              case 2:
                params = {
                  siteId: state.siteId,
                  id: item.id,
                  logType: type,
                  timestamp: Math.floor(new Date().getTime() / 1000)
                };


                ['typeId', 'classId'].forEach(function (key) {
                  if (item[key]) params[key] = item[key];
                });

                uibc = _browserCookies2.default.get('be_ad_net_userid');

                if (uibc) params.uibc = uibc;

                safeLogUrl = rootGetters['banner/config/safeLogUrl'];
                _context2.prev = 7;
                _context2.next = 10;
                return _axios2.default.get(rootGetters['banner/config/logUri'], { params: params });

              case 10:
                _context2.next = 16;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](7);

                console.warn(_context2.t0);

                if (safeLogUrl) {
                  _axios2.default.get(safeLogUrl, { params: params });
                }

              case 16:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this, [[7, 12]]);
      }))();
    }
  },

  mutations: {
    setSiteId: function setSiteId(state, siteId) {
      state.siteId = siteId;
    },
    setItems: function setItems(state) {
      var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      state.items = items;
      $ev.emit('init');
    }
  }
};

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// MODULES //

var gcd = __webpack_require__( 492 ),
	isArray = __webpack_require__( 99 ),
	isIntegerArray = __webpack_require__( 184 ),
	isFunction = __webpack_require__( 185 );


// LEAST COMMON MULTIPLE //

/**
* FUNCTION: lcm( arr[, clbk] )
*	Computes the least common multiple (lcm).
*
* @param {Number[]|Number} arr - input array of integers
* @param {Function|Number} [accessor] - accessor function for accessing array values
* @returns {Number|Null} least common multiple or null
*/
function lcm() {
	var nargs = arguments.length,
		args,
		clbk,
		arr,
		len,
		a, b,
		i;

	// Copy the input arguments to an array...
	args = new Array( nargs );
	for ( i = 0; i < nargs; i++ ) {
		args[ i ] = arguments[ i ];
	}
	// Have we been provided with integer arguments?
	if ( isIntegerArray( args ) ) {
		if ( nargs === 2 ) {
			a = args[ 0 ];
			b = args[ 1 ];
			if ( a < 0 ) {
				a = -a;
			}
			if ( b < 0 ) {
				b = -b;
			}
			if ( a === 0 || b === 0 ) {
				return 0;
			}
			return ( a/gcd(a,b) ) * b;
		}
		arr = args;
	}
	// If not integers, ensure that the first argument is an array...
	else if ( !isArray( args[ 0 ] ) ) {
		throw new TypeError( 'lcm()::invalid input argument. Must provide an array of integers. Value: `' + args[ 0 ] + '`.' );
	}
	// Have we been provided with more than one argument? If so, ensure that the accessor argument is a function...
	else if ( nargs > 1 ) {
		arr = args[ 0 ];
		clbk = args[ 1 ];
		if ( !isFunction( clbk ) ) {
			throw new TypeError( 'lcm()::invalid input argument. Accessor must be a function. Value: `' + clbk + '`.' );
		}
	}
	// We have been provided an array...
	else {
		arr = args[ 0 ];
	}
	len = arr.length;

	// Check if a sufficient number of values have been provided...
	if ( len < 2 ) {
		return null;
	}
	// If an accessor is provided, extract the array values...
	if ( clbk ) {
		a = new Array( len );
		for ( i = 0; i < len; i++ ) {
			a[ i ] = clbk( arr[ i ], i );
		}
		arr = a;
	}
	// Given an input array, ensure all array values are integers...
	if ( nargs < 3 ) {
		if ( !isIntegerArray( arr ) ) {
			throw new TypeError( 'lcm()::invalid input argument. Accessed array values must be integers. Value: `' + arr + '`.' );
		}
	}
	// Convert any negative integers to positive integers...
	for ( i = 0; i < len; i++ ) {
		a = arr[ i ];
		if ( a < 0 ) {
			arr[ i ] = -a;
		}
	}
	// Exploit the fact that the lcm is an associative function...
	a = arr[ 0 ];
	for ( i = 1; i < len; i++ ) {
		b = arr[ i ];
		if ( a === 0 || b === 0 ) {
			return 0;
		}
		a = ( a/gcd(a,b) ) * b;
	}
	return a;
} // end FUNCTION lcm()


// EXPORTS //

module.exports = lcm;


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// MODULES //

var isArray = __webpack_require__( 99 ),
	isIntegerArray = __webpack_require__( 184 ),
	isFunction = __webpack_require__( 185 );


// VARIABLES //

var MAXINT = Math.pow( 2, 53 ) - 1;


// FUNCTIONS //

/**
* FUNCTION: gcd( a, b )
*	Computes the greatest common divisor of two integers `a` and `b`, using the binary GCD algorithm.
*
* @param {Number} a - integer
* @param {Number} b - integer
* @returns {Number} greatest common divisor
*/
function gcd( a, b ) {
	var k = 1,
		t;
	// Simple cases:
	if ( a === 0 ) {
		return b;
	}
	if ( b === 0 ) {
		return a;
	}
	// Reduce `a` and/or `b` to odd numbers and keep track of the greatest power of 2 dividing both `a` and `b`...
	while ( a%2 === 0 && b%2 === 0 ) {
		a = a / 2; // right shift
		b = b / 2; // right shift
		k = k * 2; // left shift
	}
	// Reduce `a` to an odd number...
	while ( a%2 === 0 ) {
		a = a / 2; // right shift
	}
	// Henceforth, `a` is always odd...
	while ( b ) {
		// Remove all factors of 2 in `b`, as they are not common...
		while ( b%2 === 0 ) {
			b = b / 2; // right shift
		}
		// `a` and `b` are both odd. Swap values such that `b` is the larger of the two values, and then set `b` to the difference (which is even)...
		if ( a > b ) {
			t = b;
			b = a;
			a = t;
		}
		b = b - a; // b=0 iff b=a
	}
	// Restore common factors of 2...
	return k * a;
} // end FUNCTION gcd()

/**
* FUNCTION: bitwise( a, b )
*	Computes the greatest common divisor of two integers `a` and `b`, using the binary GCD algorithm and bitwise operations.
*
* @param {Number} a - safe integer
* @param {Number} b - safe integer
* @returns {Number} greatest common divisor
*/
function bitwise( a, b ) {
	var k = 0,
		t;
	// Simple cases:
	if ( a === 0 ) {
		return b;
	}
	if ( b === 0 ) {
		return a;
	}
	// Reduce `a` and/or `b` to odd numbers and keep track of the greatest power of 2 dividing both `a` and `b`...
	while ( (a & 1) === 0 && (b & 1) === 0 ) {
		a >>>= 1; // right shift
		b >>>= 1; // right shift
		k++;
	}
	// Reduce `a` to an odd number...
	while ( (a & 1) === 0 ) {
		a >>>= 1; // right shift
	}
	// Henceforth, `a` is always odd...
	while ( b ) {
		// Remove all factors of 2 in `b`, as they are not common...
		while ( (b & 1) === 0 ) {
			b >>>= 1; // right shift
		}
		// `a` and `b` are both odd. Swap values such that `b` is the larger of the two values, and then set `b` to the difference (which is even)...
		if ( a > b ) {
			t = b;
			b = a;
			a = t;
		}
		b = b - a; // b=0 iff b=a
	}
	// Restore common factors of 2...
	return a << k;
} // end FUNCTION bitwise()


// GREATEST COMMON DIVISOR //

/**
* FUNCTION: compute( arr[, clbk] )
*	Computes the greatest common divisor.
*
* @param {Number[]|Number} arr - input array of integers
* @param {Function|Number} [clbk] - accessor function for accessing array values
* @returns {Number|Null} greatest common divisor or null
*/
function compute() {
	var nargs = arguments.length,
		args,
		clbk,
		arr,
		len,
		a, b,
		i;

	// Copy the input arguments to an array...
	args = new Array( nargs );
	for ( i = 0; i < nargs; i++ ) {
		args[ i ] = arguments[ i ];
	}
	// Have we been provided with integer arguments?
	if ( isIntegerArray( args ) ) {
		if ( nargs === 2 ) {
			a = args[ 0 ];
			b = args[ 1 ];
			if ( a < 0 ) {
				a = -a;
			}
			if ( b < 0 ) {
				b = -b;
			}
			if ( a <= MAXINT && b <= MAXINT ) {
				return bitwise( a, b );
			} else {
				return gcd( a, b );
			}
		}
		arr = args;
	}
	// If not integers, ensure the first argument is an array...
	else if ( !isArray( args[ 0 ] ) ) {
		throw new TypeError( 'gcd()::invalid input argument. Must provide an array of integers. Value: `' + args[ 0 ] + '`.' );
	}
	// Have we been provided with more than one argument? If so, ensure that the accessor argument is a function...
	else if ( nargs > 1 ) {
		arr = args[ 0 ];
		clbk = args[ 1 ];
		if ( !isFunction( clbk ) ) {
			throw new TypeError( 'gcd()::invalid input argument. Accessor must be a function. Value: `' + clbk + '`.' );
		}
	}
	// We have been provided an array...
	else {
		arr = args[ 0 ];
	}
	len = arr.length;

	// Check if a sufficient number of values have been provided...
	if ( len < 2 ) {
		return null;
	}
	// If an accessor is provided, extract the array values...
	if ( clbk ) {
		a = new Array( len );
		for ( i = 0; i < len; i++ ) {
			a[ i ] = clbk( arr[ i ], i );
		}
		arr = a;
	}
	// Given an input array, ensure all array values are integers...
	if ( nargs < 3 ) {
		if ( !isIntegerArray( arr ) ) {
			throw new TypeError( 'gcd()::invalid input argument. Accessed array values must be integers. Value: `' + arr + '`.' );
		}
	}
	// Convert any negative integers to positive integers...
	for ( i = 0; i < len; i++ ) {
		a = arr[ i ];
		if ( a < 0 ) {
			arr[ i ] = -a;
		}
	}
	// Exploit the fact that the gcd is an associative function...
	a = arr[ 0 ];
	for ( i = 1; i < len; i++ ) {
		b = arr[ i ];
		if ( b <= MAXINT && a <= MAXINT ) {
			a = bitwise( a, b );
		} else {
			a = gcd( a, b );
		}
	}
	return a;
} // end FUNCTION compute()


// EXPORTS //

module.exports = compute;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
*
*	VALIDATE: integer
*
*
*	DESCRIPTION:
*		- Validates if a value is an integer.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/



// MODULES //

var isNumber = __webpack_require__( 494 );


// ISINTEGER //

/**
* FUNCTION: isInteger( value )
*	Validates if a value is an integer.
*
* @param {Number} value - value to be validated
* @returns {Boolean} boolean indicating whether value is an integer
*/
function isInteger( value ) {
	return isNumber( value ) && value%1 === 0;
} // end FUNCTION isInteger()


// EXPORTS //

module.exports = isInteger;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
*
*	VALIDATE: number
*
*
*	DESCRIPTION:
*		- Validates if a value is a number.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/



/**
* FUNCTION: isNumber( value )
*	Validates if a value is a number.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is a number
*/
function isNumber( value ) {
	return ( typeof value === 'number' || Object.prototype.toString.call( value ) === '[object Number]' ) && value.valueOf() === value.valueOf();
} // end FUNCTION isNumber()


// EXPORTS //

module.exports = isNumber;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var segments = null;

exports.default = {
  namespaced: true,

  state: {
    userCategory: null,
    schoolChoices: [],
    schools: [],
    scorePer: null
  },

  getters: {
    userCategory: function userCategory(state) {
      return state.userCategory;
    },
    schoolChoices: function schoolChoices(state) {
      return state.schoolChoices;
    },
    schools: function schools(state) {
      return state.schools;
    },
    scorePer: function scorePer(state) {
      return state.scorePer;
    }
  },

  actions: {
    init: function init(_ref, node) {
      var _this = this;

      var dispatch = _ref.dispatch,
          commit = _ref.commit,
          state = _ref.state,
          getters = _ref.getters;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                segments = node;
                _context.next = 3;
                return segments.ready();

              case 3:

                commit('setUserCategory', segments.userType.getCategory());
                segments.userType.listen(function (userType) {
                  commit('setUserCategory', segments.userType.getCategory());
                }, 'bc-banner');

                commit('setSchoolChoices', segments.schoolChoices.find());
                segments.schoolChoices.listen(function (schoolChoices) {
                  commit('setSchoolChoices', segments.schoolChoices.find());
                }, 'bc-banner');

                commit('setScorePer', segments.scores.getTotalPer());
                segments.scores.listen(function (scores) {
                  commit('setScorePer', segments.scores.getTotalPer());
                }, 'bc-banner');

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },

  mutations: {
    setUserCategory: function setUserCategory(state, category) {
      state.userCategory = category;
    },
    setSchoolChoices: function setSchoolChoices(state, schoolChoices) {
      if (JSON.stringify(schoolChoices) === JSON.stringify(state.schoolChoices)) return;
      state.schoolChoices = schoolChoices;
      var schools = schoolChoices.map(function (offerId) {
        return offerId.slice(0, 4);
      }).sort(function (a, b) {
        return a > b;
      });
      if (state.schools.length !== schools.length) {
        state.schools = schools;
      } else {
        for (var i = 0, l = schools.length; i < l; i++) {
          if (state.schools.indexOf(schools[i]) === -1) {
            state.schools = schools;
            break;
          }
        }
      }
    },
    setScorePer: function setScorePer(state, scorePer) {
      state.scorePer = scorePer;
    }
  }
};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

/*!
  * domready (c) Dustin Diaz 2014 - License MIT
  */
!function (name, definition) {

  if (true) module.exports = definition()
  else if (typeof define == 'function' && typeof define.amd == 'object') define(definition)
  else this[name] = definition()

}('domready', function () {

  var fns = [], listener
    , doc = document
    , hack = doc.documentElement.doScroll
    , domContentLoaded = 'DOMContentLoaded'
    , loaded = (hack ? /^loaded|^c/ : /^loaded|^i|^c/).test(doc.readyState)


  if (!loaded)
  doc.addEventListener(domContentLoaded, listener = function () {
    doc.removeEventListener(domContentLoaded, listener)
    loaded = 1
    while (listener = fns.shift()) listener()
  })

  return function (fn) {
    loaded ? setTimeout(fn, 0) : fns.push(fn)
  }

});


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _components = __webpack_require__(498);

var _components2 = _interopRequireDefault(_components);

var _directives = __webpack_require__(509);

var _directives2 = _interopRequireDefault(_directives);

var _vueTouch = __webpack_require__(510);

var _vueTouch2 = _interopRequireDefault(_vueTouch);

var _WindowManager = __webpack_require__(512);

var _WindowManager2 = _interopRequireDefault(_WindowManager);

var _ImageManager = __webpack_require__(186);

var _ImageManager2 = _interopRequireDefault(_ImageManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var windowManager = new _WindowManager2.default();
var imageManager = new _ImageManager2.default();

function plugin(Vue) {
  Vue.use(_vueTouch2.default);
  // // Directives
  // Object.keys(directives).forEach(key => {
  //   const directive = directives[key];
  //   Vue.directive(directive.name, directive);
  // });

  // Components
  Object.keys(_components2.default).forEach(function (key) {
    var component = _components2.default[key];
    Vue.component(component.name, component);
  });

  function blurActiveElement() {
    if (document.activeElement && document.activeElement.blur) {
      document.activeElement.blur();
    }
  }

  Vue.prototype.$bcb = {
    blurActiveElement: blurActiveElement
  };

  Vue.prototype.$window = windowManager;
  // Vue.prototype.$image = imageManager;

  Vue.prototype.$nextTickPromise = function () {
    var _this = this;

    return new Promise(function (resolve) {
      _this.$nextTick(resolve);
    });
  };
}

exports.default = plugin;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rotate = __webpack_require__(499);

var _Rotate2 = _interopRequireDefault(_Rotate);

var _Carousel = __webpack_require__(504);

var _Carousel2 = _interopRequireDefault(_Carousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Rotate: _Rotate2.default,
  Carousel: _Carousel2.default
};

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(500)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(503),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d3cd0b2a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(501);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("3860433c", content, true, {});

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".bc-banner-rotate[data-v-d3cd0b2a]{width:100%}.bc-banner-rotate[data-v-d3cd0b2a],.bc-banner-rotate [data-v-d3cd0b2a],.bc-banner-rotate[data-v-d3cd0b2a] :after,.bc-banner-rotate[data-v-d3cd0b2a] :before{box-sizing:border-box}.bc-banner-rotate a[data-v-d3cd0b2a],.bc-banner-rotate div[data-v-d3cd0b2a],.bc-banner-rotate img[data-v-d3cd0b2a],.bc-banner-rotate li[data-v-d3cd0b2a],.bc-banner-rotate ol[data-v-d3cd0b2a],.bc-banner-rotate p[data-v-d3cd0b2a],.bc-banner-rotate ul[data-v-d3cd0b2a]{margin:0;padding:0}.bc-banner-rotate a[data-v-d3cd0b2a],.bc-banner-rotate a[data-v-d3cd0b2a]:active,.bc-banner-rotate a[data-v-d3cd0b2a]:focus,.bc-banner-rotate a[data-v-d3cd0b2a]:hover{text-decoration:none}.bc-banner-rotate li[data-v-d3cd0b2a],.bc-banner-rotate ol[data-v-d3cd0b2a],.bc-banner-rotate ul[data-v-d3cd0b2a]{list-style:none}.bc-banner-rotate>a[data-v-d3cd0b2a]{display:block;width:100%;position:relative}.bc-banner-rotate>a>img[data-v-d3cd0b2a]{width:100%;max-width:none;vertical-align:bottom}.bc-banner-rotate--exist[data-v-d3cd0b2a]{min-height:1px}.my-link[data-v-d3cd0b2a]{-webkit-transition:opacity .35s;transition:opacity .35s}.my-link[data-v-d3cd0b2a]:hover{opacity:.9}.my-current-item[data-v-d3cd0b2a]{opacity:1;position:relative;top:0;left:0;z-index:0}.my-current-item.is-now-transition[data-v-d3cd0b2a]{-webkit-transition:opacity .35s cubic-bezier(.895,.03,.685,.22);transition:opacity .35s cubic-bezier(.895,.03,.685,.22);opacity:0}.my-next-item[data-v-d3cd0b2a]{position:absolute;z-index:1;top:0;left:0}.my-rotate-transition-enter[data-v-d3cd0b2a]{position:absolute;opacity:0}.my-rotate-transition-enter-active[data-v-d3cd0b2a]{-webkit-transition:opacity .35s cubic-bezier(.25,.46,.45,.94);transition:opacity .35s cubic-bezier(.25,.46,.45,.94)}.my-rotate-transition-enter-to[data-v-d3cd0b2a]{opacity:1}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/shared/bc-banner/components/Rotate.vue"],"names":[],"mappings":"AACA,mCAAmC,UAAU,CAC5C,AACD,4JAA6J,qBAAqB,CACjL,AACD,0QAA0Q,SAAS,SAAS,CAC3R,AACD,uKAAuK,oBAAoB,CAC1L,AACD,kHAAkH,eAAe,CAChI,AACD,qCAAqC,cAAc,WAAW,iBAAiB,CAC9E,AACD,yCAAyC,WAAW,eAAe,qBAAqB,CACvF,AACD,0CAA0C,cAAc,CACvD,AACD,0BAA0B,gCAAgC,uBAAuB,CAChF,AACD,gCAAgC,UAAU,CACzC,AACD,kCAAkC,UAAU,kBAAkB,MAAM,OAAO,SAAS,CACnF,AACD,oDAAoD,gEAAgE,wDAAwD,SAAS,CACpL,AACD,+BAA+B,kBAAkB,UAAU,MAAM,MAAM,CACtE,AACD,6CAA6C,kBAAkB,SAAS,CACvE,AACD,oDAAoD,8DAA8D,qDAAqD,CACtK,AACD,gDAAgD,SAAS,CACxD","file":"Rotate.vue","sourcesContent":["\n.bc-banner-rotate[data-v-d3cd0b2a]{width:100%\n}\n.bc-banner-rotate[data-v-d3cd0b2a],.bc-banner-rotate *[data-v-d3cd0b2a],.bc-banner-rotate[data-v-d3cd0b2a] :after,.bc-banner-rotate[data-v-d3cd0b2a] :before{box-sizing:border-box\n}\n.bc-banner-rotate a[data-v-d3cd0b2a],.bc-banner-rotate div[data-v-d3cd0b2a],.bc-banner-rotate img[data-v-d3cd0b2a],.bc-banner-rotate li[data-v-d3cd0b2a],.bc-banner-rotate ol[data-v-d3cd0b2a],.bc-banner-rotate p[data-v-d3cd0b2a],.bc-banner-rotate ul[data-v-d3cd0b2a]{margin:0;padding:0\n}\n.bc-banner-rotate a[data-v-d3cd0b2a],.bc-banner-rotate a[data-v-d3cd0b2a]:active,.bc-banner-rotate a[data-v-d3cd0b2a]:focus,.bc-banner-rotate a[data-v-d3cd0b2a]:hover{text-decoration:none\n}\n.bc-banner-rotate li[data-v-d3cd0b2a],.bc-banner-rotate ol[data-v-d3cd0b2a],.bc-banner-rotate ul[data-v-d3cd0b2a]{list-style:none\n}\n.bc-banner-rotate>a[data-v-d3cd0b2a]{display:block;width:100%;position:relative\n}\n.bc-banner-rotate>a>img[data-v-d3cd0b2a]{width:100%;max-width:none;vertical-align:bottom\n}\n.bc-banner-rotate--exist[data-v-d3cd0b2a]{min-height:1px\n}\n.my-link[data-v-d3cd0b2a]{-webkit-transition:opacity .35s;transition:opacity .35s\n}\n.my-link[data-v-d3cd0b2a]:hover{opacity:.9\n}\n.my-current-item[data-v-d3cd0b2a]{opacity:1;position:relative;top:0;left:0;z-index:0\n}\n.my-current-item.is-now-transition[data-v-d3cd0b2a]{-webkit-transition:opacity .35s cubic-bezier(.895,.03,.685,.22);transition:opacity .35s cubic-bezier(.895,.03,.685,.22);opacity:0\n}\n.my-next-item[data-v-d3cd0b2a]{position:absolute;z-index:1;top:0;left:0\n}\n.my-rotate-transition-enter[data-v-d3cd0b2a]{position:absolute;opacity:0\n}\n.my-rotate-transition-enter-active[data-v-d3cd0b2a]{-webkit-transition:opacity .35s cubic-bezier(.25,.46,.45,.94);transition:opacity .35s cubic-bezier(.25,.46,.45,.94)\n}\n.my-rotate-transition-enter-to[data-v-d3cd0b2a]{opacity:1\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _banner = __webpack_require__(187);

var _banner2 = _interopRequireDefault(_banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'bc-banner-rotate',

  mixins: [_banner2.default],

  props: {},

  data: function data() {
    return {
      rotationTimerId: null,
      nextItem: null,
      nowTransition: false
    };
  },


  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, this.$options.name, true), _defineProperty(_ref, this.$options.name + '--exist', this.isExist), _ref;
    },
    currentItemClasses: function currentItemClasses() {
      return {
        'is-now-transition': this.nowTransition
      };
    }
  },

  watch: {
    index: function index() {
      if (this.index !== null) this.preloadNextIndex();
    }
  },

  methods: {
    prev: function prev(e) {
      this.slideIndex(-1);
    },
    next: function next(e) {
      this.slideIndex(1);
    },
    preloadByIndex: function preloadByIndex(index) {
      var nextItem = this.items.find(function (item) {
        return item.index === index;
      });
      if (!nextItem) return;
      var image = new Image();
      image.src = nextItem['fileName_' + this.mq];
    },
    preloadNextIndex: function preloadNextIndex() {
      var nextIndex = this.index + 1;
      if (nextIndex >= this.count) {
        nextIndex = 0;
      }
      return this.preloadByIndex(nextIndex);
    },
    slideIndex: function slideIndex(ammount) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var nextIndex;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                nextIndex = _this.index + ammount;

                if (nextIndex >= _this.count) {
                  nextIndex -= _this.count;
                } else if (nextIndex < 0) {
                  nextIndex += _this.count;
                }

                _this.nextItem = _this.items[nextIndex];
                _this.nowTransition = true;

                _context.next = 6;
                return new Promise(function (resolve, reject) {
                  _this.$once('next-item-after-enter', resolve);
                });

              case 6:

                _this.nextItem = null;
                _this.nowTransition = false;
                _this.index = nextIndex;
                _this.preloadNextIndex();

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    startRotation: function startRotation() {
      var _this2 = this;

      if (!this.isExist || this.count === 1) return;
      if (this.isPause) return;

      this.stopRotation();
      this.rotationTimerId = setInterval(function () {
        _this2.next();
      }, this.rotateInterval);
    },
    stopRotation: function stopRotation() {
      if (this.rotationTimerId !== null) {
        clearInterval(this.rotationTimerId);
        this.rotationTimerId = null;
      }
    },
    reset: function reset() {
      this.stopRotation();
    },
    start: function start() {
      this.startRotation();
    },
    pauseAfter: function pauseAfter() {
      this.stopRotation();
    },
    resumeAfter: function resumeAfter() {
      this.startRotation();
    },
    beforeItemsUpdate: function beforeItemsUpdate() {
      this.reset();
    },
    afterItemsUpdate: function afterItemsUpdate() {
      this.start();
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    this.reset();
  }
};

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExist),
      expression: "isExist"
    }],
    class: _vm.classes
  }, [(_vm.currentItem) ? _c('a', {
    staticClass: "my-link",
    attrs: {
      "href": _vm.currentItem[("url_" + _vm.mq)],
      "target": _vm.currentItem.blankWindow
    },
    on: {
      "click": function($event) {
        _vm.onItemClick(_vm.currentItem, $event)
      }
    }
  }, [_c('img', {
    staticClass: "my-current-item",
    class: _vm.currentItemClasses,
    attrs: {
      "src": _vm.currentItem[("fileName_" + _vm.mq)],
      "alt": ""
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "my-rotate-transition"
    },
    on: {
      "before-enter": function($event) {
        _vm.$emit('next-item-before-enter')
      },
      "after-enter": function($event) {
        _vm.$emit('next-item-after-enter')
      }
    }
  }, [(_vm.nextItem) ? _c('img', {
    staticClass: "my-next-item",
    attrs: {
      "src": _vm.nextItem[("fileName_" + _vm.mq)],
      "alt": ""
    }
  }) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(508),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8ae95420",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(506);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("02ed2479", content, true, {});

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".bc-banner-carousel[data-v-8ae95420]{width:100%;overflow:visible}.bc-banner-carousel[data-v-8ae95420],.bc-banner-carousel [data-v-8ae95420],.bc-banner-carousel[data-v-8ae95420] :after,.bc-banner-carousel[data-v-8ae95420] :before{box-sizing:border-box}.bc-banner-carousel a[data-v-8ae95420],.bc-banner-carousel div[data-v-8ae95420],.bc-banner-carousel img[data-v-8ae95420],.bc-banner-carousel li[data-v-8ae95420],.bc-banner-carousel ol[data-v-8ae95420],.bc-banner-carousel p[data-v-8ae95420],.bc-banner-carousel ul[data-v-8ae95420]{margin:0;padding:0}.bc-banner-carousel a[data-v-8ae95420],.bc-banner-carousel a[data-v-8ae95420]:active,.bc-banner-carousel a[data-v-8ae95420]:focus,.bc-banner-carousel a[data-v-8ae95420]:hover{text-decoration:none}.bc-banner-carousel li[data-v-8ae95420],.bc-banner-carousel ol[data-v-8ae95420],.bc-banner-carousel ul[data-v-8ae95420]{list-style:none}.bc-banner-carousel--exist[data-v-8ae95420]{min-height:1px}.bc-banner-carousel--fixed[data-v-8ae95420]{position:fixed;left:0;bottom:0;width:100%;background:hsla(0,0%,100%,.8)}.bc-banner-carousel__container[data-v-8ae95420]{width:100%;overflow:visible;position:relative;margin:0 auto!important}.bc-banner-carousel__slider[data-v-8ae95420]{position:absolute;top:0;left:0;-webkit-transition-property:margin;transition-property:margin;-webkit-transition-timing-function:cubic-bezier(.25,.46,.45,.94);transition-timing-function:cubic-bezier(.25,.46,.45,.94)}.bc-banner-carousel__item[data-v-8ae95420]{position:absolute;top:0;cursor:pointer;-webkit-transition:opacity .35s;transition:opacity .35s}.bc-banner-carousel__item[data-v-8ae95420]:focus,.bc-banner-carousel__item[data-v-8ae95420]:hover{opacity:.9}.bc-banner-carousel__item a[data-v-8ae95420],.bc-banner-carousel__item img[data-v-8ae95420]{display:block;width:100%;height:100%}.bc-banner-carousel__item img[data-v-8ae95420]{pointer-events:none}.bc-banner-carousel__btn[data-v-8ae95420]{z-index:2;-webkit-user-drag:none;-khtml-user-drag:none;-ms-user-drag:none;user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:absolute;border:0;display:block;vertical-align:middle;box-sizing:border-box;cursor:pointer;text-decoration:none;background:transparent;padding:0;width:40px;height:100%}.bc-banner-carousel__btn[data-v-8ae95420],.bc-banner-carousel__btn[data-v-8ae95420]:active,.bc-banner-carousel__btn[data-v-8ae95420]:focus,.bc-banner-carousel__btn[data-v-8ae95420]:hover{text-decoration:none}.bc-banner-carousel__btn>span[data-v-8ae95420]{-webkit-user-drag:none;-khtml-user-drag:none;-ms-user-drag:none;user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:absolute;border:0;display:inline-block;vertical-align:middle;box-sizing:border-box;cursor:pointer;text-decoration:none;background:transparent;z-index:1;padding:0;margin:0;width:20px;height:32px;text-indent:100%;white-space:nowrap;overflow:hidden;background-color:#f0f0f0;top:50%;margin-top:-16px;box-shadow:0 1px 3px 0 rgba(0,0,0,.4);-webkit-transition:background-color .35s;transition:background-color .35s}.bc-banner-carousel__btn>span[data-v-8ae95420],.bc-banner-carousel__btn>span[data-v-8ae95420]:active,.bc-banner-carousel__btn>span[data-v-8ae95420]:focus,.bc-banner-carousel__btn>span[data-v-8ae95420]:hover{text-decoration:none}.bc-banner-carousel__btn>span[data-v-8ae95420]:after{content:\"\";display:block;box-sizing:border-box;position:absolute;z-index:1;top:50%;left:50%;margin-top:-4px;width:8px;height:8px;border-top:2px solid #666;border-right:2px solid #666;-webkit-transform-origin:center,center;-ms-transform-origin:center,center;transform-origin:center,center}.bc-banner-carousel__btn:focus>span[data-v-8ae95420],.bc-banner-carousel__btn:hover>span[data-v-8ae95420]{background-color:#d7d7d7}.bc-banner-carousel__btn:active>span[data-v-8ae95420]{background-color:#cacaca}.bc-banner-carousel__btn-prev[data-v-8ae95420]{left:0}.bc-banner-carousel__btn-prev>span[data-v-8ae95420]{left:0;border-radius:0 3px 3px 0}.bc-banner-carousel__btn-prev>span[data-v-8ae95420]:after{-webkit-transform:rotate(-135deg);-ms-transform:rotate(-135deg);transform:rotate(-135deg);margin-left:-2px}.bc-banner-carousel__btn-next[data-v-8ae95420]{right:0}.bc-banner-carousel__btn-next>span[data-v-8ae95420]{right:0;border-radius:3px 0 0 3px}.bc-banner-carousel__btn-next>span[data-v-8ae95420]:after{-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);margin-left:-4px}.bc-banner-carousel__scroller[data-v-8ae95420]{position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden}.bc-banner-carousel__close[data-v-8ae95420]{width:32px;height:32px;position:absolute;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;outline:none;border:0;border-radius:50%;cursor:pointer;right:-5px;top:-30px}.bc-banner-carousel__close>i[data-v-8ae95420]{display:block;width:20px;height:20px;background:#666;border-radius:50%;text-indent:100%;overflow:hidden;white-space:nowrap;position:relative;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);-webkit-transition:background .35s;transition:background .35s}.bc-banner-carousel__close>i[data-v-8ae95420]:after,.bc-banner-carousel__close>i[data-v-8ae95420]:before{content:\"\";display:block;position:absolute;background:#fff}.bc-banner-carousel__close>i[data-v-8ae95420]:before{top:3px;bottom:3px;width:2px;left:50%;margin-left:-1px}.bc-banner-carousel__close>i[data-v-8ae95420]:after{left:3px;right:3px;height:2px;top:50%;margin-top:-1px}.bc-banner-carousel__close:focus>i[data-v-8ae95420],.bc-banner-carousel__close:hover>i[data-v-8ae95420]{background:#333}.bc-banner-carousel__close:active>i[data-v-8ae95420]{background:#000}@media (max-width:709px){.bc-banner-carousel__close>i[data-v-8ae95420]{-webkit-transform:rotate(45deg) scale(.9);-ms-transform:rotate(45deg) scale(.9);transform:rotate(45deg) scale(.9)}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/shared/bc-banner/components/Carousel.vue"],"names":[],"mappings":"AACA,qCAAqC,WAAW,gBAAgB,CAC/D,AACD,oKAAqK,qBAAqB,CACzL,AACD,wRAAwR,SAAS,SAAS,CACzS,AACD,+KAA+K,oBAAoB,CAClM,AACD,wHAAwH,eAAe,CACtI,AACD,4CAA4C,cAAc,CACzD,AACD,4CAA4C,eAAe,OAAO,SAAS,WAAW,6BAA6B,CAClH,AACD,gDAAgD,WAAW,iBAAiB,kBAAkB,uBAAuB,CACpH,AACD,6CAA6C,kBAAkB,MAAM,OAAO,mCAAmC,2BAA2B,iEAAiE,wDAAwD,CAClQ,AACD,2CAA2C,kBAAkB,MAAM,eAAe,gCAAgC,uBAAuB,CACxI,AACD,kGAAkG,UAAU,CAC3G,AACD,4FAA4F,cAAc,WAAW,WAAW,CAC/H,AACD,+CAA+C,mBAAmB,CACjE,AACD,0CAA0C,UAAU,uBAAuB,sBAAsB,mBAAmB,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,2BAA2B,wCAAwC,aAAa,wBAAwB,qBAAqB,gBAAgB,kBAAkB,SAAS,cAAc,sBAAsB,sBAAsB,eAAe,qBAAqB,uBAAuB,UAAU,WAAW,WAAW,CACphB,AACD,2LAA2L,oBAAoB,CAC9M,AACD,+CAA+C,uBAAuB,sBAAsB,mBAAmB,eAAe,yBAAyB,sBAAsB,qBAAqB,iBAAiB,2BAA2B,wCAAwC,aAAa,wBAAwB,qBAAqB,gBAAgB,kBAAkB,SAAS,qBAAqB,sBAAsB,sBAAsB,eAAe,qBAAqB,uBAAuB,UAAU,UAAU,SAAS,WAAW,YAAY,iBAAiB,mBAAmB,gBAAgB,yBAAyB,QAAQ,iBAAiB,sCAAsC,yCAAyC,gCAAgC,CAC/vB,AACD,+MAA+M,oBAAoB,CAClO,AACD,qDAAqD,WAAW,cAAc,sBAAsB,kBAAkB,UAAU,QAAQ,SAAS,gBAAgB,UAAU,WAAW,0BAA0B,4BAA4B,uCAAuC,mCAAmC,8BAA8B,CACnV,AACD,0GAA0G,wBAAwB,CACjI,AACD,sDAAsD,wBAAwB,CAC7E,AACD,+CAA+C,MAAM,CACpD,AACD,oDAAoD,OAAO,yBAAyB,CACnF,AACD,0DAA0D,kCAAkC,8BAA8B,0BAA0B,gBAAgB,CACnK,AACD,+CAA+C,OAAO,CACrD,AACD,oDAAoD,QAAQ,yBAAyB,CACpF,AACD,0DAA0D,gCAAgC,4BAA4B,wBAAwB,gBAAgB,CAC7J,AACD,+CAA+C,kBAAkB,MAAM,OAAO,WAAW,YAAY,eAAe,CACnH,AACD,4CAA4C,WAAW,YAAY,kBAAkB,oBAAoB,qBAAqB,oBAAoB,aAAa,yBAAyB,2BAA2B,sBAAsB,mBAAmB,wBAAwB,+BAA+B,qBAAqB,uBAAuB,wBAAwB,qBAAqB,gBAAgB,uBAAuB,aAAa,SAAS,kBAAkB,eAAe,WAAW,SAAS,CAC7f,AACD,8CAA8C,cAAc,WAAW,YAAY,gBAAgB,kBAAkB,iBAAiB,gBAAgB,mBAAmB,kBAAkB,gCAAgC,4BAA4B,wBAAwB,mCAAmC,0BAA0B,CAC3U,AACD,yGAAyG,WAAW,cAAc,kBAAkB,eAAe,CAClK,AACD,qDAAqD,QAAQ,WAAW,UAAU,SAAS,gBAAgB,CAC1G,AACD,oDAAoD,SAAS,UAAU,WAAW,QAAQ,eAAe,CACxG,AACD,wGAAwG,eAAe,CACtH,AACD,qDAAqD,eAAe,CACnE,AACD,yBACA,8CAA8C,0CAA0C,sCAAsC,iCAAiC,CAC9J,CACA","file":"Carousel.vue","sourcesContent":["\n.bc-banner-carousel[data-v-8ae95420]{width:100%;overflow:visible\n}\n.bc-banner-carousel[data-v-8ae95420],.bc-banner-carousel *[data-v-8ae95420],.bc-banner-carousel[data-v-8ae95420] :after,.bc-banner-carousel[data-v-8ae95420] :before{box-sizing:border-box\n}\n.bc-banner-carousel a[data-v-8ae95420],.bc-banner-carousel div[data-v-8ae95420],.bc-banner-carousel img[data-v-8ae95420],.bc-banner-carousel li[data-v-8ae95420],.bc-banner-carousel ol[data-v-8ae95420],.bc-banner-carousel p[data-v-8ae95420],.bc-banner-carousel ul[data-v-8ae95420]{margin:0;padding:0\n}\n.bc-banner-carousel a[data-v-8ae95420],.bc-banner-carousel a[data-v-8ae95420]:active,.bc-banner-carousel a[data-v-8ae95420]:focus,.bc-banner-carousel a[data-v-8ae95420]:hover{text-decoration:none\n}\n.bc-banner-carousel li[data-v-8ae95420],.bc-banner-carousel ol[data-v-8ae95420],.bc-banner-carousel ul[data-v-8ae95420]{list-style:none\n}\n.bc-banner-carousel--exist[data-v-8ae95420]{min-height:1px\n}\n.bc-banner-carousel--fixed[data-v-8ae95420]{position:fixed;left:0;bottom:0;width:100%;background:hsla(0,0%,100%,.8)\n}\n.bc-banner-carousel__container[data-v-8ae95420]{width:100%;overflow:visible;position:relative;margin:0 auto!important\n}\n.bc-banner-carousel__slider[data-v-8ae95420]{position:absolute;top:0;left:0;-webkit-transition-property:margin;transition-property:margin;-webkit-transition-timing-function:cubic-bezier(.25,.46,.45,.94);transition-timing-function:cubic-bezier(.25,.46,.45,.94)\n}\n.bc-banner-carousel__item[data-v-8ae95420]{position:absolute;top:0;cursor:pointer;-webkit-transition:opacity .35s;transition:opacity .35s\n}\n.bc-banner-carousel__item[data-v-8ae95420]:focus,.bc-banner-carousel__item[data-v-8ae95420]:hover{opacity:.9\n}\n.bc-banner-carousel__item a[data-v-8ae95420],.bc-banner-carousel__item img[data-v-8ae95420]{display:block;width:100%;height:100%\n}\n.bc-banner-carousel__item img[data-v-8ae95420]{pointer-events:none\n}\n.bc-banner-carousel__btn[data-v-8ae95420]{z-index:2;-webkit-user-drag:none;-khtml-user-drag:none;-ms-user-drag:none;user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:absolute;border:0;display:block;vertical-align:middle;box-sizing:border-box;cursor:pointer;text-decoration:none;background:transparent;padding:0;width:40px;height:100%\n}\n.bc-banner-carousel__btn[data-v-8ae95420],.bc-banner-carousel__btn[data-v-8ae95420]:active,.bc-banner-carousel__btn[data-v-8ae95420]:focus,.bc-banner-carousel__btn[data-v-8ae95420]:hover{text-decoration:none\n}\n.bc-banner-carousel__btn>span[data-v-8ae95420]{-webkit-user-drag:none;-khtml-user-drag:none;-ms-user-drag:none;user-drag:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-touch-callout:none;-webkit-tap-highlight-color:transparent;outline:none;-webkit-appearance:none;-moz-appearance:none;appearance:none;position:absolute;border:0;display:inline-block;vertical-align:middle;box-sizing:border-box;cursor:pointer;text-decoration:none;background:transparent;z-index:1;padding:0;margin:0;width:20px;height:32px;text-indent:100%;white-space:nowrap;overflow:hidden;background-color:#f0f0f0;top:50%;margin-top:-16px;box-shadow:0 1px 3px 0 rgba(0,0,0,.4);-webkit-transition:background-color .35s;transition:background-color .35s\n}\n.bc-banner-carousel__btn>span[data-v-8ae95420],.bc-banner-carousel__btn>span[data-v-8ae95420]:active,.bc-banner-carousel__btn>span[data-v-8ae95420]:focus,.bc-banner-carousel__btn>span[data-v-8ae95420]:hover{text-decoration:none\n}\n.bc-banner-carousel__btn>span[data-v-8ae95420]:after{content:\"\";display:block;box-sizing:border-box;position:absolute;z-index:1;top:50%;left:50%;margin-top:-4px;width:8px;height:8px;border-top:2px solid #666;border-right:2px solid #666;-webkit-transform-origin:center,center;-ms-transform-origin:center,center;transform-origin:center,center\n}\n.bc-banner-carousel__btn:focus>span[data-v-8ae95420],.bc-banner-carousel__btn:hover>span[data-v-8ae95420]{background-color:#d7d7d7\n}\n.bc-banner-carousel__btn:active>span[data-v-8ae95420]{background-color:#cacaca\n}\n.bc-banner-carousel__btn-prev[data-v-8ae95420]{left:0\n}\n.bc-banner-carousel__btn-prev>span[data-v-8ae95420]{left:0;border-radius:0 3px 3px 0\n}\n.bc-banner-carousel__btn-prev>span[data-v-8ae95420]:after{-webkit-transform:rotate(-135deg);-ms-transform:rotate(-135deg);transform:rotate(-135deg);margin-left:-2px\n}\n.bc-banner-carousel__btn-next[data-v-8ae95420]{right:0\n}\n.bc-banner-carousel__btn-next>span[data-v-8ae95420]{right:0;border-radius:3px 0 0 3px\n}\n.bc-banner-carousel__btn-next>span[data-v-8ae95420]:after{-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);margin-left:-4px\n}\n.bc-banner-carousel__scroller[data-v-8ae95420]{position:absolute;top:0;left:0;width:100%;height:100%;overflow:hidden\n}\n.bc-banner-carousel__close[data-v-8ae95420]{width:32px;height:32px;position:absolute;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;-webkit-appearance:none;-moz-appearance:none;appearance:none;background:transparent;outline:none;border:0;border-radius:50%;cursor:pointer;right:-5px;top:-30px\n}\n.bc-banner-carousel__close>i[data-v-8ae95420]{display:block;width:20px;height:20px;background:#666;border-radius:50%;text-indent:100%;overflow:hidden;white-space:nowrap;position:relative;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);-webkit-transition:background .35s;transition:background .35s\n}\n.bc-banner-carousel__close>i[data-v-8ae95420]:after,.bc-banner-carousel__close>i[data-v-8ae95420]:before{content:\"\";display:block;position:absolute;background:#fff\n}\n.bc-banner-carousel__close>i[data-v-8ae95420]:before{top:3px;bottom:3px;width:2px;left:50%;margin-left:-1px\n}\n.bc-banner-carousel__close>i[data-v-8ae95420]:after{left:3px;right:3px;height:2px;top:50%;margin-top:-1px\n}\n.bc-banner-carousel__close:focus>i[data-v-8ae95420],.bc-banner-carousel__close:hover>i[data-v-8ae95420]{background:#333\n}\n.bc-banner-carousel__close:active>i[data-v-8ae95420]{background:#000\n}\n@media (max-width:709px){\n.bc-banner-carousel__close>i[data-v-8ae95420]{-webkit-transform:rotate(45deg) scale(.9);-ms-transform:rotate(45deg) scale(.9);transform:rotate(45deg) scale(.9)\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _banner = __webpack_require__(187);

var _banner2 = _interopRequireDefault(_banner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var SLIDER_TRANSITION_DURATION = 350;
var FIXED_ACTIVE_FIRST_JUDGE_DELAY = 500;
var FIXED_ACTIVE_DURATION = 500;
var CLICK_CANCEL_INTERVAL = 300;

exports.default = {
  name: 'bc-banner-carousel',

  mixins: [_banner2.default],

  props: {
    size: {
      type: Object,
      required: true
    },
    fixed: Boolean,
    zIndex: {
      type: [Number, String],
      default: 5001
    },
    maxContainerWidth: {
      type: [Number, String],
      default: 950
    },
    padding: {
      type: [Number, String, Object],
      default: function _default() {
        return { pc: 10, sp: 0 };
      }
    },
    itemMargin: {
      type: [Number, String],
      default: 10
    },
    backgroundColor: {
      type: String,
      default: null
    }
  },

  data: function data() {
    return {
      needs: 5,
      forceHidden: true,
      containerWidth: null,
      sliderLeft: 0,
      sliderDuration: 0,
      sliderPanAmmount: 0,
      sliderTransitionTimerId: null,
      rotationTimerId: null,
      nowPaning: false,
      fixedActive: false,
      fixedVisibility: false,
      paningTimerId: null
    };
  },


  computed: {
    isFixedHide: function isFixedHide() {
      return this.fixed && !this.fixedActive;
    },
    classes: function classes() {
      var _ref;

      return _ref = {}, _defineProperty(_ref, this.$options.name, true), _defineProperty(_ref, this.$options.name + '--exist', this.isExist), _defineProperty(_ref, this.$options.name + '--fixed', this.fixed), _defineProperty(_ref, this.$options.name + '--fixed-hide', this.isFixedHide), _ref;
    },
    styles: function styles() {
      return {
        background: this.backgroundColor ? this.backgroundColor : null,
        height: this.computedSize.height + this.computedPadding.vertical * 2 + 'px',
        padding: this.computedPadding.vertical + 'px',
        zIndex: this.fixed && this.zIndex ? this.zIndex : null,
        bottom: this.isFixedHide ? '-' + this.fullHeight + 'px' : null,
        opacity: this.fixed && !this.fixedVisibility || this.forceHidden ? 0 : 1,
        transition: this.fixed ? 'bottom ' + FIXED_ACTIVE_DURATION + 'ms' : null
      };
    },
    fullHeight: function fullHeight() {
      return this.computedPadding.vertical * 2 + this.computedSize.height + 32;
    },
    containerClasses: function containerClasses() {
      return _defineProperty({}, this.$options.name + '__container', true);
    },
    containerStyles: function containerStyles() {
      return {
        width: this.fixed && this.containerWidth ? this.containerWidth + 'px' : null,
        height: this.computedSize.height + 'px'
      };
    },
    sliderClasses: function sliderClasses() {
      var _ref3;

      return _ref3 = {}, _defineProperty(_ref3, this.$options.name + '__slider', true), _defineProperty(_ref3, this.$options.name + '__slider--transition', this.sliderLeft !== 0), _ref3;
    },
    sliderStyles: function sliderStyles() {
      return {
        width: this.computedItemWidth * this.needs + 'px',
        height: this.computedSize.height + 'px',
        marginLeft: this.sliderLeft + this.sliderPanAmmount + 'px',
        transitionDuration: this.sliderDuration !== 0 ? this.sliderDuration + 'ms' : null
      };
    },
    itemClasses: function itemClasses() {
      return _defineProperty({}, this.$options.name + '__item', true);
    },
    needsHalf: function needsHalf() {
      return Math.floor(this.needs / 2);
    },
    offsetLeft: function offsetLeft() {
      return (this.containerWidth - this.computedItemWidth) / 2 - this.needsHalf * this.computedItemWidth;
    },
    computedPaddingMqMap: function computedPaddingMqMap() {
      var padding = this.padding;
      if (padding === null || (typeof padding === 'undefined' ? 'undefined' : _typeof(padding)) !== 'object' || !padding.pc) {
        padding = {
          pc: padding,
          sp: padding
        };
      }
      ['pc', 'sp'].forEach(function (key) {
        if (_typeof(padding[key]) !== 'object') padding[key] = { horizontal: padding[key], vertical: padding[key] };
        padding[key].horizontal = parseInt(padding[key].horizontal, 10);
        padding[key].vertical = parseInt(padding[key].vertical, 10);
      });
      return padding;
    },
    computedPadding: function computedPadding() {
      return this.computedPaddingMqMap[this.mq];
    },
    computedSize: function computedSize() {
      return this.size[this.mq];
    },
    computedItemMargin: function computedItemMargin() {
      return parseInt(this.itemMargin, 10);
    },
    computedItemWidth: function computedItemWidth() {
      var size = this.computedSize;
      return size.width + this.computedItemMargin;
    },
    computedItemStyle: function computedItemStyle() {
      var size = this.computedSize;
      return {
        width: this.computedItemWidth + 'px',
        height: size.height + 'px',
        padding: '0 ' + this.computedItemMargin / 2 + 'px'
      };
    },
    computedItems: function computedItems() {
      var items = [];
      var _items = this.items;
      var startIndex = this.index - this.needsHalf;
      var size = this.computedSize;
      var style = this.computedItemStyle;

      for (var i = 0; i < this.needs; i++) {
        var index = i + startIndex;
        if (index < 0) {
          index = _items.length + index;
        } else {
          index = index % _items.length;
        }

        items.push(Object.assign({
          style: Object.assign({
            left: i * this.computedItemWidth + this.offsetLeft + 'px'
          }, style)
        }, _items[index]));
      }
      return items;
    },
    computedMaxContainerWidth: function computedMaxContainerWidth() {
      if (!this.fixed || !this.maxContainerWidth) return null;
      return parseInt(this.maxContainerWidth, 10) || null;
    },
    nowSliderTransition: function nowSliderTransition() {
      return this.sliderTransitionTimerId !== null;
    },
    isDisabled: function isDisabled() {
      return this.nowSliderTransition;
    },
    nowRotation: function nowRotation() {
      return this.rotationTimerId !== null;
    }
  },

  watch: {
    isFixedHide: function isFixedHide() {
      var _this = this;

      if (this.isFixedHide) {
        this.fixedVisibilityTimer = setTimeout(function () {
          _this.fixedVisibility = false;
        }, FIXED_ACTIVE_DURATION);
      } else {
        this.clearFixedVisibiltyTymer();
        this.fixedVisibility = true;
      }
    }
  },

  methods: {
    fixedDestroy: function fixedDestroy() {
      this.fixedActive = false;
      this.reset();
    },
    clearFixedVisibiltyTymer: function clearFixedVisibiltyTymer() {
      if (this.fixedVisibilityTimer !== null) {
        clearTimeout(this.fixedVisibilityTimer);
        this.fixedVisibilityTimer = null;
      }
    },
    prev: function prev(e) {
      if (e) this.$bcb.blurActiveElement();
      if (this.isDisabled) return;
      this.slideIndex(-1);
    },
    next: function next(e) {
      if (e) this.$bcb.blurActiveElement();
      if (this.isDisabled) return;
      this.slideIndex(1);
    },
    slideIndex: function slideIndex(ammount) {
      var _this2 = this;

      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : SLIDER_TRANSITION_DURATION;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var nextIndex, moveCount, moveWidth;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this2.isDisabled) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:

                _this2.stopRotation();
                _this2.sliderDuration = duration;

                nextIndex = _this2.index + ammount;

                if (nextIndex >= _this2.count) {
                  nextIndex -= _this2.count;
                } else if (nextIndex < 0) {
                  nextIndex += _this2.count;
                }

                if (ammount !== 0) {
                  moveCount = _this2.index + ammount - _this2.index;
                  moveWidth = _this2.computedItemWidth * moveCount;

                  _this2.sliderLeft = -moveWidth;
                }

                _context.next = 9;
                return new Promise(function (resolve, reject) {
                  _this2.sliderTransitionTimerId = setTimeout(function () {
                    requestAnimationFrame(function () {
                      _this2.index = nextIndex;
                      _this2.startRotation();
                      _this2.clearSliderTransitionTimer();
                      resolve();
                    });
                  }, SLIDER_TRANSITION_DURATION);
                });

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    clearSliderTransitionTimer: function clearSliderTransitionTimer() {
      if (this.nowSliderTransition) {
        clearTimeout(this.sliderTransitionTimerId);
        this.sliderTransitionTimerId = null;
        this.sliderLeft = 0;
        this.sliderDuration = 0;
      }
    },
    updateContainerWidth: function updateContainerWidth() {
      var _this3 = this;

      var width = this.$el.clientWidth - this.computedPadding.horizontal * 2;
      if (this.computedMaxContainerWidth && width > this.computedMaxContainerWidth) {
        width = this.computedMaxContainerWidth;
      }
      this.containerWidth = width;

      if (this.forceHidden) {
        this.$nextTick(function () {
          requestAnimationFrame(function () {
            _this3.forceHidden = false;
          });
        });
      }
    },
    startResizeListener: function startResizeListener() {
      var _this4 = this;

      if (!this.isExist) return;
      var onResize = function onResize(e) {
        _this4.updateContainerWidth();
      };

      window.addEventListener('resize', onResize, false);
      window.addEventListener('orientationchange', onResize, false);

      this._removeResizeListener = function () {
        window.removeEventListener('resize', onResize, false);
        window.removeEventListener('orientationchange', onResize, false);
      };
    },
    stopResizeListener: function stopResizeListener() {
      if (this._removeResizeListener) {
        this._removeResizeListener();
        delete this._removeResizeListener;
      }
    },
    clearPaningTimer: function clearPaningTimer() {
      if (this.paningTimerId !== null) {
        clearTimeout(this.paningTimerId);
        this.paningTimerId = null;
      }
    },
    onPanStart: function onPanStart(e) {
      this.nowPaning = true;
      this.clickDisabled = true;
      this.stopRotation();
    },
    onPanMove: function onPanMove(e) {
      this.sliderPanAmmount = e.deltaX;
    },
    onPanEnd: function onPanEnd(e) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var slideAmmount;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this5.nowPaning = false;
                _this5.clearPaningTimer();
                _this5.paningTimerId = setTimeout(function () {
                  _this5.clearPaningTimer();
                  _this5.clickDisabled = false;
                }, CLICK_CANCEL_INTERVAL);
                slideAmmount = Math.round(_this5.sliderPanAmmount / _this5.computedItemWidth) * -1;

                _this5.sliderPanAmmount = 0;
                _context2.next = 7;
                return _this5.slideIndex(slideAmmount);

              case 7:
                _this5.startRotation();

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    startRotation: function startRotation() {
      var _this6 = this;

      if (!this.isExist) return;
      if (this.isPause) {
        return;
      }
      this.stopRotation();
      this.rotationTimerId = setInterval(function () {
        _this6.next();
      }, this.rotateInterval);
    },
    stopRotation: function stopRotation() {
      if (this.rotationTimerId !== null) {
        clearInterval(this.rotationTimerId);
        this.rotationTimerId = null;
      }
    },
    reset: function reset() {
      this.clearSliderTransitionTimer();
      this.stopResizeListener();
      this.stopRotation();
      this.removeHasExpelFixedChangeListener();
      this.removeWindowScrollListener();
    },
    start: function start() {
      this.updateContainerWidth();
      this.startResizeListener();
      this.startRotation();
      this.registHasExpelFixedChangeListener();
      this.registWindowScrollListener();
    },
    pauseAfter: function pauseAfter() {
      this.stopResizeListener();
      this.stopRotation();
    },
    resumeAfter: function resumeAfter() {
      this.updateContainerWidth();
      this.startResizeListener();
      this.startRotation();
    },
    beforeItemsUpdate: function beforeItemsUpdate() {
      this.reset();
    },
    afterItemsUpdate: function afterItemsUpdate() {
      this.start();
    },
    toggleByRootHasExpelFixed: function toggleByRootHasExpelFixed() {
      if (!this.fixed) return;
      if (this.$root.hasExpelFixed) {
        this.hideFixed();
      } else {
        this.showFixed();
      }
    },
    hideFixed: function hideFixed() {
      var _this7 = this;

      this.fixedActive = false;

      setTimeout(function () {
        _this7.updateVisible();
      }, FIXED_ACTIVE_DURATION);
    },
    showFixed: function showFixed() {
      var _this8 = this;

      this.updateContainerWidth();
      this.fixedActive = true;

      setTimeout(function () {
        _this8.updateVisible();
      }, FIXED_ACTIVE_DURATION);
    },
    registHasExpelFixedChangeListener: function registHasExpelFixedChangeListener() {
      var _this9 = this;

      if (!this.fixed) return;
      this._onHasExpelFixedChange = function () {
        _this9.toggleByRootHasExpelFixed();
      };
      this.$root.$on('hasExpelFixedChange', this._onHasExpelFixedChange);
      setTimeout(function () {
        if (_this9._onHasExpelFixedChange) {
          _this9._onHasExpelFixedChange();
        }
      }, FIXED_ACTIVE_FIRST_JUDGE_DELAY);
    },
    removeHasExpelFixedChangeListener: function removeHasExpelFixedChangeListener() {
      if (!this.fixed || !this._onHasExpelFixedChange) return;
      this.$root.$off('hasExpelFixedChange', this._onHasExpelFixedChange);
      delete this._onHasExpelFixedChange;
    },
    registWindowScrollListener: function registWindowScrollListener() {
      var _this10 = this;

      if (!this.fixed) return;
      this.$window.on('scrollStart.' + this._bcb_uid_ + '--carousel', function () {
        _this10.hideFixed();
      });

      this.$window.on('scrollEnd.' + this._bcb_uid_ + '--carousel', function () {
        _this10.toggleByRootHasExpelFixed();
      });
    },
    removeWindowScrollListener: function removeWindowScrollListener() {
      if (!this.fixed) return;
      this.$window.off('.' + this._bcb_uid_ + '--carousel');
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    this.reset();
    this.clearFixedVisibiltyTymer();
  }
};

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExist),
      expression: "isExist"
    }],
    class: _vm.classes,
    style: (_vm.styles)
  }, [_c('div', {
    ref: "container",
    class: _vm.containerClasses,
    style: (_vm.containerStyles)
  }, [_c('div', {
    staticClass: "bc-banner-carousel__scroller"
  }, [_c('a', {
    staticClass: "bc-banner-carousel__btn bc-banner-carousel__btn-prev",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.prev($event)
      }
    }
  }, [_c('span', [_vm._v("前へ")])]), _vm._v(" "), (_vm.isExist) ? _c('ul', {
    class: _vm.sliderClasses,
    style: (_vm.sliderStyles)
  }, _vm._l((_vm.computedItems), function(item, index) {
    return _c('v-touch', {
      key: index,
      class: _vm.itemClasses,
      style: (item.style),
      attrs: {
        "tag": "li",
        "pan-options": {
          direction: 'horizontal',
          threshold: 0
        }
      },
      on: {
        "panstart": _vm.onPanStart,
        "panmove": _vm.onPanMove,
        "panend": _vm.onPanEnd,
        "pancancel": _vm.onPanEnd
      }
    }, [_c('a', {
      attrs: {
        "href": item[("url_" + _vm.mq)],
        "target": item.blankWindow,
        "tabindex": "-1",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          _vm.onItemClick(item, $event)
        },
        "dragstart": function($event) {
          $event.preventDefault();
        },
        "dragmove": function($event) {
          $event.preventDefault();
        },
        "dragend": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item[("fileName_" + _vm.mq)],
        "alt": "",
        "draggable": "false"
      }
    })])])
  })) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "bc-banner-carousel__btn bc-banner-carousel__btn-next",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.next($event)
      }
    }
  }, [_c('span', [_vm._v("次へ")])])]), _vm._v(" "), (_vm.fixed) ? _c('button', {
    staticClass: "bc-banner-carousel__close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.fixedDestroy($event)
      }
    }
  }, [_c('i', [_vm._v("閉じる")])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// import Tappable from './click-outside';
// import DDTappable from 'dd-tappable';
// import Linkset      from './linkset';
// import NumberRange  from './number-range';

// console.log(DDTappable);


exports.default = {
  // Tappable,
  // ClickOutside,
  // Linkset,
  // NumberRange,
};

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(511)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ddEventManager = __webpack_require__(13);

var _ddEventManager2 = _interopRequireDefault(_ddEventManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// const SCROLL_EVENT  = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
var SCROLL_END_JUDGE_INTERVAL = 500;

var WindowManager = function () {
  _createClass(WindowManager, [{
    key: 'isShow',
    get: function get() {
      return this.showState === 'show';
    }
  }, {
    key: 'isHide',
    get: function get() {
      return this.showState === 'hide';
    }

    /**
     * constructor
     */

  }]);

  function WindowManager() {
    var _this = this;

    _classCallCheck(this, WindowManager);

    this.scroll = { top: null, left: null };
    this.scrollDiff = { start: { top: null, left: null }, top: null, left: null };
    this.scrollTimerId = null;
    this.nowScroll = false;
    this.hiddenKey = null;
    this.visibilityChangeKey = null;
    this.showState = 'show';

    new _ddEventManager2.default(this);

    var onWindowLoad = function onWindowLoad(e) {
      _this._updateParams();

      // this.emit('load', this);

      // IE、EDGEでウェイトをおかないと要素の短径が正しくとれない
      setTimeout(function () {
        _this.emit('load', _this);
      }, 250);

      window.removeEventListener('load', onWindowLoad, false);
    };

    var onWindowResize = function onWindowResize(e) {
      return _this._onResize(e);
    };

    var onWindowScroll = function onWindowScroll(e) {
      return _this._onScroll(e);
    };

    window.addEventListener('load', onWindowLoad, false);
    window.addEventListener('resize', onWindowResize, false);
    window.addEventListener('orientationchange', onWindowResize, false);
    window.addEventListener('scroll', onWindowScroll, false);

    this.setupVisibilityEvent();
  }

  /**
   * ready hook
   */


  _createClass(WindowManager, [{
    key: 'ready',
    value: function ready(cb) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.hasAndOne('load', function () {
          if (typeof cb === 'function') cb(_this2);
          resolve(_this2);
        });
      });
    }

    /**
     * on resize callback
     */

  }, {
    key: '_onResize',
    value: function _onResize() {
      this._updateScrollParams();
      this._updateSize();
    }

    /**
     * on scrll callback
     */

  }, {
    key: '_onScroll',
    value: function _onScroll() {
      var _this3 = this;

      if (!this.nowScroll) {
        this.scrollDiff.start.top = this.scroll.top;
        this.scrollDiff.start.left = this.scroll.left;
      }

      this._updateScrollParams();

      this.scrollDiff.top = this.scroll.top - this.scrollDiff.start.top;
      this.scrollDiff.left = this.scroll.left - this.scrollDiff.start.left;

      if (!this.nowScroll) {
        this.nowScroll = true;
        this.emit('scrollStart', this);
      }

      this.emit('scroll', this);

      if (this.scrollTimerId !== null) {
        clearTimeout(this.scrollTimerId);
        this.scrollTimerId = null;
      }

      this.scrollTimerId = setTimeout(function () {
        _this3.nowScroll = false;
        _this3.emit('scrollEnd', _this3);
      }, SCROLL_END_JUDGE_INTERVAL);
    }

    /**
     * update all params
     */

  }, {
    key: '_updateParams',
    value: function _updateParams() {
      this._updateScrollParams();
      this._updateSize();
    }

    /**
     * update scroll params
     */

  }, {
    key: '_updateScrollParams',
    value: function _updateScrollParams() {
      this.scroll.top = window.pageYOffset;
      this.scroll.left = window.pageXOffset;
    }

    /**
     * update size params
     */

  }, {
    key: '_updateSize',
    value: function _updateSize() {
      var bw = this.width,
          bh = this.height;

      this.width = window.innerWidth;
      this.height = window.innerHeight;

      if (bw === null) return;

      if (bw !== this.width || bh !== this.height) {
        this.emit('resize', this);
      }
    }

    /**
     * setup visibility event
     */

  }, {
    key: 'setupVisibilityEvent',
    value: function setupVisibilityEvent() {
      var _this4 = this;

      var handleVisibilityChange = function handleVisibilityChange(e) {
        updateState();
      };

      var updateState = function updateState() {
        var beforeState = _this4.showState;
        _this4.showState = document[_this4.hiddenKey] ? 'hide' : 'show';
        if (beforeState !== _this4.showState) {
          _this4.emit(_this4.showState, _this4);
        }
      };

      if (document.hidden !== undefined) {
        this.hiddenKey = 'hidden';
        this.visibilityChangeKey = 'visibilitychange';
      } else if (document.mozHidden !== undefined) {
        this.hiddenKey = 'mozHidden';
        this.visibilityChangeKey = 'mozvisibilitychange';
      } else if (document.msHidden !== undefined) {
        this.hiddenKey = 'msHidden';
        this.visibilityChangeKey = 'msvisibilitychange';
      } else if (document.webkitHidden !== undefined) {
        this.hiddenKey = 'webkitHidden';
        this.visibilityChangeKey = 'webkitvisibilitychange';
      }

      if (!this.hiddenKey) {
        console.warn('ブラウザが `Page Visibility API` に対応していないため、イベントの発行を行いません。');
        return;
      }

      if (document.addEventListener === undefined || !this.hiddenKey) {
        console.warn('ブラウザが `Page Visibility API` に対応していないため、イベントの発行を行いません。');
        return;
      }

      document.addEventListener(this.visibilityChangeKey, handleVisibilityChange, false);
      updateState();
    }
  }]);

  return WindowManager;
}();

exports.default = WindowManager;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/dn.js